import {
  Unit_instanceat14thlj150z as Unit_instance,
  Enum3alwj03lh1n41 as Enum,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toString30pk9tzaqopn as toString,
  hashCodeq5arwsb9dgti as hashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  toList3jhuyej2anx2q as toList,
  VOID7hggqo3abtya as VOID,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString_0,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  createThis2j2avj17cvnv2 as createThis,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  ArrayList3it5z8td81qkl as ArrayList,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  isInterface3d6p8outrmvmk as isInterface,
  lazy2hsh8ze7j6ikd as lazy,
  isIntArrayeijsubfngq38 as isIntArray,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  KProperty1ca4yb4wlo496 as KProperty1,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  fill2542d4m9l93pn as fill,
  toByte4i43936u611k as toByte,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  SequenceScope1coiso86pqzq2 as SequenceScope,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  RuntimeException1r3t0zl97011n as RuntimeException,
  StringBuildermazzzhj6kkai as StringBuilder,
  iterator3f5i676wpaa3g as iterator,
  Iterable1y3qizuf89iou as Iterable,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  coerceAtMost322komnqp70ag as coerceAtMost,
  round2mrvepag8eey0 as round,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  isFloatArrayjjscnqphw92j as isFloatArray,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  to2cs3ny02qtbcb as to,
  mapOf1xd03cq9cnmy8 as mapOf,
  removePrefix279df90bhrqqg as removePrefix,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  split2bvyvnrlcifjv as split,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
  startsWith26w8qjqapeeq6 as startsWith,
  setOf45ia9pnfhe90 as setOf,
  toInt5qdj874w69jh as toInt,
  printStackTrace18lnx7a39cni as printStackTrace,
  contains3u8qpdzrl9an as contains,
  Collection1k04j3hzsbod0 as Collection,
  indexOff2hgzjbxdcp4 as indexOf,
  KtList3hktaavzmj137 as KtList,
  roundToInt1ue8x8yshtznx as roundToInt,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  compareTo3ankvs086tmwq as compareTo,
  Comparable198qfk8pnblz0 as Comparable,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  numberToDouble210hrknaofnhf as numberToDouble,
  protoOf180f3jzyo7rfj as protoOf,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  HashMap1a0ld5kgwhmhv as HashMap,
  startsWith1bgirhbedtv2y as startsWith_0,
  firstOrNullf6vlo6vdgu1e as firstOrNull,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  first28gmhyvs4kf06 as first,
  toMap1vec9topfei08 as toMap,
  lines3g90sq0zeq43v as lines,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  split3d3yeauc4rm2n as split_0,
  listOf1jh22dvmctj1r as listOf,
  plus310ted5e4i90h as plus,
  numberToChar93r9buh19yek as numberToChar,
  toString14fd7g605f91p as toString_1,
  toInt2q8uldh7sc951 as toInt_0,
  toDouble1kn912gjoizjp as toDouble,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
  TimedValuew9j01dao9jci as TimedValue,
  listOfvhqybd2zx248 as listOf_0,
  println2shhhgwwt4c61 as println,
  emptyList1g2z5xcrvp2zy as emptyList,
  until1jbpn0z3f8lbg as until,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  first58ocm7j58k3q as first_0,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  firstOrNull1982767dljvdy as firstOrNull_0,
  copyOfRange3alro60z4hhf8 as copyOfRange,
  toList2z3tifmtru5ra as toList_0,
  emptyMapr06gerzljqtm as emptyMap,
  last1vo29oleiqj36 as last,
  THROW_IAE23kobfj9wdoxr as THROW_IAE,
  getProgressionLastElement2w30kdy2w5nkt as getProgressionLastElement,
  isNumberiramasdbon0i as isNumber,
  toShort36kaw0zjdq3ex as toShort,
  Char__plus_impl_qi7pgjkmqmcttgys79 as Char__plus_impl_qi7pgj,
  Default_getInstancegttbt9h1yt0q as Default_getInstance,
  step18s9qzr5xwxat as step,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toList383f556t1dixk as toList_1,
  boxApply1qmzdb3dh90hg as boxApply,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  Long2qws0ah9gnpki as Long,
  copyOfRange1v9olvyjr7c0r as copyOfRange_0,
  repeat2w4c6j8zoq09o as repeat,
  getOrNull1d60i0672n7ns as getOrNull,
  joinToString1cxrrlmo0chqs as joinToString,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  primitiveArrayConcatwxgknw08pmlb as primitiveArrayConcat,
  toIntArray27j90pvfixv10 as toIntArray,
  first34dru09vyikub as first_1,
  getOrNullef5jbxih7r4f as getOrNull_0,
  lastOrNullxgbdyo3mdsps as lastOrNull,
  toLongw1zpgk99d84b as toLong,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  addAll1k27qatfgp3k5 as addAll,
  distinct10qe1scfdvu5k as distinct,
  sortedWith2csnbbb21k0lg as sortedWith,
  first1vi3grnpj1175 as first_2,
  toSet2orjxp16sotqu as toSet,
  Exceptiondt2hlxn7j7vw as Exception,
  minus27abgkurcn6u0 as minus,
  CancellationException3b36o9qz53rgr as CancellationException,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  setOf1u3mizs95ngxo as setOf_0,
  plus1nh85pok677ot as plus_0,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  Duration5ynfiptaqcrg as Duration,
  Duration__toString_impl_8d916b13ohvvi8wucz4 as Duration__toString_impl_8d916b,
  toMapcf6xfku344cz as toMap_0,
  toIntArray2d4xwvtjb01mq as toIntArray_0,
  abs1kdzbjes1idip as abs,
  lastOrNull1aq5oz189qoe1 as lastOrNull_0,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  lastOrNulllcnpzslswkag as lastOrNull_1,
  isBlank1dvkhjjvox3p0 as isBlank,
  trimStart5ewg8zf6cs5u as trimStart,
  trimEnd17pt8cbotbalj as trimEnd,
  contains2el4s70rdq4ld as contains_0,
  Regexxgw0gjiagf4z as Regex,
  drop3na99dw9feawf as drop,
  plus20p0vtfmu0596 as plus_1,
  removeLast3759euu1xvfa3 as removeLast,
  dropLast1vpiyky649o34 as dropLast,
  coerceAtLeastklytehohcpeq as coerceAtLeast_0,
  getOrNull1go7ef9ldk0df as getOrNull_1,
  fill34ox8qmmmh3u3 as fill_0,
  coerceIn10f36k81le1mm as coerceIn,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  KProperty02ce7r476m8633 as KProperty0,
  ValueTimeMark__minus_impl_f87sko6qoir9myg4l1 as ValueTimeMark__minus_impl_f87sko,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  intercepted2ogpsikxxj4u0 as intercepted,
  copyToArray2j022khrow2yi as copyToArray,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_instanceeeaudfwfrq87 as Companion_instance_0,
  RectSlicec5msorw5q4el as RectSlice,
  ImageDoNotFitException2gm4q4wt4lh58 as ImageDoNotFitException,
  _SliceOrientation___get_flipX__impl__lgb7bx2vjjbyotgryi3 as _SliceOrientation___get_flipX__impl__lgb7bx,
  _SliceOrientation___get_rotation__impl__m65r0o2xos42p9chv89 as _SliceOrientation___get_rotation__impl__m65r0o,
  Companion_getInstance2kfoysd3on6as as Companion_getInstance_0,
  _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq2n27zigfr3r41 as _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq,
  VectorPath1chx1oqdw6sb9 as VectorPath,
  applyTransform1vhqlmleb4dce as applyTransform,
  getCurves2yjahbp68cxj3 as getCurves,
  toBezier1cphbqwqpx0d3 as toBezier,
  plus1r33v70e4ipd7 as plus_2,
  get_immutablepxpdoj6e54ll as get_immutable,
  arc$default4sjbw0e0mkug as arc$default,
  VectorBuilder2g8a28qau4ty9 as VectorBuilder,
  SliceOrientation5szkqzxt7oev as SliceOrientation,
  Winding_EVEN_ODD_getInstancemyc10vdu2m52 as Winding_EVEN_ODD_getInstance,
  StrokeToFill127v8ehrppf9e as StrokeToFill,
  strokeToFill2j5wye7yyxd99 as strokeToFill,
  Companion_getInstance154uzbkgf0e3s as Companion_getInstance_1,
  LineScaleMode_NORMAL_getInstance1wxue9rdh6hry as LineScaleMode_NORMAL_getInstance,
  LineCap_BUTT_getInstancetv7srcehoz43 as LineCap_BUTT_getInstance,
  LineJoin_MITER_getInstance35lw9h64apo2h as LineJoin_MITER_getInstance,
  Winding_NON_ZERO_getInstance38kh1ikwl48ly as Winding_NON_ZERO_getInstance,
  line3u2mk0n2uhnlh as line,
  isEmpty3b7xkdp0by4c8 as isEmpty,
  rect1tyihxx4629c2 as rect,
  rect31bppuugx2wch as rect_0,
  rect3nqbmqh4a4l2a as rect_1,
  arc1vjl2w7wqv39k as arc,
  circle1t8rrxfrm1ku9 as circle,
  rMoveTo38ittbd8h3wn5 as rMoveTo,
  rLineTo1671hm1vy9pme as rLineTo,
  transformed2t6vo3srmaaf9 as transformed,
  toCurvesList2ibv2opnrpohn as toCurvesList,
  ProjectedPoint37gr1oedqap6n as ProjectedPoint,
  Companion_getInstance3d17rumlj92i7 as Companion_getInstance_2,
  write11msa0gyjblqp as write,
  get_isConvex3nm4n5empqw0n as get_isConvex,
  strokeToFill34bvxzbc34djp as strokeToFill_0,
  get_mutableqzgwrema46rx as get_mutable,
  StrokeInfo1cunqczl43ffk as StrokeInfo,
  RastScale3rcmuinujik1d as RastScale,
  PolygonScanline1ccjpk6mqxyxd as PolygonScanline,
  IntSegmentSet3br6yjcm9q2bd as IntSegmentSet,
} from './korlibs-math-root-korlibs-math.mjs';
import {
  MarginInt3jiec8xsxkfd as MarginInt,
  RectangleInt3lmu13ytuf5lk as RectangleInt,
  SizeInte6w85oa6mz6v as SizeInt,
  Companion_instanceu31qrc8c1r0r as Companion_instance_1,
  Companion_getInstancenbeyvbsm21qs as Companion_getInstance_3,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_4,
  Vector2D378fe5rov8fgw as Vector2D,
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_5,
  Line2D2pf35pcx71ncp as Line2D,
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance_6,
  Companion_getInstance2yu48324co92b as Companion_getInstance_7,
  _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i as _BoundsBuilder___get_bounds__impl__s1l1gx,
  BoundsBuilder__plus_impl_cz7f7xqnc8b6uzo82y as BoundsBuilder__plus_impl_cz7f7x,
  Rectangle3q03woyn9k8x1 as Rectangle,
  BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm as BoundsBuilder__plus_impl_cz7f7x_0,
  Scale2cm697xlulcp5 as Scale,
  toFloat3b315y36g90cd as toFloat,
  Matrix1p940sdz227jj as Matrix,
  Companion_getInstance3rze5babd97ff as Companion_getInstance_8,
  Angle_between72970e1vlen9 as Angle_between,
  Angle__unaryMinus_impl_7901fruk5m76f5kg06 as Angle__unaryMinus_impl_7901fr,
  get_degrees3czcd4ojw4i as get_degrees,
  Angle__div_impl_ut2btd19ndx9mxcgcss as Angle__div_impl_ut2btd,
  Angle2itorpob18n08 as Angle,
  Angle__hashCode_impl_szcndtx0rhatnvuhb1 as Angle__hashCode_impl_szcndt,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
  BoundsBuilder__xminOr_impl_k3l1m233j5xey4uzzri as BoundsBuilder__xminOr_impl_k3l1m2,
  BoundsBuilder__toString_impl_fmvxh7qh65bafrb2p as BoundsBuilder__toString_impl_fmvxh7,
  BoundsBuilder__hashCode_impl_649zbo2cbmgnd4y2see as BoundsBuilder__hashCode_impl_649zbo,
  BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3 as BoundsBuilder__plus_impl_cz7f7x_1,
  get_radians391vbqqjsolq6 as get_radians,
  _Angle___get_degrees__impl__qg56vw2n539uvc01e1n as _Angle___get_degrees__impl__qg56vw,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  _Angle___init__impl__g23q1m36yxttgnpy5tv as _Angle___init__impl__g23q1m,
  _Angle___get_ratio__impl__ap3on435dv91f5cbp85 as _Angle___get_ratio__impl__ap3on4,
  BoundsBuilder__boundsOrNull_impl_se9lyg1z0iqowyff423 as BoundsBuilder__boundsOrNull_impl_se9lyg,
  scaled2eehd42i2trq9 as scaled,
  MatrixType_IDENTITY_getInstance26n3n49ggvwm4 as MatrixType_IDENTITY_getInstance,
  _Angle___get_radians__impl__n00yt518seywpfbf9fr as _Angle___get_radians__impl__n00yt5,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  setExtra314k0z6q35eku as setExtra,
  hasExtra1969mplo13qgb as hasExtra,
  Mixin3lmkm5hum2vdj as Mixin,
  Property1m5vulkepgwzd as Property,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  toIntFloor3t307m2tavlm8 as toIntFloor,
  toIntCeiltm5lvaa6k4k9 as toIntCeil,
  toRatiolga1a9coidva as toRatio,
  clamp31lhm66c28ic8 as clamp,
  ilog23dbvpk38jf7rc as ilog2,
  extract2vhru1ihy4ogl as extract,
  insertm9bp9ll4cml3 as insert,
  clamp011ml7wx1d2b7sp as clamp01,
  min2wcdwdef93gdl as min,
  maxfuu7ju0dv4mx as max,
  convertRange378kqy75r4gq5 as convertRange,
  clampdicp8njiht45 as clamp_0,
  toIntFloor2i5mxseifeud5 as toIntFloor_0,
  toIntRoundjnzmk86x1qp5 as toIntRound,
  divCeil2r4o5lbvnv4lh as divCeil,
  Ratio__toFloat_impl_1ftup533krasllqk7v1 as Ratio__toFloat_impl_1ftup5,
  clampUByte16elok6pzd6c5 as clampUByte,
  get_niceStr1tlwtz2l2j4my as get_niceStr,
  interpolatexm8yaf0iv9q9 as interpolate,
  clamp012a0sd8pj80ati as clamp01_0,
  toIntCeil3h286vm49zgwd as toIntCeil_0,
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_9,
  niceStr1mw27wr6fq0ek as niceStr,
  get_niceStr3crhxydmlnaoj as get_niceStr_0,
  extractSignedx6cuhlj55jv4 as extractSigned,
  insert163hf9bvod0wg0m as insert16,
  toIntRound1mv0y8x9hh1p4 as toIntRound_0,
  _Ratio___init__impl__9mwvn2mn8x7j48jyfs as _Ratio___init__impl__9mwvn2,
  clamp1qclpmpfxm7xb as clamp_1,
  toRatio1hooqit5gulhr as toRatio_0,
  interpolate35pbs3ac913y4 as interpolate_0,
  Ratio__times_impl_ucdh7y2x1w5kf040xma as Ratio__times_impl_ucdh7y,
  Ratio__toDouble_impl_o7epze2ppsc3gplivz8 as Ratio__toDouble_impl_o7epze,
  _Ratio___init__impl__9mwvn224skkn3fz6cfs as _Ratio___init__impl__9mwvn2_0,
  umodgae5ifx362au as umod,
  insert8f3zk23r8x9da as insert8,
  toStringDecimalw23mr08es1e2 as toStringDecimal,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  IntArray23680o40e0fgt8 as IntArray2,
  Companion_instancelqpzd9anuk16 as Companion_instance_2,
  Companion_instance3ldriv9x4zcjm as Companion_instance_3,
  FloatArray2beehiaucxmzd as FloatArray2,
  GenericSubList2rec7qqyf06nw as GenericSubList,
  GenericListIterator397gjg9p2xwl5 as GenericListIterator,
  toIntMapp1jij98esrcm as toIntMap,
  associateByInt3vmv30txx5avl as associateByInt,
  IntMap2d9g6f5pyaoc2 as IntMap,
  IntArrayList3liuagbdnwmna as IntArrayList,
  reverse22fe0u1pwl2c6 as reverse,
  DoubleArrayList3by0we6lhx26x as DoubleArrayList,
  IntIntMap3mvg5iqgd5t3z as IntIntMap,
  getCyclic28wvgqye98jqx as getCyclic,
  toIntArrayList3jlt4o6tyleu as toIntArrayList,
  toDeque2gx2crptp8sro as toDeque,
  TGenDeque2zx9g0ftfbw19 as TGenDeque,
  doubleArrayListOfkj3z9zq4pobs as doubleArrayListOf,
  DoubleVectorArrayListq54dfthnqi2t as DoubleVectorArrayList,
  intArrayListOf18h0hna7wb0zr as intArrayListOf,
  _TGenStack___init__impl__yynjgt2kqnbzr6sil9y as _TGenStack___init__impl__yynjgt,
  TGenStack__push_impl_9yh33t21dxxdiycat5m as TGenStack__push_impl_9yh33t,
  TGenStack__pop_impl_qisxa01c9hqlgdxaps5 as TGenStack__pop_impl_qisxa0,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  invalidOp1stebxh2m3n07 as invalidOp,
  NativeImageRefqizti6jm75 as NativeImageRef,
  reserved38luap2kxmc9d as reserved,
  get_unreachable2fi7msfg0vgzd as get_unreachable,
  get_reserved2d9gxjta2y60d as get_reserved,
  get_invalidOp31x7cztl0dv9m as get_invalidOp,
  Endian_BIG_ENDIAN_getInstance3qe1a0k2pp7jd as Endian_BIG_ENDIAN_getInstance,
  Endian_LITTLE_ENDIAN_getInstance29hybk19wzxil as Endian_LITTLE_ENDIAN_getInstance,
  FileNotFoundException2tz8ve019qipn as FileNotFoundException,
  ByteArrayBuilderyrflhqjz64ju as ByteArrayBuilder,
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance_10,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  arraycopy14jict0dth60o as arraycopy,
  UByteArrayInt__get_impl_px6q8a2tesw5a6a7pt2 as UByteArrayInt__get_impl_px6q8a,
  UByteArrayInt__set_impl_gn45323mc9aqt29pp9p as UByteArrayInt__set_impl_gn4532,
  arraycopy3czrd9re36wzt as arraycopy_0,
  _UByteArrayInt___init__impl__xif7bu3la1vncefaitd as _UByteArrayInt___init__impl__xif7bu,
  getU83agrw8yj0shar as getU8,
  _UShortArrayInt___init__impl__kdofb8124zcs6bgqfxc as _UShortArrayInt___init__impl__kdofb8,
  UShortArrayInt__set_impl_38wgvc2wqa90g1ifa1l as UShortArrayInt__set_impl_38wgvc,
  UShortArrayInt__get_impl_ciz20k3q1wtux9fkamc as UShortArrayInt__get_impl_ciz20k,
  getU16LE2cizldw8qp53x as getU16LE,
  getU16BE2rszf3doox5o as getU16BE,
  getU24LEi3x1z5ajbdbv as getU24LE,
  getU24BE36pml41y2814b as getU24BE,
  getS32LE1pxm9wohin3g8 as getS32LE,
  getS32BE5aphh7sm8f2q as getS32BE,
  getU1616fejrhhqwfv2 as getU16,
  getS3225c4j90s7n16a as getS32,
  _UByteArrayInt___init__impl__xif7bu3qwnn3s49fymk as _UByteArrayInt___init__impl__xif7bu_0,
  asByteArray1mw554k0vpuh5 as asByteArray,
  UByteArrayInt__getOrElse_impl_f0pf7216mblxgilcglu as UByteArrayInt__getOrElse_impl_f0pf72,
  _UByteArrayInt___get_size__impl__bcjnte1riayqw17gpkp as _UByteArrayInt___get_size__impl__bcjnte,
  UByteArrayInt247ue4nx0pkns as UByteArrayInt,
  asInt32Arrayf0ml2lp92o3m as asInt32Array,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  substr2jonrcqd8qwvx as substr,
  substr1q77u5lo4evr6 as substr_0,
  unquote1kjyk5vajgaow as unquote,
  get_UTF82geyfhi1l22xl as get_UTF8,
  get_UTF16_BE3rxrt7v8707y4 as get_UTF16_BE,
  Companion_getInstance6aal8l6ipt6u as Companion_getInstance_11,
  Charsets_instance2e55bmt8joybi as Charsets_instance,
  ASCII_getInstancey3nspn0nzsaa as ASCII_getInstance,
  toString2x583ovdqfjci as toString_2,
  splitInChunks2h1zfocl4rvqy as splitInChunks,
  splitKeep2hxk3xif9u3vx as splitKeep,
  WStringReader2bukzqxb5clbi as WStringReader,
  _WChar___get_codePoint__impl__c8brwu2vjc0ffpg6ich as _WChar___get_codePoint__impl__c8brwu,
  WStringambx64bqrrmq as WString,
} from './korlibs-string-root-korlibs-string.mjs';
import {
  appendHexByte1xtb46j7ij290 as appendHexByte,
  fromBase6434uveajlhn2ar as fromBase64,
  get_hex32p4ssq0y1xxx as get_hex,
  get_hex3lw8e6gsph9rg as get_hex_0,
} from './korlibs-encoding-root-korlibs-encoding.mjs';
import {
  Xmlepssdknidwxh as Xml,
  get12f8xnsftqcwn as get,
  Companion_getInstance345a0ojzj45ct as Companion_getInstance_12,
} from './korlibs-serialization-root-korlibs-serialization.mjs';
import {
  get_dynw5edstkdie96 as get_dyn,
  Dyn__get_impl_6l2p802ap79h85reiiq as Dyn__get_impl_6l2p80,
  Dyn__toDoubleDefault_impl_fspogf1rn8v9q6wbx2 as Dyn__toDoubleDefault_impl_fspogf,
  Dyn__toStringOrNull_impl_7e6cgy1b2jkpzd6lmvg as Dyn__toStringOrNull_impl_7e6cgy,
  Dyn__toList_impl_pxssgreuo7vfsc7aqn as Dyn__toList_impl_pxssgr,
  Dyn__toString_impl_9l0v3s3bs6vkriyagvh as Dyn__toString_impl_9l0v3s,
  _Dyn___get_int__impl__sh8lhmx5zxcvkgp62x as _Dyn___get_int__impl__sh8lhm,
} from './korlibs-dyn-root-korlibs-dyn.mjs';
import {
  Companion_getInstance3mocpl8hga9iq as Companion_getInstance_13,
  uncompress3ofkd276wd0zn as uncompress,
} from './korlibs-compression-root-korlibs-compression.mjs';
import {
  openFastStream2r4uuohoj0wpo as openFastStream,
  toSyncStream3g0dpktigjx33 as toSyncStream,
  FastByteArrayInputStream1jjm4ufd0tkh5 as FastByteArrayInputStream,
  sliceHere162e6oimkowhf as sliceHere,
  readString3h14fm47a2tde as readString,
  readU162q6ft3yjssyvs as readU16,
  readS325wl7ebgpu38s as readS32,
  readBytesExact305h8zdeltghk as readBytesExact,
  sliceStart186j1d4dpd1wx as sliceStart,
  readStringzzxx8hll1ncys as readStringz,
  skipToAlignusebk6ndjvs1 as skipToAlign,
  openSync2m3qn99fqytu0 as openSync,
  sliceStart237tx6t7cytus as sliceStart_0,
  readString3106ot9qwcir2 as readString_0,
  readBytes3l26albs0coyl as readBytes,
  readAll1pkrq4jwoqns4 as readAll,
  readS32BE1vkzsiuy9pof1 as readS32BE,
  get_eofaukbsoaf5jcj as get_eof,
  readStringz3jxaogr49n5ys as readStringz_0,
  readStream3s64ivrsklqly as readStream,
  readU82o15i0epsnmc5 as readU8,
  readAll3m5rixujsbctr as readAll_0,
  openAsync37anb1e84urmo as openAsync,
} from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import {
  Level_DEBUG_getInstancewzibhbcrmy7h as Level_DEBUG_getInstance,
  Companion_getInstance3qvmjlq9y5ia6 as Companion_getInstance_14,
  Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance,
  Level_ERROR_getInstance18552yzhsfztk as Level_ERROR_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  get_baseName2yf63efofm8te as get_baseName,
  readAsSyncStream2ficq0l6vek7d as readAsSyncStream,
  getUnderlyingUnscapedFilej1r5tpfxb7a7 as getUnderlyingUnscapedFile,
  UrlVfs292f1sja450ff as UrlVfs,
  LocalVfs18bzski76hhpp as LocalVfs,
} from './korlibs-io-vfs-root-korlibs-io-vfs.mjs';
import { atomic$ref$130aurmcwdfdf1 as atomic$ref$1 } from './kotlinx-atomicfu.mjs';
import {
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
  runBlockingNoSuspensions25hsuevf2mle as runBlockingNoSuspensions,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  get_fastSecondsxsf72e0ltu4j as get_fastSeconds,
  toDuration15w5sljvx2ut2 as toDuration_0,
  get_fast37cu8s8qwnuyi as get_fast,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  Companion_instance3mhfp4g0i6mgz as Companion_instance_4,
  decodeBytes3q5q9i2zh0cy6 as decodeBytes,
} from './korlibs-image-core-root-korlibs-image-core.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from './kotlinx-coroutines-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
var log2 = Math.log2;
//endregion
//region block: pre-declaration
class GrowMethod extends Enum {}
class Entry {
  constructor(slice, data) {
    this.b3w_1 = slice;
    this.c3w_1 = data;
  }
  toString() {
    return 'Entry(slice=' + this.b3w_1.toString() + ', data=' + toString(this.c3w_1) + ')';
  }
  hashCode() {
    var result = this.b3w_1.hashCode();
    result = imul(result, 31) + (this.c3w_1 == null ? 0 : hashCode(this.c3w_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry))
      return false;
    var tmp0_other_with_cast = other instanceof Entry ? other : THROW_CCE();
    if (!this.b3w_1.equals(tmp0_other_with_cast.b3w_1))
      return false;
    if (!equals(this.c3w_1, tmp0_other_with_cast.c3w_1))
      return false;
    return true;
  }
}
class MutableAtlas {
  static g3x(binPacker, border, premultiplied, allowToGrow, growMethod) {
    border = border === VOID ? 2 : border;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    allowToGrow = allowToGrow === VOID ? true : allowToGrow;
    growMethod = growMethod === VOID ? GrowMethod_NEW_IMAGES_getInstance() : growMethod;
    var $this = createThis(this);
    $this.d3w_1 = binPacker;
    $this.e3w_1 = border;
    $this.f3w_1 = premultiplied;
    $this.g3w_1 = allowToGrow;
    $this.h3w_1 = growMethod;
    $this.i3w_1 = MarginInt.v28($this.e3w_1);
    $this.j3w_1 = Bitmap32.e3x($this.m2i(), $this.n2i(), VOID, $this.f3w_1);
    $this.k3w_1 = arrayListOf([$this.j3w_1]);
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.l3w_1 = ArrayList.h1();
    $this.m3w_1 = LinkedHashMap.bc();
    $this.n3w_1 = null;
    return $this;
  }
  static h3x(width, height, border, premultiplied, allowToGrow, growMethod) {
    width = width === VOID ? 2048 : width;
    height = height === VOID ? width : height;
    border = border === VOID ? 2 : border;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    allowToGrow = allowToGrow === VOID ? true : allowToGrow;
    growMethod = growMethod === VOID ? GrowMethod_NEW_IMAGES_getInstance() : growMethod;
    return this.g3x(Companion_instance_0.m3e(width, height), border, premultiplied, allowToGrow, growMethod);
  }
  m2i() {
    return numberToInt(this.d3w_1.m2i());
  }
  n2i() {
    return numberToInt(this.d3w_1.n2i());
  }
  e1() {
    return this.l3w_1.e1();
  }
  i3x(bmp, data, name) {
    return this.f3x(slice(bmp, VOID, name), data, name);
  }
  j3x(bmp, data, name, $super) {
    name = name === VOID ? 'Slice' + this.e1() : name;
    return $super === VOID ? this.i3x(bmp, data, name) : $super.i3x.call(this, bmp, data, name);
  }
  f3x(bmp, data, name) {
    var tmp = get_bmp(bmp);
    if (!(tmp instanceof Bitmap32)) {
      return this.i3x(extract_0(bmp).x3x(), data, name);
    }
    if (!(bmp instanceof RectSlice))
      THROW_CCE();
    try {
      var rname = name == null ? 'Slice' + this.e1() : name;
      var isEmpty = isFullyTransparent(bmp);
      var entry = null;
      if (isEmpty && !(this.n3w_1 == null)) {
        var bigEmptySlice = ensureNotNull(this.n3w_1).b3w_1;
        if (bigEmptySlice.b3g_1 >= bmp.b3g_1 && bigEmptySlice.c3g_1 >= bmp.c3g_1) {
          entry = new Entry(bigEmptySlice.l3h(RectangleInt.u2e(0, 0, bmp.b3g_1, bmp.c3g_1)), data);
        }
      }
      if (entry == null) {
        var rect = this.d3w_1.h2r(bmp.b3g_1 + imul(this.e3w_1, 2), bmp.c3g_1 + imul(this.e3w_1, 2));
        var slice = sliceWithSize(this.j3w_1, numberToInt(rect.v25() + this.e3w_1), numberToInt(rect.x25() + this.e3w_1), bmp.b3g_1, bmp.c3g_1, rname);
        var dstX = slice.v25();
        var dstY = slice.x25();
        var boundsWithBorder = get_bounds_0(slice).v2e(this.i3w_1);
        // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
        var this_0 = this.j3w_1;
        if (true) {
          this_0.y3x();
        }
        var result;
        try {
          // Inline function 'korlibs.image.atlas.MutableAtlas.add.<anonymous>' call
          this.j3w_1.z3x(bmp, dstX, dstY);
          expandBorder(this.j3w_1, slice.t3f_1, this.e3w_1);
        }finally {
          result = true ? this_0.a3y(boundsWithBorder) : 0;
        }
        entry = new Entry(slice, data);
        if (this.n3w_1 == null || bmp.i2f() > ensureNotNull(this.n3w_1).b3w_1.i2f()) {
          this.n3w_1 = entry;
        }
      }
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = this.l3w_1;
      var element = entry;
      this_1.h(element);
      // Inline function 'kotlin.collections.set' call
      var this_2 = this.m3w_1;
      var value = entry;
      this_2.e3(rname, value);
      return entry;
    } catch ($p) {
      if ($p instanceof ImageDoNotFitException) {
        var e = $p;
        if (!this.g3w_1)
          throw e;
        growAtlas(this, bmp);
        return this.f3x(bmp, data, name);
      } else {
        throw $p;
      }
    }
  }
  b3y(bmp, data, name, $super) {
    name = name === VOID ? bmp.w3f_1 : name;
    return $super === VOID ? this.f3x(bmp, data, name) : $super.f3x.call(this, bmp, data, name);
  }
}
class Bitmap {
  static c3y(width, height, bpp, premultiplied, backingArray) {
    var $this = createThis(this);
    $this.k3x_1 = new Mixin();
    $this.l3x_1 = width;
    $this.m3x_1 = height;
    $this.n3x_1 = bpp;
    $this.o3x_1 = backingArray;
    $this.p3x_1 = RectangleInt.u2e(0, 0, $this.l3x_1, $this.m3x_1);
    $this.q3x_1 = null;
    $this.r3x_1 = premultiplied;
    $this.s3x_1 = false;
    var tmp = $this;
    tmp.t3x_1 = lazy(Bitmap$tempInts$delegate$lambda($this));
    $this.u3x_1 = 0;
    $this.v3x_1 = null;
    $this.w3x_1 = false;
    return $this;
  }
  vx(_set____db54di) {
    this.k3x_1.vx(_set____db54di);
  }
  wx() {
    return this.k3x_1.wx();
  }
  e1() {
    return SizeInt.k2g(this.l3x_1, this.m3x_1);
  }
  d3y() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t3x_1;
    tempInts$factory();
    return this_0.r1();
  }
  e3y() {
    return _RgbaArray___init__impl__oib4y4(this.d3y());
  }
  f3y() {
    return imul(this.l3x_1, this.n3x_1) / 8 | 0;
  }
  i2f() {
    return imul(this.l3x_1, this.m3x_1);
  }
  g3y(x, y) {
    return imul(y, this.l3x_1) + x | 0;
  }
  h3y() {
    if (!(this.v3x_1 == null)) {
      this.v3x_1 = null;
    }
  }
  y3x() {
    return Unit_instance;
  }
  a3y(rect) {
    if (this.v3x_1 == null)
      this.v3x_1 = rect;
    else
      this.v3x_1 = Companion_instance_1.b2f(ensureNotNull(this.v3x_1), rect);
    this.u3x_1 = this.u3x_1 + 1 | 0;
    return this.u3x_1;
  }
  i3y(x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            out[_unary__edvuaz] = _RGBA___get_value__impl__hhco8v(this.j3y(x0 + x | 0, y0 + y | 0));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  }
  k3y(x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp = x0 + x | 0;
            var tmp_0 = y0 + y | 0;
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            this.l3y(tmp, tmp_0, _RGBA___init__impl__lqpay5(out[_unary__edvuaz]));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  }
  m3y(x, y, width, height, out, offset, $super) {
    offset = offset === VOID ? 0 : offset;
    var tmp;
    if ($super === VOID) {
      this.k3y(x, y, width, height, out, offset);
      tmp = Unit_instance;
    } else {
      tmp = $super.k3y.call(this, x, y, width, height, out, offset);
    }
    return tmp;
  }
  n3y(x, y, v) {
    if (this.r3x_1) {
      this.l3y(x, y, asNonPremultiplied(_RGBA___get_premultiplied__impl__3bulqc(v)));
    } else {
      this.l3y(x, y, v);
    }
  }
  o3y(x, y) {
    var tmp;
    if (this.r3x_1) {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = asPremultiplied(this.j3y(x, y));
      tmp = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
    } else {
      tmp = this.j3y(x, y);
    }
    return tmp;
  }
  p3y(x, y, color) {
    this.l3y(x, y, _RGBA___init__impl__lqpay5(color));
  }
  q3y(x, y) {
    return _RGBA___get_value__impl__hhco8v(this.j3y(x, y));
  }
  r3y(x, y) {
    var x0 = toIntFloor(x);
    var y0 = toIntFloor(y);
    if (x0 < 0 || y0 < 0 || x0 >= this.l3x_1 || y0 >= this.m3x_1)
      return Colors_getInstance().x3y_1;
    var x1 = toIntCeil(x);
    var y1 = toIntCeil(y);
    var x1Inside = x1 < (this.l3x_1 - 1 | 0);
    var y1Inside = y1 < (this.m3x_1 - 1 | 0);
    // Inline function 'korlibs.math.fract' call
    var xratio = x - toIntFloor(x);
    // Inline function 'korlibs.math.fract' call
    var yratio = y - toIntFloor(y);
    var c00 = this.j3y(x0, y0);
    var c10 = x1Inside ? this.j3y(x1, y0) : c00;
    var c01 = y1Inside ? this.j3y(x0, y1) : c00;
    var c11 = x1Inside && y1Inside ? this.j3y(x1, y1) : c01;
    return Companion_getInstance_22().p44(c00, c10, c01, c11, toRatio(xratio), toRatio(yratio));
  }
  q44(srcX, srcY, dst, dstX, dstY, width, height) {
    var src = this;
    var srcX0 = src.r44(srcX);
    var srcX1 = src.r44(srcX + width | 0);
    var srcY0 = src.s44(srcY);
    var srcY1 = src.s44(srcY + height | 0);
    var dstX0 = dst.r44(dstX);
    var dstX1 = dst.r44(dstX + width | 0);
    var dstY0 = dst.s44(dstY);
    var dstY1 = dst.s44(dstY + height | 0);
    var srcX_0 = srcX0;
    var srcY_0 = srcY0;
    var dstX_0 = dstX0;
    var dstY_0 = dstY0;
    // Inline function 'kotlin.math.min' call
    var a = srcX1 - srcX0 | 0;
    var b = dstX1 - dstX0 | 0;
    var width_0 = Math.min(a, b);
    // Inline function 'kotlin.math.min' call
    var a_0 = srcY1 - srcY0 | 0;
    var b_0 = dstY1 - dstY0 | 0;
    var height_0 = Math.min(a_0, b_0);
    this.t44(srcX_0, srcY_0, dst, dstX_0, dstY_0, width_0, height_0);
  }
  t44(srcX, srcY, dst, dstX, dstY, width, height) {
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.i3y(srcX, srcY + y | 0, width, 1, this.d3y(), 0);
        dst.k3y(dstX, dstY + y | 0, width, 1, this.d3y(), 0);
      }
       while (inductionVariable < height);
  }
  u44(x) {
    return x >= 0 && x < this.l3x_1;
  }
  v44(y) {
    return y >= 0 && y < this.m3x_1;
  }
  w44(x, y) {
    return this.u44(x) && this.v44(y);
  }
  x44(x) {
    return clamp(x, 0, this.l3x_1 - 1 | 0);
  }
  y44(y) {
    return clamp(y, 0, this.m3x_1 - 1 | 0);
  }
  r44(x) {
    return clamp(x, 0, this.l3x_1);
  }
  s44(y) {
    return clamp(y, 0, this.m3x_1);
  }
  z44() {
    var inductionVariable = 0;
    var last = this.m3x_1 / 2 | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.a45(y, (this.m3x_1 - y | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  }
  b45() {
    var inductionVariable = 0;
    var last = this.l3x_1 / 2 | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.c45(x, (this.l3x_1 - x | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  }
  d45(rotation) {
    var tmp;
    switch (rotation.n3_1) {
      case 0:
        tmp = this.sx();
        break;
      case 1:
        tmp = this.e45().b45();
        break;
      case 2:
        tmp = this.e45().b45().e45().b45();
        break;
      case 3:
        tmp = this.e45().z44();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  f45(orientation) {
    var out = this.sx();
    if (_SliceOrientation___get_flipX__impl__lgb7bx(orientation)) {
      out.b45();
    }
    return out.d45(_SliceOrientation___get_rotation__impl__m65r0o(orientation));
  }
  e45() {
    var temp = new IntArray2(this.l3x_1, this.m3x_1, readPixelsUnsafe(this, 0, 0, this.l3x_1, this.m3x_1));
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width = this.m3x_1;
    var height = this.l3x_1;
    var tmp = 0;
    var tmp_0 = imul(width, height);
    var tmp_1 = new Int32Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = 0;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var out = new IntArray2(width, height, isIntArray(tmp_2) ? tmp_2 : THROW_CCE());
    var inductionVariable = 0;
    var last = this.m3x_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.l3x_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            out.s2i(y, x, temp.p27(x, y));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.also' call
    var this_0 = this.g45(this.m3x_1, this.l3x_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap.transposed.<anonymous>' call
    this_0.m3y(0, 0, this.m3x_1, this.l3x_1, out.l2i_1);
    return this_0;
  }
  a45(y0, y1) {
    var inductionVariable = 0;
    var last = this.l3x_1;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.q3y(x, y0);
        var c1 = this.q3y(x, y1);
        this.p3y(x, y0, c1);
        this.p3y(x, y1, c0);
      }
       while (inductionVariable < last);
  }
  c45(x0, x1) {
    var inductionVariable = 0;
    var last = this.m3x_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.q3y(x0, y);
        var c1 = this.q3y(x1, y);
        this.p3y(x0, y, c1);
        this.p3y(x1, y, c0);
      }
       while (inductionVariable < last);
  }
  h45(antialiasing) {
    throw UnsupportedOperationException.aa('Not implemented context2d on Bitmap, please use NativeImage or Bitmap32 instead');
  }
  g45(width, height) {
    invalidOp('Unsupported createWithThisFormat (' + toString_0(this) + ')');
  }
  x3x() {
    // Inline function 'kotlin.also' call
    var this_0 = Bitmap32.e3x(this.l3x_1, this.m3x_1, VOID, this.r3x_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap.toBMP32.<anonymous>' call
    this.i3y(0, 0, this.l3x_1, this.m3x_1, this_0.b3x_1, 0);
    return this_0;
  }
  i45() {
    var tmp;
    if (this instanceof Bitmap32) {
      tmp = this;
    } else {
      tmp = this.x3x();
    }
    return tmp;
  }
  sx() {
    var out = this.g45(this.l3x_1, this.m3x_1);
    this.t44(0, 0, out, 0, 0, this.l3x_1, this.m3x_1);
    return out;
  }
}
class Companion {
  constructor() {
    Companion_instance_5 = this;
    this.s45_1 = Bitmap32.e3x(0, 0, VOID, true);
  }
  t45(width, height, value) {
    // Inline function 'kotlin.apply' call
    var this_0 = Bitmap32.e3x(width, height, VOID, true);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Companion.invoke.<anonymous>' call
    fill(this_0.b3x_1, _RGBAPremultiplied___get_value__impl__bqfhud(value));
    return this_0;
  }
  u45(width, height, premultiplied) {
    return Bitmap32.e3x(width, height, new Int32Array(imul(width, height)), premultiplied);
  }
  v45(src, srcChannel, dst, dstChannel) {
    var srcShift = srcChannel.z45_1;
    var dstShift = dstChannel.z45_1;
    var dstClear = dstChannel.b46_1;
    var dstData = dst.b3x_1;
    var srcData = src.b3x_1;
    var inductionVariable = 0;
    var last = dst.i2f();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = (srcData[n] >>> srcShift | 0) & 255;
        dstData[n] = dstData[n] & dstClear | c << dstShift;
      }
       while (inductionVariable < last);
  }
  c46(src, dst, dstChannel) {
    var destShift = imul(dstChannel.y45_1, 8);
    var destClear = ~(255 << destShift);
    var inductionVariable = 0;
    var last = dst.i2f();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = src.x46()[n] & 255;
        dst.b3x_1[n] = dst.b3x_1[n] & destClear | c << destShift;
      }
       while (inductionVariable < last);
  }
  y46(src, srcChannel, dst) {
    var shift = srcChannel.z45_1;
    var inductionVariable = 0;
    var last = src.i2f();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        dst.x46()[n] = toByte((src.b3x_1[n] >>> shift | 0) & 255);
      }
       while (inductionVariable < last);
  }
}
class Bitmap32$iterator$slambda {
  constructor(this$0) {
    this.q45_1 = this$0;
  }
  z46($this$iterator, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$iterator), $completion);
  }
  qd(p1, $completion) {
    return this.z46(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  }
}
class Bitmap32 extends Bitmap {
  static e3x(width, height, ints, premultiplied) {
    Companion_getInstance_15();
    ints = ints === VOID ? new Int32Array(imul(width, height)) : ints;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    var $this = this.c3y(width, height, 32, premultiplied, ints);
    $this.b3x_1 = ints;
    if ($this.b3x_1.length < imul(width, height))
      throw RuntimeException.ja('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + $this.b3x_1.length + '), area=' + imul(width, height));
    var tmp = $this;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    tmp.c3x_1 = new Int32Array(tmp$ret$0);
    $this.d3x_1 = RectangleInt.u2e(0, 0, width, height);
    return $this;
  }
  g45(width, height) {
    return Bitmap32.e3x(width, height, VOID, this.r3x_1);
  }
  t44(srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap32))
      return super.t44(srcX, srcY, dst, dstX, dstY, width, height);
    var src = this;
    var srcArray = src.b3x_1;
    var dstArray = dst.b3x_1;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        arraycopy(srcArray, src.g3y(srcX, srcY + y | 0), dstArray, dst.g3y(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  }
  a47(x, y, color) {
    this.n3y(x, y, color);
  }
  b47(x, y) {
    return this.o3y(x, y);
  }
  p3y(x, y, color) {
    this.b3x_1[this.g3y(x, y)] = color;
  }
  q3y(x, y) {
    return this.b3x_1[this.g3y(x, y)];
  }
  j3y(x, y) {
    return _RGBA___init__impl__lqpay5(this.q3y(x, y));
  }
  l3y(x, y, v) {
    return this.p3y(x, y, _RGBA___get_value__impl__hhco8v(v));
  }
  c47(n, color) {
    this.b3x_1[n] = this.r3x_1 ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(color)) : _RGBA___get_value__impl__hhco8v(color);
  }
  d47(n, color) {
    var tmp;
    if (this.r3x_1) {
      tmp = _RGBAPremultiplied___get_value__impl__bqfhud(color);
    } else {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(color);
      tmp = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
    }
    this.b3x_1[n] = tmp;
  }
  r45(n) {
    var tmp;
    if (this.r3x_1) {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = _RGBAPremultiplied___init__impl__uos02x(this.b3x_1[n]);
      tmp = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
    } else {
      tmp = _RGBA___init__impl__lqpay5(this.b3x_1[n]);
    }
    return tmp;
  }
  e47(n) {
    return this.r3x_1 ? _RGBAPremultiplied___init__impl__uos02x(this.b3x_1[n]) : _RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.b3x_1[n]));
  }
  f47(src, dx, dy, sleft, stop, sright, sbottom, mix_0) {
    var dst = this;
    var width = sright - sleft | 0;
    var height = sbottom - stop | 0;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var dstOffset = dst.g3y(dx, dy + y | 0);
        var srcOffset = src.g3y(sleft, stop + y | 0);
        if (mix_0) {
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < width)
            do {
              var x = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              dst.d47(dstOffset + x | 0, mix(dst.e47(dstOffset + x | 0), src.e47(srcOffset + x | 0)));
            }
             while (inductionVariable_0 < width);
        } else {
          if (dst.r3x_1 === src.r3x_1) {
            arraycopy(src.b3x_1, srcOffset, dst.b3x_1, dstOffset, width);
          } else if (!dst.r3x_1) {
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < width)
              do {
                var x_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                dst.c47(dstOffset + x_0 | 0, src.r45(srcOffset + x_0 | 0));
              }
               while (inductionVariable_1 < width);
          } else {
            var inductionVariable_2 = 0;
            if (inductionVariable_2 < width)
              do {
                var x_1 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                dst.d47(dstOffset + x_1 | 0, src.e47(srcOffset + x_1 | 0));
              }
               while (inductionVariable_2 < width);
          }
        }
      }
       while (inductionVariable < height);
  }
  g47(src, dx, dy, sleft, stop, sright, sbottom, mix) {
    var sleft_0 = sleft;
    var stop_0 = stop;
    var dx_0 = dx;
    var dy_0 = dy;
    if (dx_0 < 0) {
      sleft_0 = sleft_0 - dx_0 | 0;
      dx_0 = 0;
    }
    if (dy_0 < 0) {
      stop_0 = stop_0 - dy_0 | 0;
      dy_0 = 0;
    }
    var availableWidth = this.l3x_1 - dx_0 | 0;
    var availableHeight = this.m3x_1 - dy_0 | 0;
    // Inline function 'kotlin.math.min' call
    var b = sright - sleft_0 | 0;
    var awidth = Math.min(availableWidth, b);
    // Inline function 'kotlin.math.min' call
    var b_0 = sbottom - stop_0 | 0;
    var aheight = Math.min(availableHeight, b_0);
    this.f47(src, dx_0, dy_0, sleft_0, stop_0, sleft_0 + awidth | 0, stop_0 + aheight | 0, mix);
  }
  h47(mix, other, _dx, _dy) {
    this.g47(other, _dx, _dy, 0, 0, other.l3x_1, other.m3x_1, mix);
  }
  i47(color, x, y, width, height) {
    var x1 = this.x44(x);
    var x2 = this.x44((x + width | 0) - 1 | 0);
    var y1 = this.y44(y);
    var y2 = this.y44((y + height | 0) - 1 | 0);
    var colorInt = RGBA__premultipliedValue_impl_oja55q(color, this.r3x_1);
    var inductionVariable = y1;
    if (inductionVariable <= y2)
      do {
        var cy = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        fill(this.b3x_1, colorInt, this.g3y(x1, cy), this.g3y(x2, cy) + 1 | 0);
      }
       while (!(cy === y2));
  }
  j47(color, x, y, width, height, $super) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    width = width === VOID ? this.l3x_1 - x | 0 : width;
    height = height === VOID ? this.m3x_1 - y | 0 : height;
    var tmp;
    if ($super === VOID) {
      this.i47(color, x, y, width, height);
      tmp = Unit_instance;
    } else {
      tmp = $super.i47.call(this, new RGBA(color), x, y, width, height);
    }
    return tmp;
  }
  k47(src, dx, dy, mix) {
    var b = get_bounds_0(src);
    this.g47(get_bmp(src), dx, dy, b.v25(), b.x25(), b.w25(), b.y25(), mix);
  }
  l47(src, dx, dy) {
    return this.h47(false, src, dx, dy);
  }
  m47(src, dx, dy) {
    return this.h47(true, src, dx, dy);
  }
  z3x(src, dx, dy) {
    return this.k47(src, dx, dy, true);
  }
  n47(destination, input, source) {
    return Companion_getInstance_15().v45(input, source, this, destination);
  }
  o47(destination, input) {
    return Companion_getInstance_15().c46(input, this, destination);
  }
  p47(channel, out) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.extractChannel.<anonymous>' call
    Companion_getInstance_15().y46(this, channel, out);
    return out;
  }
  q47(channel, out, $super) {
    out = out === VOID ? Bitmap8.l48(this.l3x_1, this.m3x_1) : out;
    return $super === VOID ? this.p47(channel, out) : $super.p47.call(this, channel, out);
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.toString.<anonymous>' call
    this_0.ob('Bitmap32(');
    this_0.sg(this.l3x_1);
    this_0.ob(', ');
    this_0.sg(this.m3x_1);
    if (!(this.q3x_1 == null)) {
      this_0.ob(', name=');
      this_0.ob(this.q3x_1);
    }
    this_0.ob(')');
    return this_0.toString();
  }
  a45(y0, y1) {
    var s0 = this.g3y(0, y0);
    var s1 = this.g3y(0, y1);
    arraycopy(this.b3x_1, s0, this.c3x_1, 0, this.l3x_1);
    arraycopy(this.b3x_1, s1, this.b3x_1, s0, this.l3x_1);
    arraycopy(this.c3x_1, 0, this.b3x_1, s1, this.l3x_1);
  }
  sx() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.b3x_1.slice();
    return Bitmap32.e3x(this.l3x_1, this.m3x_1, tmp$ret$1, this.r3x_1);
  }
  h45(antialiasing) {
    return new Context2d(new Bitmap32Context2d(this, antialiasing));
  }
  m48() {
    return this.r3x_1 ? this : this.copyPremultiplied();
  }
  n48() {
    return !this.r3x_1 ? this : this.o48();
  }
  copyPremultiplied() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.sx();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.premultiplied.<anonymous>' call
    this_0.p48();
    return this_0;
  }
  o48() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.sx();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.depremultiplied.<anonymous>' call
    this_0.q48();
    return this_0;
  }
  p48() {
    if (this.r3x_1)
      return Unit_instance;
    this.r3x_1 = true;
    var inductionVariable = 0;
    var last = this.i2f();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.b3x_1[n] = _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.b3x_1[n])));
      }
       while (inductionVariable < last);
  }
  q48() {
    if (!this.r3x_1)
      return Unit_instance;
    this.r3x_1 = false;
    var inductionVariable = 0;
    var last = this.i2f();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
        var this_0 = _RGBAPremultiplied___init__impl__uos02x(this.b3x_1[n]);
        var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
        this.b3x_1[n] = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
      }
       while (inductionVariable < last);
  }
  a1() {
    return iterator(Bitmap32$iterator$slambda_0(this));
  }
  r48(x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy(_RgbaArray___get_ints__impl__u2kps1(data), 0, this.b3x_1, this.g3y(x, y), width);
    } else {
      var m = this.g3y(x, y);
      var inductionVariable = 0;
      if (inductionVariable < width)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.b3x_1[m] = _RgbaArray___get_ints__impl__u2kps1(data)[n];
          m = m + increment | 0;
        }
         while (inductionVariable < width);
    }
  }
  x3x() {
    return this;
  }
}
class Companion_0 {
  s48(src, srcX, srcY, dst, dstX, dstY, width, height) {
    return src.q44(srcX, srcY, dst, dstX, dstY, width, height);
  }
}
class BitmapIndexed extends Bitmap {
  static u48(bpp, width, height, bytes, palette) {
    bytes = bytes === VOID ? new Int8Array(imul(width, height) / (8 / bpp | 0) | 0) : bytes;
    palette = palette === VOID ? Companion_instance_11.t48(1 << bpp) : palette;
    var $this = this.c3y(width, height, bpp, false, bytes);
    $this.q46_1 = bytes;
    $this.r46_1 = palette;
    if ($this.q46_1.length < (imul(width, height) / (8 / bpp | 0) | 0))
      throw RuntimeException.ja('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + $this.x46().length + '), area=' + imul(width, height));
    var tmp = $this;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    tmp.s46_1 = new Int8Array(tmp$ret$0);
    $this.t46_1 = _UByteArrayInt___init__impl__xif7bu($this.x46());
    $this.u46_1 = 8 / bpp | 0;
    $this.v46_1 = ilog2($this.u46_1);
    $this.w46_1 = $this.u46_1 - 1 | 0;
    return $this;
  }
  x46() {
    return this.q46_1;
  }
  toString() {
    return 'BitmapIndexed(bpp=' + this.n3x_1 + ', width=' + this.l3x_1 + ', height=' + this.m3x_1 + ', clut=' + _RgbaArray___get_size__impl__imxef8(this.r46_1) + ')';
  }
  q3y(x, y) {
    return this.w48(this.g3y(x, y));
  }
  p3y(x, y, color) {
    return this.v48(this.g3y(x, y), color);
  }
  w48(n) {
    var iD = this.y48(n);
    var iM = this.z48(n);
    return extract(UByteArrayInt__get_impl_px6q8a(this.t46_1, iD), imul(this.n3x_1, iM), this.n3x_1);
  }
  v48(n, color) {
    var iD = this.y48(n);
    var iM = this.z48(n);
    UByteArrayInt__set_impl_gn4532(this.t46_1, iD, insert(UByteArrayInt__get_impl_px6q8a(this.t46_1, iD), color, imul(this.n3x_1, iM), this.n3x_1));
  }
  j3y(x, y) {
    var tmp = this.r46_1;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    var tmp$ret$0 = this.q3y(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  }
  l3y(x, y, v) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Not yet implemented';
    throw NotImplementedError.od('An operation is not implemented: ' + reason);
  }
  x48(x, y) {
    return this.y48(this.g3y(x, y));
  }
  y48(n) {
    return n >>> this.v46_1 | 0;
  }
  z48(n) {
    return n & this.w46_1;
  }
  a45(y0, y1) {
    var s0 = this.x48(0, y0);
    var s1 = this.x48(0, y1);
    arraycopy_0(this.x46(), s0, this.s46_1, 0, this.f3y());
    arraycopy_0(this.x46(), s1, this.x46(), s0, this.f3y());
    arraycopy_0(this.s46_1, 0, this.x46(), s1, this.f3y());
  }
  a49(x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy_0(data, 0, this.x46(), this.g3y(x, y), width / this.u46_1 | 0);
    } else {
      var m = this.g3y(x, y);
      var inductionVariable = 0;
      var last = width / this.u46_1 | 0;
      if (inductionVariable < last)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.x46()[m] = data[n];
          m = m + increment | 0;
        }
         while (inductionVariable < last);
    }
  }
  x3x() {
    // Inline function 'kotlin.also' call
    var this_0 = Bitmap32.e3x(this.l3x_1, this.m3x_1, VOID, this.r3x_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.toBMP32.<anonymous>' call
    var out = this_0.b3x_1;
    var pal = _RgbaArray___get_ints__impl__u2kps1(this.r46_1);
    var inductionVariable = 0;
    var last = this.i2f();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out[n] = pal[this.w48(n)];
      }
       while (inductionVariable < last);
    return this_0;
  }
}
class Bitmap8 extends BitmapIndexed {
  static l48(width, height, data, palette) {
    data = data === VOID ? new Int8Array(imul(width, height)) : data;
    palette = palette === VOID ? Companion_instance_11.t48(256) : palette;
    return this.u48(8, width, height, data, palette);
  }
  g45(width, height) {
    return Bitmap8.l48(width, height, VOID, this.r46_1);
  }
  p3y(x, y, color) {
    return this.v48(this.g3y(x, y), color);
  }
  q3y(x, y) {
    return UByteArrayInt__get_impl_px6q8a(this.t46_1, this.g3y(x, y));
  }
  j3y(x, y) {
    var tmp = this.r46_1;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    var tmp$ret$0 = this.q3y(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  }
  w48(n) {
    return UByteArrayInt__get_impl_px6q8a(this.t46_1, n);
  }
  v48(n, color) {
    UByteArrayInt__set_impl_gn4532(this.t46_1, n, color);
  }
  t44(srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap8))
      return super.t44(srcX, srcY, dst, dstX, dstY, width, height);
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.x46();
        var tmp_0 = this.g3y(srcX, srcY + y | 0);
        arraycopy_0(tmp, tmp_0, (dst instanceof Bitmap8 ? dst : THROW_CCE()).x46(), dst.g3y(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  }
  sx() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = this.x46().slice();
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = _RgbaArray___get_ints__impl__u2kps1(this.r46_1).slice();
    return Bitmap8.l48(this.l3x_1, this.m3x_1, tmp, _RgbaArray___init__impl__oib4y4(tmp$ret$3));
  }
  toString() {
    return 'Bitmap8(' + this.l3x_1 + ', ' + this.m3x_1 + ', palette=' + _RgbaArray___get_size__impl__imxef8(this.r46_1) + ')';
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_7 = this;
    this.b49_1 = values();
  }
  d1(index) {
    return this.b49_1[index];
  }
}
class BitmapChannel extends Enum {
  constructor(name, ordinal, index) {
    super(name, ordinal);
    this.y45_1 = index;
    this.z45_1 = imul(this.y45_1, 8);
    this.a46_1 = 255 << this.z45_1;
    this.b46_1 = ~this.a46_1;
  }
}
class Bitmaps {}
class Companion_2 {
  constructor() {
    this.c49_1 = 1.0;
    this.d49_1 = 1.4142135;
  }
}
class DistanceBitmap {
  constructor(width, height, d, px, py) {
    d = d === VOID ? new Float32Array(imul(width, height)) : d;
    px = px === VOID ? new Int32Array(imul(width, height)) : px;
    py = py === VOID ? new Int32Array(imul(width, height)) : py;
    this.e49_1 = width;
    this.f49_1 = height;
    this.g49_1 = d;
    this.h49_1 = px;
    this.i49_1 = py;
    this.j49_1 = imul(this.e49_1, this.f49_1);
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.g49_1.length >= this.j49_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.w4(toString_0(message));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.h49_1.length >= this.j49_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_0 = 'Check failed.';
      throw IllegalStateException.w4(toString_0(message_0));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.i49_1.length >= this.j49_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_1 = 'Check failed.';
      throw IllegalStateException.w4(toString_0(message_1));
    }
  }
  u44(x) {
    return x >= 0 && x < this.e49_1;
  }
  v44(y) {
    return y >= 0 && y < this.f49_1;
  }
  w44(x, y) {
    return this.u44(x) && this.v44(y);
  }
  g3y(x, y) {
    return imul(y, this.e49_1) + x | 0;
  }
  o49(x, y) {
    return this.w44(x, y) ? this.g49_1[this.g3y(x, y)] : Infinity;
  }
  l49(x, y) {
    return this.w44(x, y) ? this.h49_1[this.g3y(x, y)] : -1;
  }
  m49(x, y) {
    return this.w44(x, y) ? this.i49_1[this.g3y(x, y)] : -1;
  }
  n49(x, y, d) {
    if (!this.w44(x, y))
      return Unit_instance;
    this.g49_1[this.g3y(x, y)] = d;
  }
  p49(x, y, px, py) {
    if (!this.w44(x, y))
      return Unit_instance;
    var index = this.g3y(x, y);
    this.h49_1[index] = px;
    this.i49_1[index] = py;
  }
  k49(x, y, px, py) {
    return this.p49(x, y, this.l49(px, py), this.m49(px, py));
  }
  q49(bmp, thresold) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.e49_1 === bmp.l3x_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.w4(toString_0(message));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.f49_1 === bmp.m3x_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_0 = 'Check failed.';
      throw IllegalStateException.w4(toString_0(message_0));
    }
    var thresoldInt = numberToInt(clamp01(thresold) * 255);
    var inductionVariable = 0;
    var last = this.f49_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.e49_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this.n49(x, y, Infinity);
            this.p49(x, y, -1, -1);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    var inductionVariable_1 = 0;
    var last_1 = this.f49_1;
    if (inductionVariable_1 < last_1)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_2 = this.e49_1;
        if (inductionVariable_2 < last_2)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var cur = setFromBitmap$getAlpha(bmp, x_0, y_0, thresoldInt);
            var left = setFromBitmap$getAlpha(bmp, x_0 - 1 | 0, y_0, thresoldInt);
            var right = setFromBitmap$getAlpha(bmp, x_0 + 1 | 0, y_0, thresoldInt);
            var up = setFromBitmap$getAlpha(bmp, x_0, y_0 - 1 | 0, thresoldInt);
            var down = setFromBitmap$getAlpha(bmp, x_0, y_0 + 1 | 0, thresoldInt);
            if (!(left === cur) || !(right === cur) || !(up === cur) || !(down === cur)) {
              this.n49(x_0, y_0, 0.0);
              this.p49(x_0, y_0, x_0, y_0);
            }
          }
           while (inductionVariable_2 < last_2);
      }
       while (inductionVariable_1 < last_1);
    var inductionVariable_3 = 0;
    var last_3 = this.f49_1;
    if (inductionVariable_3 < last_3)
      do {
        var y_1 = inductionVariable_3;
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        var inductionVariable_4 = 0;
        var last_4 = this.e49_1;
        if (inductionVariable_4 < last_4)
          do {
            var x_1 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            setFromBitmap$pass(this, x_1, y_1, -1, -1, 1.4142135);
            setFromBitmap$pass(this, x_1, y_1, 0, -1, 1.0);
            setFromBitmap$pass(this, x_1, y_1, 1, -1, 1.4142135);
            setFromBitmap$pass(this, x_1, y_1, -1, 0, 1.0);
          }
           while (inductionVariable_4 < last_4);
      }
       while (inductionVariable_3 < last_3);
    var inductionVariable_5 = this.f49_1 - 1 | 0;
    if (0 <= inductionVariable_5)
      do {
        var y_2 = inductionVariable_5;
        inductionVariable_5 = inductionVariable_5 + -1 | 0;
        var inductionVariable_6 = this.e49_1 - 1 | 0;
        if (0 <= inductionVariable_6)
          do {
            var x_2 = inductionVariable_6;
            inductionVariable_6 = inductionVariable_6 + -1 | 0;
            setFromBitmap$pass(this, x_2, y_2, 1, 0, 1.0);
            setFromBitmap$pass(this, x_2, y_2, -1, 1, 1.4142135);
            setFromBitmap$pass(this, x_2, y_2, 0, 1, 1.0);
            setFromBitmap$pass(this, x_2, y_2, 1, 1, 1.4142135);
          }
           while (0 <= inductionVariable_6);
      }
       while (0 <= inductionVariable_5);
    var inductionVariable_7 = this.f49_1 - 1 | 0;
    if (0 <= inductionVariable_7)
      do {
        var y_3 = inductionVariable_7;
        inductionVariable_7 = inductionVariable_7 + -1 | 0;
        var inductionVariable_8 = this.e49_1 - 1 | 0;
        if (0 <= inductionVariable_8)
          do {
            var x_3 = inductionVariable_8;
            inductionVariable_8 = inductionVariable_8 + -1 | 0;
            if (setFromBitmap$getAlpha(bmp, x_3, y_3, thresoldInt)) {
              this.n49(x_3, y_3, -this.o49(x_3, y_3));
            }
          }
           while (0 <= inductionVariable_8);
      }
       while (0 <= inductionVariable_7);
  }
}
class FloatBitmap32 extends Bitmap {
  static f4a(width, height, data, premultiplied) {
    data = data === VOID ? new Float32Array(imul(imul(width, height), 4)) : data;
    premultiplied = premultiplied === VOID ? false : premultiplied;
    var $this = this.c3y(width, height, 32, premultiplied, data);
    $this.e4a_1 = data;
    return $this;
  }
  l3y(x, y, v) {
    var rindex = index4(this, x, y);
    this.e4a_1[rindex + 0 | 0] = _RGBA___get_rf__impl__kvz75k(v);
    this.e4a_1[rindex + 1 | 0] = _RGBA___get_gf__impl__5gcu1f(v);
    this.e4a_1[rindex + 2 | 0] = _RGBA___get_bf__impl__1xz5yg(v);
    this.e4a_1[rindex + 3 | 0] = _RGBA___get_af__impl__vu36qv(v);
  }
  j3y(x, y) {
    var rindex = index4(this, x, y);
    return Companion_getInstance_22().g4a(this.e4a_1[rindex + 0 | 0], this.e4a_1[rindex + 1 | 0], this.e4a_1[rindex + 2 | 0], this.e4a_1[rindex + 3 | 0]);
  }
  h4a(x, y) {
    return this.e4a_1[index4(this, x, y) + 0 | 0];
  }
  i4a(x, y) {
    return this.e4a_1[index4(this, x, y) + 1 | 0];
  }
  j4a(x, y) {
    return this.e4a_1[index4(this, x, y) + 2 | 0];
  }
  k4a(x, y) {
    return this.e4a_1[index4(this, x, y) + 3 | 0];
  }
  l4a(x, y, r, g, b, a) {
    var rindex = index4(this, x, y);
    this.e4a_1[rindex + 0 | 0] = r;
    this.e4a_1[rindex + 1 | 0] = g;
    this.e4a_1[rindex + 2 | 0] = b;
    this.e4a_1[rindex + 3 | 0] = a;
  }
  m4a(x, y, out) {
    var rindex = index4(this, x, y);
    _RGBAf___set_r__impl__pz5j5e(out, this.e4a_1[rindex + 0 | 0]);
    _RGBAf___set_g__impl__c4jj21(out, this.e4a_1[rindex + 1 | 0]);
    _RGBAf___set_b__impl__a2n9pa(out, this.e4a_1[rindex + 2 | 0]);
    _RGBAf___set_a__impl__iqz7cx(out, this.e4a_1[rindex + 3 | 0]);
    return out;
  }
  n4a(out) {
    var min_0 = Infinity;
    var max_0 = -Infinity;
    var temp = _RGBAf___init__impl__idjpgn_0();
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.l3x_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.m3x_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.g3y(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.getMinMax.<anonymous>' call
            n = n + 1 | 0;
            var c = this.m4a(x, y, temp);
            min_0 = min(min_0, _RGBAf___get_r__impl__jfq8gq(c), _RGBAf___get_g__impl__dhoraz(c), _RGBAf___get_b__impl__fjl0nq(c), _RGBAf___get_a__impl__qnwk97(c));
            max_0 = max(max_0, _RGBAf___get_r__impl__jfq8gq(c), _RGBAf___get_g__impl__dhoraz(c), _RGBAf___get_b__impl__fjl0nq(c), _RGBAf___get_a__impl__qnwk97(c));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    out[0] = min_0;
    out[1] = max_0;
    return out;
  }
  o4a(out, $super) {
    out = out === VOID ? new Float32Array(2) : out;
    return $super === VOID ? this.n4a(out) : $super.n4a.call(this, out);
  }
  p4a(minSrc, maxSrc, minDst, maxDst) {
    var out = _RGBAf___init__impl__idjpgn_0();
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.l3x_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.m3x_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.g3y(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.convertRange.<anonymous>' call
            n = n + 1 | 0;
            var rgbaf = this.m4a(x, y, out);
            this.l4a(x, y, convertRange(_RGBAf___get_r__impl__jfq8gq(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_g__impl__dhoraz(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_b__impl__fjl0nq(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_a__impl__qnwk97(rgbaf), minSrc, maxSrc, minDst, maxDst));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
  q4a(minSrc, maxSrc, minDst, maxDst, $super) {
    minDst = minDst === VOID ? 0.0 : minDst;
    maxDst = maxDst === VOID ? 1.0 : maxDst;
    var tmp;
    if ($super === VOID) {
      this.p4a(minSrc, maxSrc, minDst, maxDst);
      tmp = Unit_instance;
    } else {
      tmp = $super.p4a.call(this, minSrc, maxSrc, minDst, maxDst);
    }
    return tmp;
  }
  r4a() {
    var _destruct__k2r9zo = this.o4a();
    // Inline function 'kotlin.collections.component1' call
    var min = _destruct__k2r9zo[0];
    // Inline function 'kotlin.collections.component2' call
    var max = _destruct__k2r9zo[1];
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.absoluteValue' call
    var a = Math.abs(min);
    // Inline function 'kotlin.math.absoluteValue' call
    var b = Math.abs(max);
    var range = Math.max(a, b);
    this.q4a(-range, +range);
  }
  s4a(scale) {
    return this.t4a(scale, scale, scale, scale);
  }
  t4a(scaleRed, scaleGreen, scaleBlue, scaleAlpha) {
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.l3x_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.m3x_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.g3y(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.scale.<anonymous>' call
            n = n + 1 | 0;
            this.l4a(x, y, this.h4a(x, y) * scaleRed, this.i4a(x, y) * scaleGreen, this.j4a(x, y) * scaleBlue, this.k4a(x, y) * scaleAlpha);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
  u4a(min, max) {
    // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent' call
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.l3x_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.m3x_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.g3y(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent.<anonymous>' call
            n = n + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value = this.h4a(x, y);
            var tmp = clamp_0(value, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_0 = this.i4a(x, y);
            var tmp_0 = clamp_0(value_0, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_1 = this.j4a(x, y);
            var tmp_1 = clamp_0(value_1, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_2 = this.k4a(x, y);
            var tmp$ret$3 = clamp_0(value_2, min, max);
            this.l4a(x, y, tmp, tmp_0, tmp_1, tmp$ret$3);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
}
class MultiBitmap extends Bitmap {}
class NativeImage extends Bitmap {
  static j4b(width, height, data, premultiplied) {
    var $this = this.c3y(width, height, 32, premultiplied, null);
    $this.i4b_1 = data;
    return $this;
  }
  x3x() {
    // Inline function 'kotlin.also' call
    var this_0 = Companion_getInstance_15().u45(this.l3x_1, this.m3x_1, this.r3x_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.NativeImage.toBMP32.<anonymous>' call
    this.i3y(0, 0, this.l3x_1, this.m3x_1, this_0.b3x_1, 0);
    return this_0;
  }
  l3y(x, y, v) {
    RgbaArray__set_impl_epw2wg(this.e3y(), 0, v);
    this.k3y(x, y, 1, 1, this.d3y(), 0);
  }
  j3y(x, y) {
    this.i3y(x, y, 1, 1, this.d3y(), 0);
    return RgbaArray__get_impl_nzyo1o(this.e3y(), 0);
  }
  p3y(x, y, color) {
    return this.l3y(x, y, _RGBA___init__impl__lqpay5(color));
  }
  q3y(x, y) {
    return _RGBA___get_value__impl__hhco8v(this.j3y(x, y));
  }
  z44() {
    var tmp = this.x3x().z44();
    this.m3y(0, 0, this.l3x_1, this.m3x_1, (tmp instanceof Bitmap32 ? tmp : THROW_CCE()).b3x_1);
    return this;
  }
  b45() {
    var tmp = this.x3x().b45();
    this.m3y(0, 0, this.l3x_1, this.m3x_1, (tmp instanceof Bitmap32 ? tmp : THROW_CCE()).b3x_1);
    return this;
  }
  a45(y0, y1) {
    this.i3y(0, y0, this.l3x_1, 1, this.d3y(), 0);
    this.i3y(0, y1, this.l3x_1, 1, this.d3y(), this.l3x_1);
    this.k3y(0, y1, this.l3x_1, 1, this.d3y(), 0);
    this.k3y(0, y0, this.l3x_1, 1, this.d3y(), this.l3x_1);
  }
  c45(x0, x1) {
    this.i3y(x0, 0, 1, this.m3x_1, this.d3y(), 0);
    this.i3y(x1, 0, 1, this.m3x_1, this.d3y(), this.l3x_1);
    this.k3y(x1, 0, 1, this.m3x_1, this.d3y(), 0);
    this.k3y(x0, 0, 1, this.m3x_1, this.d3y(), this.l3x_1);
  }
  g45(width, height) {
    return NativeImage_0(width, height);
  }
  toString() {
    return this.o3() + '(' + this.l3x_1 + ', ' + this.m3x_1 + ')';
  }
}
class ForcedTexId {}
function get_forcedTexTarget() {
  return 3553;
}
class NullBitmap extends Bitmap {
  static o4c(width, height, premultiplied) {
    Companion_getInstance_19();
    premultiplied = premultiplied === VOID ? true : premultiplied;
    return this.c3y(width, height, 32, premultiplied, null);
  }
  l3y(x, y, v) {
    return Unit_instance;
  }
  j3y(x, y) {
    return _RGBA___init__impl__lqpay5(0);
  }
}
class Companion_3 extends NullBitmap {
  static a4c() {
    Companion_instance_9 = null;
    var $this = this.o4c(1, 1);
    Companion_instance_9 = $this;
    return $this;
  }
}
class Palette {
  constructor(colors, names, changeStart, changeEnd) {
    names = names === VOID ? null : names;
    changeStart = changeStart === VOID ? 0 : changeStart;
    changeEnd = changeEnd === VOID ? 0 : changeEnd;
    this.p4c_1 = colors;
    this.q4c_1 = names;
    this.r4c_1 = changeStart;
    this.s4c_1 = changeEnd;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Palette.toString.<anonymous>' call
    this_0.ob('Palette(');
    var inductionVariable = 0;
    var last = _RgbaArray___get_size__impl__imxef8(this.p4c_1);
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var color = RgbaArray__get_impl_nzyo1o(this.p4c_1, n);
        var tmp22_safe_receiver = this.q4c_1;
        var name = tmp22_safe_receiver == null ? null : tmp22_safe_receiver[n];
        if (n > 0) {
          this_0.ob(', ');
        }
        if (!(name == null)) {
          this_0.ob(name);
          this_0.ob(': ');
        }
        this_0.ob(RGBA__toString_impl_4lw6dp(color));
      }
       while (inductionVariable < last);
    this_0.ob(')');
    return this_0.toString();
  }
}
class Result {
  constructor(bmp, buffer, radius, cutoff) {
    this.d4d_1 = bmp;
    this.e4d_1 = buffer;
    this.f4d_1 = radius;
    this.g4d_1 = cutoff;
  }
  toString() {
    return 'Result(bmp=' + this.d4d_1.toString() + ', buffer=' + this.e4d_1 + ', radius=' + this.f4d_1 + ', cutoff=' + this.g4d_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.d4d_1);
    result = imul(result, 31) + this.e4d_1 | 0;
    result = imul(result, 31) + this.f4d_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.g4d_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals(this.d4d_1, tmp0_other_with_cast.d4d_1))
      return false;
    if (!(this.e4d_1 === tmp0_other_with_cast.e4d_1))
      return false;
    if (!(this.f4d_1 === tmp0_other_with_cast.f4d_1))
      return false;
    if (!equals(this.g4d_1, tmp0_other_with_cast.g4d_1))
      return false;
    return true;
  }
}
class NewSDF {
  constructor() {
    this.h4d_1 = 1.0E10;
  }
  i4d(bmp, maxSide, buffer, radius, cutoff) {
    var size = maxSide + imul(buffer, 4) | 0;
    var out = Bitmap32.e3x(bmp.l3x_1 + imul(buffer, 2) | 0, bmp.m3x_1 + imul(buffer, 2) | 0);
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width = out.l3x_1;
    var height = out.m3x_1;
    var tmp = 0;
    var tmp_0 = imul(width, height);
    var tmp_1 = new Float32Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = 1.0E10;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var gridOuter = new FloatArray2(width, height, isFloatArray(tmp_2) ? tmp_2 : THROW_CCE());
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width_0 = out.l3x_1;
    var height_0 = out.m3x_1;
    var tmp_3 = 0;
    var tmp_4 = imul(width_0, height_0);
    var tmp_5 = new Float32Array(tmp_4);
    while (tmp_3 < tmp_4) {
      tmp_5[tmp_3] = 0.0;
      tmp_3 = tmp_3 + 1 | 0;
    }
    var tmp_6 = tmp_5;
    var gridInner = new FloatArray2(width_0, height_0, isFloatArray(tmp_6) ? tmp_6 : THROW_CCE());
    var f = new Float32Array(size);
    var z = new Float32Array(size + 1 | 0);
    var v = _UShortArrayInt___init__impl__kdofb8(size);
    var inductionVariable = 0;
    var last = bmp.m3x_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = bmp.l3x_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var a = _RGBA___get_af__impl__vu36qv(bmp.b47(x, y));
            var x0 = x + buffer | 0;
            var y0 = y + buffer | 0;
            switch (a) {
              case 0.0:
                gridOuter.z2i(x0, y0, 1.0E10);
                gridInner.z2i(x0, y0, 0.0);
                break;
              case 1.0:
                gridOuter.z2i(x0, y0, 0.0);
                gridInner.z2i(x0, y0, 1.0E10);
                break;
              default:
                var d = 0.5 - a;
                gridOuter.z2i(x0, y0, d > 0.0 ? d * d : 0.0);
                gridInner.z2i(x0, y0, d < 0.0 ? d * d : 0.0);
                break;
            }
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    this.j4d(gridOuter.x2i_1, 0, 0, out.l3x_1, out.m3x_1, gridOuter.m2i(), f, v, z);
    this.j4d(gridInner.x2i_1, buffer, buffer, bmp.l3x_1, bmp.m3x_1, gridInner.m2i(), f, v, z);
    var inductionVariable_1 = 0;
    var last_1 = out.m3x_1;
    if (inductionVariable_1 < last_1)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_2 = out.l3x_1;
        if (inductionVariable_2 < last_2)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var gout = gridOuter.p27(x_0, y_0);
            var gin = gridInner.p27(x_0, y_0);
            // Inline function 'kotlin.math.sqrt' call
            var tmp_7 = Math.sqrt(gout);
            // Inline function 'kotlin.math.sqrt' call
            var d_0 = tmp_7 - Math.sqrt(gin);
            var a_0 = toIntRound(255 - 255 * (d_0 / radius + cutoff));
            out.a47(x_0, y_0, Companion_getInstance_22().c4d(255, 255, 255, clamp(a_0, 0, 255)));
          }
           while (inductionVariable_2 < last_2);
      }
       while (inductionVariable_1 < last_1);
    return new Result(out, buffer, radius, cutoff);
  }
  k4d(bmp, maxSide, buffer, radius, cutoff, $super) {
    var tmp;
    if (maxSide === VOID) {
      // Inline function 'kotlin.math.max' call
      var a = bmp.l3x_1;
      var b = bmp.m3x_1;
      tmp = Math.max(a, b);
    } else {
      tmp = maxSide;
    }
    maxSide = tmp;
    buffer = buffer === VOID ? divCeil(maxSide, 8) : buffer;
    radius = radius === VOID ? divCeil(maxSide, 3) : radius;
    cutoff = cutoff === VOID ? 0.5 : cutoff;
    return $super === VOID ? this.i4d(bmp, maxSide, buffer, radius, cutoff) : $super.i4d.call(this, bmp, maxSide, buffer, radius, cutoff);
  }
  j4d(data, x0, y0, width, height, gridSize, f, v, z) {
    var inductionVariable = x0;
    var last = x0 + width | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.l4d(data, imul(y0, gridSize) + x | 0, gridSize, height, f, v, z);
      }
       while (inductionVariable < last);
    var inductionVariable_0 = y0;
    var last_0 = y0 + height | 0;
    if (inductionVariable_0 < last_0)
      do {
        var y = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.l4d(data, imul(y, gridSize) + x0 | 0, 1, width, f, v, z);
      }
       while (inductionVariable_0 < last_0);
  }
  l4d(grid, offset, stride, length, f, v, z) {
    UShortArrayInt__set_impl_38wgvc(v, 0, 0);
    z[0] = -1.0E10;
    z[1] = 1.0E10;
    f[0] = grid[offset];
    var k = 0;
    var s = 0.0;
    var inductionVariable = 1;
    if (inductionVariable < length)
      do {
        var q = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        f[q] = grid[offset + imul(q, stride) | 0];
        var q2 = imul(q, q);
        $l$1: do {
          $l$0: do {
            var r = UShortArrayInt__get_impl_ciz20k(v, k);
            s = (f[q] - f[r] + q2 - imul(r, r)) / (q - r | 0) / 2.0;
          }
           while (false);
          var tmp;
          if (s <= z[k]) {
            k = k - 1 | 0;
            tmp = k > -1;
          } else {
            tmp = false;
          }
        }
         while (tmp);
        k = k + 1 | 0;
        UShortArrayInt__set_impl_38wgvc(v, k, q);
        z[k] = s;
        z[k + 1 | 0] = 1.0E10;
      }
       while (inductionVariable < length);
    k = 0;
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < length)
      do {
        var q_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        while (z[k + 1 | 0] < q_0) {
          k = k + 1 | 0;
        }
        var r_0 = UShortArrayInt__get_impl_ciz20k(v, k);
        var qr = q_0 - r_0 | 0;
        grid[offset + imul(q_0, stride) | 0] = f[r_0] + imul(qr, qr);
      }
       while (inductionVariable_0 < length);
  }
}
class ColorFormat32 {
  constructor() {
    this.r4d_1 = 32;
  }
  m4d() {
    return this.r4d_1;
  }
}
class ColorFormat24 {
  constructor() {
    this.s4d_1 = 24;
  }
  m4d() {
    return this.s4d_1;
  }
}
class ColorTransformMul {
  constructor(_r, _g, _b, _a) {
    _r = _r === VOID ? 1.0 : _r;
    _g = _g === VOID ? 1.0 : _g;
    _b = _b === VOID ? 1.0 : _b;
    _a = _a === VOID ? 1.0 : _a;
    this.t4d_1 = _r;
    this.u4d_1 = _g;
    this.v4d_1 = _b;
    this.w4d_1 = _a;
    this.x4d_1 = true;
    this.y4d_1 = Colors_getInstance().s3y_1;
  }
  z4d() {
    return this.t4d_1;
  }
  a4e() {
    return this.u4d_1;
  }
  b4e() {
    return this.v4d_1;
  }
  c4e(value) {
    this.w4d_1 = value;
    this.x4d_1 = true;
  }
  d4e() {
    return this.w4d_1;
  }
  e4e(v) {
    this.f4e(_RGBA___get_rf__impl__kvz75k(v), _RGBA___get_gf__impl__5gcu1f(v), _RGBA___get_bf__impl__1xz5yg(v), _RGBA___get_af__impl__vu36qv(v));
    this.y4d_1 = v;
    this.x4d_1 = false;
  }
  g4e() {
    if (this.x4d_1) {
      this.x4d_1 = false;
      this.y4d_1 = Companion_getInstance_22().g4a(this.t4d_1, this.u4d_1, this.v4d_1, this.w4d_1);
    }
    return this.y4d_1;
  }
  f4e(r, g, b, a) {
    this.t4d_1 = r;
    this.u4d_1 = g;
    this.v4d_1 = b;
    this.w4d_1 = a;
    this.x4d_1 = true;
  }
  h4e(other) {
    return this.f4e(other.t4d_1, other.u4d_1, other.v4d_1, other.w4d_1);
  }
  i4e(a, b) {
    return this.f4e(a.z4d() * b.z4d(), a.a4e() * b.a4e(), a.b4e() * b.b4e(), a.d4e() * b.d4e());
  }
  toString() {
    return 'ColorTransformMul(_r=' + this.t4d_1 + ', _g=' + this.u4d_1 + ', _b=' + this.v4d_1 + ', _a=' + this.w4d_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.t4d_1);
    result = imul(result, 31) + getNumberHashCode(this.u4d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v4d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w4d_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorTransformMul))
      return false;
    var tmp0_other_with_cast = other instanceof ColorTransformMul ? other : THROW_CCE();
    if (!equals(this.t4d_1, tmp0_other_with_cast.t4d_1))
      return false;
    if (!equals(this.u4d_1, tmp0_other_with_cast.u4d_1))
      return false;
    if (!equals(this.v4d_1, tmp0_other_with_cast.v4d_1))
      return false;
    if (!equals(this.w4d_1, tmp0_other_with_cast.w4d_1))
      return false;
    return true;
  }
}
class Colors {
  constructor() {
    Colors_instance = this;
    this.s3y_1 = Companion_getInstance_22().c4d(255, 255, 255, 255);
    this.t3y_1 = Companion_getInstance_22().c4d(0, 0, 0, 255);
    this.u3y_1 = Companion_getInstance_22().c4d(255, 0, 0, 255);
    this.v3y_1 = Companion_getInstance_22().c4d(0, 255, 0, 255);
    this.w3y_1 = Companion_getInstance_22().c4d(0, 0, 255, 255);
    this.x3y_1 = Companion_getInstance_22().c4d(0, 0, 0, 0);
    this.y3y_1 = Companion_getInstance_22().c4d(255, 255, 255, 0);
    this.z3y_1 = Companion_getInstance_22().j4e(240, 248, 255);
    this.a3z_1 = Companion_getInstance_22().j4e(250, 235, 215);
    this.b3z_1 = Companion_getInstance_22().j4e(0, 255, 255);
    this.c3z_1 = Companion_getInstance_22().j4e(127, 255, 212);
    this.d3z_1 = Companion_getInstance_22().j4e(240, 255, 255);
    this.e3z_1 = Companion_getInstance_22().j4e(245, 245, 220);
    this.f3z_1 = Companion_getInstance_22().j4e(255, 228, 196);
    this.g3z_1 = Companion_getInstance_22().j4e(255, 235, 205);
    this.h3z_1 = Companion_getInstance_22().j4e(138, 43, 226);
    this.i3z_1 = Companion_getInstance_22().j4e(165, 42, 42);
    this.j3z_1 = Companion_getInstance_22().j4e(222, 184, 135);
    this.k3z_1 = Companion_getInstance_22().j4e(95, 158, 160);
    this.l3z_1 = Companion_getInstance_22().j4e(127, 255, 0);
    this.m3z_1 = Companion_getInstance_22().j4e(210, 105, 30);
    this.n3z_1 = Companion_getInstance_22().j4e(255, 127, 80);
    this.o3z_1 = Companion_getInstance_22().j4e(100, 149, 237);
    this.p3z_1 = Companion_getInstance_22().j4e(255, 248, 220);
    this.q3z_1 = Companion_getInstance_22().j4e(220, 20, 60);
    this.r3z_1 = Companion_getInstance_22().j4e(0, 0, 139);
    this.s3z_1 = Companion_getInstance_22().j4e(0, 255, 255);
    this.t3z_1 = Companion_getInstance_22().j4e(0, 139, 139);
    this.u3z_1 = Companion_getInstance_22().j4e(184, 134, 11);
    this.v3z_1 = Companion_getInstance_22().j4e(169, 169, 169);
    this.w3z_1 = Companion_getInstance_22().j4e(0, 100, 0);
    this.x3z_1 = Companion_getInstance_22().j4e(169, 169, 169);
    this.y3z_1 = Companion_getInstance_22().j4e(189, 183, 107);
    this.z3z_1 = Companion_getInstance_22().j4e(255, 0, 255);
    this.a40_1 = Companion_getInstance_22().j4e(139, 0, 139);
    this.b40_1 = Companion_getInstance_22().j4e(85, 107, 47);
    this.c40_1 = Companion_getInstance_22().j4e(255, 140, 0);
    this.d40_1 = Companion_getInstance_22().j4e(153, 50, 204);
    this.e40_1 = Companion_getInstance_22().j4e(139, 0, 0);
    this.f40_1 = Companion_getInstance_22().j4e(233, 150, 122);
    this.g40_1 = Companion_getInstance_22().j4e(143, 188, 143);
    this.h40_1 = Companion_getInstance_22().j4e(72, 61, 139);
    this.i40_1 = Companion_getInstance_22().j4e(47, 79, 79);
    this.j40_1 = Companion_getInstance_22().j4e(47, 79, 79);
    this.k40_1 = Companion_getInstance_22().j4e(0, 206, 209);
    this.l40_1 = Companion_getInstance_22().j4e(148, 0, 211);
    this.m40_1 = Companion_getInstance_22().j4e(255, 20, 147);
    this.n40_1 = Companion_getInstance_22().j4e(0, 191, 255);
    this.o40_1 = Companion_getInstance_22().j4e(105, 105, 105);
    this.p40_1 = Companion_getInstance_22().j4e(105, 105, 105);
    this.q40_1 = Companion_getInstance_22().j4e(30, 144, 255);
    this.r40_1 = Companion_getInstance_22().j4e(178, 34, 34);
    this.s40_1 = Companion_getInstance_22().j4e(255, 250, 240);
    this.t40_1 = Companion_getInstance_22().j4e(34, 139, 34);
    this.u40_1 = Companion_getInstance_22().j4e(255, 0, 255);
    this.v40_1 = Companion_getInstance_22().j4e(220, 220, 220);
    this.w40_1 = Companion_getInstance_22().j4e(248, 248, 255);
    this.x40_1 = Companion_getInstance_22().j4e(255, 215, 0);
    this.y40_1 = Companion_getInstance_22().j4e(218, 165, 32);
    this.z40_1 = Companion_getInstance_22().j4e(173, 255, 47);
    this.a41_1 = Companion_getInstance_22().j4e(240, 255, 240);
    this.b41_1 = Companion_getInstance_22().j4e(255, 105, 180);
    this.c41_1 = Companion_getInstance_22().j4e(205, 92, 92);
    this.d41_1 = Companion_getInstance_22().j4e(75, 0, 130);
    this.e41_1 = Companion_getInstance_22().j4e(255, 255, 240);
    this.f41_1 = Companion_getInstance_22().j4e(240, 230, 140);
    this.g41_1 = Companion_getInstance_22().j4e(230, 230, 250);
    this.h41_1 = Companion_getInstance_22().j4e(255, 240, 245);
    this.i41_1 = Companion_getInstance_22().j4e(124, 252, 0);
    this.j41_1 = Companion_getInstance_22().j4e(255, 250, 205);
    this.k41_1 = Companion_getInstance_22().j4e(173, 216, 230);
    this.l41_1 = Companion_getInstance_22().j4e(240, 128, 128);
    this.m41_1 = Companion_getInstance_22().j4e(224, 255, 255);
    this.n41_1 = Companion_getInstance_22().j4e(250, 250, 210);
    this.o41_1 = Companion_getInstance_22().j4e(211, 211, 211);
    this.p41_1 = Companion_getInstance_22().j4e(144, 238, 144);
    this.q41_1 = Companion_getInstance_22().j4e(211, 211, 211);
    this.r41_1 = Companion_getInstance_22().j4e(255, 182, 193);
    this.s41_1 = Companion_getInstance_22().j4e(255, 160, 122);
    this.t41_1 = Companion_getInstance_22().j4e(32, 178, 170);
    this.u41_1 = Companion_getInstance_22().j4e(135, 206, 250);
    this.v41_1 = Companion_getInstance_22().j4e(119, 136, 153);
    this.w41_1 = Companion_getInstance_22().j4e(119, 136, 153);
    this.x41_1 = Companion_getInstance_22().j4e(176, 196, 222);
    this.y41_1 = Companion_getInstance_22().j4e(255, 255, 224);
    this.z41_1 = Companion_getInstance_22().j4e(0, 255, 0);
    this.a42_1 = Companion_getInstance_22().j4e(50, 205, 50);
    this.b42_1 = Companion_getInstance_22().j4e(250, 240, 230);
    this.c42_1 = Companion_getInstance_22().j4e(128, 0, 0);
    this.d42_1 = Companion_getInstance_22().j4e(102, 205, 170);
    this.e42_1 = Companion_getInstance_22().j4e(0, 0, 205);
    this.f42_1 = Companion_getInstance_22().j4e(186, 85, 211);
    this.g42_1 = Companion_getInstance_22().j4e(147, 112, 219);
    this.h42_1 = Companion_getInstance_22().j4e(60, 179, 113);
    this.i42_1 = Companion_getInstance_22().j4e(123, 104, 238);
    this.j42_1 = Companion_getInstance_22().j4e(0, 250, 154);
    this.k42_1 = Companion_getInstance_22().j4e(72, 209, 204);
    this.l42_1 = Companion_getInstance_22().j4e(199, 21, 133);
    this.m42_1 = Companion_getInstance_22().j4e(25, 25, 112);
    this.n42_1 = Companion_getInstance_22().j4e(245, 255, 250);
    this.o42_1 = Companion_getInstance_22().j4e(255, 228, 225);
    this.p42_1 = Companion_getInstance_22().j4e(255, 228, 181);
    this.q42_1 = Companion_getInstance_22().j4e(255, 222, 173);
    this.r42_1 = Companion_getInstance_22().j4e(0, 0, 128);
    this.s42_1 = Companion_getInstance_22().j4e(253, 245, 230);
    this.t42_1 = Companion_getInstance_22().j4e(128, 128, 0);
    this.u42_1 = Companion_getInstance_22().j4e(107, 142, 35);
    this.v42_1 = Companion_getInstance_22().j4e(255, 165, 0);
    this.w42_1 = Companion_getInstance_22().j4e(255, 69, 0);
    this.x42_1 = Companion_getInstance_22().j4e(218, 112, 214);
    this.y42_1 = Companion_getInstance_22().j4e(238, 232, 170);
    this.z42_1 = Companion_getInstance_22().j4e(152, 251, 152);
    this.a43_1 = Companion_getInstance_22().j4e(175, 238, 238);
    this.b43_1 = Companion_getInstance_22().j4e(219, 112, 147);
    this.c43_1 = Companion_getInstance_22().j4e(255, 239, 213);
    this.d43_1 = Companion_getInstance_22().j4e(255, 218, 185);
    this.e43_1 = Companion_getInstance_22().j4e(205, 133, 63);
    this.f43_1 = Companion_getInstance_22().j4e(255, 192, 203);
    this.g43_1 = Companion_getInstance_22().j4e(221, 160, 221);
    this.h43_1 = Companion_getInstance_22().j4e(176, 224, 230);
    this.i43_1 = Companion_getInstance_22().j4e(128, 0, 128);
    this.j43_1 = Companion_getInstance_22().j4e(188, 143, 143);
    this.k43_1 = Companion_getInstance_22().j4e(65, 105, 225);
    this.l43_1 = Companion_getInstance_22().j4e(139, 69, 19);
    this.m43_1 = Companion_getInstance_22().j4e(250, 128, 114);
    this.n43_1 = Companion_getInstance_22().j4e(244, 164, 96);
    this.o43_1 = Companion_getInstance_22().j4e(46, 139, 87);
    this.p43_1 = Companion_getInstance_22().j4e(255, 245, 238);
    this.q43_1 = Companion_getInstance_22().j4e(160, 82, 45);
    this.r43_1 = Companion_getInstance_22().j4e(192, 192, 192);
    this.s43_1 = Companion_getInstance_22().j4e(135, 206, 235);
    this.t43_1 = Companion_getInstance_22().j4e(106, 90, 205);
    this.u43_1 = Companion_getInstance_22().j4e(112, 128, 144);
    this.v43_1 = Companion_getInstance_22().j4e(112, 128, 144);
    this.w43_1 = Companion_getInstance_22().j4e(255, 250, 250);
    this.x43_1 = Companion_getInstance_22().j4e(0, 255, 127);
    this.y43_1 = Companion_getInstance_22().j4e(70, 130, 180);
    this.z43_1 = Companion_getInstance_22().j4e(210, 180, 140);
    this.a44_1 = Companion_getInstance_22().j4e(0, 128, 128);
    this.b44_1 = Companion_getInstance_22().j4e(216, 191, 216);
    this.c44_1 = Companion_getInstance_22().j4e(255, 99, 71);
    this.d44_1 = Companion_getInstance_22().j4e(64, 224, 208);
    this.e44_1 = Companion_getInstance_22().j4e(238, 130, 238);
    this.f44_1 = Companion_getInstance_22().j4e(245, 222, 179);
    this.g44_1 = Companion_getInstance_22().j4e(245, 245, 245);
    this.h44_1 = Companion_getInstance_22().j4e(154, 205, 50);
    this.i44_1 = Companion_getInstance_22().j4e(255, 255, 0);
    this.j44_1 = mapOf([to('black', new RGBA(this.t3y_1)), to('white', new RGBA(this.s3y_1)), to('red', new RGBA(this.u3y_1)), to('green', new RGBA(this.v3y_1)), to('blue', new RGBA(this.w3y_1)), to('aliceblue', new RGBA(this.z3y_1)), to('antiquewhite', new RGBA(this.a3z_1)), to('aqua', new RGBA(this.b3z_1)), to('aquamarine', new RGBA(this.c3z_1)), to('azure', new RGBA(this.d3z_1)), to('beige', new RGBA(this.e3z_1)), to('bisque', new RGBA(this.f3z_1)), to('blanchedalmond', new RGBA(this.g3z_1)), to('blueviolet', new RGBA(this.h3z_1)), to('brown', new RGBA(this.i3z_1)), to('burlywood', new RGBA(this.j3z_1)), to('cadetblue', new RGBA(this.k3z_1)), to('chartreuse', new RGBA(this.l3z_1)), to('chocolate', new RGBA(this.m3z_1)), to('coral', new RGBA(this.n3z_1)), to('cornflowerblue', new RGBA(this.o3z_1)), to('cornsilk', new RGBA(this.p3z_1)), to('crimson', new RGBA(this.q3z_1)), to('cyan', new RGBA(this.s3z_1)), to('darkblue', new RGBA(this.r3z_1)), to('darkcyan', new RGBA(this.t3z_1)), to('darkgoldenrod', new RGBA(this.u3z_1)), to('darkgray', new RGBA(this.v3z_1)), to('darkgreen', new RGBA(this.w3z_1)), to('darkgrey', new RGBA(this.x3z_1)), to('darkkhaki', new RGBA(this.y3z_1)), to('darkmagenta', new RGBA(this.a40_1)), to('darkolivegreen', new RGBA(this.b40_1)), to('darkorange', new RGBA(this.c40_1)), to('darkorchid', new RGBA(this.d40_1)), to('darkred', new RGBA(this.e40_1)), to('darksalmon', new RGBA(this.f40_1)), to('darkseagreen', new RGBA(this.g40_1)), to('darkslateblue', new RGBA(this.h40_1)), to('darkslategray', new RGBA(this.i40_1)), to('darkslategrey', new RGBA(this.j40_1)), to('darkturquoise', new RGBA(this.k40_1)), to('darkviolet', new RGBA(this.l40_1)), to('deeppink', new RGBA(this.m40_1)), to('deepskyblue', new RGBA(this.n40_1)), to('dimgray', new RGBA(this.o40_1)), to('dimgrey', new RGBA(this.p40_1)), to('dodgerblue', new RGBA(this.q40_1)), to('firebrick', new RGBA(this.r40_1)), to('floralwhite', new RGBA(this.s40_1)), to('forestgreen', new RGBA(this.t40_1)), to('fuchsia', new RGBA(this.u40_1)), to('gainsboro', new RGBA(this.v40_1)), to('ghostwhite', new RGBA(this.w40_1)), to('gold', new RGBA(this.x40_1)), to('goldenrod', new RGBA(this.y40_1)), to('greenyellow', new RGBA(this.z40_1)), to('honeydew', new RGBA(this.a41_1)), to('hotpink', new RGBA(this.b41_1)), to('indianred', new RGBA(this.c41_1)), to('indigo', new RGBA(this.d41_1)), to('ivory', new RGBA(this.e41_1)), to('khaki', new RGBA(this.f41_1)), to('lavender', new RGBA(this.g41_1)), to('lavenderblush', new RGBA(this.h41_1)), to('lawngreen', new RGBA(this.i41_1)), to('lemonchiffon', new RGBA(this.j41_1)), to('lightblue', new RGBA(this.k41_1)), to('lightcoral', new RGBA(this.l41_1)), to('lightcyan', new RGBA(this.m41_1)), to('lightgoldenrodyellow', new RGBA(this.n41_1)), to('lightgray', new RGBA(this.o41_1)), to('lightgreen', new RGBA(this.p41_1)), to('lightgrey', new RGBA(this.q41_1)), to('lightpink', new RGBA(this.r41_1)), to('lightsalmon', new RGBA(this.s41_1)), to('lightseagreen', new RGBA(this.t41_1)), to('lightskyblue', new RGBA(this.u41_1)), to('lightslategray', new RGBA(this.v41_1)), to('lightslategrey', new RGBA(this.w41_1)), to('lightsteelblue', new RGBA(this.x41_1)), to('lightyellow', new RGBA(this.y41_1)), to('lime', new RGBA(this.z41_1)), to('limegreen', new RGBA(this.a42_1)), to('linen', new RGBA(this.b42_1)), to('magenta', new RGBA(this.z3z_1)), to('maroon', new RGBA(this.c42_1)), to('mediumaquamarine', new RGBA(this.d42_1)), to('mediumblue', new RGBA(this.e42_1)), to('mediumorchid', new RGBA(this.f42_1)), to('mediumpurple', new RGBA(this.g42_1)), to('mediumseagreen', new RGBA(this.h42_1)), to('mediumslateblue', new RGBA(this.i42_1)), to('mediumspringgreen', new RGBA(this.j42_1)), to('mediumturquoise', new RGBA(this.k42_1)), to('mediumvioletred', new RGBA(this.l42_1)), to('midnightblue', new RGBA(this.m42_1)), to('mintcream', new RGBA(this.n42_1)), to('mistyrose', new RGBA(this.o42_1)), to('moccasin', new RGBA(this.p42_1)), to('navajowhite', new RGBA(this.q42_1)), to('navy', new RGBA(this.r42_1)), to('oldlace', new RGBA(this.s42_1)), to('olive', new RGBA(this.t42_1)), to('olivedrab', new RGBA(this.u42_1)), to('orange', new RGBA(this.v42_1)), to('orangered', new RGBA(this.w42_1)), to('orchid', new RGBA(this.x42_1)), to('palegoldenrod', new RGBA(this.y42_1)), to('palegreen', new RGBA(this.z42_1)), to('paleturquoise', new RGBA(this.a43_1)), to('palevioletred', new RGBA(this.b43_1)), to('papayawhip', new RGBA(this.c43_1)), to('peachpuff', new RGBA(this.d43_1)), to('peru', new RGBA(this.e43_1)), to('pink', new RGBA(this.f43_1)), to('plum', new RGBA(this.g43_1)), to('powderblue', new RGBA(this.h43_1)), to('purple', new RGBA(this.i43_1)), to('rosybrown', new RGBA(this.j43_1)), to('royalblue', new RGBA(this.k43_1)), to('saddlebrown', new RGBA(this.l43_1)), to('salmon', new RGBA(this.m43_1)), to('sandybrown', new RGBA(this.n43_1)), to('seagreen', new RGBA(this.o43_1)), to('seashell', new RGBA(this.p43_1)), to('sienna', new RGBA(this.q43_1)), to('silver', new RGBA(this.r43_1)), to('skyblue', new RGBA(this.s43_1)), to('slateblue', new RGBA(this.t43_1)), to('slategray', new RGBA(this.u43_1)), to('slategrey', new RGBA(this.v43_1)), to('snow', new RGBA(this.w43_1)), to('springgreen', new RGBA(this.x43_1)), to('steelblue', new RGBA(this.y43_1)), to('tan', new RGBA(this.z43_1)), to('teal', new RGBA(this.a44_1)), to('thistle', new RGBA(this.b44_1)), to('tomato', new RGBA(this.c44_1)), to('turquoise', new RGBA(this.d44_1)), to('violet', new RGBA(this.e44_1)), to('wheat', new RGBA(this.f44_1)), to('whitesmoke', new RGBA(this.g44_1)), to('yellowgreen', new RGBA(this.h44_1)), to('yellow', new RGBA(this.i44_1))]);
  }
  k4e(str) {
    return this.l4e(str, this.x3y_1, true);
  }
  l4e(str, default_0, errorOnDefault) {
    try {
      if (startsWith(str, '#')) {
        var hex = substr(str, 1);
        if (!setOf([3, 4, 6, 8]).w2(hex.length))
          return this.t3y_1;
        var chars = hex.length < 6 ? 1 : 2;
        var scale = hex.length < 6 ? 255.0 / 15.0 : 1.0;
        var hasAlpha = (hex.length / chars | 0) >= 4;
        var r = numberToInt(toInt(substr_0(hex, imul(0, chars), chars), 16) * scale);
        var g = numberToInt(toInt(substr_0(hex, imul(1, chars), chars), 16) * scale);
        var b = numberToInt(toInt(substr_0(hex, imul(2, chars), chars), 16) * scale);
        var a = hasAlpha ? numberToInt(toInt(substr_0(hex, imul(3, chars), chars), 16) * scale) : 255;
        return Companion_getInstance_22().c4d(r, g, b, a);
      } else if (startsWith(str, 'RGBA(', true)) {
        // Inline function 'kotlin.text.toUpperCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = str.toUpperCase();
        var parts = split(removeSuffix(removePrefix(tmp$ret$1, 'RGBA('), ')'), [',']);
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        if (0 <= 0 ? 0 < parts.e1() : false) {
          tmp = parts.d1(0);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp = '0';
        }
        var tmp$ret$3 = tmp;
        var tmp0_elvis_lhs = toIntOrNull(tmp$ret$3);
        var r_0 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0;
        if (0 <= 1 ? 1 < parts.e1() : false) {
          tmp_0 = parts.d1(1);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_0 = '0';
        }
        var tmp$ret$5 = tmp_0;
        var tmp1_elvis_lhs = toIntOrNull(tmp$ret$5);
        var g_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_1;
        if (0 <= 2 ? 2 < parts.e1() : false) {
          tmp_1 = parts.d1(2);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_1 = '0';
        }
        var tmp$ret$7 = tmp_1;
        var tmp2_elvis_lhs = toIntOrNull(tmp$ret$7);
        var b_0 = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_2;
        if (0 <= 3 ? 3 < parts.e1() : false) {
          tmp_2 = parts.d1(3);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_2 = '1.0';
        }
        var tmp$ret$9 = tmp_2;
        var tmp3_elvis_lhs = toDoubleOrNull(tmp$ret$9);
        var af = tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs;
        return Companion_getInstance_22().c4d(r_0, g_0, b_0, numberToInt(af * 255));
      } else {
        // Inline function 'kotlin.text.toLowerCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$11 = str.toLowerCase();
        var tmp_3 = this.j44_1.c3(tmp$ret$11);
        var col = tmp_3 == null ? null : tmp_3.m4e_1;
        var tmp_4;
        var tmp_5 = col;
        if ((tmp_5 == null ? null : new RGBA(tmp_5)) == null) {
          tmp_4 = errorOnDefault;
        } else {
          tmp_4 = false;
        }
        if (tmp_4)
          return this.n4e('#' + str, default_0);
        var tmp_6;
        var tmp_7 = col;
        if ((tmp_7 == null ? null : new RGBA(tmp_7)) == null) {
          tmp_6 = default_0;
        } else {
          tmp_6 = col;
        }
        return tmp_6;
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        return Colors_getInstance().u3y_1;
      } else {
        throw $p;
      }
    }
  }
  n4e(str, default_0, errorOnDefault, $super) {
    errorOnDefault = errorOnDefault === VOID ? false : errorOnDefault;
    return $super === VOID ? this.l4e(str, default_0, errorOnDefault) : $super.l4e.call(this, str, new RGBA(default_0), errorOnDefault).m4e_1;
  }
}
class MaterialColors {
  constructor() {
    MaterialColors_instance = this;
    this.o4e_1 = Colors_getInstance().k4e('#FFEBEE');
    this.p4e_1 = Colors_getInstance().k4e('#FFCDD2');
    this.q4e_1 = Colors_getInstance().k4e('#EF9A9A');
    this.r4e_1 = Colors_getInstance().k4e('#E57373');
    this.s4e_1 = Colors_getInstance().k4e('#EF5350');
    this.t4e_1 = Colors_getInstance().k4e('#F44336');
    this.u4e_1 = Colors_getInstance().k4e('#E53935');
    this.v4e_1 = Colors_getInstance().k4e('#D32F2F');
    this.w4e_1 = Colors_getInstance().k4e('#C62828');
    this.x4e_1 = Colors_getInstance().k4e('#B71C1C');
    this.y4e_1 = Colors_getInstance().k4e('#FF8A80');
    this.z4e_1 = Colors_getInstance().k4e('#FF5252');
    this.a4f_1 = Colors_getInstance().k4e('#FF1744');
    this.b4f_1 = Colors_getInstance().k4e('#D50000');
    this.c4f_1 = Colors_getInstance().k4e('#FCE4EC');
    this.d4f_1 = Colors_getInstance().k4e('#F8BBD0');
    this.e4f_1 = Colors_getInstance().k4e('#F48FB1');
    this.f4f_1 = Colors_getInstance().k4e('#F06292');
    this.g4f_1 = Colors_getInstance().k4e('#EC407A');
    this.h4f_1 = Colors_getInstance().k4e('#E91E63');
    this.i4f_1 = Colors_getInstance().k4e('#D81B60');
    this.j4f_1 = Colors_getInstance().k4e('#C2185B');
    this.k4f_1 = Colors_getInstance().k4e('#AD1457');
    this.l4f_1 = Colors_getInstance().k4e('#880E4F');
    this.m4f_1 = Colors_getInstance().k4e('#FF80AB');
    this.n4f_1 = Colors_getInstance().k4e('#FF4081');
    this.o4f_1 = Colors_getInstance().k4e('#F50057');
    this.p4f_1 = Colors_getInstance().k4e('#C51162');
    this.q4f_1 = Colors_getInstance().k4e('#F3E5F5');
    this.r4f_1 = Colors_getInstance().k4e('#E1BEE7');
    this.s4f_1 = Colors_getInstance().k4e('#CE93D8');
    this.t4f_1 = Colors_getInstance().k4e('#BA68C8');
    this.u4f_1 = Colors_getInstance().k4e('#AB47BC');
    this.v4f_1 = Colors_getInstance().k4e('#9C27B0');
    this.w4f_1 = Colors_getInstance().k4e('#8E24AA');
    this.x4f_1 = Colors_getInstance().k4e('#7B1FA2');
    this.y4f_1 = Colors_getInstance().k4e('#6A1B9A');
    this.z4f_1 = Colors_getInstance().k4e('#4A148C');
    this.a4g_1 = Colors_getInstance().k4e('#EA80FC');
    this.b4g_1 = Colors_getInstance().k4e('#E040FB');
    this.c4g_1 = Colors_getInstance().k4e('#D500F9');
    this.d4g_1 = Colors_getInstance().k4e('#AA00FF');
    this.e4g_1 = Colors_getInstance().k4e('#EDE7F6');
    this.f4g_1 = Colors_getInstance().k4e('#D1C4E9');
    this.g4g_1 = Colors_getInstance().k4e('#B39DDB');
    this.h4g_1 = Colors_getInstance().k4e('#9575CD');
    this.i4g_1 = Colors_getInstance().k4e('#7E57C2');
    this.j4g_1 = Colors_getInstance().k4e('#673AB7');
    this.k4g_1 = Colors_getInstance().k4e('#5E35B1');
    this.l4g_1 = Colors_getInstance().k4e('#512DA8');
    this.m4g_1 = Colors_getInstance().k4e('#4527A0');
    this.n4g_1 = Colors_getInstance().k4e('#311B92');
    this.o4g_1 = Colors_getInstance().k4e('#B388FF');
    this.p4g_1 = Colors_getInstance().k4e('#7C4DFF');
    this.q4g_1 = Colors_getInstance().k4e('#651FFF');
    this.r4g_1 = Colors_getInstance().k4e('#6200EA');
    this.s4g_1 = Colors_getInstance().k4e('#E3F2FD');
    this.t4g_1 = Colors_getInstance().k4e('#BBDEFB');
    this.u4g_1 = Colors_getInstance().k4e('#90CAF9');
    this.v4g_1 = Colors_getInstance().k4e('#64B5F6');
    this.w4g_1 = Colors_getInstance().k4e('#42A5F5');
    this.x4g_1 = Colors_getInstance().k4e('#2196F3');
    this.y4g_1 = Colors_getInstance().k4e('#1E88E5');
    this.z4g_1 = Colors_getInstance().k4e('#1976D2');
    this.a4h_1 = Colors_getInstance().k4e('#1565C0');
    this.b4h_1 = Colors_getInstance().k4e('#0D47A1');
    this.c4h_1 = Colors_getInstance().k4e('#82B1FF');
    this.d4h_1 = Colors_getInstance().k4e('#448AFF');
    this.e4h_1 = Colors_getInstance().k4e('#2979FF');
    this.f4h_1 = Colors_getInstance().k4e('#2962FF');
    this.g4h_1 = Colors_getInstance().k4e('#E1F5FE');
    this.h4h_1 = Colors_getInstance().k4e('#B3E5FC');
    this.i4h_1 = Colors_getInstance().k4e('#81D4FA');
    this.j4h_1 = Colors_getInstance().k4e('#4FC3F7');
    this.k4h_1 = Colors_getInstance().k4e('#29B6F6');
    this.l4h_1 = Colors_getInstance().k4e('#03A9F4');
    this.m4h_1 = Colors_getInstance().k4e('#039BE5');
    this.n4h_1 = Colors_getInstance().k4e('#0288D1');
    this.o4h_1 = Colors_getInstance().k4e('#0277BD');
    this.p4h_1 = Colors_getInstance().k4e('#01579B');
    this.q4h_1 = Colors_getInstance().k4e('#80D8FF');
    this.r4h_1 = Colors_getInstance().k4e('#40C4FF');
    this.s4h_1 = Colors_getInstance().k4e('#00B0FF');
    this.t4h_1 = Colors_getInstance().k4e('#0091EA');
    this.u4h_1 = Colors_getInstance().k4e('#E0F7FA');
    this.v4h_1 = Colors_getInstance().k4e('#B2EBF2');
    this.w4h_1 = Colors_getInstance().k4e('#80DEEA');
    this.x4h_1 = Colors_getInstance().k4e('#4DD0E1');
    this.y4h_1 = Colors_getInstance().k4e('#26C6DA');
    this.z4h_1 = Colors_getInstance().k4e('#00BCD4');
    this.a4i_1 = Colors_getInstance().k4e('#00ACC1');
    this.b4i_1 = Colors_getInstance().k4e('#0097A7');
    this.c4i_1 = Colors_getInstance().k4e('#00838F');
    this.d4i_1 = Colors_getInstance().k4e('#006064');
    this.e4i_1 = Colors_getInstance().k4e('#84FFFF');
    this.f4i_1 = Colors_getInstance().k4e('#18FFFF');
    this.g4i_1 = Colors_getInstance().k4e('#00E5FF');
    this.h4i_1 = Colors_getInstance().k4e('#00B8D4');
    this.i4i_1 = Colors_getInstance().k4e('#E0F2F1');
    this.j4i_1 = Colors_getInstance().k4e('#B2DFDB');
    this.k4i_1 = Colors_getInstance().k4e('#80CBC4');
    this.l4i_1 = Colors_getInstance().k4e('#4DB6AC');
    this.m4i_1 = Colors_getInstance().k4e('#26A69A');
    this.n4i_1 = Colors_getInstance().k4e('#009688');
    this.o4i_1 = Colors_getInstance().k4e('#00897B');
    this.p4i_1 = Colors_getInstance().k4e('#00796B');
    this.q4i_1 = Colors_getInstance().k4e('#00695C');
    this.r4i_1 = Colors_getInstance().k4e('#004D40');
    this.s4i_1 = Colors_getInstance().k4e('#A7FFEB');
    this.t4i_1 = Colors_getInstance().k4e('#64FFDA');
    this.u4i_1 = Colors_getInstance().k4e('#1DE9B6');
    this.v4i_1 = Colors_getInstance().k4e('#00BFA5');
    this.w4i_1 = Colors_getInstance().k4e('#E8F5E9');
    this.x4i_1 = Colors_getInstance().k4e('#C8E6C9');
    this.y4i_1 = Colors_getInstance().k4e('#A5D6A7');
    this.z4i_1 = Colors_getInstance().k4e('#81C784');
    this.a4j_1 = Colors_getInstance().k4e('#66BB6A');
    this.b4j_1 = Colors_getInstance().k4e('#4CAF50');
    this.c4j_1 = Colors_getInstance().k4e('#43A047');
    this.d4j_1 = Colors_getInstance().k4e('#388E3C');
    this.e4j_1 = Colors_getInstance().k4e('#2E7D32');
    this.f4j_1 = Colors_getInstance().k4e('#1B5E20');
    this.g4j_1 = Colors_getInstance().k4e('#B9F6CA');
    this.h4j_1 = Colors_getInstance().k4e('#69F0AE');
    this.i4j_1 = Colors_getInstance().k4e('#00E676');
    this.j4j_1 = Colors_getInstance().k4e('#00C853');
    this.k4j_1 = Colors_getInstance().k4e('#F1F8E9');
    this.l4j_1 = Colors_getInstance().k4e('#DCEDC8');
    this.m4j_1 = Colors_getInstance().k4e('#C5E1A5');
    this.n4j_1 = Colors_getInstance().k4e('#AED581');
    this.o4j_1 = Colors_getInstance().k4e('#9CCC65');
    this.p4j_1 = Colors_getInstance().k4e('#8BC34A');
    this.q4j_1 = Colors_getInstance().k4e('#7CB342');
    this.r4j_1 = Colors_getInstance().k4e('#689F38');
    this.s4j_1 = Colors_getInstance().k4e('#558B2F');
    this.t4j_1 = Colors_getInstance().k4e('#33691E');
    this.u4j_1 = Colors_getInstance().k4e('#CCFF90');
    this.v4j_1 = Colors_getInstance().k4e('#B2FF59');
    this.w4j_1 = Colors_getInstance().k4e('#76FF03');
    this.x4j_1 = Colors_getInstance().k4e('#64DD17');
    this.y4j_1 = Colors_getInstance().k4e('#F9FBE7');
    this.z4j_1 = Colors_getInstance().k4e('#F0F4C3');
    this.a4k_1 = Colors_getInstance().k4e('#E6EE9C');
    this.b4k_1 = Colors_getInstance().k4e('#DCE775');
    this.c4k_1 = Colors_getInstance().k4e('#D4E157');
    this.d4k_1 = Colors_getInstance().k4e('#CDDC39');
    this.e4k_1 = Colors_getInstance().k4e('#C0CA33');
    this.f4k_1 = Colors_getInstance().k4e('#AFB42B');
    this.g4k_1 = Colors_getInstance().k4e('#9E9D24');
    this.h4k_1 = Colors_getInstance().k4e('#827717');
    this.i4k_1 = Colors_getInstance().k4e('#F4FF81');
    this.j4k_1 = Colors_getInstance().k4e('#EEFF41');
    this.k4k_1 = Colors_getInstance().k4e('#C6FF00');
    this.l4k_1 = Colors_getInstance().k4e('#AEEA00');
    this.m4k_1 = Colors_getInstance().k4e('#FFFDE7');
    this.n4k_1 = Colors_getInstance().k4e('#FFF9C4');
    this.o4k_1 = Colors_getInstance().k4e('#FFF59D');
    this.p4k_1 = Colors_getInstance().k4e('#FFF176');
    this.q4k_1 = Colors_getInstance().k4e('#FFEE58');
    this.r4k_1 = Colors_getInstance().k4e('#FFEB3B');
    this.s4k_1 = Colors_getInstance().k4e('#FDD835');
    this.t4k_1 = Colors_getInstance().k4e('#FBC02D');
    this.u4k_1 = Colors_getInstance().k4e('#F9A825');
    this.v4k_1 = Colors_getInstance().k4e('#F57F17');
    this.w4k_1 = Colors_getInstance().k4e('#FFFF8D');
    this.x4k_1 = Colors_getInstance().k4e('#FFFF00');
    this.y4k_1 = Colors_getInstance().k4e('#FFEA00');
    this.z4k_1 = Colors_getInstance().k4e('#FFD600');
    this.a4l_1 = Colors_getInstance().k4e('#FFF8E1');
    this.b4l_1 = Colors_getInstance().k4e('#FFECB3');
    this.c4l_1 = Colors_getInstance().k4e('#FFE082');
    this.d4l_1 = Colors_getInstance().k4e('#FFD54F');
    this.e4l_1 = Colors_getInstance().k4e('#FFCA28');
    this.f4l_1 = Colors_getInstance().k4e('#FFC107');
    this.g4l_1 = Colors_getInstance().k4e('#FFB300');
    this.h4l_1 = Colors_getInstance().k4e('#FFA000');
    this.i4l_1 = Colors_getInstance().k4e('#FF8F00');
    this.j4l_1 = Colors_getInstance().k4e('#FF6F00');
    this.k4l_1 = Colors_getInstance().k4e('#FFE57F');
    this.l4l_1 = Colors_getInstance().k4e('#FFD740');
    this.m4l_1 = Colors_getInstance().k4e('#FFC400');
    this.n4l_1 = Colors_getInstance().k4e('#FFAB00');
    this.o4l_1 = Colors_getInstance().k4e('#FFF3E0');
    this.p4l_1 = Colors_getInstance().k4e('#FFE0B2');
    this.q4l_1 = Colors_getInstance().k4e('#FFCC80');
    this.r4l_1 = Colors_getInstance().k4e('#FFB74D');
    this.s4l_1 = Colors_getInstance().k4e('#FFA726');
    this.t4l_1 = Colors_getInstance().k4e('#FF9800');
    this.u4l_1 = Colors_getInstance().k4e('#FB8C00');
    this.v4l_1 = Colors_getInstance().k4e('#F57C00');
    this.w4l_1 = Colors_getInstance().k4e('#EF6C00');
    this.x4l_1 = Colors_getInstance().k4e('#E65100');
    this.y4l_1 = Colors_getInstance().k4e('#FFD180');
    this.z4l_1 = Colors_getInstance().k4e('#FFAB40');
    this.a4m_1 = Colors_getInstance().k4e('#FF9100');
    this.b4m_1 = Colors_getInstance().k4e('#FF6D00');
    this.c4m_1 = Colors_getInstance().k4e('#FBE9E7');
    this.d4m_1 = Colors_getInstance().k4e('#FFCCBC');
    this.e4m_1 = Colors_getInstance().k4e('#FFAB91');
    this.f4m_1 = Colors_getInstance().k4e('#FF8A65');
    this.g4m_1 = Colors_getInstance().k4e('#FF7043');
    this.h4m_1 = Colors_getInstance().k4e('#FF5722');
    this.i4m_1 = Colors_getInstance().k4e('#F4511E');
    this.j4m_1 = Colors_getInstance().k4e('#E64A19');
    this.k4m_1 = Colors_getInstance().k4e('#D84315');
    this.l4m_1 = Colors_getInstance().k4e('#BF360C');
    this.m4m_1 = Colors_getInstance().k4e('#FF9E80');
    this.n4m_1 = Colors_getInstance().k4e('#FF6E40');
    this.o4m_1 = Colors_getInstance().k4e('#FF3D00');
    this.p4m_1 = Colors_getInstance().k4e('#DD2C00');
    this.q4m_1 = Colors_getInstance().k4e('#EFEBE9');
    this.r4m_1 = Colors_getInstance().k4e('#EFEBE9');
    this.s4m_1 = Colors_getInstance().k4e('#D7CCC8');
    this.t4m_1 = Colors_getInstance().k4e('#BCAAA4');
    this.u4m_1 = Colors_getInstance().k4e('#8D6E63');
    this.v4m_1 = Colors_getInstance().k4e('#795548');
    this.w4m_1 = Colors_getInstance().k4e('#6D4C41');
    this.x4m_1 = Colors_getInstance().k4e('#5D4037');
    this.y4m_1 = Colors_getInstance().k4e('#4E342E');
    this.z4m_1 = Colors_getInstance().k4e('#3E2723');
    this.a4n_1 = Colors_getInstance().k4e('#FAFAFA');
    this.b4n_1 = Colors_getInstance().k4e('#F5F5F5');
    this.c4n_1 = Colors_getInstance().k4e('#EEEEEE');
    this.d4n_1 = Colors_getInstance().k4e('#E0E0E0');
    this.e4n_1 = Colors_getInstance().k4e('#BDBDBD');
    this.f4n_1 = Colors_getInstance().k4e('#9E9E9E');
    this.g4n_1 = Colors_getInstance().k4e('#757575');
    this.h4n_1 = Colors_getInstance().k4e('#616161');
    this.i4n_1 = Colors_getInstance().k4e('#424242');
    this.j4n_1 = Colors_getInstance().k4e('#212121');
    this.k4n_1 = Colors_getInstance().k4e('#ECEFF1');
    this.l4n_1 = Colors_getInstance().k4e('#CFD8DC');
    this.m4n_1 = Colors_getInstance().k4e('#B0BEC5');
    this.n4n_1 = Colors_getInstance().k4e('#90A4AE');
    this.o4n_1 = Colors_getInstance().k4e('#78909C');
    this.p4n_1 = Colors_getInstance().k4e('#607D8B');
    this.q4n_1 = Colors_getInstance().k4e('#546E7A');
    this.r4n_1 = Colors_getInstance().k4e('#455A64');
    this.s4n_1 = Colors_getInstance().k4e('#37474F');
    this.t4n_1 = Colors_getInstance().k4e('#263238');
  }
}
class RGB extends ColorFormat24 {
  constructor(rOffset, gOffset, bOffset) {
    Companion_getInstance_20();
    super();
    this.v4n_1 = rOffset;
    this.w4n_1 = gOffset;
    this.x4n_1 = bOffset;
  }
  n4d(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.v4n_1 | 0) & 255;
  }
  o4d(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.w4n_1 | 0) & 255;
  }
  p4d(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.x4n_1 | 0) & 255;
  }
  q4d(v) {
    return 255;
  }
}
class Companion_4 extends RGB {
  constructor() {
    Companion_instance_10 = null;
    super(0, 8, 16);
    Companion_instance_10 = this;
  }
}
class Companion_5 {
  t48(size) {
    return _RgbaArray___init__impl__oib4y4(new Int32Array(size));
  }
}
class RgbaArray {
  constructor(ints) {
    this.y4n_1 = ints;
  }
  z2(fromIndex, toIndex) {
    return RgbaArray__subList_impl_rbyi98(this.y4n_1, fromIndex, toIndex);
  }
  z4n(elements) {
    return RgbaArray__containsAll_impl_l6gz5c(this.y4n_1, elements);
  }
  x2(elements) {
    return RgbaArray__containsAll_impl_l6gz5c_0(this, elements);
  }
  a4o(element) {
    return RgbaArray__indexOf_impl_d6b5pl(this.y4n_1, element);
  }
  l1(element) {
    return RgbaArray__indexOf_impl_d6b5pl_0(this, element);
  }
  g1() {
    return RgbaArray__isEmpty_impl_nch3ip(this.y4n_1);
  }
  a1() {
    return RgbaArray__iterator_impl_5wfwsm(this.y4n_1);
  }
  y2() {
    return RgbaArray__listIterator_impl_m4kjt0(this.y4n_1);
  }
  i1(index) {
    return RgbaArray__listIterator_impl_m4kjt0_0(this.y4n_1, index);
  }
  e1() {
    return _RgbaArray___get_size__impl__imxef8(this.y4n_1);
  }
  b4o(index) {
    return RgbaArray__get_impl_nzyo1o(this.y4n_1, index);
  }
  d1(index) {
    return RgbaArray__get_impl_nzyo1o_0(this, index);
  }
  toString() {
    return RgbaArray__toString_impl_vgvk04(this.y4n_1);
  }
  hashCode() {
    return RgbaArray__hashCode_impl_ht2l65(this.y4n_1);
  }
  equals(other) {
    return RgbaArray__equals_impl_6qvuf(this.y4n_1, other);
  }
}
class Companion_6 extends ColorFormat32 {
  constructor() {
    Companion_instance_12 = null;
    super();
    Companion_instance_12 = this;
    this.l44_1 = 0;
    this.m44_1 = 8;
    this.n44_1 = 16;
    this.o44_1 = 24;
  }
  g4a(r, g, b, a) {
    return this.d4o(f2i(r), f2i(g), f2i(b), f2i(a));
  }
  d4o(r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntUnchecked(r, g, b, a));
  }
  c4d(r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, a));
  }
  j4e(r, g, b) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, 255));
  }
  e4o(rgb, a) {
    return _RGBA___init__impl__lqpay5(rgb & 16777215 | a << 24);
  }
  n4d(v) {
    return _RGBA___get_r__impl__duz7mo(_RGBA___init__impl__lqpay5(v));
  }
  o4d(v) {
    return _RGBA___get_g__impl__o8pukr(_RGBA___init__impl__lqpay5(v));
  }
  p4d(v) {
    return _RGBA___get_b__impl__m6tl80(_RGBA___init__impl__lqpay5(v));
  }
  q4d(v) {
    return _RGBA___get_a__impl__6msvu7(_RGBA___init__impl__lqpay5(v));
  }
  f4o(c1, c2, factor256) {
    return _RGBA___init__impl__lqpay5(this.g4o(_RGBA___get_value__impl__hhco8v(c1), _RGBA___get_value__impl__hhco8v(c2), factor256));
  }
  g4o(c1, c2, factor256) {
    var ifactor256 = 256 - factor256 | 0;
    return ((imul(c1 & 16711935, ifactor256) + imul(c2 & 16711935, factor256) | 0) & -16711936 | (imul(c1 & 65280, ifactor256) + imul(c2 & 65280, factor256) | 0) & 16711680) >>> 8 | 0;
  }
  h4o(c1, c2, factor) {
    // Inline function 'kotlin.math.roundToInt' call
    var this_0 = Ratio__toFloat_impl_1ftup5(factor) * 256;
    var tmp$ret$0 = roundToInt(this_0);
    return this.f4o(c1, c2, tmp$ret$0);
  }
  i4o(c1, c2, factor) {
    return Companion_getInstance_22().e4o(_RGBA___get_rgb__impl__tijaqt(this.h4o(c1, c2, factor)), blendComponent(this, _RGBA___get_a__impl__6msvu7(c1), _RGBA___get_a__impl__6msvu7(c2), factor));
  }
  p44(c00, c10, c01, c11, factorX, factorY) {
    var c1 = this.i4o(c00, c10, factorX);
    var c2 = this.i4o(c01, c11, factorX);
    return this.i4o(c1, c2, factorY);
  }
  b4d(dst, src) {
    var srcA = _RGBA___get_a__impl__6msvu7(src);
    var iSrcA = 255 - srcA | 0;
    switch (srcA) {
      case 0:
        return dst;
      case 255:
        return src;
      default:
        return Companion_getInstance_22().e4o(_RGBA___get_rgb__impl__tijaqt(this.f4o(dst, src, srcA + 1 | 0)), clampUByte(srcA + (imul(_RGBA___get_a__impl__6msvu7(dst), iSrcA) / 255 | 0) | 0));
    }
  }
  c4o(c1, c2) {
    return Companion_getInstance_22().c4d(imul(_RGBA___get_r__impl__duz7mo(c1), _RGBA___get_r__impl__duz7mo(c2)) / 255 | 0, imul(_RGBA___get_g__impl__o8pukr(c1), _RGBA___get_g__impl__o8pukr(c2)) / 255 | 0, imul(_RGBA___get_b__impl__m6tl80(c1), _RGBA___get_b__impl__m6tl80(c2)) / 255 | 0, imul(_RGBA___get_a__impl__6msvu7(c1), _RGBA___get_a__impl__6msvu7(c2)) / 255 | 0);
  }
  j4o(src, dst, ratio) {
    return Companion_getInstance_22().c4d(interpolate(ratio, _RGBA___get_r__impl__duz7mo(src), _RGBA___get_r__impl__duz7mo(dst)), interpolate(ratio, _RGBA___get_g__impl__o8pukr(src), _RGBA___get_g__impl__o8pukr(dst)), interpolate(ratio, _RGBA___get_b__impl__m6tl80(src), _RGBA___get_b__impl__m6tl80(dst)), interpolate(ratio, _RGBA___get_a__impl__6msvu7(src), _RGBA___get_a__impl__6msvu7(dst)));
  }
}
class RGBA {
  constructor(value) {
    Companion_getInstance_22();
    this.m4e_1 = value;
  }
  sx() {
    return RGBA__clone_impl_w007z0(this.m4e_1);
  }
  toString() {
    return RGBA__toString_impl_4lw6dp(this.m4e_1);
  }
  k4o(other) {
    return RGBA__compareTo_impl_lrfjc1(this.m4e_1, other);
  }
  d(other) {
    return RGBA__compareTo_impl_lrfjc1_0(this, other);
  }
  hashCode() {
    return RGBA__hashCode_impl_h59qf6(this.m4e_1);
  }
  equals(other) {
    return RGBA__equals_impl_4vjmca(this.m4e_1, other);
  }
}
class Companion_7 {
  constructor() {
    this.l4o_1 = 16711935;
    this.m4o_1 = -16711936;
  }
  n4o(dst, src) {
    return _RGBAPremultiplied___init__impl__uos02x(sumPacked4MulR(_RGBAPremultiplied___get_value__impl__bqfhud(src), _RGBAPremultiplied___get_value__impl__bqfhud(dst), 256 - _RGBAPremultiplied___get_a__impl__f0hnd1(src) | 0));
  }
}
class Companion_8 {
  o4o(size) {
    return _RgbaPremultipliedArray___init__impl__lx83hy(new Int32Array(size));
  }
}
class RgbaPremultipliedArray {
  constructor(ints) {
    this.p4o_1 = ints;
  }
  toString() {
    return RgbaPremultipliedArray__toString_impl_seal6e(this.p4o_1);
  }
  hashCode() {
    return RgbaPremultipliedArray__hashCode_impl_kvnjzv(this.p4o_1);
  }
  equals(other) {
    return RgbaPremultipliedArray__equals_impl_vav5d5(this.p4o_1, other);
  }
}
class Companion_9 {
  q4o(f, s) {
    return insert(insert(0, f, 0, 16), s, 16, 16);
  }
}
class Companion_10 {}
class Kerning {
  constructor(first, second, amount) {
    this.z4o_1 = first;
    this.a4p_1 = second;
    this.b4p_1 = amount;
  }
}
class Glyph {
  constructor(fontSize, id, texture, xoffset, yoffset, xadvance) {
    this.r4o_1 = fontSize;
    this.s4o_1 = id;
    this.t4o_1 = texture;
    this.u4o_1 = xoffset;
    this.v4o_1 = yoffset;
    this.w4o_1 = xadvance;
    var tmp = this;
    tmp.x4o_1 = lazy(BitmapFont$Glyph$bmp$delegate$lambda(this));
    this.y4o_1 = new GlyphMetrics(this.r4o_1, true, -1, Companion_getInstance_4().u2d(this.u4o_1, this.v4o_1, this.t4o_1.b3g_1, this.t4o_1.c3g_1), this.w4o_1);
  }
  c4p() {
    return this.t4o_1.b3g_1;
  }
  d4p() {
    return this.t4o_1.c3g_1;
  }
  e4p() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x4o_1;
    bmp$factory();
    return this_0.r1();
  }
  toString() {
    return 'Glyph(fontSize=' + this.r4o_1 + ', id=' + this.s4o_1 + ', texture=' + this.t4o_1.toString() + ', xoffset=' + this.u4o_1 + ', yoffset=' + this.v4o_1 + ', xadvance=' + this.w4o_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.r4o_1);
    result = imul(result, 31) + this.s4o_1 | 0;
    result = imul(result, 31) + this.t4o_1.hashCode() | 0;
    result = imul(result, 31) + this.u4o_1 | 0;
    result = imul(result, 31) + this.v4o_1 | 0;
    result = imul(result, 31) + this.w4o_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Glyph))
      return false;
    var tmp0_other_with_cast = other instanceof Glyph ? other : THROW_CCE();
    if (!equals(this.r4o_1, tmp0_other_with_cast.r4o_1))
      return false;
    if (!(this.s4o_1 === tmp0_other_with_cast.s4o_1))
      return false;
    if (!this.t4o_1.equals(tmp0_other_with_cast.t4o_1))
      return false;
    if (!(this.u4o_1 === tmp0_other_with_cast.u4o_1))
      return false;
    if (!(this.v4o_1 === tmp0_other_with_cast.v4o_1))
      return false;
    if (!(this.w4o_1 === tmp0_other_with_cast.w4o_1))
      return false;
    return true;
  }
}
class Font {}
function getOrNull_2() {
  return this;
}
function getFontMetrics$default(size, metrics, $super) {
  metrics = metrics === VOID ? new FontMetrics() : metrics;
  return $super === VOID ? this.o4p(size, metrics) : $super.o4p.call(this, size, metrics);
}
function getGlyphMetrics$default(size, codePoint, metrics, reader, $super) {
  metrics = metrics === VOID ? new GlyphMetrics() : metrics;
  reader = reader === VOID ? null : reader;
  return $super === VOID ? this.a4q(size, codePoint, metrics, reader) : $super.a4q.call(this, size, codePoint, metrics, reader);
}
function renderGlyph$default(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw, $super) {
  reader = reader === VOID ? null : reader;
  beforeDraw = beforeDraw === VOID ? null : beforeDraw;
  return $super === VOID ? this.m4q(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) : $super.m4q.call(this, ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw);
}
class BitmapFont {}
function get_baseBmp() {
  return get_bmp(this.l4p().t4o_1);
}
function getFontMetrics(size, metrics) {
  return metrics.y4p(this.m4p(), size);
}
function getGlyphMetrics(size, codePoint, metrics, reader) {
  var tmp38_safe_receiver = this.y2l(codePoint);
  var tmp0_elvis_lhs = tmp38_safe_receiver == null ? null : tmp38_safe_receiver.y4o_1;
  return metrics.g4q(tmp0_elvis_lhs == null ? this.n4p() : tmp0_elvis_lhs, size, codePoint);
}
function getTextScale(size) {
  return size / this.f4p();
}
function get_0(charCode) {
  var tmp0_elvis_lhs = this.y2l(charCode);
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.y2l(32) : tmp0_elvis_lhs;
  return tmp1_elvis_lhs == null ? this.l4p() : tmp1_elvis_lhs;
}
function get_1(char) {
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(char);
  return this.d1(tmp$ret$0);
}
function getGlyph(char) {
  return this.k4q(char);
}
function renderGlyph(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) {
  var scale = this.j4q(size);
  var tmp0_elvis_lhs = this.i4p().d1(codePoint);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var g = tmp;
  // Inline function 'kotlin.takeIf' call
  var this_0 = this.a4q(size, codePoint, metrics, reader);
  // Inline function 'kotlin.contracts.contract' call
  var tmp_0;
  // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>' call
  if (this_0.c4q_1) {
    tmp_0 = this_0;
  } else {
    tmp_0 = null;
  }
  if (tmp_0 == null)
    return false;
  if (metrics.m2i() === 0.0 && metrics.n2i() === 0.0)
    return false;
  var texX = pos.e25_1 + metrics.v25();
  var texY = pos.f25_1 + metrics.x25();
  var swidth = metrics.m2i();
  var sheight = metrics.n2i();
  var tmp_1;
  if (equals(ctx.j4r(), new RGBA(get_DefaultPaint()))) {
    tmp_1 = g.e4p();
  } else {
    // Inline function 'korlibs.image.bitmap.context2d' call
    var this_1 = Bitmap32.e3x(g.e4p().l3x_1, g.e4p().m3x_1, VOID, true);
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = this_1.p3x_1;
    if (true) {
      this_1.y3x();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx_0 = this_1.h45(true);
      try {
        // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>' call
        // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
        var t = ctx_0.m45_1.n4q_1;
        try {
          // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>.<anonymous>' call
          ctx_0.i4r(1.0 / scale);
          ctx_0.k4r(ctx.j4r());
          // Inline function 'korlibs.image.vector.Context2d.fillRect' call
          var width = ctx_0.m2i() * scale;
          var height = ctx_0.n2i() * scale;
          ctx_0.l4r(numberToDouble(0), numberToDouble(0), numberToDouble(width), numberToDouble(height));
        }finally {
          ctx_0.m45_1.n4q_1 = t;
        }
      }finally {
        ctx_0.d18();
      }
    }finally {
      result = true ? this_1.a3y(rect) : 0;
    }
    var bmpFill = this_1;
    bmpFill.n47(BitmapChannel_ALPHA_getInstance(), g.e4p(), BitmapChannel_ALPHA_getInstance());
    tmp_1 = bmpFill;
  }
  var bmp = tmp_1;
  if (beforeDraw == null)
    null;
  else
    beforeDraw();
  ctx.m4r(bmp, Vector2D.n27(texX, texY - metrics.y25()), Size2D.b2e(swidth, sheight));
  return true;
}
function getKerning(size, leftCodePoint, rightCodePoint) {
  var tmp = this.j4q(size);
  var tmp40_safe_receiver = this.i4q(leftCodePoint, rightCodePoint);
  var tmp41_safe_receiver = tmp40_safe_receiver == null ? null : tmp40_safe_receiver.b4p_1;
  var tmp0_elvis_lhs = tmp41_safe_receiver == null ? null : tmp41_safe_receiver;
  return tmp * (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
}
class BitmapFontImpl {
  constructor(fontSize, lineHeight, base, glyphs, kernings, name, distanceField) {
    name = name === VOID ? 'BitmapFont' : name;
    distanceField = distanceField === VOID ? null : distanceField;
    this.p4r_1 = new Mixin();
    this.q4r_1 = fontSize;
    this.r4r_1 = lineHeight;
    this.s4r_1 = base;
    this.t4r_1 = glyphs;
    this.u4r_1 = kernings;
    this.v4r_1 = name;
    this.w4r_1 = distanceField;
    this.x4r_1 = this.r4r_1 - this.s4r_1;
    var tmp = this;
    tmp.y4r_1 = lazy(BitmapFontImpl$naturalFontMetrics$delegate$lambda(this));
    this.z4r_1 = new GlyphMetrics(this.q4r_1, false, 0, Companion_getInstance_4().a29(), 0.0);
    var tmp_0 = this;
    tmp_0.a4s_1 = lazy(BitmapFontImpl$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.b4s_1 = lazy(BitmapFontImpl$invalidGlyph$delegate$lambda(this));
  }
  vx(_set____db54di) {
    this.p4r_1.vx(_set____db54di);
  }
  wx() {
    return this.p4r_1.wx();
  }
  f4p() {
    return this.q4r_1;
  }
  g4p() {
    return this.r4r_1;
  }
  b3h() {
    return this.s4r_1;
  }
  i4p() {
    return this.t4r_1;
  }
  j4p() {
    return this.u4r_1;
  }
  o3() {
    return this.v4r_1;
  }
  h4p() {
    return this.w4r_1;
  }
  zy() {
    return this;
  }
  m4p() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y4r_1;
    naturalFontMetrics$factory();
    return this_0.r1();
  }
  n4p() {
    return this.z4r_1;
  }
  i4q(first, second) {
    return this.u4r_1.d1(Companion_instance_15.q4o(first, second));
  }
  y2l(codePoint) {
    return this.t4r_1.d1(codePoint);
  }
  l4p() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.a4s_1;
    anyGlyph$factory();
    return this_0.r1();
  }
  c4s() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b4s_1;
    invalidGlyph$factory();
    return this_0.r1();
  }
}
class TextToBitmapResult {
  constructor(bmp, fmetrics, metrics, glyphs, glyphsPerLine, shape) {
    shape = shape === VOID ? null : shape;
    this.s4u_1 = bmp;
    this.t4u_1 = fmetrics;
    this.u4u_1 = metrics;
    this.v4u_1 = glyphs;
    this.w4u_1 = glyphsPerLine;
    this.x4u_1 = shape;
  }
  toString() {
    return 'TextToBitmapResult(bmp=' + toString_0(this.s4u_1) + ', fmetrics=' + this.t4u_1.toString() + ', metrics=' + this.u4u_1.toString() + ', glyphs=' + toString_0(this.v4u_1) + ', glyphsPerLine=' + toString_0(this.w4u_1) + ', shape=' + toString(this.x4u_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.s4u_1);
    result = imul(result, 31) + this.t4u_1.hashCode() | 0;
    result = imul(result, 31) + this.u4u_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.v4u_1) | 0;
    result = imul(result, 31) + hashCode(this.w4u_1) | 0;
    result = imul(result, 31) + (this.x4u_1 == null ? 0 : hashCode(this.x4u_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextToBitmapResult))
      return false;
    var tmp0_other_with_cast = other instanceof TextToBitmapResult ? other : THROW_CCE();
    if (!equals(this.s4u_1, tmp0_other_with_cast.s4u_1))
      return false;
    if (!this.t4u_1.equals(tmp0_other_with_cast.t4u_1))
      return false;
    if (!this.u4u_1.equals(tmp0_other_with_cast.u4u_1))
      return false;
    if (!equals(this.v4u_1, tmp0_other_with_cast.v4u_1))
      return false;
    if (!equals(this.w4u_1, tmp0_other_with_cast.w4u_1))
      return false;
    if (!equals(this.x4u_1, tmp0_other_with_cast.x4u_1))
      return false;
    return true;
  }
}
class PlacedGlyphMetrics {
  constructor(codePoint, pos, metrics, fontMetrics, transform, index, nline) {
    this.j4v_1 = codePoint;
    this.k4v_1 = pos;
    this.l4v_1 = metrics;
    this.m4v_1 = fontMetrics;
    this.n4v_1 = transform;
    this.o4v_1 = index;
    this.p4v_1 = nline;
    var tmp = this;
    tmp.q4v_1 = lazy(PlacedGlyphMetrics$boundsPath$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.r4v_1 = lazy(PlacedGlyphMetrics$boundsPathCurves$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.s4v_1 = lazy(PlacedGlyphMetrics$caretStart$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.t4v_1 = lazy(PlacedGlyphMetrics$caretEnd$delegate$lambda(this));
  }
  u4v() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q4v_1;
    boundsPath$factory();
    return this_0.r1();
  }
  v4v() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.r4v_1;
    boundsPathCurves$factory();
    return this_0.r1();
  }
  w4v() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s4v_1;
    caretStart$factory();
    return this_0.r1();
  }
  x4v() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t4v_1;
    caretEnd$factory();
    return this_0.r1();
  }
  y4v(x, y, startEnd) {
    if (this.u4v().k3p(x, y))
      return 0.0;
    var tmp;
    switch (startEnd) {
      case true:
        tmp = this.w4v().l3b(Companion_getInstance_9().mx_1);
        break;
      case false:
        tmp = this.x4v().l3b(Companion_getInstance_9().mx_1);
        break;
      case null:
        // Inline function 'korlibs.math.geom.Companion.middle' call

        Companion_getInstance_6();
        var a = this.w4v().l3b(Companion_getInstance_9().mx_1);
        // Inline function 'korlibs.math.geom.Vector2D.times' call

        // Inline function 'korlibs.math.geom.Vector2D.plus' call

        var that = this.x4v().l3b(Companion_getInstance_9().mx_1);
        var this_0 = Vector2D.n27(a.e25_1 + that.e25_1, a.f25_1 + that.f25_1);
        tmp = Vector2D.n27(this_0.e25_1 * 0.5, this_0.f25_1 * 0.5);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var middle = tmp;
    return Companion_getInstance_6().a2f(middle.e25_1, middle.f25_1, x, y);
  }
  z4v(p, startEnd) {
    return this.y4v(p.e25_1, p.f25_1, startEnd);
  }
  a4w(p, startEnd, $super) {
    startEnd = startEnd === VOID ? null : startEnd;
    return $super === VOID ? this.z4v(p, startEnd) : $super.z4v.call(this, p, startEnd);
  }
  toString() {
    return 'PlacedGlyphMetrics(codePoint=' + this.j4v_1 + ', pos=' + this.k4v_1.toString() + ', metrics=' + this.l4v_1.toString() + ', fontMetrics=' + this.m4v_1.toString() + ', transform=' + this.n4v_1.toString() + ', index=' + this.o4v_1 + ', nline=' + this.p4v_1 + ')';
  }
  hashCode() {
    var result = this.j4v_1;
    result = imul(result, 31) + this.k4v_1.hashCode() | 0;
    result = imul(result, 31) + this.l4v_1.hashCode() | 0;
    result = imul(result, 31) + this.m4v_1.hashCode() | 0;
    result = imul(result, 31) + this.n4v_1.hashCode() | 0;
    result = imul(result, 31) + this.o4v_1 | 0;
    result = imul(result, 31) + this.p4v_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlacedGlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof PlacedGlyphMetrics ? other : THROW_CCE();
    if (!(this.j4v_1 === tmp0_other_with_cast.j4v_1))
      return false;
    if (!this.k4v_1.equals(tmp0_other_with_cast.k4v_1))
      return false;
    if (!this.l4v_1.equals(tmp0_other_with_cast.l4v_1))
      return false;
    if (!this.m4v_1.equals(tmp0_other_with_cast.m4v_1))
      return false;
    if (!this.n4v_1.equals(tmp0_other_with_cast.n4v_1))
      return false;
    if (!(this.o4v_1 === tmp0_other_with_cast.o4v_1))
      return false;
    if (!(this.p4v_1 === tmp0_other_with_cast.p4v_1))
      return false;
    return true;
  }
}
class TextMetricsResult {
  constructor(fmetrics, metrics, glyphs, glyphsPerLine) {
    fmetrics = fmetrics === VOID ? new FontMetrics() : fmetrics;
    metrics = metrics === VOID ? new TextMetrics() : metrics;
    glyphs = glyphs === VOID ? emptyList() : glyphs;
    glyphsPerLine = glyphsPerLine === VOID ? emptyList() : glyphsPerLine;
    this.b4w_1 = fmetrics;
    this.c4w_1 = metrics;
    this.d4w_1 = glyphs;
    this.e4w_1 = glyphsPerLine;
  }
  toString() {
    return 'TextMetricsResult(fmetrics=' + this.b4w_1.toString() + ', metrics=' + this.c4w_1.toString() + ', glyphs=' + toString_0(this.d4w_1) + ', glyphsPerLine=' + toString_0(this.e4w_1) + ')';
  }
  hashCode() {
    var result = this.b4w_1.hashCode();
    result = imul(result, 31) + this.c4w_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.d4w_1) | 0;
    result = imul(result, 31) + hashCode(this.e4w_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetricsResult))
      return false;
    var tmp0_other_with_cast = other instanceof TextMetricsResult ? other : THROW_CCE();
    if (!this.b4w_1.equals(tmp0_other_with_cast.b4w_1))
      return false;
    if (!this.c4w_1.equals(tmp0_other_with_cast.c4w_1))
      return false;
    if (!equals(this.d4w_1, tmp0_other_with_cast.d4w_1))
      return false;
    if (!equals(this.e4w_1, tmp0_other_with_cast.e4w_1))
      return false;
    return true;
  }
}
class MultiplePlacedGlyphMetrics {
  constructor() {
    this.g4x_1 = FastArrayList.ny();
    this.h4x_1 = FastArrayList.ny();
  }
  e1() {
    return this.g4x_1.e1();
  }
  m4y(glyph) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.g4x_1.h(glyph);
    while (this.h4x_1.e1() <= glyph.p4v_1) {
      this.h4x_1.h(FastArrayList.ny());
    }
    this.h4x_1.d1(glyph.p4v_1).h(glyph);
  }
}
class ITextRendererActions {}
function reset() {
  this.w50(Companion_getInstance_6().g25_1);
}
function advance(x) {
  // Inline function 'korlibs.math.geom.Vector2D.plus' call
  var this_0 = this.tw();
  var that = Vector2D.n27(x, 0.0);
  var tmp$ret$0 = Vector2D.n27(this_0.e25_1 + that.e25_1, this_0.f25_1 + that.f25_1);
  this.w50(tmp$ret$0);
}
function newLine(y, end) {
  this.w50(Vector2D.n27(0.0, this.tw().f25_1 + y));
  var _unary__edvuaz = this.o50();
  this.u50(_unary__edvuaz + 1 | 0);
}
class TextRendererActions {
  constructor($box) {
    boxApply(this, $box);
    this.e50_1 = new GlyphPath();
    this.f50_1 = new GlyphMetrics();
    this.g50_1 = new FontMetrics();
    this.h50_1 = 0;
    this.j50_1 = 0.0;
    this.k50_1 = Companion_getInstance_6().g25_1;
    this.l50_1 = Companion_getInstance_5().x28_1;
    this.m50_1 = null;
    this.n50_1 = Colors_getInstance().s3y_1;
  }
  g4p() {
    return this.g50_1.g4p();
  }
  u50(_set____db54di) {
    this.h50_1 = _set____db54di;
  }
  o50() {
    return this.h50_1;
  }
  t50() {
    var tmp = this.i50_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('font');
    }
  }
  v50(font, size) {
    this.i50_1 = font;
    this.j50_1 = size;
    font.o4p(size, this.g50_1);
  }
  w50(_set____db54di) {
    this.k50_1 = _set____db54di;
  }
  tw() {
    return this.k50_1;
  }
  x50(reader, codePoint) {
    return this.t50().a4q(this.j50_1, codePoint, this.f50_1, reader);
  }
  y50(_set____db54di) {
    this.l50_1 = _set____db54di;
  }
  r50() {
    return this.l50_1;
  }
  i4q(leftCodePoint, rightCodePoint) {
    return this.t50().o4r(this.j50_1, leftCodePoint, rightCodePoint);
  }
}
class drawText$actions$1 extends TextRendererActions {
  constructor($renderer, $text, $size, $fnt, $align, $pos, $ctx, $paint, $textRangeStart, $textRangeEnd, $doRender, $glyphs, $placed, $box) {
    if ($box === VOID)
      $box = {};
    $box.t4z_1 = $size;
    $box.u4z_1 = $align;
    $box.v4z_1 = $pos;
    $box.w4z_1 = $ctx;
    $box.x4z_1 = $paint;
    $box.y4z_1 = $textRangeStart;
    $box.z4z_1 = $textRangeEnd;
    $box.a50_1 = $doRender;
    $box.b50_1 = $glyphs;
    $box.c50_1 = $placed;
    super($box);
    this.r4z_1 = measure($renderer, $text, $size, $fnt);
    this.s4z_1 = 0;
  }
  d50(reader, codePoint) {
    var nline = this.o50();
    var dx = this.r4z_1.p50(this.u4z_1.d4y_1, nline);
    var dy = this.r4z_1.g4y(this.u4z_1.e4y_1, this.g50_1);
    var px = this.tw().e25_1 + this.v4z_1.e25_1 - dx;
    var py = this.tw().f25_1 + this.v4z_1.f25_1 + dy;
    var tmp71_safe_receiver = this.w4z_1;
    if (tmp71_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
      var t = tmp71_safe_receiver.m45_1.n4q_1;
      try {
        // Inline function 'korlibs.image.font.<no name provided>.put.<anonymous>' call
        this.w4z_1.q50(px, py);
        this.w4z_1.s50(get_immutable(this.r50()));
        var tmp0_elvis_lhs = this.m50_1;
        var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.x4z_1 : tmp0_elvis_lhs;
        this.w4z_1.k4r(tmp1_elvis_lhs == null ? NonePaint_instance : tmp1_elvis_lhs);
        var containsLower = this.y4z_1;
        var containsUpper = this.z4z_1;
        var containsArg = this.s4z_1;
        if (containsLower <= containsArg ? containsArg < containsUpper : false) {
          this.t50().m4q(this.w4z_1, this.t4z_1, codePoint, Companion_getInstance_6().g25_1, null, this.f50_1, reader, this.a50_1);
        }
        this.s4z_1 = this.s4z_1 + 1 | 0;
      }finally {
        tmp71_safe_receiver.m45_1.n4q_1 = t;
      }
    }
    if (!(this.b50_1 == null)) {
      var glyph = new PlacedGlyphMetrics(codePoint, Vector2D.n27(px, py), this.f50_1.sx(), this.g50_1.sx(), this.r50(), this.b50_1.e1(), nline);
      this.b50_1.m4y(glyph);
    }
    var tmp72_safe_receiver = this.c50_1;
    if (tmp72_safe_receiver == null)
      null;
    else
      tmp72_safe_receiver(this, codePoint, Vector2D.n27(px, py), this.t4z_1, this.f50_1, this.g50_1, this.r50());
    return this.f50_1;
  }
}
class GlyphPath {
  constructor(path, colorShape, bitmap, bitmapOffset, bitmapScale, transform, scale) {
    path = path === VOID ? new VectorPath() : path;
    colorShape = colorShape === VOID ? null : colorShape;
    bitmap = bitmap === VOID ? null : bitmap;
    bitmapOffset = bitmapOffset === VOID ? Vector2D.a28(0, 0) : bitmapOffset;
    bitmapScale = bitmapScale === VOID ? Scale.q2f(1, 1) : bitmapScale;
    transform = transform === VOID ? Companion_getInstance_5().a29() : transform;
    scale = scale === VOID ? 1.0 : scale;
    this.b51_1 = path;
    this.c51_1 = colorShape;
    this.d51_1 = bitmap;
    this.e51_1 = bitmapOffset;
    this.f51_1 = bitmapScale;
    this.g51_1 = transform;
    this.h51_1 = scale;
  }
  i51() {
    return this.d51_1 == null && this.c51_1 == null;
  }
  j51(c) {
    // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
    var t = c.m45_1.n4q_1;
    try {
      // Inline function 'korlibs.image.font.GlyphPath.draw.<anonymous>' call
      c.s50(this.g51_1);
      if (!(this.d51_1 == null)) {
        c.m4r(ensureNotNull(this.d51_1), this.e51_1, toFloat(ensureNotNull(this.d51_1).e1()).e2g(this.f51_1));
      } else if (!(this.c51_1 == null)) {
        c.k51(ensureNotNull(this.c51_1));
        c.f4x();
      } else {
        draw_1(c, this.b51_1);
      }
    }finally {
      c.m45_1.n4q_1 = t;
    }
  }
  toString() {
    return 'GlyphPath(path=' + this.b51_1.toString() + ', colorShape=' + toString(this.c51_1) + ', bitmap=' + toString(this.d51_1) + ', bitmapOffset=' + this.e51_1.toString() + ', bitmapScale=' + this.f51_1.toString() + ', transform=' + this.g51_1.toString() + ', scale=' + this.h51_1 + ')';
  }
  hashCode() {
    var result = this.b51_1.hashCode();
    result = imul(result, 31) + (this.c51_1 == null ? 0 : hashCode(this.c51_1)) | 0;
    result = imul(result, 31) + (this.d51_1 == null ? 0 : hashCode(this.d51_1)) | 0;
    result = imul(result, 31) + this.e51_1.hashCode() | 0;
    result = imul(result, 31) + this.f51_1.hashCode() | 0;
    result = imul(result, 31) + this.g51_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.h51_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphPath ? other : THROW_CCE();
    if (!this.b51_1.equals(tmp0_other_with_cast.b51_1))
      return false;
    if (!equals(this.c51_1, tmp0_other_with_cast.c51_1))
      return false;
    if (!equals(this.d51_1, tmp0_other_with_cast.d51_1))
      return false;
    if (!this.e51_1.equals(tmp0_other_with_cast.e51_1))
      return false;
    if (!this.f51_1.equals(tmp0_other_with_cast.f51_1))
      return false;
    if (!this.g51_1.equals(tmp0_other_with_cast.g51_1))
      return false;
    if (!equals(this.h51_1, tmp0_other_with_cast.h51_1))
      return false;
    return true;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_17 = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(32);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    tmp.l51_1 = new Int32Array([tmp$ret$0]);
  }
}
class LazyBitmapFont {
  constructor(font, fontSize, distanceField) {
    Companion_getInstance_27();
    distanceField = distanceField === VOID ? null : distanceField;
    this.m51_1 = new Mixin();
    this.n51_1 = font;
    this.o51_1 = fontSize;
    this.p51_1 = distanceField;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = MutableAtlas.h3x(1024, 1024, 2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.LazyBitmapFont.atlas.<anonymous>' call
    if (!(this.p51_1 == null))
      this_0.j3w_1;
    else
      mipmaps(this_0.j3w_1);
    tmp.q51_1 = this_0;
    this.r51_1 = this.n51_1.z4p(this.o51_1);
    this.s51_1 = this.r51_1.g4p();
    this.t51_1 = this.r51_1.s4p_1;
    this.u51_1 = IntMap.i2o();
    this.v51_1 = IntMap.i2o();
    var tmp_0 = this;
    tmp_0.w51_1 = lazy(LazyBitmapFont$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.x51_1 = lazy(LazyBitmapFont$invalidGlyph$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.y51_1 = lazy(LazyBitmapFont$naturalFontMetrics$delegate$lambda(this));
    this.z51_1 = new GlyphMetrics(this.o51_1, false, 0, Companion_getInstance_4().a29(), 0.0);
  }
  vx(_set____db54di) {
    this.m51_1.vx(_set____db54di);
  }
  wx() {
    return this.m51_1.wx();
  }
  f4p() {
    return this.o51_1;
  }
  h4p() {
    return this.p51_1;
  }
  g4p() {
    return this.s51_1;
  }
  b3h() {
    return this.t51_1;
  }
  i4p() {
    return this.u51_1;
  }
  j4p() {
    return this.v51_1;
  }
  l4p() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w51_1;
    anyGlyph$factory_0();
    return this_0.r1();
  }
  c4s() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x51_1;
    invalidGlyph$factory_0();
    return this_0.r1();
  }
  o3() {
    return this.n51_1.o3();
  }
  m4p() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y51_1;
    naturalFontMetrics$factory_0();
    return this_0.r1();
  }
  n4p() {
    return this.z51_1;
  }
  i4q(first, second) {
    var kerning = this.n51_1.o4r(this.o51_1, first, second);
    var tmp;
    if (kerning === 0.0) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var this_0 = this.v51_1;
      var key = Companion_instance_15.q4o(first, second);
      var res = this_0.d1(key);
      if (res == null) {
        // Inline function 'korlibs.image.font.LazyBitmapFont.getKerning.<anonymous>' call
        var tmp$ret$0 = new Kerning(first, second, numberToInt(kerning));
        this_0.c2o(key, tmp$ret$0);
      }
      tmp = ensureNotNull(this_0.d1(key));
    }
    return tmp;
  }
  y2l(codePoint) {
    if (this.u51_1.d1(codePoint) == null) {
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(97);
      var tmp = Char__toInt_impl_vasixd(this_0);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(122);
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
      this.a52(codePoint, numberRangeToNumber(tmp, tmp$ret$1));
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(65);
      var tmp_0 = Char__toInt_impl_vasixd(this_2);
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(90);
      var tmp$ret$3 = Char__toInt_impl_vasixd(this_3);
      this.a52(codePoint, numberRangeToNumber(tmp_0, tmp$ret$3));
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(48);
      var tmp_1 = Char__toInt_impl_vasixd(this_4);
      // Inline function 'kotlin.code' call
      var this_5 = _Char___init__impl__6a9atx(57);
      var tmp$ret$5 = Char__toInt_impl_vasixd(this_5);
      this.a52(codePoint, numberRangeToNumber(tmp_1, tmp$ret$5));
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$6 = new Int32Array([codePoint]);
      this.b52(tmp$ret$6);
    }
    return this.u51_1.d1(codePoint);
  }
  a52(codePoint, range) {
    var containsLower = range.a2_1;
    if (codePoint <= range.b2_1 ? containsLower <= codePoint : false) {
      // Inline function 'korlibs.datastructure.toIntList' call
      // Inline function 'kotlin.also' call
      var this_0 = IntArrayList.n2j(coerceAtLeast(range.e2() - range.f2() | 0, 0));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.toIntList.<anonymous>' call
      var inductionVariable = range.f2();
      var last = range.e2();
      if (inductionVariable <= last)
        do {
          var v = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.t2j(v);
        }
         while (!(v === last));
      this.b52(this_0.g2k());
    }
  }
  b52(codePoints) {
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var this_0 = this.q51_1.j3w_1;
    var rect = this_0.p3x_1;
    if (true) {
      this_0.y3x();
    }
    var result;
    try {
      // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>' call
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < codePoints.length) {
        // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var codePoint = codePoints[_unary__edvuaz];
        // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
        var this_1 = this.u51_1;
        var res = this_1.d1(codePoint);
        if (res == null) {
          // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>.<anonymous>.<anonymous>' call
          var tmp;
          if (!(this.p51_1 == null)) {
            // Inline function 'kotlin.math.max' call
            var b = toIntCeil_0(this.o51_1 / 8.0);
            tmp = Math.max(4, b);
          } else {
            tmp = 1;
          }
          var border = tmp;
          var tmp83_$receiver = this.n51_1;
          var tmp84_size = this.o51_1;
          var tmp85_paint = Colors_getInstance().s3y_1;
          var result_0 = renderGlyphToBitmap(tmp83_$receiver, tmp84_size, codePoint, new RGBA(tmp85_paint), true, null, border);
          var bmp = result_0.s4u_1.x3x();
          var rbmp;
          switch (this.p51_1) {
            case 'msdf':
              rbmp = msdfBmp(ensureNotNull(result_0.x4u_1).c52(), bmp.l3x_1, bmp.m3x_1);
              break;
            case 'sdf':
              rbmp = sdfBmp(ensureNotNull(result_0.x4u_1).c52(), bmp.l3x_1, bmp.m3x_1);
              break;
            default:
              rbmp = bmp;
              break;
          }
          var entry = this.q51_1.j3x(rbmp, Unit_instance);
          var slice = entry.b3w_1.h3h(border, border, entry.b3w_1.b3g_1 - border | 0, entry.b3w_1.c3g_1 - border | 0);
          var g = first_0(result_0.v4u_1);
          var m = g.l4v_1;
          var xadvance = m.f4q_1;
          var tmp$ret$1 = new Glyph(this.o51_1, codePoint, slice, -toIntRound(g.k4v_1.e25_1) | 0, -toIntRound(g.k4v_1.f25_1) | 0, toIntRound(xadvance));
          this_1.c2o(codePoint, tmp$ret$1);
        }
        ensureNotNull(this_1.d1(codePoint));
      }
    }finally {
      result = true ? this_0.a3y(rect) : 0;
    }
  }
}
class FontMetrics {
  constructor(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) {
    size = size === VOID ? 0.0 : size;
    top = top === VOID ? 0.0 : top;
    ascent = ascent === VOID ? 0.0 : ascent;
    baseline = baseline === VOID ? 0.0 : baseline;
    descent = descent === VOID ? 0.0 : descent;
    bottom = bottom === VOID ? 0.0 : bottom;
    lineGap = lineGap === VOID ? 0.0 : lineGap;
    maxWidth = maxWidth === VOID ? 0.0 : maxWidth;
    unitsPerEm = unitsPerEm === VOID ? 0.0 : unitsPerEm;
    this.p4p_1 = size;
    this.q4p_1 = top;
    this.r4p_1 = ascent;
    this.s4p_1 = baseline;
    this.t4p_1 = descent;
    this.u4p_1 = bottom;
    this.v4p_1 = lineGap;
    this.w4p_1 = maxWidth;
    this.x4p_1 = unitsPerEm;
  }
  d52() {
    // Inline function 'kotlin.math.max' call
    var a = this.r4p_1;
    var b = this.q4p_1;
    return Math.max(a, b);
  }
  e52() {
    // Inline function 'kotlin.math.min' call
    var a = this.t4p_1;
    var b = this.u4p_1;
    return Math.min(a, b);
  }
  f52() {
    return this.d52() - this.e52();
  }
  g4p() {
    return this.f52() + this.v4p_1;
  }
  m4x(other) {
    return this.g52(other, 1.0);
  }
  y4p(other, size) {
    return this.g52(other, size / other.p4p_1);
  }
  g52(other, scale) {
    this.p4p_1 = other.p4p_1 * scale;
    this.q4p_1 = other.q4p_1 * scale;
    this.r4p_1 = other.r4p_1 * scale;
    this.s4p_1 = other.s4p_1 * scale;
    this.t4p_1 = other.t4p_1 * scale;
    this.u4p_1 = other.u4p_1 * scale;
    this.v4p_1 = other.v4p_1 * scale;
    this.x4p_1 = other.x4p_1 * scale;
    this.w4p_1 = other.w4p_1 * scale;
    return this;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.FontMetrics.toString.<anonymous>' call
    this_0.ob('FontMetrics(');
    this_0.ob('size=' + niceStr(this.p4p_1, 1) + ', ');
    this_0.ob('top=' + niceStr(this.q4p_1, 1) + ', ');
    this_0.ob('ascent=' + niceStr(this.r4p_1, 1) + ', ');
    this_0.ob('baseline=' + niceStr(this.s4p_1, 1) + ', ');
    this_0.ob('descent=' + niceStr(this.t4p_1, 1) + ', ');
    this_0.ob('bottom=' + niceStr(this.u4p_1, 1) + ', ');
    this_0.ob('lineGap=' + niceStr(this.v4p_1, 1) + ', ');
    this_0.ob('unitsPerEm=' + niceStr(this.x4p_1, 1) + ', ');
    this_0.ob('maxWidth=' + niceStr(this.w4p_1, 1) + ', ');
    this_0.ob('lineHeight=' + niceStr(this.g4p(), 1));
    this_0.ob(')');
    return this_0.toString();
  }
  sx() {
    return this.h52();
  }
  i52(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) {
    return new FontMetrics(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm);
  }
  h52(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm, $super) {
    size = size === VOID ? this.p4p_1 : size;
    top = top === VOID ? this.q4p_1 : top;
    ascent = ascent === VOID ? this.r4p_1 : ascent;
    baseline = baseline === VOID ? this.s4p_1 : baseline;
    descent = descent === VOID ? this.t4p_1 : descent;
    bottom = bottom === VOID ? this.u4p_1 : bottom;
    lineGap = lineGap === VOID ? this.v4p_1 : lineGap;
    maxWidth = maxWidth === VOID ? this.w4p_1 : maxWidth;
    unitsPerEm = unitsPerEm === VOID ? this.x4p_1 : unitsPerEm;
    return $super === VOID ? this.i52(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) : $super.i52.call(this, size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm);
  }
  hashCode() {
    var result = getNumberHashCode(this.p4p_1);
    result = imul(result, 31) + getNumberHashCode(this.q4p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r4p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s4p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.t4p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.u4p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v4p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w4p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.x4p_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FontMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof FontMetrics ? other : THROW_CCE();
    if (!equals(this.p4p_1, tmp0_other_with_cast.p4p_1))
      return false;
    if (!equals(this.q4p_1, tmp0_other_with_cast.q4p_1))
      return false;
    if (!equals(this.r4p_1, tmp0_other_with_cast.r4p_1))
      return false;
    if (!equals(this.s4p_1, tmp0_other_with_cast.s4p_1))
      return false;
    if (!equals(this.t4p_1, tmp0_other_with_cast.t4p_1))
      return false;
    if (!equals(this.u4p_1, tmp0_other_with_cast.u4p_1))
      return false;
    if (!equals(this.v4p_1, tmp0_other_with_cast.v4p_1))
      return false;
    if (!equals(this.w4p_1, tmp0_other_with_cast.w4p_1))
      return false;
    if (!equals(this.x4p_1, tmp0_other_with_cast.x4p_1))
      return false;
    return true;
  }
}
class GlyphMetrics {
  constructor(size, existing, codePoint, bounds, xadvance) {
    size = size === VOID ? 0.0 : size;
    existing = existing === VOID ? false : existing;
    codePoint = codePoint === VOID ? 0 : codePoint;
    bounds = bounds === VOID ? Companion_getInstance_4().a29() : bounds;
    xadvance = xadvance === VOID ? 0.0 : xadvance;
    this.b4q_1 = size;
    this.c4q_1 = existing;
    this.d4q_1 = codePoint;
    this.e4q_1 = bounds;
    this.f4q_1 = xadvance;
  }
  y25() {
    return this.e4q_1.y25();
  }
  v25() {
    return this.e4q_1.v25();
  }
  x25() {
    return this.e4q_1.x25();
  }
  m2i() {
    return this.e4q_1.q25_1;
  }
  n2i() {
    return this.e4q_1.r25_1;
  }
  sx() {
    return this.j52(VOID, VOID, VOID, this.e4q_1.sx());
  }
  g4q(other, size, codePoint) {
    return this.k52(other, size / other.b4q_1, codePoint);
  }
  k52(other, scale, codePoint) {
    this.b4q_1 = other.b4q_1;
    this.c4q_1 = other.c4q_1;
    this.d4q_1 = codePoint;
    this.e4q_1 = other.e4q_1.t2d(scale);
    this.f4q_1 = other.f4q_1 * scale;
    return this;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.GlyphMetrics.toString.<anonymous>' call
    this_0.ob('GlyphMetrics(');
    this_0.ob('codePoint=' + this.d4q_1 + " ('" + toString_1(numberToChar(this.d4q_1)) + "'), ");
    this_0.ob('existing=' + this.c4q_1 + ', ');
    this_0.ob('xadvance=' + roundToInt(this.f4q_1) + ', ');
    this_0.ob('bounds=' + this.e4q_1.i2().toString());
    this_0.ob(')');
    return this_0.toString();
  }
  l52(size, existing, codePoint, bounds, xadvance) {
    return new GlyphMetrics(size, existing, codePoint, bounds, xadvance);
  }
  j52(size, existing, codePoint, bounds, xadvance, $super) {
    size = size === VOID ? this.b4q_1 : size;
    existing = existing === VOID ? this.c4q_1 : existing;
    codePoint = codePoint === VOID ? this.d4q_1 : codePoint;
    bounds = bounds === VOID ? this.e4q_1 : bounds;
    xadvance = xadvance === VOID ? this.f4q_1 : xadvance;
    return $super === VOID ? this.l52(size, existing, codePoint, bounds, xadvance) : $super.l52.call(this, size, existing, codePoint, bounds, xadvance);
  }
  hashCode() {
    var result = getNumberHashCode(this.b4q_1);
    result = imul(result, 31) + getBooleanHashCode(this.c4q_1) | 0;
    result = imul(result, 31) + this.d4q_1 | 0;
    result = imul(result, 31) + this.e4q_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.f4q_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphMetrics ? other : THROW_CCE();
    if (!equals(this.b4q_1, tmp0_other_with_cast.b4q_1))
      return false;
    if (!(this.c4q_1 === tmp0_other_with_cast.c4q_1))
      return false;
    if (!(this.d4q_1 === tmp0_other_with_cast.d4q_1))
      return false;
    if (!this.e4q_1.equals(tmp0_other_with_cast.e4q_1))
      return false;
    if (!equals(this.f4q_1, tmp0_other_with_cast.f4q_1))
      return false;
    return true;
  }
}
class TextMetrics {
  constructor(bounds, lineBounds, fontMetrics, nlines) {
    bounds = bounds === VOID ? Companion_getInstance_4().a29() : bounds;
    lineBounds = lineBounds === VOID ? emptyList() : lineBounds;
    fontMetrics = fontMetrics === VOID ? new FontMetrics() : fontMetrics;
    nlines = nlines === VOID ? 0 : nlines;
    this.i4x_1 = bounds;
    this.j4x_1 = lineBounds;
    this.k4x_1 = fontMetrics;
    this.l4x_1 = nlines;
  }
  m52() {
    var tmp0_elvis_lhs = firstOrNull_0(this.j4x_1);
    return tmp0_elvis_lhs == null ? Companion_getInstance_4().a26_1 : tmp0_elvis_lhs;
  }
  v25() {
    return this.i4x_1.v25();
  }
  x25() {
    return this.i4x_1.x25();
  }
  m2i() {
    return this.i4x_1.q25_1;
  }
  n2i() {
    return this.i4x_1.r25_1;
  }
  n52() {
    return -this.v25();
  }
  o52() {
    return this.m52().r25_1 + this.m52().x25();
  }
  l4y() {
    return this.k4x_1.r4p_1;
  }
  g4p() {
    return this.k4x_1.g4p();
  }
  toString() {
    return 'TextMetrics[' + get_niceStr_0(this.v25()) + ', ' + get_niceStr_0(this.x25()) + ', ' + get_niceStr_0(this.m2i()) + ', ' + get_niceStr_0(this.n2i()) + '][' + get_niceStr_0(this.n52()) + ', ' + get_niceStr_0(this.o52()) + ']';
  }
  hashCode() {
    var result = this.i4x_1.hashCode();
    result = imul(result, 31) + hashCode(this.j4x_1) | 0;
    result = imul(result, 31) + this.k4x_1.hashCode() | 0;
    result = imul(result, 31) + this.l4x_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof TextMetrics ? other : THROW_CCE();
    if (!this.i4x_1.equals(tmp0_other_with_cast.i4x_1))
      return false;
    if (!equals(this.j4x_1, tmp0_other_with_cast.j4x_1))
      return false;
    if (!this.k4x_1.equals(tmp0_other_with_cast.k4x_1))
      return false;
    if (!(this.l4x_1 === tmp0_other_with_cast.l4x_1))
      return false;
    return true;
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_18 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_0();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.cc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.Companion.VALUES_BY_ID.<anonymous>' call
      var tmp$ret$0 = element.r52_1;
      destination.e3(tmp$ret$0, element);
    }
    tmp.s52_1 = toIntMap(destination);
  }
  d1(id) {
    return this.s52_1.d1(id);
  }
}
class GlyphPath_0 {
  constructor(path, advanceWidth) {
    this.t52_1 = path;
    this.u52_1 = advanceWidth;
  }
  toString() {
    return 'GlyphPath(path=' + this.t52_1.toString() + ', advanceWidth=' + this.u52_1 + ')';
  }
  hashCode() {
    var result = this.t52_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.u52_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath_0))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphPath_0 ? other : THROW_CCE();
    if (!this.t52_1.equals(tmp0_other_with_cast.t52_1))
      return false;
    if (!equals(this.u52_1, tmp0_other_with_cast.u52_1))
      return false;
    return true;
  }
}
class CFFResult {
  constructor(charstringsIndex, globalSubrIndex, localSubrsIndex, privateDict) {
    this.v52_1 = charstringsIndex;
    this.w52_1 = globalSubrIndex;
    this.x52_1 = localSubrsIndex;
    this.y52_1 = privateDict;
    var tmp = this;
    var tmp90_safe_receiver = this.y52_1.c3(Op_defaultWidthX_getInstance());
    var tmp91_safe_receiver = tmp90_safe_receiver == null ? null : firstOrNull_0(tmp90_safe_receiver);
    var tmp0_elvis_lhs = tmp91_safe_receiver == null ? null : numberToDouble(tmp91_safe_receiver);
    tmp.z52_1 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    var tmp_0 = this;
    var tmp92_safe_receiver = this.y52_1.c3(Op_nominalWidthX_getInstance());
    var tmp93_safe_receiver = tmp92_safe_receiver == null ? null : firstOrNull_0(tmp92_safe_receiver);
    var tmp0_elvis_lhs_0 = tmp93_safe_receiver == null ? null : numberToDouble(tmp93_safe_receiver);
    tmp_0.a53_1 = tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0;
  }
  b53(index, flipY) {
    var evalCtx = new EvalContext(this.w52_1, this.x52_1, this.z52_1, this.a53_1, index);
    var vp = new VectorPath();
    var bytes = this.v52_1.d1(index);
    CharStringType2_instance.e53(vp, openFastStream(bytes), evalCtx);
    if (flipY) {
      vp.x3p(1.0, -1.0);
    }
    return new GlyphPath_0(vp, evalCtx.o53_1);
  }
  q53(index, flipY, $super) {
    flipY = flipY === VOID ? true : flipY;
    return $super === VOID ? this.b53(index, flipY) : $super.b53.call(this, index, flipY);
  }
}
class DataIndex {
  static r53(offsets, bytes) {
    var $this = createThis(this);
    $this.c53_1 = offsets;
    $this.d53_1 = bytes;
    return $this;
  }
  static s53() {
    // Inline function 'kotlin.intArrayOf' call
    var tmp = new Int32Array([0]);
    // Inline function 'kotlin.byteArrayOf' call
    var tmp$ret$1 = new Int8Array([]);
    return this.r53(tmp, tmp$ret$1);
  }
  e1() {
    return this.c53_1.length - 1 | 0;
  }
  t53(index) {
    return this.c53_1[index + 1 | 0] - this.c53_1[index] | 0;
  }
  d1(index) {
    return copyOfRange(this.d53_1, this.c53_1[index], this.c53_1[index + 1 | 0]);
  }
  u53() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.e1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.a2_1;
    var last = this_0.b2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.DataIndex.toList.<anonymous>' call
        var it = item;
        var tmp$ret$0 = this.d1(it);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return destination;
  }
  a1() {
    return this.u53().a1();
  }
  toString() {
    var tmp = this.e1();
    var tmp_0 = toString_0(toList_0(this.c53_1));
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.e1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.a2_1;
    var last = this_0.b2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.DataIndex.toString.<anonymous>' call
        var it = item;
        var tmp$ret$0 = this.t53(it);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return 'DataIndex[' + tmp + '](' + tmp_0 + ')(' + toString_0(destination) + ')';
  }
}
class Op extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.r52_1 = id;
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_19 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_1();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.cc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.Companion.MAP.<anonymous>' call
      var tmp$ret$0 = element.x53_1;
      destination.e3(tmp$ret$0, element);
    }
    tmp.y53_1 = toIntMap(destination);
  }
  d1(id) {
    var tmp0_elvis_lhs = this.y53_1.d1(id);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'Unknown CFF CS2 operator ' + id;
      throw IllegalStateException.w4(toString_0(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
}
class EvalContext {
  constructor(globalSubrIndex, localSubrsIndex, defaultWidthX, nominalWidthX, index, heap) {
    globalSubrIndex = globalSubrIndex === VOID ? DataIndex.s53() : globalSubrIndex;
    localSubrsIndex = localSubrsIndex === VOID ? DataIndex.s53() : localSubrsIndex;
    defaultWidthX = defaultWidthX === VOID ? 0.0 : defaultWidthX;
    nominalWidthX = nominalWidthX === VOID ? 0.0 : nominalWidthX;
    index = index === VOID ? -1 : index;
    heap = heap === VOID ? new Float64Array(32) : heap;
    this.f53_1 = globalSubrIndex;
    this.g53_1 = localSubrsIndex;
    this.h53_1 = defaultWidthX;
    this.i53_1 = nominalWidthX;
    this.j53_1 = index;
    this.k53_1 = heap;
    this.l53_1 = computeSubrBias(CharStringType2_instance, this.f53_1.e1());
    this.m53_1 = computeSubrBias(CharStringType2_instance, this.g53_1.e1());
    this.n53_1 = 0;
    this.o53_1 = this.h53_1;
    this.p53_1 = false;
  }
}
class Op_0 extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.x53_1 = id;
  }
}
class CFF {
  z53(_this__u8e3s4) {
    this.a54(_this__u8e3s4);
    var nameIndex = this.b54(_this__u8e3s4);
    var topDictIndex = this.b54(_this__u8e3s4);
    var topDictByte = topDictIndex.d1(0)[1];
    var topDict = this.c54(openFastStream(topDictIndex.d1(0)));
    var stringIndex = this.b54(_this__u8e3s4);
    var globalSubrIndex = this.b54(_this__u8e3s4);
    var privateSizeOffset = topDict.c3(Op_Private_getInstance());
    var localSubrsIndex = DataIndex.s53();
    var privateDict = emptyMap();
    if (!(privateSizeOffset == null)) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(privateSizeOffset, 10));
      var tmp0_iterator = privateSizeOffset.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.image.font.CFF.readCFF.<anonymous>' call
        var tmp$ret$0 = numberToInt(item);
        destination.h(tmp$ret$0);
      }
      // Inline function 'kotlin.collections.component1' call
      var privateSize = destination.d1(0);
      // Inline function 'kotlin.collections.component2' call
      var privateOffset = destination.d1(1);
      privateDict = this.c54(_this__u8e3s4.w1p(privateOffset, privateSize));
      var localSubrs = privateDict.c3(Op_Subrs_getInstance());
      if (!(localSubrs == null)) {
        var subrsOffset = privateOffset + numberToInt(last(localSubrs)) | 0;
        localSubrsIndex = this.b54(_this__u8e3s4.x1p(subrsOffset));
      }
    }
    var charstringsOffsets = topDict.c3(Op_CharStrings_getInstance());
    var charstringsOffset = numberToInt(first_0(ensureNotNull(charstringsOffsets)));
    var charstringsIndex = this.b54(_this__u8e3s4.x1p(charstringsOffset));
    return new CFFResult(charstringsIndex, globalSubrIndex, localSubrsIndex, privateDict);
  }
  a54(_this__u8e3s4) {
    var versionMajor = _this__u8e3s4.c1q();
    var versionMinor = _this__u8e3s4.c1q();
    var headerSize = _this__u8e3s4.c1q();
    var offsetSize = _this__u8e3s4.c1q();
    if (versionMajor > 1) {
      // Inline function 'kotlin.error' call
      var message = 'Only supported CFF version 1';
      throw IllegalStateException.w4(toString_0(message));
    }
    // Inline function 'korlibs.logger.Logger.debug' call
    var this_0 = TtfCIDFont_getInstance().d54_1;
    var level = Level_DEBUG_getInstance();
    var tmp;
    if (this_0.j2t(level)) {
      // Inline function 'korlibs.image.font.CFF.readHeader.<anonymous>' call
      var tmp$ret$0 = 'CFF.versionMajor/Minor: ' + versionMajor + '.' + versionMinor + ' : headerSize=' + headerSize + ', offsetSize=' + offsetSize;
      this_0.k2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  }
  e54(_this__u8e3s4) {
    return _this__u8e3s4.c1q();
  }
  f54(_this__u8e3s4, offSize) {
    var roffSize = offSize < 0 ? this.e54(_this__u8e3s4) : offSize;
    var tmp;
    switch (roffSize) {
      case 1:
        tmp = _this__u8e3s4.c1q();
        break;
      case 2:
        tmp = _this__u8e3s4.e1q();
        break;
      case 3:
        tmp = _this__u8e3s4.f1q();
        break;
      case 4:
        tmp = _this__u8e3s4.g1q();
        break;
      default:
        reserved('' + roffSize);
        break;
    }
    return tmp;
  }
  b54(_this__u8e3s4) {
    var count = _this__u8e3s4.e1q();
    if (count === 0)
      return DataIndex.s53();
    var offSize = this.e54(_this__u8e3s4);
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_0 = until(0, count + 1 | 0);
    // Inline function 'kotlin.also' call
    var this_1 = IntArrayList.n2j((coerceAtLeast(this_0.e2() - this_0.f2() | 0, 0) / this_0.c2_1 | 0) + 1 | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var nestedFirst = this_0.f2();
    var nestedLast = this_0.e2();
    var stepArg = this_0.c2_1;
    if (stepArg <= 0)
      THROW_IAE('Step must be positive, was: ' + stepArg + '.');
    var inductionVariable = nestedFirst;
    var last = getProgressionLastElement(nestedFirst, nestedLast, stepArg);
    if (inductionVariable <= last)
      do {
        var v = inductionVariable;
        inductionVariable = inductionVariable + stepArg | 0;
        // Inline function 'korlibs.image.font.CFF.readIndex.<anonymous>' call
        var tmp$ret$0 = CFF_instance.f54(_this__u8e3s4, offSize) - 1 | 0;
        this_1.t2j(tmp$ret$0);
      }
       while (!(v === last));
    var offsets = this_1;
    var bytes = _this__u8e3s4.a1q(offsets.c2k());
    return DataIndex.r53(offsets.g2k(), bytes);
  }
  c54(_this__u8e3s4) {
    var map = LinkedHashMap.bc();
    // Inline function 'kotlin.collections.arrayListOf' call
    var values = ArrayList.h1();
    while (_this__u8e3s4.cw()) {
      var item = this.g54(_this__u8e3s4);
      if (item instanceof Op) {
        // Inline function 'kotlin.collections.set' call
        var value = toList(values);
        map.e3(item, value);
        values.h3();
      } else {
        if (isNumber(item)) {
          values.h(item);
        }
      }
    }
    return map;
  }
  g54(_this__u8e3s4) {
    var b0 = _this__u8e3s4.c1q();
    var tmp;
    if (0 <= b0 ? b0 <= 21 : false) {
      var tmp_0 = Companion_getInstance_28();
      tmp = tmp_0.d1(b0 === 12 ? b0 << 8 | _this__u8e3s4.c1q() : b0);
    } else if (22 <= b0 ? b0 <= 27 : false) {
      get_reserved();
    } else if (b0 === 28) {
      tmp = toShort(_this__u8e3s4.c1q() << 8 | _this__u8e3s4.c1q());
    } else if (b0 === 29) {
      tmp = _this__u8e3s4.c1q() << 24 | _this__u8e3s4.c1q() << 16 | _this__u8e3s4.c1q() << 8 | _this__u8e3s4.c1q();
    } else if (b0 === 30) {
      tmp = this.h54(_this__u8e3s4, false);
    } else if (b0 === 31) {
      get_reserved();
    } else if (32 <= b0 ? b0 <= 246 : false) {
      tmp = b0 - 139 | 0;
    } else if (247 <= b0 ? b0 <= 250 : false) {
      tmp = (imul(b0 - 247 | 0, 256) + _this__u8e3s4.c1q() | 0) + 108 | 0;
    } else if (251 <= b0 ? b0 <= 254 : false) {
      tmp = ((-imul(b0 - 251 | 0, 256) | 0) - _this__u8e3s4.c1q() | 0) - 108 | 0;
    } else if (b0 === 255) {
      get_reserved();
    } else {
      get_unreachable();
    }
    return tmp;
  }
  i54(_this__u8e3s4, readHeader) {
    if (readHeader) {
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(_this__u8e3s4.c1q() === 30)) {
        // Inline function 'kotlin.check.<anonymous>' call
        var message = 'Check failed.';
        throw IllegalStateException.w4(toString_0(message));
      }
    }
    var str = StringBuilder.f();
    end: while (true) {
      var byte = _this__u8e3s4.c1q();
      var inductionVariable = 0;
      if (inductionVariable <= 1)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var nibble = (byte >>> imul(1 - n | 0, 4) | 0) & 15;
          if (nibble === 15)
            break end;
          switch (nibble) {
            case 15:
              break end;
            case 12:
              str.ob('E-');
              break;
            default:
              str.pb((0 <= nibble ? nibble <= 9 : false) ? Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(48), nibble) : nibble === 10 ? _Char___init__impl__6a9atx(46) : nibble === 11 ? _Char___init__impl__6a9atx(69) : nibble === 14 ? _Char___init__impl__6a9atx(45) : _Char___init__impl__6a9atx(48));
              break;
          }
        }
         while (inductionVariable <= 1);
    }
    return str.toString();
  }
  h54(_this__u8e3s4, readHeader) {
    return toDouble(this.i54(_this__u8e3s4, readHeader));
  }
}
class CharStringType2 {
  j54(_this__u8e3s4, value) {
    _this__u8e3s4.v2k(_this__u8e3s4.e1() - 1 | 0, value);
  }
  k54(_this__u8e3s4) {
    return _this__u8e3s4.d1(_this__u8e3s4.e1() - 1 | 0);
  }
  l54(_this__u8e3s4) {
    return _this__u8e3s4.l3(_this__u8e3s4.e1() - 1 | 0);
  }
  m54(_this__u8e3s4, value) {
    _this__u8e3s4.nz(value);
  }
  n54(_this__u8e3s4, value) {
    _this__u8e3s4.nz(value);
  }
  o54(_this__u8e3s4) {
    var lastPoint = _this__u8e3s4.w3o();
    _this__u8e3s4.c6();
    _this__u8e3s4.u3d(lastPoint);
  }
  p54(_this__u8e3s4, x, y) {
    _this__u8e3s4.e3p(Vector2D.n27(x, y));
  }
  q54(_this__u8e3s4, x, y) {
    _this__u8e3s4.f3p(Vector2D.n27(x, y));
  }
  r54(_this__u8e3s4, fcx1, fcy1, fcx2, fcy2, fax, fay) {
    _this__u8e3s4.v3d(Vector2D.n27(fcx1, fcy1), Vector2D.n27(fcx2, fcy2), Vector2D.n27(fax, fay));
  }
  s54(_this__u8e3s4, cx1, cy1, cx2, cy2, ax, ay) {
    var fcx1 = _this__u8e3s4.w3o().e25_1 + cx1;
    var fcy1 = _this__u8e3s4.w3o().f25_1 + cy1;
    var fcx2 = fcx1 + cx2;
    var fcy2 = fcy1 + cy2;
    var fax = fcx2 + ax;
    var fay = fcy2 + ay;
    this.r54(_this__u8e3s4, fcx1, fcy1, fcx2, fcy2, fax, fay);
  }
  t54(_this__u8e3s4, v, horizontal) {
    return this.p54(_this__u8e3s4, horizontal ? v : 0.0, !horizontal ? v : 0.0);
  }
  u54(_this__u8e3s4, v, horizontal) {
    return this.q54(_this__u8e3s4, horizontal ? v : 0.0, !horizontal ? v : 0.0);
  }
  v54(_this__u8e3s4) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CharStringType2.u8.<anonymous>' call
    return _this__u8e3s4.c1q();
  }
  w54(ctx, s, evalCtx, stack, stackLevel) {
    while (s.cw()) {
      var v0 = this.v54(s);
      if ((0 <= v0 ? v0 <= 27 : false) || (29 <= v0 ? v0 <= 31 : false)) {
        var tmp = Companion_getInstance_29();
        var op = tmp.d1(v0 === 12 ? v0 << 8 | this.v54(s) : v0);
        switch (op.n3_1) {
          case 13:
            return Unit_instance;
          case 16:
            var tmp_0;
            // Inline function 'kotlin.collections.isNotEmpty' call

            if (!stack.g1()) {
              tmp_0 = !evalCtx.p53_1;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              evalCtx.o53_1 = stack.d1(0) + evalCtx.i53_1;
              evalCtx.p53_1 = true;
            }

            if (!(ctx.v3o() === 0)) {
              this.o54(ctx);
            }

            return Unit_instance;
          case 11:
          case 40:
            var global = op.equals(Op_callgsubr_getInstance());
            var funcOffset = numberToInt(this.l54(stack));
            var bytes = global ? evalCtx.f53_1.d1(evalCtx.l53_1 + funcOffset | 0) : evalCtx.g53_1.d1(evalCtx.m53_1 + funcOffset | 0);
            this.w54(ctx, openFastStream(bytes), evalCtx, stack, stackLevel + 1 | 0);
            break;
          case 22:
            this.l54(stack);
            break;
          case 38:
            // Inline function 'kotlin.also' call

            var this_0 = this.l54(stack);
            // Inline function 'kotlin.contracts.contract' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            stack.o2k(this_0, this_0);
            break;
          case 39:
            stack.e2k(stack.e1() - 2 | 0, stack.e1() - 1 | 0);
            break;
          case 43:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.od();
          case 41:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.od();
          case 25:
            var index = this.l54(stack);
            var value = this.l54(stack);
            evalCtx.k53_1[numberToInt(index)] = value;
            break;
          case 27:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var it = this.k54(stack);
            var tmp$ret$3 = evalCtx.k53_1[numberToInt(it)];
            this.j54(stack, tmp$ret$3);
            break;
          case 2:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r = this.l54(stack);
            var l = this.l54(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$5 = !(l === 0.0) && !(r === 0.0) ? 1 : 0;
            this.m54(stack, tmp$ret$5);
            break;
          case 4:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_0 = this.l54(stack);
            var l_0 = this.l54(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$7 = !(l_0 === 0.0) || !(r_0 === 0.0) ? 1 : 0;
            this.m54(stack, tmp$ret$7);
            break;
          case 6:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$9 = this.k54(stack) === 0.0 ? 1 : 0;
            this.j54(stack, tmp$ret$9);
            break;
          case 19:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_1 = this.l54(stack);
            var l_1 = this.l54(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$11 = l_1 === r_1 ? 1 : 0;
            this.m54(stack, tmp$ret$11);
            break;
          case 29:
            var v2 = this.l54(stack);
            var v1 = this.l54(stack);
            var s2 = this.l54(stack);
            var s1 = this.l54(stack);
            this.m54(stack, v1 <= v2 ? s1 : s2);
            break;
          case 31:
            stack.nz(Default_getInstance().so());
            break;
          case 36:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'kotlin.math.sqrt' call

            var x = this.k54(stack);
            var tmp$ret$13 = Math.sqrt(x);
            this.j54(stack, tmp$ret$13);
            break;
          case 10:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'kotlin.math.abs' call

            var x_0 = this.k54(stack);
            var tmp$ret$15 = Math.abs(x_0);
            this.j54(stack, tmp$ret$15);
            break;
          case 17:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$16 = -this.k54(stack);
            this.j54(stack, tmp$ret$16);
            break;
          case 12:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_2 = this.l54(stack);
            var l_2 = this.l54(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$17 = l_2 + r_2;
            this.m54(stack, tmp$ret$17);
            break;
          case 14:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_3 = this.l54(stack);
            var l_3 = this.l54(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$18 = l_3 - r_3;
            this.m54(stack, tmp$ret$18);
            break;
          case 15:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_4 = this.l54(stack);
            var l_4 = this.l54(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$19 = l_4 / r_4;
            this.m54(stack, tmp$ret$19);
            break;
          case 33:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_5 = this.l54(stack);
            var l_5 = this.l54(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$20 = l_5 * r_5;
            this.m54(stack, tmp$ret$20);
            break;
          case 26:
            if (stack.e1() > 2) {
              evalCtx.o53_1 = stack.d1(0) + evalCtx.i53_1;
              evalCtx.p53_1 = true;
            }

            if (!(ctx.v3o() === 0)) {
              this.o54(ctx);
            }

            this.p54(ctx, stack.d1(stack.e1() - 2 | 0), stack.d1(stack.e1() - 1 | 0));
            stack.h3();
            break;
          case 3:
          case 28:
            if (stack.e1() > 1) {
              evalCtx.o53_1 = stack.d1(0) + evalCtx.i53_1;
              evalCtx.p53_1 = true;
            }

            this.t54(ctx, this.l54(stack), op.equals(Op_hmoveto_getInstance()));
            stack.h3();
            break;
          case 5:
            var progression = step(until(0, stack.e1()), 2);
            var inductionVariable = progression.a2_1;
            var last = progression.b2_1;
            var step_0 = progression.c2_1;
            if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
              do {
                var n = inductionVariable;
                inductionVariable = inductionVariable + step_0 | 0;
                this.q54(ctx, stack.d1(n), stack.d1(n + 1 | 0));
              }
               while (!(n === last));
            stack.h3();
            break;
          case 7:
          case 8:
            var toggle = op.equals(Op_hlineto_getInstance());
            var inductionVariable_0 = 0;
            var last_0 = stack.e1();
            if (inductionVariable_0 < last_0)
              do {
                var n_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                this.u54(ctx, stack.d1(n_0), toggle);
                toggle = !toggle;
              }
               while (inductionVariable_0 < last_0);
            stack.h3();
            break;
          case 9:
          case 32:
          case 34:
            var n_1 = 0;
            if (op.equals(Op_rlinecurve_getInstance())) {
              while ((stack.e1() - n_1 | 0) < 6) {
                var _unary__edvuaz = n_1;
                n_1 = _unary__edvuaz + 1 | 0;
                var tmp_1 = stack.d1(_unary__edvuaz);
                var _unary__edvuaz_0 = n_1;
                n_1 = _unary__edvuaz_0 + 1 | 0;
                this.q54(ctx, tmp_1, stack.d1(_unary__edvuaz_0));
              }
            }

            while ((stack.e1() - n_1 | 0) >= 6) {
              var _unary__edvuaz_1 = n_1;
              n_1 = _unary__edvuaz_1 + 1 | 0;
              var tmp_2 = stack.d1(_unary__edvuaz_1);
              var _unary__edvuaz_2 = n_1;
              n_1 = _unary__edvuaz_2 + 1 | 0;
              var tmp_3 = stack.d1(_unary__edvuaz_2);
              var _unary__edvuaz_3 = n_1;
              n_1 = _unary__edvuaz_3 + 1 | 0;
              var tmp_4 = stack.d1(_unary__edvuaz_3);
              var _unary__edvuaz_4 = n_1;
              n_1 = _unary__edvuaz_4 + 1 | 0;
              var tmp_5 = stack.d1(_unary__edvuaz_4);
              var _unary__edvuaz_5 = n_1;
              n_1 = _unary__edvuaz_5 + 1 | 0;
              var tmp_6 = stack.d1(_unary__edvuaz_5);
              var _unary__edvuaz_6 = n_1;
              n_1 = _unary__edvuaz_6 + 1 | 0;
              this.s54(ctx, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, stack.d1(_unary__edvuaz_6));
            }

            if (op.equals(Op_rcurveline_getInstance())) {
              while (n_1 < stack.e1()) {
                var _unary__edvuaz_7 = n_1;
                n_1 = _unary__edvuaz_7 + 1 | 0;
                var tmp_7 = stack.d1(_unary__edvuaz_7);
                var _unary__edvuaz_8 = n_1;
                n_1 = _unary__edvuaz_8 + 1 | 0;
                this.q54(ctx, tmp_7, stack.d1(_unary__edvuaz_8));
              }
            }

            stack.h3();
            break;
          case 35:
          case 37:
            var horizontal = op.equals(Op_hhcurveto_getInstance());
            var n_2 = 0;
            var tmp_8;
            if ((stack.e1() % 2 | 0) === 1) {
              var _unary__edvuaz_9 = n_2;
              n_2 = _unary__edvuaz_9 + 1 | 0;
              tmp_8 = stack.d1(_unary__edvuaz_9);
            } else {
              tmp_8 = 0.0;
            }

            var v = tmp_8;
            var initialY = horizontal ? v : 0.0;
            var initialX = horizontal ? 0.0 : v;
            if (!(((stack.e1() - n_2 | 0) % 4 | 0) === 0)) {
              // Inline function 'kotlin.error' call
              var message = 'Invalid number of operands';
              throw IllegalStateException.w4(toString_0(message));
            }

            while (n_2 < stack.e1()) {
              var _unary__edvuaz_10 = n_2;
              n_2 = _unary__edvuaz_10 + 1 | 0;
              var vv = stack.d1(_unary__edvuaz_10);
              var x1 = initialX + (horizontal ? vv : 0.0);
              var y1 = initialY + (horizontal ? 0.0 : vv);
              var _unary__edvuaz_11 = n_2;
              n_2 = _unary__edvuaz_11 + 1 | 0;
              var x2 = stack.d1(_unary__edvuaz_11);
              var _unary__edvuaz_12 = n_2;
              n_2 = _unary__edvuaz_12 + 1 | 0;
              var y2 = stack.d1(_unary__edvuaz_12);
              var _unary__edvuaz_13 = n_2;
              n_2 = _unary__edvuaz_13 + 1 | 0;
              var v1_0 = stack.d1(_unary__edvuaz_13);
              var lastX = horizontal ? v1_0 : 0.0;
              var lastY = horizontal ? 0.0 : v1_0;
              this.s54(ctx, x1, y1, x2, y2, lastX, lastY);
              initialX = 0.0;
              initialY = 0.0;
            }

            stack.h3();
            break;
          case 42:
          case 44:
            reverse(stack);
            var toggle_0 = op.equals(Op_hvcurveto_getInstance());
            $l$loop: while (true) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!!stack.g1()) {
                break $l$loop;
              }
              var vv_0 = this.l54(stack);
              var x1_0 = toggle_0 ? vv_0 : 0.0;
              var y1_0 = toggle_0 ? 0.0 : vv_0;
              var x2_0 = this.l54(stack);
              var y2_0 = this.l54(stack);
              var v1_1 = this.l54(stack);
              var v2_0 = stack.e1() === 1 ? this.l54(stack) : 0.0;
              var ax = toggle_0 ? v2_0 : v1_1;
              var ay = toggle_0 ? v1_1 : v2_0;
              this.s54(ctx, x1_0, y1_0, x2_0, y2_0, ax, ay);
              toggle_0 = !toggle_0;
            }

            stack.h3();
            break;
          case 45:
          case 46:
          case 47:
          case 48:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.od();
          case 0:
          case 1:
          case 21:
          case 30:
          case 23:
          case 24:
            if (!((stack.e1() % 2 | 0) === 0) && !evalCtx.p53_1) {
              var value_0 = stack.d1(0);
              evalCtx.o53_1 = value_0 + evalCtx.i53_1;
            }

            evalCtx.n53_1 = evalCtx.n53_1 + (stack.e1() >>> 1 | 0) | 0;
            evalCtx.p53_1 = true;
            stack.h3();
            if (op.equals(Op_hintmask_getInstance()) || op.equals(Op_cntrmask_getInstance())) {
              var skipCount = (evalCtx.n53_1 + 7 | 0) >>> 3 | 0;
              s.hw(skipCount);
            }

            break;
          case 18:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.od();
          case 20:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.od();
          default:
            noWhenBranchMatchedException();
            break;
        }
      } else if (v0 === 255) {
        var integerPart = this.v54(s) << 8 | this.v54(s);
        var fractionPart = this.v54(s) << 8 | this.v54(s);
        var value_1 = integerPart + fractionPart / 65536.0;
        this.m54(stack, value_1);
      } else {
        var tmp_9;
        if (v0 === 28) {
          tmp_9 = toShort(this.v54(s) << 8 | this.v54(s));
        } else if (32 <= v0 ? v0 <= 246 : false) {
          tmp_9 = v0 - 139 | 0;
        } else if (247 <= v0 ? v0 <= 250 : false) {
          tmp_9 = (imul(v0 - 247 | 0, 256) + this.v54(s) | 0) + 108 | 0;
        } else if (251 <= v0 ? v0 <= 254 : false) {
          tmp_9 = ((-imul(v0 - 251 | 0, 256) | 0) - this.v54(s) | 0) - 108 | 0;
        } else {
          get_unreachable();
        }
        var value_2 = tmp_9;
        this.n54(stack, value_2);
      }
    }
  }
  e53(ctx, s, evalCtx, stack, stackLevel, $super) {
    stack = stack === VOID ? DoubleArrayList.j2k(32) : stack;
    stackLevel = stackLevel === VOID ? 0 : stackLevel;
    var tmp;
    if ($super === VOID) {
      this.w54(ctx, s, evalCtx, stack, stackLevel);
      tmp = Unit_instance;
    } else {
      tmp = $super.w54.call(this, ctx, s, evalCtx, stack, stackLevel);
    }
    return tmp;
  }
}
class TtfCIDFont {
  constructor() {
    TtfCIDFont_instance = this;
    this.d54_1 = Companion_getInstance_14().mw('TtfCIDFont');
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_20 = this;
    this.x54_1 = Companion_getInstance_14().mw('TTF');
  }
}
class VectorFont {}
function getGlyphPath$default(size, codePoint, path, reader, $super) {
  path = path === VOID ? new GlyphPath() : path;
  reader = reader === VOID ? null : reader;
  return $super === VOID ? this.n57(size, codePoint, path, reader) : $super.n57.call(this, size, codePoint, path, reader);
}
function renderGlyph_0(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) {
  $l$block: {
    // Inline function 'korlibs.io.lang.keep' call
    var tmp0_elvis_lhs = reader == null ? null : reader.vv_1;
    var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    try {
      // Inline function 'korlibs.image.font.VectorFont.renderGlyph.<anonymous>' call
      this.a4q(size, codePoint, metrics, reader);
      break $l$block;
    }finally {
      if (reader == null)
        null;
      else {
        reader.vv_1 = old;
      }
    }
  }
  var g = this.o57(size, codePoint, VOID, reader);
  if (!(g == null)) {
    if (!(fill == null)) {
      ctx.f4x();
    }
    if (!g.i51()) {
      if (beforeDraw == null)
        null;
      else
        beforeDraw();
    }
    // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
    var t = ctx.m45_1.n4q_1;
    try {
      // Inline function 'korlibs.image.font.VectorFont.renderGlyph.<anonymous>' call
      // Inline function 'korlibs.image.vector.Context2d.translate' call
      ctx.q50(pos.e25_1, pos.f25_1);
      g.j51(ctx);
    }finally {
      ctx.m45_1.n4q_1 = t;
    }
    switch (fill) {
      case true:
        ctx.o4y();
        break;
      case false:
        ctx.n4y();
        break;
      case null:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return !g.i51();
  }
  return false;
}
class BaseTtfFont {
  static j5h(s, extName, onlyReadMetadata, enableLigatures) {
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    var $this = createThis(this);
    $this.y54_1 = new Mixin();
    $this.z54_1 = s;
    $this.a55_1 = extName;
    $this.b55_1 = onlyReadMetadata;
    $this.c55_1 = enableLigatures;
    $this.d55_1 = new NamesInfo();
    var tmp = $this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(3), null);
    while (tmp_0 < 3) {
      tmp_1[tmp_0] = new Contour();
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.e55_1 = tmp_1;
    $this.f55_1 = 0;
    $this.g55_1 = 0;
    $this.h55_1 = 0;
    $this.i55_1 = 0;
    $this.j55_1 = 0;
    $this.k55_1 = 0;
    $this.l55_1 = 0;
    $this.m55_1 = 0;
    $this.n55_1 = 0;
    $this.o55_1 = 0;
    $this.p55_1 = 0;
    $this.q55_1 = 0;
    $this.r55_1 = 0;
    $this.s55_1 = 0;
    $this.t55_1 = Companion_instance_24.k5h(0, 0);
    $this.u55_1 = 0;
    $this.v55_1 = 0;
    $this.w55_1 = 0;
    $this.x55_1 = 0;
    $this.y55_1 = 0;
    $this.z55_1 = 0;
    $this.a56_1 = 0;
    $this.b56_1 = 0;
    $this.c56_1 = 0;
    $this.d56_1 = 0;
    $this.e56_1 = 0;
    $this.f56_1 = 0;
    $this.g56_1 = new Int32Array(0);
    $this.h56_1 = Companion_instance_24.k5h(0, 0);
    $this.i56_1 = 128;
    $this.j56_1 = 0;
    $this.k56_1 = 0;
    $this.l56_1 = 0;
    $this.m56_1 = 0;
    $this.n56_1 = 0;
    $this.o56_1 = 0;
    $this.p56_1 = 0;
    $this.q56_1 = 0;
    $this.r56_1 = 0;
    var tmp_2 = $this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_2.s56_1 = emptyList();
    $this.t56_1 = LinkedHashMap.bc();
    $this.u56_1 = LinkedHashMap.bc();
    $this.v56_1 = IntMap.i2o(512);
    $this.w56_1 = LinkedHashMap.bc();
    var tmp_3 = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_3.x56_1 = [];
    $this.y56_1 = IntMap.i2o();
    var tmp_4 = $this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_4.z56_1 = emptyList();
    $this.a57_1 = new COLRv1();
    $this.b57_1 = false;
    $this.c57_1 = IntIntMap.a2p();
    $this.d57_1 = IntMap.i2o();
    $this.f57_1 = new GlyphMetrics(1.0, false, 0, Companion_getInstance_4().a29(), 0.0);
    $this.g57_1 = false;
    $this.h57_1 = null;
    return $this;
  }
  vx(_set____db54di) {
    this.y54_1.vx(_set____db54di);
  }
  wx() {
    return this.y54_1.wx();
  }
  static i57(d, extName, onlyReadMetadata, enableLigatures) {
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    return this.j5h(openFastStream(d), extName, onlyReadMetadata, enableLigatures);
  }
  o4p(size, metrics) {
    return metrics.y4p(this.s57(), size);
  }
  a4q(size, codePoint, metrics, reader) {
    var tmp104_safe_receiver = this.d59(reader, codePoint);
    var tmp0_elvis_lhs = tmp104_safe_receiver == null ? null : tmp104_safe_receiver.p5e_1;
    return metrics.g4q(tmp0_elvis_lhs == null ? this.f57_1 : tmp0_elvis_lhs, size, codePoint);
  }
  o4r(size, leftCodePoint, rightCodePoint) {
    return 0.0;
  }
  n57(size, codePoint, path, reader) {
    var spos = reader == null ? null : reader.vv_1;
    var codePointPeek = reader == null ? null : reader.dw(0);
    var tmp0_elvis_lhs = this.c59(reader, codePoint, true);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var g = tmp;
    var scale = this.j4q(size);
    path.b51_1 = g.o21().s5e_1;
    var tmp_0 = path;
    var tmp107_safe_receiver = g.c5f();
    tmp_0.c51_1 = tmp107_safe_receiver == null ? null : tmp107_safe_receiver.u5e();
    var bitmapEntry = g.e5f();
    var bitmap = bitmapEntry == null ? null : bitmapEntry.e5c();
    path.d51_1 = bitmap;
    if (!(bitmapEntry == null)) {
      var scaleX = this.i56_1 / bitmapEntry.n5b_1.t5a_1;
      var scaleY = this.i56_1 / bitmapEntry.n5b_1.u5a_1;
      path.e51_1 = Vector2D.n27(0.0, ((-bitmapEntry.o5b_1 | 0) - bitmapEntry.y5b() | 0) * scaleY);
      path.f51_1 = Scale.g2d(scaleX, scaleY);
    }
    path.g51_1 = Companion_getInstance_5().x28_1.x29(scale, scale);
    path.h51_1 = scale;
    return path;
  }
  j4q(size) {
    return size / this.i56_1;
  }
  p57(key) {
    return this.t56_1.c3(key);
  }
  q57(codePoint, glyphID) {
    // Inline function 'kotlin.collections.set' call
    this.t56_1.e3(codePoint, glyphID);
    // Inline function 'kotlin.collections.set' call
    this.u56_1.e3(glyphID, codePoint);
  }
  r57(codePoint, glyphID) {
  }
  s57() {
    var tmp = this.e57_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('fontMetrics1px');
    }
  }
  t57() {
    return this.d55_1.t57();
  }
  o3() {
    var tmp0_elvis_lhs = this.a55_1;
    return tmp0_elvis_lhs == null ? this.t57() : tmp0_elvis_lhs;
  }
  j57() {
    this.k57();
    this.z57();
    this.a58();
    this.b58();
    this.x57();
    if (!this.b55_1) {
      if (!(this.m57('CFF ') == null) && this.m57('glyf') == null) {
        // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
        var tmp111_safe_receiver = this.w57('CFF ');
        if (tmp111_safe_receiver == null)
          null;
        else {
          // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>' call
          // Inline function 'kotlin.apply' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>.<anonymous>' call
          this.h57_1 = CFF_instance.z53(tmp111_safe_receiver);
        }
      }
      this.y57();
      this.z58();
      this.c58();
      this.d58();
      this.y58();
      this.x58();
      this.f58();
      this.g58();
      this.h58();
    }
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new FontMetrics();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>' call
    var scale = this.j4q(1.0);
    this_0.p4p_1 = 1.0;
    this_0.q4p_1 = this.m56_1 * scale;
    this_0.r4p_1 = this.u55_1 * scale;
    this_0.s4p_1 = 0.0 * scale;
    this_0.t4p_1 = this.v55_1 * scale;
    this_0.u4p_1 = this.k56_1 * scale;
    this_0.v4p_1 = this.w55_1 * scale;
    this_0.w4p_1 = this.x55_1 * scale;
    this_0.x4p_1 = this.i56_1 * scale;
    tmp.e57_1 = this_0;
  }
  toString() {
    return 'TtfFont(name=' + this.o3() + ')';
  }
  u57(_this__u8e3s4) {
    return _FWord___init__impl__2rjyqf(_this__u8e3s4.e1q());
  }
  v57(_this__u8e3s4) {
    return Companion_instance_24.k5h(_this__u8e3s4.d1q(), _this__u8e3s4.d1q());
  }
  w57(name) {
    var tmp109_safe_receiver = this.m57(name);
    return tmp109_safe_receiver == null ? null : tmp109_safe_receiver.h5a();
  }
  x57() {
    var tmp111_safe_receiver = this.w57('name');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readNames.<anonymous>' call
      Companion_instance_23.k5a(tmp111_safe_receiver, this.d55_1);
    }
    return Unit_instance;
  }
  y57() {
    var tmp111_safe_receiver = this.w57('loca');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>' call
      var tmp;
      switch (this.q56_1) {
        case 0:
          tmp = 2;
          break;
        case 1:
          tmp = 4;
          break;
        default:
          get_invalidOp();
          break;
      }
      var bytesPerEntry = tmp;
      var data = tmp111_safe_receiver.a1q(imul(bytesPerEntry, this.f55_1 + 1 | 0));
      var tmp_0 = this;
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>.<anonymous>' call
      var $this$run = new FastByteArrayInputStream(data);
      var tmp_1;
      switch (this.q56_1) {
        case 0:
          // Inline function 'korlibs.datastructure.mapInt' call

          var this_0 = $this$run.k1q(this.f55_1 + 1 | 0);
          // Inline function 'kotlin.also' call

          var this_1 = new Int32Array(this_0.length);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

          var inductionVariable = 0;
          var last = this_0.length;
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>.<anonymous>.<anonymous>' call
              // Inline function 'kotlin.code' call
              var this_2 = this_0[n];
              var tmp$ret$0 = Char__toInt_impl_vasixd(this_2);
              this_1[n] = imul(tmp$ret$0, 2);
            }
             while (inductionVariable < last);
          tmp_1 = this_1;
          break;
        case 1:
          tmp_1 = $this$run.m1q(this.f55_1 + 1 | 0);
          break;
        default:
          get_invalidOp();
          break;
      }
      tmp_0.g56_1 = tmp_1;
    }
    return Unit_instance;
  }
  z57() {
    var tmp111_safe_receiver = this.w57('head');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(tmp111_safe_receiver.e1q() === 1)) {
        invalidOp('Invalid TTF');
      }
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(tmp111_safe_receiver.e1q() === 0)) {
        invalidOp('Invalid TTF');
      }
      this.h56_1 = this.v57(tmp111_safe_receiver);
      var checkSumAdjustment = tmp111_safe_receiver.g1q();
      // Inline function 'kotlin.apply' call
      var this_0 = tmp111_safe_receiver.g1q();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(this_0 === 1594834165)) {
        invalidOp('Invalid magic ' + get_hex(this_0));
      }
      var flags = tmp111_safe_receiver.e1q();
      this.i56_1 = tmp111_safe_receiver.e1q();
      var created = tmp111_safe_receiver.h1q().v3(new Long(1000, 0));
      var modified = tmp111_safe_receiver.h1q().v3(new Long(1000, 0));
      this.j56_1 = tmp111_safe_receiver.d1q();
      this.k56_1 = tmp111_safe_receiver.d1q();
      this.l56_1 = tmp111_safe_receiver.d1q();
      this.m56_1 = tmp111_safe_receiver.d1q();
      this.n56_1 = tmp111_safe_receiver.e1q();
      this.o56_1 = tmp111_safe_receiver.e1q();
      this.p56_1 = tmp111_safe_receiver.d1q();
      this.q56_1 = tmp111_safe_receiver.d1q();
      this.r56_1 = tmp111_safe_receiver.d1q();
    }
    return Unit_instance;
  }
  a58() {
    var tmp111_safe_receiver = this.w57('maxp');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readMaxp.<anonymous>' call
      var version = this.v57(tmp111_safe_receiver);
      this.f55_1 = tmp111_safe_receiver.e1q();
      this.g55_1 = tmp111_safe_receiver.e1q();
      this.h55_1 = tmp111_safe_receiver.e1q();
      this.i55_1 = tmp111_safe_receiver.e1q();
      this.j55_1 = tmp111_safe_receiver.e1q();
      this.k55_1 = tmp111_safe_receiver.e1q();
      this.l55_1 = tmp111_safe_receiver.e1q();
      this.m55_1 = tmp111_safe_receiver.e1q();
      this.n55_1 = tmp111_safe_receiver.e1q();
      this.o55_1 = tmp111_safe_receiver.e1q();
      this.p55_1 = tmp111_safe_receiver.e1q();
      this.q55_1 = tmp111_safe_receiver.e1q();
      this.r55_1 = tmp111_safe_receiver.e1q();
      this.s55_1 = tmp111_safe_receiver.e1q();
    }
    return Unit_instance;
  }
  b58() {
    var tmp111_safe_receiver = this.w57('hhea');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHhea.<anonymous>' call
      this.t55_1 = this.v57(tmp111_safe_receiver);
      this.u55_1 = tmp111_safe_receiver.d1q();
      this.v55_1 = tmp111_safe_receiver.d1q();
      this.w55_1 = tmp111_safe_receiver.d1q();
      this.x55_1 = tmp111_safe_receiver.e1q();
      this.y55_1 = tmp111_safe_receiver.d1q();
      this.z55_1 = tmp111_safe_receiver.d1q();
      this.a56_1 = tmp111_safe_receiver.d1q();
      this.b56_1 = tmp111_safe_receiver.d1q();
      this.c56_1 = tmp111_safe_receiver.d1q();
      this.d56_1 = tmp111_safe_receiver.d1q();
      tmp111_safe_receiver.d1q();
      tmp111_safe_receiver.d1q();
      tmp111_safe_receiver.d1q();
      tmp111_safe_receiver.d1q();
      this.e56_1 = tmp111_safe_receiver.d1q();
      this.f56_1 = tmp111_safe_receiver.e1q();
    }
    return Unit_instance;
  }
  c58() {
    var tmp111_safe_receiver = this.w57('hmtx');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, this.f56_1);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var inductionVariable = this_0.a2_1;
      var last_0 = this_0.b2_1;
      if (inductionVariable <= last_0)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>.<anonymous>' call
          var tmp$ret$0 = new HorMetric(tmp111_safe_receiver.e1q(), tmp111_safe_receiver.d1q());
          destination.h(tmp$ret$0);
        }
         while (!(item === last_0));
      var firstMetrics = destination;
      var lastAdvanceWidth = last(firstMetrics).i5a_1;
      // Inline function 'kotlin.collections.map' call
      var this_1 = until(0, this.f55_1 - this.f56_1 | 0);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var inductionVariable_0 = this_1.a2_1;
      var last_1 = this_1.b2_1;
      if (inductionVariable_0 <= last_1)
        do {
          var item_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>.<anonymous>' call
          var tmp$ret$3 = new HorMetric(lastAdvanceWidth, tmp111_safe_receiver.d1q());
          destination_0.h(tmp$ret$3);
        }
         while (!(item_0 === last_1));
      var compressedMetrics = destination_0;
      this.s56_1 = plus(firstMetrics, compressedMetrics);
    }
    return Unit_instance;
  }
  d58() {
    var tmp111_safe_receiver = this.w57('CPAL');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCpal.<anonymous>' call
      var version = tmp111_safe_receiver.e1q();
      switch (version) {
        case 0:
        case 1:
          var numPaletteEntries = tmp111_safe_receiver.e1q();
          var numPalettes = tmp111_safe_receiver.e1q();
          var numColorRecords = tmp111_safe_receiver.e1q();
          var colorRecordsArrayOffset = tmp111_safe_receiver.g1q();
          var colorRecordIndices = tmp111_safe_receiver.j1q(numPalettes);
          var paletteTypesArrayOffset = version === 1 ? tmp111_safe_receiver.g1q() : -1;
          var paletteLabelsArrayOffset = version === 1 ? tmp111_safe_receiver.g1q() : -1;
          var paletteEntryLabelsArrayOffset = version === 1 ? tmp111_safe_receiver.g1q() : -1;
          tmp111_safe_receiver.s1p(colorRecordsArrayOffset);
          var colorInts = tmp111_safe_receiver.l1q(numColorRecords);
          var inductionVariable = 0;
          var last = colorInts.length;
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var c = _RGBA___init__impl__lqpay5(colorInts[n]);
              colorInts[n] = _RGBA___get_value__impl__hhco8v(Companion_getInstance_22().c4d(_RGBA___get_b__impl__m6tl80(c), _RGBA___get_g__impl__o8pukr(c), _RGBA___get_r__impl__duz7mo(c), _RGBA___get_a__impl__6msvu7(c)));
            }
             while (inductionVariable < last);
          var tmp = this;
          // Inline function 'kotlin.collections.map' call

          // Inline function 'kotlin.collections.mapTo' call

          var destination = ArrayList.w(colorRecordIndices.length);
          var inductionVariable_0 = 0;
          var last_0 = colorRecordIndices.length;
          while (inductionVariable_0 < last_0) {
            var item = colorRecordIndices[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCpal.<anonymous>.<anonymous>' call
            var tmp$ret$0 = new Palette(_RgbaArray___init__impl__oib4y4(copyOfRange_0(colorInts, item, item + numPaletteEntries | 0)));
            destination.h(tmp$ret$0);
          }

          tmp.z56_1 = destination;
          break;
        default:
          println('TTF WARNING CPAL version != 0,1');
          break;
      }
    }
    return Unit_instance;
  }
  e58(_this__u8e3s4) {
    return new SbitLineMetrics(_this__u8e3s4.b1q(), _this__u8e3s4.b1q(), _this__u8e3s4.c1q(), _this__u8e3s4.b1q(), _this__u8e3s4.b1q(), _this__u8e3s4.b1q(), _this__u8e3s4.b1q(), _this__u8e3s4.b1q(), _this__u8e3s4.b1q(), _this__u8e3s4.b1q(), _this__u8e3s4.b1q(), _this__u8e3s4.b1q());
  }
  f58() {
    var tmp111_safe_receiver = this.w57('CBLC');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCblc.<anonymous>' call
      var majorVersion = tmp111_safe_receiver.e1q();
      var minorVersion = tmp111_safe_receiver.e1q();
      if (majorVersion === 3) {
        var numSizes = tmp111_safe_receiver.g1q();
        var tmp = 0;
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_0 = fillArrayVal(Array(numSizes), null);
        while (tmp < numSizes) {
          tmp_0[tmp] = new ColorBitmapInfo(tmp111_safe_receiver.g1q(), tmp111_safe_receiver.g1q(), tmp111_safe_receiver.g1q(), tmp111_safe_receiver.g1q(), this.e58(tmp111_safe_receiver), this.e58(tmp111_safe_receiver), tmp111_safe_receiver.e1q(), tmp111_safe_receiver.e1q(), tmp111_safe_receiver.c1q(), tmp111_safe_receiver.c1q(), tmp111_safe_receiver.c1q(), tmp111_safe_receiver.b1q());
          tmp = tmp + 1 | 0;
        }
        var colorBitmapInfos = toList_1(tmp_0);
        var _iterator__ex2g4s = colorBitmapInfos.a1();
        while (_iterator__ex2g4s.b1()) {
          var cbi = _iterator__ex2g4s.c1();
          var glyphCount = cbi.s5a_1 - cbi.r5a_1 | 0;
          tmp111_safe_receiver.s1p(cbi.l5a_1);
          var tmp_1 = 0;
          var tmp_2 = cbi.n5a_1;
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_3 = fillArrayVal(Array(tmp_2), null);
          while (tmp_1 < tmp_2) {
            tmp_3[tmp_1] = new BaseTtfFont$readCblc$Subtable(tmp111_safe_receiver.e1q(), tmp111_safe_receiver.e1q(), tmp111_safe_receiver.g1q());
            tmp_1 = tmp_1 + 1 | 0;
          }
          var subtables = tmp_3;
          var inductionVariable = 0;
          var last = subtables.length;
          while (inductionVariable < last) {
            var subtable = subtables[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            tmp111_safe_receiver.s1p(cbi.l5a_1 + subtable.w5g_1 | 0);
            var indexFormat = tmp111_safe_receiver.e1q();
            var imageFormat = tmp111_safe_receiver.e1q();
            var imageDataOffset = tmp111_safe_receiver.g1q();
            var tmp_4;
            if (indexFormat === 1) {
              var tmp_5 = 0;
              var tmp_6 = subtable.x5g() + 1 | 0;
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_7 = fillArrayVal(Array(tmp_6), null);
              while (tmp_5 < tmp_6) {
                tmp_7[tmp_5] = imageDataOffset + tmp111_safe_receiver.g1q() | 0;
                tmp_5 = tmp_5 + 1 | 0;
              }
              tmp_4 = tmp_7;
            } else {
              // Inline function 'kotlin.emptyArray' call
              tmp_4 = [];
            }
            var offsets = tmp_4;
            var inductionVariable_0 = 0;
            var last_0 = offsets.length - 1 | 0;
            if (inductionVariable_0 < last_0)
              do {
                var n = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var offset = offsets[n];
                var size = offsets[n + 1 | 0] - offset | 0;
                var glyphID = (subtable.u5g_1 + n | 0) - 1 | 0;
                // Inline function 'kotlin.collections.set' call
                var this_0 = this.w56_1;
                var value = new BitmapGlyphInfo(glyphID, imageFormat, offset, size, cbi);
                this_0.e3(glyphID, value);
              }
               while (inductionVariable_0 < last_0);
          }
        }
      } else {
        println('Unsupported CBLC ' + majorVersion + '.' + minorVersion);
      }
    }
    return Unit_instance;
  }
  g58() {
    var tmp111_safe_receiver = this.w57('CBDT');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCbdt.<anonymous>' call
      var majorVersion = tmp111_safe_receiver.e1q();
      var minorVersion = tmp111_safe_receiver.e1q();
      if (majorVersion === 3) {
        var _iterator__ex2g4s = this.w56_1.i3().a1();
        while (_iterator__ex2g4s.b1()) {
          var i = _iterator__ex2g4s.c1();
          var format = i.k5b_1;
          if (format === 17 || format === 18) {
            i.o5b_1 = tmp111_safe_receiver.c1q();
            i.p5b_1 = tmp111_safe_receiver.c1q();
            i.q5b_1 = tmp111_safe_receiver.b1q();
            i.r5b_1 = tmp111_safe_receiver.b1q();
            i.s5b_1 = tmp111_safe_receiver.c1q();
            i.t5b_1 = format === 18 ? tmp111_safe_receiver.b1q() : i.q5b_1;
            i.u5b_1 = format === 18 ? tmp111_safe_receiver.b1q() : i.r5b_1;
            i.v5b_1 = format === 18 ? tmp111_safe_receiver.b1q() : i.s5b_1;
          }
          var dataLen = tmp111_safe_receiver.g1q();
          i.w5b_1 = tmp111_safe_receiver.v1p(dataLen);
        }
      } else {
        println('Unsupported CBDT ' + majorVersion + '.' + minorVersion);
      }
    }
    return Unit_instance;
  }
  h58() {
    var tmp111_safe_receiver = this.w57('sbix');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>' call
      var version = tmp111_safe_receiver.e1q();
      var flags = tmp111_safe_receiver.e1q();
      var numStrikes = tmp111_safe_receiver.g1q();
      var strikeOffsets = tmp111_safe_receiver.m1q(numStrikes);
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(strikeOffsets.length);
      var inductionVariable = 0;
      var last = strikeOffsets.length;
      while (inductionVariable < last) {
        var item = strikeOffsets[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
        tmp111_safe_receiver.s1p(item);
        var tmp$ret$0 = new BaseTtfFont$readSbix$StrikeInfo(tmp111_safe_receiver.e1q(), tmp111_safe_receiver.e1q(), item, toIntArrayList(tmp111_safe_receiver.m1q(this.f55_1 + 1 | 0)));
        destination.h(tmp$ret$0);
      }
      var strikes = destination;
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.maxByOrNull' call
        var iterator = strikes.a1();
        if (!iterator.b1()) {
          tmp$ret$3 = null;
          break $l$block_0;
        }
        var maxElem = iterator.c1();
        if (!iterator.b1()) {
          tmp$ret$3 = maxElem;
          break $l$block_0;
        }
        // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
        var maxValue = maxElem.y5g_1;
        do {
          var e = iterator.c1();
          // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
          var v = e.y5g_1;
          if (compareTo(maxValue, v) < 0) {
            maxElem = e;
            maxValue = v;
          }
        }
         while (iterator.b1());
        tmp$ret$3 = maxElem;
      }
      var strike = ensureNotNull(tmp$ret$3);
      var inductionVariable_0 = 0;
      var last_0 = this.f55_1;
      if (inductionVariable_0 < last_0)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var glyphID = n;
          var offset = strike.b5h_1.d1(n);
          var len = strike.b5h_1.d1(n + 1 | 0) - offset | 0;
          var start = strike.a5h_1 + offset | 0;
          var end = start + len | 0;
          tmp111_safe_receiver.s1p(start);
          var originOffsetX = tmp111_safe_receiver.d1q();
          var originOffsetY = tmp111_safe_receiver.d1q();
          var graphicType = tmp111_safe_receiver.p1q(4);
          var bytes = tmp111_safe_receiver.v1p(len - 8 | 0);
          // Inline function 'kotlin.collections.set' call
          var this_0 = this.w56_1;
          // Inline function 'kotlin.also' call
          var this_1 = new BitmapGlyphInfo(glyphID, VOID, VOID, VOID, new ColorBitmapInfo(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, strike.y5g_1, strike.y5g_1));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
          this_1.w5b_1 = bytes;
          this_0.e3(glyphID, this_1);
        }
         while (inductionVariable_0 < last_0);
    }
    return Unit_instance;
  }
  i58(_this__u8e3s4) {
    return _this__u8e3s4.g1q();
  }
  j58(_this__u8e3s4) {
    return _this__u8e3s4.e1q();
  }
  k58(_this__u8e3s4) {
    return _this__u8e3s4.d1q();
  }
  l58(_this__u8e3s4) {
    return _this__u8e3s4.e1q();
  }
  m58(_this__u8e3s4) {
    return _this__u8e3s4.f1q();
  }
  n58(_this__u8e3s4) {
    return _this__u8e3s4.g1q();
  }
  o58(_this__u8e3s4, isVar) {
    var xx = this.j59(_this__u8e3s4);
    var yx = this.j59(_this__u8e3s4);
    var xy = this.j59(_this__u8e3s4);
    var yy = this.j59(_this__u8e3s4);
    var dx = this.j59(_this__u8e3s4);
    var dy = this.j59(_this__u8e3s4);
    return new Matrix(xx, yx, xy, yy, dx, -dy);
  }
  p58(_this__u8e3s4, out) {
    out.i5c_1 = this.i59(_this__u8e3s4);
    out.j5c_1 = _this__u8e3s4.e1q();
    out.k5c_1 = this.i59(_this__u8e3s4);
    return out;
  }
  q58(_this__u8e3s4, out, $super) {
    out = out === VOID ? new ColorStop(0.0, 0, 0.0) : out;
    return $super === VOID ? this.p58(_this__u8e3s4, out) : $super.p58.call(this, _this__u8e3s4, out);
  }
  r58(_this__u8e3s4, doVar) {
    var format = _this__u8e3s4.c1q();
    var xMin = this.k58(_this__u8e3s4);
    var yMin = this.k58(_this__u8e3s4);
    var xMax = this.k58(_this__u8e3s4);
    var yMax = this.k58(_this__u8e3s4);
    if (format === 2) {
      var varIndexBase = this.i58(_this__u8e3s4);
    }
    return Companion_getInstance_4().y2d(xMin, yMin, xMax, yMax);
  }
  s58(_this__u8e3s4, doVar, $super) {
    doVar = doVar === VOID ? false : doVar;
    return $super === VOID ? this.r58(_this__u8e3s4, doVar) : $super.r58.call(this, _this__u8e3s4, doVar);
  }
  t58(_this__u8e3s4) {
    var cycle;
    switch (_this__u8e3s4.c1q()) {
      case 0:
        cycle = CycleMethod_NO_CYCLE_getInstance();
        break;
      case 1:
        cycle = CycleMethod_REPEAT_getInstance();
        break;
      case 2:
        cycle = CycleMethod_REFLECT_getInstance();
        break;
      default:
        cycle = CycleMethod_NO_CYCLE_getInstance();
        break;
    }
    // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf16' call
    var tmp = 0;
    var tmp_0 = _this__u8e3s4.e1q();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      // Inline function 'korlibs.image.font.BaseTtfFont.readColorLine.<anonymous>' call
      tmp_1[tmp] = this.q58(_this__u8e3s4);
      tmp = tmp + 1 | 0;
    }
    return new ColorLine(cycle, toList_1(tmp_1));
  }
  u58(glyphID, s, c, pal, level) {
    var nodeFormat = s.c1q();
    var isVar = (nodeFormat % 2 | 0) === 1;
    var indent = repeat('  ', level);
    var debug = false;
    var debugShape = false;
    if (debug) {
      println(indent + 'interpretColrv1[glyphID=' + glyphID + ']: ' + nodeFormat + ' - ' + toString(getOrNull(Companion_getInstance_32().t59_1, nodeFormat)));
    }
    switch (nodeFormat) {
      case 1:
        var numLayers = s.c1q();
        var firstLayerIndex = s.g1q();
        var inductionVariable = 0;
        if (inductionVariable < numLayers)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var paint = this.a57_1.n5d_1[firstLayerIndex + n | 0];
            this.u58(glyphID, this.a57_1.q5d_1.x1p(paint), c, pal, level + 1 | 0);
          }
           while (inductionVariable < numLayers);
        break;
      case 2:
      case 3:
        var paletteIndex = s.e1q();
        var alpha = this.i59(s);
        if (isVar) {
          var varIndexBase = this.i58(s);
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.od();
        }

        var color = RGBA__concatAd_impl_gwhfm(RgbaArray__get_impl_nzyo1o(this.z56_1.d1(pal).p4c_1, paletteIndex), alpha);
        if (debugShape) {
          println("ctx.fillStyle = '" + _RGBA___get_htmlStringSimple__impl__l4nu0u(color) + "';");
          println('ctx.fill();');
        }

        if (debug) {
          println(indent + RGBA__toString_impl_4lw6dp(color));
        }

        c.r4y(new RGBA(color));
        break;
      case 4:
      case 5:
        var colorLineOffset = this.m58(s);
        var x0 = this.k58(s);
        var y0 = this.k58(s);
        var x1 = this.k58(s);
        var y1 = this.k58(s);
        var x2 = this.k58(s);
        var y2 = this.k58(s);
        var colorLine = this.t58(s.x1p(colorLineOffset));
        if (isVar) {
          var varIndexBase_0 = this.i58(s);
        }

        // Inline function 'korlibs.image.paint.LinearGradientPaint' call

        var y0_0 = -y0;
        var y1_0 = -y1;
        var cycle = colorLine.f5c_1;
        var transform = Companion_getInstance_5().x28_1;
        // Inline function 'kotlin.also' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.image.paint.LinearGradientPaint.<anonymous>' call

        var paint_0 = new GradientPaint(GradientKind_LINEAR_getInstance(), numberToDouble(x0), numberToDouble(y0_0), 0.0, numberToDouble(x1), numberToDouble(y1_0), 0.0, VOID, VOID, cycle, transform);
        colorLine.h5c(paint_0, this.z56_1.d1(pal));
        if (debug) {
          println(indent + paint_0.toString());
        }

        c.r4y(paint_0);
        break;
      case 6:
      case 7:
        var colorLineOffset_0 = this.m58(s);
        var x0_0 = this.k58(s);
        var y0_1 = this.k58(s);
        var radius0 = this.j58(s);
        var x1_0 = this.k58(s);
        var y1_1 = this.k58(s);
        var radius1 = this.j58(s);
        var colorLine_0 = this.t58(s.x1p(colorLineOffset_0));
        if (isVar) {
          var varIndexBase_1 = this.i58(s);
        }

        if (debugShape) {
          println('ctx.fillStyle = ctx.createRadialGradient(' + x0_0 + ', -' + y0_1 + ', ' + radius0 + ', ' + x1_0 + ', -' + y1_1 + ', ' + radius1 + ');');
          println('ctx.fill();');
        }

        // Inline function 'korlibs.image.paint.RadialGradientPaint' call

        var y0_2 = -y0_1;
        var y1_2 = -y1_1;
        var cycle_0 = colorLine_0.f5c_1;
        var transform_0 = Companion_getInstance_5().x28_1;
        // Inline function 'kotlin.also' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.image.paint.RadialGradientPaint.<anonymous>' call

        var paint_1 = new GradientPaint(GradientKind_RADIAL_getInstance(), numberToDouble(x0_0), numberToDouble(y0_2), numberToDouble(radius0), numberToDouble(x1_0), numberToDouble(y1_2), numberToDouble(radius1), VOID, VOID, cycle_0, transform_0);
        colorLine_0.h5c(paint_1, this.z56_1.d1(pal));
        if (debug) {
          println(indent + paint_1.toString());
        }

        c.r4y(paint_1);
        break;
      case 8:
      case 9:
        var colorLine_1 = this.m58(s);
        var centerX = this.k58(s);
        var centerY = this.k58(s);
        var startAngle = this.i59(s);
        var endAngle = this.i59(s);
        if (isVar) {
          var varIndexBase_2 = this.i58(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.od();
      case 10:
        var paint_2 = this.m58(s);
        var glyphID_0 = s.e1q();
        var colr = this.y56_1.d1(glyphID_0);
        var glyph = this.h59(glyphID_0);
        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.y4y();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          if (!(glyph == null)) {
            if (debugShape) {
              println(joinToString(toContext2dCommands(glyph.o21().s5e_1), '\n'));
            }
            c.l5h(glyph.o21().s5e_1);
            this.u58(glyphID_0, s.x1p(paint_2), c, pal, level + 1 | 0);
          }
        }finally {
          c.g4z();
        }

        break;
      case 11:
        var glyphID_1 = s.e1q();
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.od();
      case 12:
      case 13:
        var paint_3 = this.m58(s);
        var transform_1 = this.m58(s);
        var affine = this.o58(s.x1p(transform_1), isVar);
        if (debug) {
          println(indent + 'affine=' + affine.toString());
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.y4y();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          c.s50(affine);
          this.u58(glyphID, s.x1p(paint_3), c, pal, level + 1 | 0);
        }finally {
          c.g4z();
        }

        break;
      case 14:
      case 15:
        var paint_4 = this.m58(s);
        var dx = FWord__toDouble_impl_53j5qp(this.u57(s));
        var dy = FWord__toDouble_impl_53j5qp(this.u57(s));
        if (isVar) {
          var varIndexBase_3 = this.i58(s);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.y4y();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          if (debug) {
            println('translate: ' + dx + ', ' + dy);
          }
          c.q50(dx, -dy);
          this.u58(glyphID, s.x1p(paint_4), c, pal, level + 1 | 0);
        }finally {
          c.g4z();
        }

        break;
      case 16:
      case 17:
      case 18:
      case 19:
        var paint_5 = this.m58(s);
        var scaleX = this.i59(s);
        var scaleY = this.i59(s);
        var aroundCenter = nodeFormat >= 18;
        if (aroundCenter) {
          var centerX_0 = this.k58(s);
          var centerY_0 = this.k58(s);
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.od();
        }

        if (isVar) {
          var varIndexBase_4 = this.i58(s);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.y4y();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          // Inline function 'korlibs.image.vector.Context2d.scale' call
          c.m5h(numberToDouble(scaleX), numberToDouble(scaleY));
          this.u58(glyphID, s.x1p(paint_5), c, pal, level + 1 | 0);
        }finally {
          c.g4z();
        }

        break;
      case 20:
      case 21:
      case 22:
      case 23:
        var paint_6 = this.m58(s);
        var scale = this.i59(s);
        if (nodeFormat >= 22) {
          var centerX_1 = this.k58(s);
          var centerY_1 = this.k58(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_5 = this.i58(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.od();
      case 24:
      case 25:
      case 26:
      case 27:
        var paint_7 = this.m58(s);
        var angle = this.i59(s);
        if (nodeFormat >= 26) {
          var centerX_2 = this.k58(s);
          var centerY_2 = this.k58(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_6 = this.i58(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.od();
      case 28:
      case 29:
      case 30:
      case 31:
        var paint_8 = this.m58(s);
        var xSkewAngle = this.i59(s);
        var ySkewAngle = this.i59(s);
        if (nodeFormat >= 30) {
          var centerX_3 = this.k58(s);
          var centerY_3 = this.k58(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_7 = this.i58(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.od();
      case 32:
        var sourcePaint = this.m58(s);
        var compositeMode = s.c1q();
        var backdropPaint = this.m58(s);
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.od();
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'Unknown colorv1 format=' + nodeFormat;
        throw NotImplementedError.od('An operation is not implemented: ' + reason);
    }
  }
  v58(_this__u8e3s4, hintedCount) {
    var coverageFormat = _this__u8e3s4.e1q();
    switch (coverageFormat) {
      case 1:
        var glyphCount = _this__u8e3s4.e1q();
        // Inline function 'korlibs.datastructure.mapInt' call

        var this_0 = _this__u8e3s4.k1q(glyphCount);
        // Inline function 'kotlin.also' call

        var this_1 = new Int32Array(this_0.length);
        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

        var inductionVariable = 0;
        var last = this_0.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
            // Inline function 'kotlin.code' call
            var this_2 = this_0[n];
            this_1[n] = Char__toInt_impl_vasixd(this_2);
          }
           while (inductionVariable < last);
        return this_1;
      case 2:
        var rangeCount = _this__u8e3s4.e1q();
        // Inline function 'kotlin.collections.map' call

        var this_3 = until(0, rangeCount);
        // Inline function 'kotlin.collections.mapTo' call

        var destination = ArrayList.w(collectionSizeOrDefault(this_3, 10));
        var inductionVariable_0 = this_3.a2_1;
        var last_0 = this_3.b2_1;
        if (inductionVariable_0 <= last_0)
          do {
            var item = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
            var tmp$ret$4 = new BaseTtfFont$readCoverage$RangeInfo(_this__u8e3s4.e1q(), _this__u8e3s4.e1q(), _this__u8e3s4.e1q());
            destination.h(tmp$ret$4);
          }
           while (!(item === last_0));
        var ranges = destination;
        // Inline function 'kotlin.collections.maxOf' call

        var iterator = ranges.a1();
        if (!iterator.b1())
          throw NoSuchElementException.k6();
        // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call

        var it = iterator.c1();
        var maxValue = it.e5h_1 + it.f5h_1 | 0;
        while (iterator.b1()) {
          // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
          var it_0 = iterator.c1();
          var v = it_0.e5h_1 + it_0.f5h_1 | 0;
          if (compareTo(maxValue, v) < 0) {
            maxValue = v;
          }
        }

        var glyphCount_0 = maxValue;
        var glyphArray = new Int32Array(glyphCount_0);
        var _iterator__ex2g4s = ranges.a1();
        while (_iterator__ex2g4s.b1()) {
          var range = _iterator__ex2g4s.c1();
          var inductionVariable_1 = range.c5h_1;
          var last_1 = range.d5h_1;
          if (inductionVariable_1 <= last_1)
            do {
              var glyphID = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var offset = glyphID - range.c5h_1 | 0;
              glyphArray[range.e5h_1 + offset | 0] = glyphID;
            }
             while (!(glyphID === last_1));
        }

        return glyphArray;
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'coverageFormat=' + coverageFormat;
        throw NotImplementedError.od('An operation is not implemented: ' + reason);
    }
  }
  w58(_this__u8e3s4, hintedCount, $super) {
    hintedCount = hintedCount === VOID ? -1 : hintedCount;
    return $super === VOID ? this.v58(_this__u8e3s4, hintedCount) : $super.v58.call(this, _this__u8e3s4, hintedCount);
  }
  x58() {
    var tmp111_safe_receiver = this.w57('GSUB');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>' call
      var totalLength = tmp111_safe_receiver.a();
      var majorVersion = tmp111_safe_receiver.e1q();
      var minorVersion = tmp111_safe_receiver.e1q();
      if (!(majorVersion === 1)) {
        // Inline function 'kotlin.error' call
        var message = 'Unknown GSUB majorVerrsion=' + majorVersion;
        throw IllegalStateException.w4(toString_0(message));
      }
      var scriptListOffset = this.l58(tmp111_safe_receiver);
      var featureListOffset = this.l58(tmp111_safe_receiver);
      var lookupListOffset = this.l58(tmp111_safe_receiver);
      if (minorVersion >= 1) {
        var featureVariationsOffset = this.n58(tmp111_safe_receiver);
      }
      // Inline function 'kotlin.apply' call
      var this_0 = tmp111_safe_receiver.x1p(scriptListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var scriptCount = this_0.e1q();
      var inductionVariable = 0;
      if (inductionVariable < scriptCount)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var scriptTag = this_0.p1q(4);
          var scriptOffset = this.l58(this_0);
        }
         while (inductionVariable < scriptCount);
      // Inline function 'kotlin.apply' call
      var this_1 = tmp111_safe_receiver.x1p(featureListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var featureCount = this_1.e1q();
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < featureCount)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var featureTag = this_1.p1q(4);
          var featureOffset = this.l58(this_1);
        }
         while (inductionVariable_0 < featureCount);
      // Inline function 'kotlin.apply' call
      var this_2 = tmp111_safe_receiver.x1p(lookupListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var lookupCount = this_2.e1q();
      // Inline function 'korlibs.datastructure.mapInt' call
      var this_3 = until(0, lookupCount);
      // Inline function 'kotlin.also' call
      var this_4 = IntArrayList.n2j((coerceAtLeast(this_3.e2() - this_3.f2() | 0, 0) / this_3.c2_1 | 0) + 1 | 0);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
      var nestedFirst = this_3.f2();
      var nestedLast = this_3.e2();
      var stepArg = this_3.c2_1;
      if (stepArg <= 0)
        THROW_IAE('Step must be positive, was: ' + stepArg + '.');
      var inductionVariable_1 = nestedFirst;
      var last = getProgressionLastElement(nestedFirst, nestedLast, stepArg);
      if (inductionVariable_1 <= last)
        do {
          var v = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + stepArg | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>' call
          var tmp$ret$2 = this.l58(this_2);
          this_4.t2j(tmp$ret$2);
        }
         while (!(v === last));
      var lookups = this_4;
      var _iterator__ex2g4s = lookups.a1();
      while (_iterator__ex2g4s.b1()) {
        var lookupOffset = _iterator__ex2g4s.c1();
        // Inline function 'kotlin.apply' call
        var this_5 = this_2.x1p(lookupOffset);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>' call
        var lookupType = this_5.e1q();
        var lookupFlag = this_5.e1q();
        var subTableCount = this_5.e1q();
        // Inline function 'korlibs.datastructure.mapInt' call
        var this_6 = this_5.j1q(subTableCount);
        // Inline function 'kotlin.also' call
        var this_7 = new Int32Array(this_6.length);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
        var inductionVariable_2 = 0;
        var last_0 = this_6.length;
        if (inductionVariable_2 < last_0)
          do {
            var n_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            this_7[n_1] = this_6[n_1] & 65535;
          }
           while (inductionVariable_2 < last_0);
        var subtableOffsets = this_7;
        var markFilteringSet = this_5.e1q();
        var inductionVariable_3 = 0;
        var last_1 = subtableOffsets.length;
        while (inductionVariable_3 < last_1) {
          var offset = subtableOffsets[inductionVariable_3];
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          // Inline function 'kotlin.apply' call
          var this_8 = this_5.x1p(offset);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
          var subsTable = this_8;
          switch (lookupType) {
            case 1:
              var substFormat = this_8.e1q();
              var coverageOffset = this.l58(this_8);
              switch (substFormat) {
                case 1:
                  var deltaGlyphID = this_8.d1q();
                  var coverageTable = this.w58(this_8.x1p(coverageOffset));
                  var inductionVariable_4 = 0;
                  var last_2 = coverageTable.length;
                  while (inductionVariable_4 < last_2) {
                    var glyphID = coverageTable[inductionVariable_4];
                    inductionVariable_4 = inductionVariable_4 + 1 | 0;
                    this.c57_1.z2o(glyphID, glyphID + deltaGlyphID | 0);
                  }

                  break;
                case 2:
                  var glyphCount = this_8.e1q();
                  var coverageTable_0 = this.w58(this_8.x1p(coverageOffset));
                  // Inline function 'korlibs.datastructure.mapInt' call

                  var this_9 = this_8.k1q(glyphCount);
                  // Inline function 'kotlin.also' call

                  var this_10 = new Int32Array(this_9.length);
                  // Inline function 'kotlin.contracts.contract' call

                  // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

                  var inductionVariable_5 = 0;
                  var last_3 = this_9.length;
                  if (inductionVariable_5 < last_3)
                    do {
                      var n_2 = inductionVariable_5;
                      inductionVariable_5 = inductionVariable_5 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      // Inline function 'kotlin.code' call
                      var this_11 = this_9[n_2];
                      this_10[n_2] = Char__toInt_impl_vasixd(this_11);
                    }
                     while (inductionVariable_5 < last_3);
                  var substituteGlyphIDs = this_10;
                  // Inline function 'kotlin.repeat' call

                  // Inline function 'kotlin.contracts.contract' call

                  var inductionVariable_6 = 0;
                  if (inductionVariable_6 < glyphCount)
                    do {
                      var index = inductionVariable_6;
                      inductionVariable_6 = inductionVariable_6 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      this.c57_1.z2o(coverageTable_0[index], substituteGlyphIDs[index]);
                    }
                     while (inductionVariable_6 < glyphCount);
                  break;
                default:
                  // Inline function 'kotlin.error' call

                  var message_0 = 'Unsupported lookupType=1, substFormat=' + substFormat;
                  throw IllegalStateException.w4(toString_0(message_0));
              }

              break;
            case 4:
              var substFormat_0 = this_8.e1q();
              if (!(substFormat_0 === 1)) {
                // Inline function 'kotlin.error' call
                var message_1 = 'For lookType=4 only substFormat=1 is supported';
                throw IllegalStateException.w4(toString_0(message_1));
              }

              var coverageOffset_0 = this.l58(this_8);
              var ligatureSetCount = this_8.e1q();
              // Inline function 'korlibs.datastructure.mapInt' call

              var this_12 = this_8.k1q(ligatureSetCount);
              // Inline function 'kotlin.also' call

              var this_13 = new Int32Array(this_12.length);
              // Inline function 'kotlin.contracts.contract' call

              // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

              var inductionVariable_7 = 0;
              var last_4 = this_12.length;
              if (inductionVariable_7 < last_4)
                do {
                  var n_3 = inductionVariable_7;
                  inductionVariable_7 = inductionVariable_7 + 1 | 0;
                  // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  // Inline function 'kotlin.code' call
                  var this_14 = this_12[n_3];
                  this_13[n_3] = Char__toInt_impl_vasixd(this_14);
                }
                 while (inductionVariable_7 < last_4);
              var ligatureSetOffsets = this_13;
              var glyphArray = this.v58(this_8.x1p(coverageOffset_0), ligatureSetCount);
              var inductionVariable_8 = 0;
              var last_5 = ligatureSetOffsets.length - 1 | 0;
              if (inductionVariable_8 <= last_5)
                do {
                  var n_4 = inductionVariable_8;
                  inductionVariable_8 = inductionVariable_8 + 1 | 0;
                  var glyphID_0 = glyphArray[n_4];
                  var asetoffset = ligatureSetOffsets[n_4];
                  var map = LinkedHashMap.bc();
                  var codePoint = this.b59(glyphID_0);
                  // Inline function 'kotlin.intArrayOf' call
                  var codePointIntArray = new Int32Array([codePoint]);
                  var maxComponentCount = 1;
                  // Inline function 'kotlin.apply' call
                  var this_15 = subsTable.x1p(asetoffset);
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var ligatureCount = this_15.e1q();
                  // Inline function 'korlibs.datastructure.mapInt' call
                  var this_16 = this_15.k1q(ligatureCount);
                  // Inline function 'kotlin.also' call
                  var this_17 = new Int32Array(this_16.length);
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
                  var inductionVariable_9 = 0;
                  var last_6 = this_16.length;
                  if (inductionVariable_9 < last_6)
                    do {
                      var n_5 = inductionVariable_9;
                      inductionVariable_9 = inductionVariable_9 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      // Inline function 'kotlin.code' call
                      var this_18 = this_16[n_5];
                      this_17[n_5] = Char__toInt_impl_vasixd(this_18);
                    }
                     while (inductionVariable_9 < last_6);
                  var ligatureOffsets = this_17;
                  var inductionVariable_10 = 0;
                  var last_7 = ligatureOffsets.length;
                  while (inductionVariable_10 < last_7) {
                    var offset_0 = ligatureOffsets[inductionVariable_10];
                    inductionVariable_10 = inductionVariable_10 + 1 | 0;
                    // Inline function 'kotlin.apply' call
                    var this_19 = this_15.x1p(offset_0);
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                    var ligatureGlyph = this_19.e1q();
                    var componentCount = this_19.e1q();
                    // Inline function 'kotlin.math.max' call
                    var a = maxComponentCount;
                    var b = componentCount + 1 | 0;
                    maxComponentCount = Math.max(a, b);
                    // Inline function 'korlibs.datastructure.mapInt' call
                    var this_20 = this_19.k1q(componentCount - 1 | 0);
                    // Inline function 'kotlin.also' call
                    var this_21 = new Int32Array(this_20.length);
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
                    var inductionVariable_11 = 0;
                    var last_8 = this_20.length;
                    if (inductionVariable_11 < last_8)
                      do {
                        var n_6 = inductionVariable_11;
                        inductionVariable_11 = inductionVariable_11 + 1 | 0;
                        // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        // Inline function 'kotlin.code' call
                        var this_22 = this_20[n_6];
                        var tmp$ret$22 = Char__toInt_impl_vasixd(this_22);
                        this_21[n_6] = this.b59(tmp$ret$22);
                      }
                       while (inductionVariable_11 < last_8);
                    var componentCodePoints = this_21;
                    var tmp = Companion_getInstance_11();
                    // Inline function 'kotlin.collections.plus' call
                    var tmp$ret$26 = primitiveArrayConcat([codePointIntArray, componentCodePoints]);
                    var ligature = tmp.kw(tmp$ret$26);
                    // Inline function 'kotlin.collections.set' call
                    // Inline function 'kotlin.intArrayOf' call
                    var value = new Int32Array([ligatureGlyph]);
                    map.e3(ligature, value);
                  }
                  this.d57_1.c2o(codePoint, new SubstitutionInfo(maxComponentCount, map));
                }
                 while (inductionVariable_8 <= last_5);
              break;
            default:
              // Inline function 'korlibs.logger.Logger.info' call

              var this_23 = Companion_getInstance_30().x54_1;
              var level = Level_INFO_getInstance();
              var tmp_0;
              if (this_23.j2t(level)) {
                // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                var tmp$ret$30 = 'TTF.GSUB: Unsupported lookupType=' + lookupType;
                this_23.k2t(level, tmp$ret$30);
                tmp_0 = Unit_instance;
              }

              break;
          }
        }
      }
    }
    return Unit_instance;
  }
  y58() {
    var tmp111_safe_receiver = this.w57('COLR');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>' call
      var version = tmp111_safe_receiver.e1q();
      switch (version) {
        case 0:
        case 1:
          var numBaseGlyphRecords = tmp111_safe_receiver.e1q();
          var baseGlyphRecordsOffset = tmp111_safe_receiver.g1q();
          var layerRecordsOffset = tmp111_safe_receiver.g1q();
          var numLayerRecords = tmp111_safe_receiver.e1q();
          // Inline function 'kotlin.apply' call

          var this_0 = tmp111_safe_receiver.x1p(layerRecordsOffset);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call

          var tmp = this;
          var tmp_0 = 0;
          // Inline function 'kotlin.arrayOfNulls' call

          var tmp_1 = fillArrayVal(Array(numLayerRecords), null);
          while (tmp_0 < numLayerRecords) {
            tmp_1[tmp_0] = new ColrLayerInfo(this, this_0.e1q(), this_0.e1q());
            tmp_0 = tmp_0 + 1 | 0;
          }

          tmp.x56_1 = tmp_1;
          // Inline function 'kotlin.apply' call

          var this_1 = tmp111_safe_receiver.x1p(baseGlyphRecordsOffset);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call

          var inductionVariable = 0;
          if (inductionVariable < numBaseGlyphRecords)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var info = new ColrGlyphInfoV0(this, this_1.e1q(), this_1.e1q(), this_1.e1q());
              this.y56_1.c2o(info.y5e_1, info);
            }
             while (inductionVariable < numBaseGlyphRecords);
          if (version === 1) {
            var baseGlyphListOffset = this.n58(tmp111_safe_receiver);
            var layerListOffset = this.n58(tmp111_safe_receiver);
            var clipListOffset = this.n58(tmp111_safe_receiver);
            var varIdxMapOffset = this.n58(tmp111_safe_receiver);
            var varStoreOffset = this.n58(tmp111_safe_receiver);
            this.a57_1.s5d_1.h3();
            var tmp_2 = this;
            var tmp126_s = tmp111_safe_receiver.x1p(0);
            // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
            var this_2 = tmp111_safe_receiver.x1p(layerListOffset);
            var tmp_3 = 0;
            var tmp_4 = this_2.g1q();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_5 = fillArrayVal(Array(tmp_4), null);
            while (tmp_3 < tmp_4) {
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              tmp_5[tmp_3] = this.n58(this_2);
              tmp_3 = tmp_3 + 1 | 0;
            }
            var tmp127_layerList = toIntArray(tmp_5);
            var tmp128_sBaseOffset = tmp111_safe_receiver.x1p(baseGlyphListOffset);
            var tmp129_sLayerOffset = tmp111_safe_receiver.x1p(layerListOffset);
            // Inline function 'kotlin.takeIf' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_6;
            // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
            if (!(clipListOffset === 0)) {
              tmp_6 = clipListOffset;
            } else {
              tmp_6 = null;
            }
            var tmp125_safe_receiver = tmp_6;
            var tmp_7;
            if (tmp125_safe_receiver == null) {
              tmp_7 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              tmp_7 = tmp111_safe_receiver.x1p(tmp125_safe_receiver);
            }
            var tmp130_sClipOffset = tmp_7;
            tmp_2.a57_1 = new COLRv1(tmp127_layerList, tmp126_s, tmp128_sBaseOffset, tmp129_sLayerOffset, tmp130_sClipOffset);
            // Inline function 'kotlin.takeIf' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_8;
            // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
            if (!(clipListOffset === 0)) {
              tmp_8 = clipListOffset;
            } else {
              tmp_8 = null;
            }
            if (tmp_8 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              var s = tmp111_safe_receiver.x1p(clipListOffset);
              var format = s.c1q();
              // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
              var tmp_9 = 0;
              var tmp_10 = s.g1q();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_11 = fillArrayVal(Array(tmp_10), null);
              while (tmp_9 < tmp_10) {
                var tmp_12 = tmp_9;
                var startGlyphID = s.e1q();
                var endGlyphID = s.e1q();
                var clipBoxOffset = this.m58(s);
                var inductionVariable_0 = startGlyphID;
                if (inductionVariable_0 <= endGlyphID)
                  do {
                    var glyphID = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    this.a57_1.s5d_1.z2o(glyphID, clipBoxOffset);
                  }
                   while (!(glyphID === endGlyphID));
                tmp_11[tmp_12] = Unit_instance;
                tmp_9 = tmp_9 + 1 | 0;
              }
            }
            // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
            var this_3 = tmp111_safe_receiver.x1p(baseGlyphListOffset);
            var tmp_13 = 0;
            var tmp_14 = this_3.g1q();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_15 = fillArrayVal(Array(tmp_14), null);
            while (tmp_13 < tmp_14) {
              var tmp_16 = tmp_13;
              var glyphID_0 = this_3.e1q();
              var paint = this.n58(this_3);
              this.y56_1.c2o(glyphID_0, new ColrGlyphInfoV1(this, glyphID_0, paint));
              tmp_15[tmp_16] = Unit_instance;
              tmp_13 = tmp_13 + 1 | 0;
            }
          }

          break;
        default:
          println('TTF WARNING CCOLv' + version + ' not supported');
          break;
      }
    }
    return Unit_instance;
  }
  z58() {
    var tmp111_safe_receiver = this.w57('cmap');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>' call
      var version = tmp111_safe_receiver.e1q();
      var numTables = tmp111_safe_receiver.e1q();
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, numTables);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var inductionVariable = this_0.a2_1;
      var last = this_0.b2_1;
      if (inductionVariable <= last)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>.<anonymous>' call
          var tmp$ret$0 = new BaseTtfFont$readCmap$EncodingRecord(tmp111_safe_receiver.e1q(), tmp111_safe_receiver.e1q(), tmp111_safe_receiver.g1q());
          destination.h(tmp$ret$0);
        }
         while (!(item === last));
      var tables = destination;
      var index = 0;
      var _iterator__ex2g4s = tables.a1();
      while (_iterator__ex2g4s.b1()) {
        var table = _iterator__ex2g4s.c1();
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        var $this$run = tmp111_safe_receiver.x1p(table.i5h_1);
        var format = $this$run.e1q();
        try {
          switch (format) {
            case 0:
              var length = $this$run.e1q();
              var language = $this$run.e1q();
              // Inline function 'korlibs.datastructure.mapInt' call

              var this_1 = $this$run.a1q(256);
              // Inline function 'kotlin.also' call

              var this_2 = new Int32Array(this_1.length);
              // Inline function 'kotlin.contracts.contract' call

              // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

              var inductionVariable_0 = 0;
              var last_0 = this_1.length;
              if (inductionVariable_0 < last_0)
                do {
                  var n = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>.<anonymous>.<anonymous>' call
                  this_2[n] = this_1[n] & 255;
                }
                 while (inductionVariable_0 < last_0);
              var glyphIdArray = this_2;
              var inductionVariable_1 = 0;
              if (inductionVariable_1 < 256)
                do {
                  var n_0 = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  this.r57(n_0, glyphIdArray[n_0]);
                }
                 while (inductionVariable_1 < 256);
              break;
            case 2:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 4:
              var length_0 = $this$run.e1q();
              var language_0 = $this$run.e1q();
              var segCount = $this$run.e1q() / 2 | 0;
              var searchRangeS = $this$run.e1q();
              var entrySelector = $this$run.e1q();
              var rangeShift = $this$run.e1q();
              var endCount = $this$run.k1q(segCount);
              $this$run.e1q();
              var startCount = $this$run.k1q(segCount);
              var idDelta = $this$run.j1q(segCount);
              var rangeOffsetPos = $this$run.t1p();
              var idRangeOffset = $this$run.k1q(segCount);
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < segCount)
                do {
                  var n_1 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  var ec = Char__toInt_impl_vasixd(endCount[n_1]);
                  var sc = Char__toInt_impl_vasixd(startCount[n_1]);
                  var delta = idDelta[n_1];
                  var iro = Char__toInt_impl_vasixd(idRangeOffset[n_1]);
                  var inductionVariable_3 = sc;
                  if (inductionVariable_3 <= ec)
                    do {
                      var c = inductionVariable_3;
                      inductionVariable_3 = inductionVariable_3 + 1 | 0;
                      if (!(iro === 0)) {
                        var glyphIndexOffset = rangeOffsetPos + imul(n_1, 2) | 0;
                        glyphIndexOffset = glyphIndexOffset + iro | 0;
                        glyphIndexOffset = glyphIndexOffset + imul(c - sc | 0, 2) | 0;
                        index = $this$run.x1p(glyphIndexOffset).e1q();
                        if (!(index === 0)) {
                          index = index + delta | 0;
                        }
                      } else {
                        index = c + delta | 0;
                      }
                      this.q57(c, index & 65535);
                    }
                     while (!(c === ec));
                }
                 while (inductionVariable_2 < segCount);
              break;
            case 6:
              var length_1 = $this$run.e1q();
              var language_1 = $this$run.e1q();
              var firstCode = $this$run.e1q();
              var entryCount = $this$run.e1q();
              var inductionVariable_4 = 0;
              if (inductionVariable_4 < entryCount)
                do {
                  var n_2 = inductionVariable_4;
                  inductionVariable_4 = inductionVariable_4 + 1 | 0;
                  var codePoint = firstCode + n_2 | 0;
                  this.q57(codePoint, $this$run.e1q());
                }
                 while (inductionVariable_4 < entryCount);
              break;
            case 8:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 10:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 12:
              $this$run.e1q();
              var length_2 = $this$run.g1q();
              var language_2 = $this$run.g1q();
              var numGroups = $this$run.g1q();
              var inductionVariable_5 = 0;
              if (inductionVariable_5 < numGroups)
                do {
                  var n_3 = inductionVariable_5;
                  inductionVariable_5 = inductionVariable_5 + 1 | 0;
                  var startCharCode = $this$run.g1q();
                  var endCharCode = $this$run.g1q();
                  var startGlyphId = $this$run.g1q();
                  var inductionVariable_6 = startCharCode;
                  if (inductionVariable_6 <= endCharCode)
                    do {
                      var c_0 = inductionVariable_6;
                      inductionVariable_6 = inductionVariable_6 + 1 | 0;
                      var m = c_0 - startCharCode | 0;
                      this.q57(c_0, startGlyphId + m | 0);
                    }
                     while (!(c_0 === endCharCode));
                }
                 while (inductionVariable_5 < numGroups);
              break;
            case 13:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            default:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
          } else {
            throw $p;
          }
        }
      }
    }
    return Unit_instance;
  }
  a59(charIndex, default_0) {
    // Inline function 'kotlin.collections.getOrElse' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp0_elvis_lhs = this.u56_1.c3(charIndex);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.font.BaseTtfFont.getCodePointFromCharIndexOrElse.<anonymous>' call
      tmp = default_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  b59(charIndex, default_0, $super) {
    default_0 = default_0 === VOID ? -1 : default_0;
    return $super === VOID ? this.a59(charIndex, default_0) : $super.a59.call(this, charIndex, default_0);
  }
  c59(reader, codePoint, cache) {
    var g = this.f59(codePoint);
    var skipCount = 1;
    if (this.c55_1 && !(g == null)) {
      var subs = this.d57_1.d1(codePoint);
      if (!(reader == null) && !(subs == null)) {
        // Inline function 'kotlin.math.min' call
        var a = reader.wv();
        var b = subs.f5a_1;
        var inductionVariable = Math.min(a, b);
        if (2 <= inductionVariable)
          $l$loop_0: do {
            var count = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var sub = reader.iw(0, count);
            var replacement = subs.g5a_1.c3(sub);
            if (!(replacement == null)) {
              skipCount = sub.a();
              var tmp0_elvis_lhs = this.h59(first_1(replacement));
              var tmp;
              if (tmp0_elvis_lhs == null) {
                break $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              g = tmp;
              break $l$loop_0;
            }
          }
           while (2 <= inductionVariable);
      }
    }
    if (reader == null)
      null;
    else {
      reader.hw(skipCount);
    }
    return g;
  }
  d59(reader, codePoint, cache, $super) {
    cache = cache === VOID ? true : cache;
    return $super === VOID ? this.c59(reader, codePoint, cache) : $super.c59.call(this, reader, codePoint, cache);
  }
  e59(codePoint, cache) {
    var tmp134_safe_receiver = this.p57(codePoint);
    var tmp;
    if (tmp134_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByCodePoint.<anonymous>' call
      tmp = this.g59(tmp134_safe_receiver, cache, codePoint);
    }
    return tmp;
  }
  f59(codePoint, cache, $super) {
    cache = cache === VOID ? true : cache;
    return $super === VOID ? this.e59(codePoint, cache) : $super.e59.call(this, codePoint, cache);
  }
  g59(index, cache, codePoint) {
    var cff = this.h57_1;
    if (!(cff == null)) {
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var this_0 = this.v56_1;
      var res = this_0.d1(index);
      if (res == null) {
        // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
        var gvector = cff.q53(index);
        var tmp$ret$0 = new CFFGlyph(this, index, 0, 0, 0, 0, numberToInt(gvector.u52_1), new GlyphGraphicsPath(index, gvector.t52_1));
        this_0.c2o(index, tmp$ret$0);
      }
      return ensureNotNull(this_0.d1(index));
    }
    var tmp0_elvis_lhs = getOrNull_0(this.g56_1, index);
    var start = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = getOrNull_0(this.g56_1, index + 1 | 0);
    var end = tmp1_elvis_lhs == null ? start : tmp1_elvis_lhs;
    var size = end - start | 0;
    var tmp;
    if (!(size === 0)) {
      var tmp2_elvis_lhs = this.v56_1.d1(index);
      var tmp_0;
      if (tmp2_elvis_lhs == null) {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.image.font.BaseTtfFont.runTable' call
          var tmp0_elvis_lhs_0 = this.m57('glyf');
          var tmp_1;
          if (tmp0_elvis_lhs_0 == null) {
            tmp$ret$2 = null;
            break $l$block;
          } else {
            tmp_1 = tmp0_elvis_lhs_0;
          }
          var table = tmp_1;
          // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
          var $this$runTable = table.h5a();
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>.<anonymous>' call
          tmp$ret$2 = this.l59($this$runTable.x1p(start), index);
        }
        tmp_0 = tmp$ret$2;
      } else {
        tmp_0 = tmp2_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.intArrayOf' call
      var tmp_2 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp_3 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp_4 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$9 = new Int32Array([]);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
      tmp = new SimpleGlyph(this, index, 0, 0, 0, 0, tmp_2, tmp_3, tmp_4, tmp$ret$9, this.s56_1.d1(index).i5a_1, true);
    }
    var glyph = tmp;
    if (cache && !this.b57_1) {
      this.v56_1.c2o(index, glyph);
    }
    return glyph;
  }
  h59(index, cache, codePoint, $super) {
    cache = cache === VOID ? true : cache;
    codePoint = codePoint === VOID ? -1 : codePoint;
    return $super === VOID ? this.g59(index, cache, codePoint) : $super.g59.call(this, index, cache, codePoint);
  }
  i59(_this__u8e3s4) {
    var v = _this__u8e3s4.d1q();
    var i = extractSigned(v, 14, 2);
    var f = extract(v, 0, 14);
    return i + f / 16384.0;
  }
  j59(_this__u8e3s4) {
    var v = _this__u8e3s4.g1q();
    var i = extractSigned(v, 16, 16);
    var f = extract(v, 0, 16);
    return i + f / 65536.0;
  }
  k59(_this__u8e3s4, signed, word) {
    var tmp;
    if (!word && signed) {
      tmp = _this__u8e3s4.b1q();
    } else if (!word && !signed) {
      tmp = _this__u8e3s4.c1q();
    } else if (word && signed) {
      tmp = _this__u8e3s4.d1q();
    } else if (word && !signed) {
      tmp = _this__u8e3s4.e1q();
    } else {
      get_invalidOp();
    }
    return tmp;
  }
  l59(_this__u8e3s4, index) {
    var ncontours = _this__u8e3s4.d1q();
    var xMin = _this__u8e3s4.d1q();
    var yMin = _this__u8e3s4.d1q();
    var xMax = _this__u8e3s4.d1q();
    var yMax = _this__u8e3s4.d1q();
    var advanceWidth = this.s56_1.d1(index).i5a_1;
    // Inline function 'kotlin.also' call
    var tmp;
    if (ncontours < 0) {
      var ARG_1_AND_2_ARE_WORDS = 1;
      var ARGS_ARE_XY_VALUES = 2;
      var ROUND_XY_TO_GRID = 4;
      var WE_HAVE_A_SCALE = 8;
      var MORE_COMPONENTS = 32;
      var WE_HAVE_AN_X_AND_Y_SCALE = 64;
      var WE_HAVE_A_TWO_BY_TWO = 128;
      var WE_HAVE_INSTRUCTIONS = 256;
      var USE_MY_METRICS = 512;
      var OVERLAP_COMPOUND = 1024;
      var SCALED_COMPONENT_OFFSET = 2048;
      var UNSCALED_COMPONENT_OFFSET = 4096;
      // Inline function 'kotlin.collections.arrayListOf' call
      var references = ArrayList.h1();
      do {
        var flags = _this__u8e3s4.e1q();
        var glyphIndex = _this__u8e3s4.e1q();
        var signed = !((flags & ARGS_ARE_XY_VALUES) === 0);
        var words = !((flags & ARG_1_AND_2_ARE_WORDS) === 0);
        var x = this.k59(_this__u8e3s4, signed, words);
        var y = this.k59(_this__u8e3s4, signed, words);
        var scaleX = 1.0;
        var scaleY = 1.0;
        var scale01 = 0.0;
        var scale10 = 0.0;
        if (!((flags & WE_HAVE_A_SCALE) === 0)) {
          scaleX = this.i59(_this__u8e3s4);
          scaleY = scaleX;
        } else if (!((flags & WE_HAVE_AN_X_AND_Y_SCALE) === 0)) {
          scaleX = this.i59(_this__u8e3s4);
          scaleY = this.i59(_this__u8e3s4);
        } else if (!((flags & WE_HAVE_A_TWO_BY_TWO) === 0)) {
          scaleX = this.i59(_this__u8e3s4);
          scale01 = this.i59(_this__u8e3s4);
          scale10 = this.i59(_this__u8e3s4);
          scaleY = this.i59(_this__u8e3s4);
        }
        var ref = new GlyphReference(ensureNotNull(this.h59(glyphIndex)), x, y, scaleX, scale01, scale10, scaleY);
        // Inline function 'kotlin.collections.plusAssign' call
        references.h(ref);
      }
       while (!((flags & MORE_COMPONENTS) === 0));
      tmp = new CompositeGlyph(this, index, xMin, yMin, xMax, yMax, references, advanceWidth);
    } else {
      var contoursIndices = new Int32Array(ncontours + 1 | 0);
      contoursIndices[0] = -1;
      var inductionVariable = 1;
      if (inductionVariable <= ncontours)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          contoursIndices[n] = _this__u8e3s4.e1q();
        }
         while (!(n === ncontours));
      var instructionLength = _this__u8e3s4.e1q();
      var instructions = _this__u8e3s4.a1q(instructionLength);
      var tmp139_safe_receiver = lastOrNull(contoursIndices);
      var tmp0_elvis_lhs = tmp139_safe_receiver == null ? null : tmp139_safe_receiver + 1 | 0;
      var numPoints = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      var flags_0 = IntArrayList.n2j();
      var npos = 0;
      while (npos < numPoints) {
        var cf = _this__u8e3s4.c1q();
        flags_0.t2j(cf);
        if (!((cf & 8) === 0)) {
          var count = _this__u8e3s4.c1q();
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < count)
            do {
              var n_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              flags_0.t2j(cf);
            }
             while (inductionVariable_0 < count);
          npos = npos + (count + 1 | 0) | 0;
        } else {
          npos = npos + 1 | 0;
        }
      }
      var xPos = new Int32Array(numPoints);
      var yPos = new Int32Array(numPoints);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= 1)
        do {
          var xy = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var pos = xy === 0 ? xPos : yPos;
          var p = 0;
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < numPoints)
            do {
              var n_1 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var flag = flags_0.qx(n_1);
              var b1 = !(((flag >>> (1 + xy | 0) | 0) & 1) === 0);
              var b2 = !(((flag >>> (4 + xy | 0) | 0) & 1) === 0);
              if (b1) {
                var magnitude = _this__u8e3s4.c1q();
                if (b2)
                  p = p + magnitude | 0;
                else
                  p = p - magnitude | 0;
              } else if (!b2) {
                p = p + _this__u8e3s4.d1q() | 0;
              }
              pos[n_1] = p;
            }
             while (inductionVariable_2 < numPoints);
        }
         while (inductionVariable_1 <= 1);
      tmp = new SimpleGlyph(this, index, xMin, yMin, xMax, yMax, contoursIndices, flags_0.g2k(), xPos, yPos, advanceWidth);
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BaseTtfFont.readGlyph.<anonymous>' call
    return tmp;
  }
}
class TtfFont extends BaseTtfFont {
  static r4u(d, extName, onlyReadMetadata, enableLigatures) {
    Companion_getInstance_30();
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    var $this = this.i57(d, extName, onlyReadMetadata, enableLigatures);
    $this.q4u_1 = LinkedHashMap.bc();
    $this.j57();
    return $this;
  }
  k57() {
    this.q4u_1.g3(Companion_instance_23.l57(this.z54_1.y1p()));
  }
  m57(name) {
    return this.q4u_1.c3(name);
  }
}
class Companion_15 {
  constructor() {
    this.s59_1 = 26;
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_22 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.arrayOfNulls' call
    var this_0 = fillArrayVal(Array(1), null);
    var elements = values_3();
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t59_1 = this_0.concat(elements);
  }
}
class NamesInfo {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.u59_1 = fillArrayVal(Array(26), null);
    this.v59_1 = new Int32Array(26);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = new Int32Array(26);
    while (tmp_1 < 26) {
      tmp_2[tmp_1] = -1;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.w59_1 = tmp_2;
    var tmp_3 = this;
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = fillArrayVal(Array(26), null);
    while (tmp_4 < 26) {
      tmp_5[tmp_4] = get_UTF8();
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.x59_1 = tmp_5;
    this.y59_1 = null;
  }
  t57() {
    var tmp0_elvis_lhs = this.z59(NameId_NAME_getInstance());
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.z59(NameId_COMPLETE_NAME_getInstance()) : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? 'TtfFont' : tmp1_elvis_lhs;
  }
  a5a(nameId) {
    if (this.u59_1[nameId] == null) {
      var nameLength = this.w59_1[nameId];
      if (nameLength < 0)
        return null;
      var string = ensureNotNull(this.y59_1).n1q(this.v59_1[nameId], nameLength, this.x59_1[nameId]);
      var tmp;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(string) === 0) {
        tmp = string;
      } else {
        if (charSequenceGet(string, 0) === _Char___init__impl__6a9atx(0)) {
          // Inline function 'kotlin.text.filter' call
          // Inline function 'kotlin.text.filterTo' call
          var destination = StringBuilder.f();
          var inductionVariable = 0;
          var last = charSequenceLength(string);
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var element = charSequenceGet(string, index);
              // Inline function 'korlibs.image.font.NamesInfo.getName.<anonymous>' call
              if (!(element === _Char___init__impl__6a9atx(0))) {
                destination.pb(element);
              }
            }
             while (inductionVariable < last);
          tmp = destination.toString();
        } else {
          tmp = string;
        }
      }
      this.u59_1[nameId] = tmp;
    }
    return this.u59_1[nameId];
  }
  z59(nameId) {
    return this.a5a(nameId.d5a_1);
  }
  e5a() {
    // Inline function 'kotlin.collections.associateWith' call
    var this_0 = values_2();
    var result = LinkedHashMap.cc(coerceAtLeast(mapCapacity(this_0.length), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.NamesInfo.toMap.<anonymous>' call
      var tmp$ret$0 = this.z59(element);
      result.e3(element, tmp$ret$0);
    }
    return result;
  }
  toString() {
    return 'NamesInfo(' + toString_0(this.e5a()) + ')';
  }
}
class SubstitutionInfo {
  constructor(maxSequence, map) {
    this.f5a_1 = maxSequence;
    this.g5a_1 = map;
  }
}
class Table {
  constructor(id, checksum, offset, length) {
    this.m59_1 = id;
    this.n59_1 = checksum;
    this.o59_1 = offset;
    this.p59_1 = length;
    this.q59_1 = null;
    var tmp = this;
    tmp.r59_1 = lazy(BaseTtfFont$Table$ss$delegate$lambda(this));
  }
  h5a() {
    return _get_ss__ndcawb(this).sx();
  }
  toString() {
    return 'Table(id=' + this.m59_1 + ', checksum=' + this.n59_1 + ', offset=' + this.o59_1 + ', length=' + this.p59_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.m59_1);
    result = imul(result, 31) + this.n59_1 | 0;
    result = imul(result, 31) + this.o59_1 | 0;
    result = imul(result, 31) + this.p59_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Table))
      return false;
    var tmp0_other_with_cast = other instanceof Table ? other : THROW_CCE();
    if (!(this.m59_1 === tmp0_other_with_cast.m59_1))
      return false;
    if (!(this.n59_1 === tmp0_other_with_cast.n59_1))
      return false;
    if (!(this.o59_1 === tmp0_other_with_cast.o59_1))
      return false;
    if (!(this.p59_1 === tmp0_other_with_cast.p59_1))
      return false;
    return true;
  }
}
class HorMetric {
  constructor(advanceWidth, lsb) {
    this.i5a_1 = advanceWidth;
    this.j5a_1 = lsb;
  }
  toString() {
    return 'HorMetric(advanceWidth=' + this.i5a_1 + ', lsb=' + this.j5a_1 + ')';
  }
  hashCode() {
    var result = this.i5a_1;
    result = imul(result, 31) + this.j5a_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HorMetric))
      return false;
    var tmp0_other_with_cast = other instanceof HorMetric ? other : THROW_CCE();
    if (!(this.i5a_1 === tmp0_other_with_cast.i5a_1))
      return false;
    if (!(this.j5a_1 === tmp0_other_with_cast.j5a_1))
      return false;
    return true;
  }
}
class Companion_17 {
  k5a(s, info) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var format = s.e1q();
    var count = s.e1q();
    var stringOffset = s.e1q();
    var inductionVariable = 0;
    if (inductionVariable < count)
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var platformId = s.e1q();
        var encodingId = s.e1q();
        var languageId = s.e1q();
        var nameId = s.e1q();
        var length = s.e1q();
        var offset = s.e1q();
        if (nameId < 0 || nameId >= 26)
          continue $l$loop;
        var charset;
        switch (encodingId) {
          case 0:
            charset = get_UTF8();
            break;
          case 1:
            charset = get_UTF16_BE();
            break;
          default:
            charset = get_UTF16_BE();
            break;
        }
        if (platformId === 0 && languageId === 0 || info.w59_1[nameId] === -1) {
          info.v59_1[nameId] = stringOffset + offset | 0;
          info.w59_1[nameId] = length;
          info.x59_1[nameId] = charset;
          info.y59_1 = s;
        }
      }
       while (inductionVariable < count);
    return Unit_instance;
  }
  l57(s) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    if (s.g1q() === 1953784678) {
      var majorVersion = s.e1q();
      var minorVersion = s.e1q();
      var numFonts = s.g1q();
      var tableDirectoryOffsets = s.m1q(numFonts);
      if (majorVersion >= 2) {
        var dsigTag = s.g1q();
        var dsigLength = s.g1q();
        var dsigOffset = s.g1q();
      }
      s.s1p(tableDirectoryOffsets[0]);
    } else {
      s.z1p(4);
    }
    // Inline function 'kotlin.apply' call
    var this_0 = s.e1q();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
    if (!(this_0 === 1) && !(this_0 === 20308)) {
      invalidOp('Not a TTF/OTF file');
    }
    var majorVersion_0 = this_0;
    // Inline function 'kotlin.apply' call
    var this_1 = s.e1q();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
    if (!(this_1 === 0) && !(this_1 === 21583)) {
      invalidOp('Not a TTF/OTF file');
    }
    var minorVersion_0 = this_1;
    var numTables = s.e1q();
    var searchRange = s.e1q();
    var entrySelector = s.e1q();
    var rangeShift = s.e1q();
    // Inline function 'kotlin.collections.map' call
    var this_2 = until(0, numTables);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_2, 10));
    var inductionVariable = this_2.a2_1;
    var last = this_2.b2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
        var tmp$ret$2 = new Table(s.p1q(4), s.g1q(), s.g1q(), s.g1q());
        destination.h(tmp$ret$2);
      }
       while (!(item === last));
    var tables = destination;
    var tablesByName = LinkedHashMap.bc();
    var _iterator__ex2g4s = tables.a1();
    while (_iterator__ex2g4s.b1()) {
      var table = _iterator__ex2g4s.c1();
      var tmp = table;
      tmp.q59_1 = BaseTtfFont$Companion$readHeaderTables$lambda(s, table);
      // Inline function 'kotlin.collections.set' call
      var key = table.m59_1;
      tablesByName.e3(key, table);
    }
    return tablesByName;
  }
}
class NameId extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.d5a_1 = id;
  }
}
class ColorBitmapInfo {
  constructor(indexSubTableArrayOffset, indexTablesSize, numberofIndexSubTables, colorRef, hori, vert, startGlyphIndex, endGlyphIndex, ppemX, ppemY, bitDepth, flags) {
    indexSubTableArrayOffset = indexSubTableArrayOffset === VOID ? 0 : indexSubTableArrayOffset;
    indexTablesSize = indexTablesSize === VOID ? 0 : indexTablesSize;
    numberofIndexSubTables = numberofIndexSubTables === VOID ? 0 : numberofIndexSubTables;
    colorRef = colorRef === VOID ? 0 : colorRef;
    hori = hori === VOID ? new SbitLineMetrics() : hori;
    vert = vert === VOID ? new SbitLineMetrics() : vert;
    startGlyphIndex = startGlyphIndex === VOID ? 0 : startGlyphIndex;
    endGlyphIndex = endGlyphIndex === VOID ? 0 : endGlyphIndex;
    ppemX = ppemX === VOID ? 0 : ppemX;
    ppemY = ppemY === VOID ? 0 : ppemY;
    bitDepth = bitDepth === VOID ? 0 : bitDepth;
    flags = flags === VOID ? 0 : flags;
    this.l5a_1 = indexSubTableArrayOffset;
    this.m5a_1 = indexTablesSize;
    this.n5a_1 = numberofIndexSubTables;
    this.o5a_1 = colorRef;
    this.p5a_1 = hori;
    this.q5a_1 = vert;
    this.r5a_1 = startGlyphIndex;
    this.s5a_1 = endGlyphIndex;
    this.t5a_1 = ppemX;
    this.u5a_1 = ppemY;
    this.v5a_1 = bitDepth;
    this.w5a_1 = flags;
  }
  toString() {
    return 'ColorBitmapInfo(indexSubTableArrayOffset=' + this.l5a_1 + ', indexTablesSize=' + this.m5a_1 + ', numberofIndexSubTables=' + this.n5a_1 + ', colorRef=' + this.o5a_1 + ', hori=' + this.p5a_1.toString() + ', vert=' + this.q5a_1.toString() + ', startGlyphIndex=' + this.r5a_1 + ', endGlyphIndex=' + this.s5a_1 + ', ppemX=' + this.t5a_1 + ', ppemY=' + this.u5a_1 + ', bitDepth=' + this.v5a_1 + ', flags=' + this.w5a_1 + ')';
  }
  hashCode() {
    var result = this.l5a_1;
    result = imul(result, 31) + this.m5a_1 | 0;
    result = imul(result, 31) + this.n5a_1 | 0;
    result = imul(result, 31) + this.o5a_1 | 0;
    result = imul(result, 31) + this.p5a_1.hashCode() | 0;
    result = imul(result, 31) + this.q5a_1.hashCode() | 0;
    result = imul(result, 31) + this.r5a_1 | 0;
    result = imul(result, 31) + this.s5a_1 | 0;
    result = imul(result, 31) + this.t5a_1 | 0;
    result = imul(result, 31) + this.u5a_1 | 0;
    result = imul(result, 31) + this.v5a_1 | 0;
    result = imul(result, 31) + this.w5a_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorBitmapInfo))
      return false;
    var tmp0_other_with_cast = other instanceof ColorBitmapInfo ? other : THROW_CCE();
    if (!(this.l5a_1 === tmp0_other_with_cast.l5a_1))
      return false;
    if (!(this.m5a_1 === tmp0_other_with_cast.m5a_1))
      return false;
    if (!(this.n5a_1 === tmp0_other_with_cast.n5a_1))
      return false;
    if (!(this.o5a_1 === tmp0_other_with_cast.o5a_1))
      return false;
    if (!this.p5a_1.equals(tmp0_other_with_cast.p5a_1))
      return false;
    if (!this.q5a_1.equals(tmp0_other_with_cast.q5a_1))
      return false;
    if (!(this.r5a_1 === tmp0_other_with_cast.r5a_1))
      return false;
    if (!(this.s5a_1 === tmp0_other_with_cast.s5a_1))
      return false;
    if (!(this.t5a_1 === tmp0_other_with_cast.t5a_1))
      return false;
    if (!(this.u5a_1 === tmp0_other_with_cast.u5a_1))
      return false;
    if (!(this.v5a_1 === tmp0_other_with_cast.v5a_1))
      return false;
    if (!(this.w5a_1 === tmp0_other_with_cast.w5a_1))
      return false;
    return true;
  }
}
class SbitLineMetrics {
  constructor(ascender, descender, widthMax, caretSlopeNumerator, caretSlopeDenominator, caretOffset, minOriginSB, minAdvanceSB, maxBeforeBL, minAfterBL, pad1, pad2) {
    ascender = ascender === VOID ? 0 : ascender;
    descender = descender === VOID ? 0 : descender;
    widthMax = widthMax === VOID ? 0 : widthMax;
    caretSlopeNumerator = caretSlopeNumerator === VOID ? 0 : caretSlopeNumerator;
    caretSlopeDenominator = caretSlopeDenominator === VOID ? 0 : caretSlopeDenominator;
    caretOffset = caretOffset === VOID ? 0 : caretOffset;
    minOriginSB = minOriginSB === VOID ? 0 : minOriginSB;
    minAdvanceSB = minAdvanceSB === VOID ? 0 : minAdvanceSB;
    maxBeforeBL = maxBeforeBL === VOID ? 0 : maxBeforeBL;
    minAfterBL = minAfterBL === VOID ? 0 : minAfterBL;
    pad1 = pad1 === VOID ? 0 : pad1;
    pad2 = pad2 === VOID ? 0 : pad2;
    this.x5a_1 = ascender;
    this.y5a_1 = descender;
    this.z5a_1 = widthMax;
    this.a5b_1 = caretSlopeNumerator;
    this.b5b_1 = caretSlopeDenominator;
    this.c5b_1 = caretOffset;
    this.d5b_1 = minOriginSB;
    this.e5b_1 = minAdvanceSB;
    this.f5b_1 = maxBeforeBL;
    this.g5b_1 = minAfterBL;
    this.h5b_1 = pad1;
    this.i5b_1 = pad2;
  }
  toString() {
    return 'SbitLineMetrics(ascender=' + this.x5a_1 + ', descender=' + this.y5a_1 + ', widthMax=' + this.z5a_1 + ', caretSlopeNumerator=' + this.a5b_1 + ', caretSlopeDenominator=' + this.b5b_1 + ', caretOffset=' + this.c5b_1 + ', minOriginSB=' + this.d5b_1 + ', minAdvanceSB=' + this.e5b_1 + ', maxBeforeBL=' + this.f5b_1 + ', minAfterBL=' + this.g5b_1 + ', pad1=' + this.h5b_1 + ', pad2=' + this.i5b_1 + ')';
  }
  hashCode() {
    var result = this.x5a_1;
    result = imul(result, 31) + this.y5a_1 | 0;
    result = imul(result, 31) + this.z5a_1 | 0;
    result = imul(result, 31) + this.a5b_1 | 0;
    result = imul(result, 31) + this.b5b_1 | 0;
    result = imul(result, 31) + this.c5b_1 | 0;
    result = imul(result, 31) + this.d5b_1 | 0;
    result = imul(result, 31) + this.e5b_1 | 0;
    result = imul(result, 31) + this.f5b_1 | 0;
    result = imul(result, 31) + this.g5b_1 | 0;
    result = imul(result, 31) + this.h5b_1 | 0;
    result = imul(result, 31) + this.i5b_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SbitLineMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof SbitLineMetrics ? other : THROW_CCE();
    if (!(this.x5a_1 === tmp0_other_with_cast.x5a_1))
      return false;
    if (!(this.y5a_1 === tmp0_other_with_cast.y5a_1))
      return false;
    if (!(this.z5a_1 === tmp0_other_with_cast.z5a_1))
      return false;
    if (!(this.a5b_1 === tmp0_other_with_cast.a5b_1))
      return false;
    if (!(this.b5b_1 === tmp0_other_with_cast.b5b_1))
      return false;
    if (!(this.c5b_1 === tmp0_other_with_cast.c5b_1))
      return false;
    if (!(this.d5b_1 === tmp0_other_with_cast.d5b_1))
      return false;
    if (!(this.e5b_1 === tmp0_other_with_cast.e5b_1))
      return false;
    if (!(this.f5b_1 === tmp0_other_with_cast.f5b_1))
      return false;
    if (!(this.g5b_1 === tmp0_other_with_cast.g5b_1))
      return false;
    if (!(this.h5b_1 === tmp0_other_with_cast.h5b_1))
      return false;
    if (!(this.i5b_1 === tmp0_other_with_cast.i5b_1))
      return false;
    return true;
  }
}
class BitmapGlyphInfo {
  constructor(glyphID, imageFormat, offset, size, info, height, width, horiBearingX, horiBearingY, horiAdvance, vertBearingX, vertBearingY, vertAdvance) {
    imageFormat = imageFormat === VOID ? 0 : imageFormat;
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? 0 : size;
    height = height === VOID ? 0 : height;
    width = width === VOID ? 0 : width;
    horiBearingX = horiBearingX === VOID ? 0 : horiBearingX;
    horiBearingY = horiBearingY === VOID ? 0 : horiBearingY;
    horiAdvance = horiAdvance === VOID ? 0 : horiAdvance;
    vertBearingX = vertBearingX === VOID ? 0 : vertBearingX;
    vertBearingY = vertBearingY === VOID ? 0 : vertBearingY;
    vertAdvance = vertAdvance === VOID ? 0 : vertAdvance;
    this.j5b_1 = glyphID;
    this.k5b_1 = imageFormat;
    this.l5b_1 = offset;
    this.m5b_1 = size;
    this.n5b_1 = info;
    this.o5b_1 = height;
    this.p5b_1 = width;
    this.q5b_1 = horiBearingX;
    this.r5b_1 = horiBearingY;
    this.s5b_1 = horiAdvance;
    this.t5b_1 = vertBearingX;
    this.u5b_1 = vertBearingY;
    this.v5b_1 = vertAdvance;
    this.w5b_1 = null;
    this.x5b_1 = null;
  }
  y5b() {
    return this.n5b_1.p5a_1.y5a_1;
  }
  z5b(cache) {
    var tmp0_elvis_lhs = this.x5b_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0;
      try {
        tmp_0 = PNG_getInstance().d5c(toSyncStream(ensureNotNull(this.w5b_1)));
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          println('Error in TtfFont.BitmapGlyphInfo: ' + e.message);
          // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
          var tmp$ret$0 = get_Bitmaps_transparent();
          tmp_1 = get_bmp(tmp$ret$0);
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var bmp = tmp;
    if (cache)
      this.x5b_1 = bmp;
    return bmp;
  }
  e5c(cache, $super) {
    cache = cache === VOID ? false : cache;
    return $super === VOID ? this.z5b(cache) : $super.z5b.call(this, cache);
  }
  toString() {
    return 'BitmapGlyphInfo(glyphID=' + this.j5b_1 + ', imageFormat=' + this.k5b_1 + ', offset=' + this.l5b_1 + ', size=' + this.m5b_1 + ', info=' + this.n5b_1.toString() + ', height=' + this.o5b_1 + ', width=' + this.p5b_1 + ', horiBearingX=' + this.q5b_1 + ', horiBearingY=' + this.r5b_1 + ', horiAdvance=' + this.s5b_1 + ', vertBearingX=' + this.t5b_1 + ', vertBearingY=' + this.u5b_1 + ', vertAdvance=' + this.v5b_1 + ')';
  }
  hashCode() {
    var result = this.j5b_1;
    result = imul(result, 31) + this.k5b_1 | 0;
    result = imul(result, 31) + this.l5b_1 | 0;
    result = imul(result, 31) + this.m5b_1 | 0;
    result = imul(result, 31) + this.n5b_1.hashCode() | 0;
    result = imul(result, 31) + this.o5b_1 | 0;
    result = imul(result, 31) + this.p5b_1 | 0;
    result = imul(result, 31) + this.q5b_1 | 0;
    result = imul(result, 31) + this.r5b_1 | 0;
    result = imul(result, 31) + this.s5b_1 | 0;
    result = imul(result, 31) + this.t5b_1 | 0;
    result = imul(result, 31) + this.u5b_1 | 0;
    result = imul(result, 31) + this.v5b_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapGlyphInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapGlyphInfo ? other : THROW_CCE();
    if (!(this.j5b_1 === tmp0_other_with_cast.j5b_1))
      return false;
    if (!(this.k5b_1 === tmp0_other_with_cast.k5b_1))
      return false;
    if (!(this.l5b_1 === tmp0_other_with_cast.l5b_1))
      return false;
    if (!(this.m5b_1 === tmp0_other_with_cast.m5b_1))
      return false;
    if (!this.n5b_1.equals(tmp0_other_with_cast.n5b_1))
      return false;
    if (!(this.o5b_1 === tmp0_other_with_cast.o5b_1))
      return false;
    if (!(this.p5b_1 === tmp0_other_with_cast.p5b_1))
      return false;
    if (!(this.q5b_1 === tmp0_other_with_cast.q5b_1))
      return false;
    if (!(this.r5b_1 === tmp0_other_with_cast.r5b_1))
      return false;
    if (!(this.s5b_1 === tmp0_other_with_cast.s5b_1))
      return false;
    if (!(this.t5b_1 === tmp0_other_with_cast.t5b_1))
      return false;
    if (!(this.u5b_1 === tmp0_other_with_cast.u5b_1))
      return false;
    if (!(this.v5b_1 === tmp0_other_with_cast.v5b_1))
      return false;
    return true;
  }
}
class ColorLine {
  constructor(cycle, stops) {
    this.f5c_1 = cycle;
    this.g5c_1 = stops;
  }
  h5c(paint, palette) {
    var _iterator__ex2g4s = this.g5c_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var stop = _iterator__ex2g4s.c1();
      paint.j5d(stop.i5c_1, RGBA__concatAd_impl_gwhfm(RgbaArray__get_impl_nzyo1o(palette.p4c_1, stop.j5c_1), stop.k5c_1));
    }
  }
  toString() {
    return 'ColorLine(cycle=' + this.f5c_1.toString() + ', stops=' + toString_0(this.g5c_1) + ')';
  }
  hashCode() {
    var result = this.f5c_1.hashCode();
    result = imul(result, 31) + hashCode(this.g5c_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorLine))
      return false;
    var tmp0_other_with_cast = other instanceof ColorLine ? other : THROW_CCE();
    if (!this.f5c_1.equals(tmp0_other_with_cast.f5c_1))
      return false;
    if (!equals(this.g5c_1, tmp0_other_with_cast.g5c_1))
      return false;
    return true;
  }
}
class ColorStop {
  constructor(stopOffset, paletteIndex, alpha) {
    this.i5c_1 = stopOffset;
    this.j5c_1 = paletteIndex;
    this.k5c_1 = alpha;
  }
}
class Colrv1Paint extends Enum {
  constructor(name, ordinal) {
    super(name, ordinal);
    this.m5d_1 = this.n3_1 + 1 | 0;
  }
}
class COLRv1 {
  constructor(layerList, s, sBaseOffset, sLayerOffset, sClipOffset) {
    var tmp;
    if (layerList === VOID) {
      // Inline function 'kotlin.intArrayOf' call
      tmp = new Int32Array([]);
    } else {
      tmp = layerList;
    }
    layerList = tmp;
    var tmp_0;
    if (s === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0 = new Int8Array([]);
      tmp_0 = new FastByteArrayInputStream(tmp$ret$0);
    } else {
      tmp_0 = s;
    }
    s = tmp_0;
    var tmp_1;
    if (sBaseOffset === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0_0 = new Int8Array([]);
      tmp_1 = new FastByteArrayInputStream(tmp$ret$0_0);
    } else {
      tmp_1 = sBaseOffset;
    }
    sBaseOffset = tmp_1;
    var tmp_2;
    if (sLayerOffset === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0_1 = new Int8Array([]);
      tmp_2 = new FastByteArrayInputStream(tmp$ret$0_1);
    } else {
      tmp_2 = sLayerOffset;
    }
    sLayerOffset = tmp_2;
    sClipOffset = sClipOffset === VOID ? null : sClipOffset;
    this.n5d_1 = layerList;
    this.o5d_1 = s;
    this.p5d_1 = sBaseOffset;
    this.q5d_1 = sLayerOffset;
    this.r5d_1 = sClipOffset;
    this.s5d_1 = IntIntMap.a2p();
  }
}
class Contour {
  constructor(x, y, onCurve) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    onCurve = onCurve === VOID ? false : onCurve;
    this.t5d_1 = x;
    this.u5d_1 = y;
    this.v5d_1 = onCurve;
  }
  toString() {
    return 'Contour(x=' + this.t5d_1 + ', y=' + this.u5d_1 + ', onCurve=' + this.v5d_1 + ')';
  }
  hashCode() {
    var result = this.t5d_1;
    result = imul(result, 31) + this.u5d_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.v5d_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Contour))
      return false;
    var tmp0_other_with_cast = other instanceof Contour ? other : THROW_CCE();
    if (!(this.t5d_1 === tmp0_other_with_cast.t5d_1))
      return false;
    if (!(this.u5d_1 === tmp0_other_with_cast.u5d_1))
      return false;
    if (!(this.v5d_1 === tmp0_other_with_cast.v5d_1))
      return false;
    return true;
  }
}
class GlyphReference {
  constructor(glyph, x, y, scaleX, scale01, scale10, scaleY) {
    this.w5d_1 = glyph;
    this.x5d_1 = x;
    this.y5d_1 = y;
    this.z5d_1 = scaleX;
    this.a5e_1 = scale01;
    this.b5e_1 = scale10;
    this.c5e_1 = scaleY;
  }
  toString() {
    return 'GlyphReference(glyph=' + toString_0(this.w5d_1) + ', x=' + this.x5d_1 + ', y=' + this.y5d_1 + ', scaleX=' + this.z5d_1 + ', scale01=' + this.a5e_1 + ', scale10=' + this.b5e_1 + ', scaleY=' + this.c5e_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.w5d_1);
    result = imul(result, 31) + this.x5d_1 | 0;
    result = imul(result, 31) + this.y5d_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.z5d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.a5e_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.b5e_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c5e_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphReference))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphReference ? other : THROW_CCE();
    if (!equals(this.w5d_1, tmp0_other_with_cast.w5d_1))
      return false;
    if (!(this.x5d_1 === tmp0_other_with_cast.x5d_1))
      return false;
    if (!(this.y5d_1 === tmp0_other_with_cast.y5d_1))
      return false;
    if (!equals(this.z5d_1, tmp0_other_with_cast.z5d_1))
      return false;
    if (!equals(this.a5e_1, tmp0_other_with_cast.a5e_1))
      return false;
    if (!equals(this.b5e_1, tmp0_other_with_cast.b5e_1))
      return false;
    if (!equals(this.c5e_1, tmp0_other_with_cast.c5e_1))
      return false;
    return true;
  }
}
class ColrLayerInfo {
  constructor($outer, glyphID, paletteIndex) {
    this.f5e_1 = $outer;
    this.d5e_1 = glyphID;
    this.e5e_1 = paletteIndex;
  }
  g5e(pal) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = new RgbaArray(getCyclic(this.f5e_1.z56_1, pal).p4c_1);
    var index = this.e5e_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= index ? index < this_0.e1() : false) {
      tmp = this_0.d1(index);
    } else {
      // Inline function 'korlibs.image.font.ColrLayerInfo.color.<anonymous>' call
      tmp = new RGBA(Colors_getInstance().u40_1);
    }
    return tmp.m4e_1;
  }
  h5e() {
    return this.g5e(0);
  }
  i5e(pal) {
    var tmp135_safe_receiver = this.f5e_1.h59(this.d5e_1);
    var tmp136_safe_receiver = tmp135_safe_receiver == null ? null : tmp135_safe_receiver.o21();
    var tmp;
    if (tmp136_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.ColrLayerInfo.getShape.<anonymous>' call
      tmp = new FillShape(tmp136_safe_receiver.s5e_1, null, new RGBA(this.g5e(pal)));
    }
    return tmp;
  }
  toString() {
    return 'ColrLayerInfo(' + this.d5e_1 + ', ' + this.e5e_1 + ', ' + RGBA__toString_impl_4lw6dp(this.h5e()) + ')';
  }
}
class ColrGlyphInfo {}
function getColorShape$default(pal, $super) {
  pal = pal === VOID ? 0 : pal;
  return $super === VOID ? this.t5e(pal) : $super.t5e.call(this, pal);
}
class ColrGlyphInfoV1 {
  constructor($outer, glyphID, paint) {
    this.x5e_1 = $outer;
    this.v5e_1 = glyphID;
    this.w5e_1 = paint;
  }
  t5e(pal) {
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.image.vector.buildShape' call
    // Inline function 'kotlin.apply' call
    var this_0 = new ShapeBuilder(null, null);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.ColrGlyphInfoV1.getColorShape.<anonymous>' call
    var paintS = this.x5e_1.a57_1.p5d_1.x1p(this.w5e_1);
    try {
      this.x5e_1.u58(this.v5e_1, paintS, this_0, pal, 0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.ColrGlyphInfoV1.getColorShape.<anonymous>' call
    return this_0.i4v();
  }
  toString() {
    return 'ColrGlyphInfoV1[' + this.v5e_1 + '][' + this.w5e_1 + ']';
  }
}
class ColrGlyphInfoV0 {
  constructor($outer, glyphID, firstLayerIndex, numLayers) {
    this.b5f_1 = $outer;
    this.y5e_1 = glyphID;
    this.z5e_1 = firstLayerIndex;
    this.a5f_1 = numLayers;
  }
  d1(index) {
    return this.b5f_1.x56_1[this.z5e_1 + index | 0];
  }
  u53() {
    var tmp = 0;
    var tmp_0 = this.a5f_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = this.d1(tmp_2);
      tmp = tmp + 1 | 0;
    }
    return toList_1(tmp_1);
  }
  t5e(pal) {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = this.u53();
    var destination = ArrayList.h1();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.image.font.ColrGlyphInfoV0.getColorShape.<anonymous>' call
      var tmp0_safe_receiver = element.i5e(pal);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.h(tmp0_safe_receiver);
      }
    }
    return new CompoundShape(destination);
  }
  toString() {
    return 'ColrGlyphInfoV0[' + this.y5e_1 + '][' + this.a5f_1 + '](' + toString_0(this.u53()) + ')';
  }
}
class GlyphGraphicsPath {
  constructor(glpyhIndex, path) {
    this.r5e_1 = glpyhIndex;
    this.s5e_1 = path;
  }
  u3d(p) {
    this.s5e_1.u3d(p);
  }
  h3e(p) {
    this.s5e_1.h3e(p);
  }
  i3e(c, a) {
    this.s5e_1.i3e(c, a);
  }
  v3d(c1, c2, a) {
    this.s5e_1.v3d(c1, c2, a);
  }
  c6() {
    this.s5e_1.c6();
  }
  x3o(p0, p1) {
    this.s5e_1.x3o(p0, p1);
  }
  y3o(rect) {
    this.s5e_1.y3o(rect);
  }
  z3o(pos, size) {
    this.s5e_1.z3o(pos, size);
  }
  a3p(x, y, width, height) {
    this.s5e_1.a3p(x, y, width, height);
  }
  b3p(center, r, start, end, counterclockwise) {
    this.s5e_1.b3p(center, r, start, end, counterclockwise);
  }
  d3p(center, radius) {
    this.s5e_1.d3p(center, radius);
  }
  e3p(delta) {
    this.s5e_1.e3p(delta);
  }
  f3p(delta) {
    this.s5e_1.f3p(delta);
  }
  x2e(m) {
    return this.s5e_1.x2e(m);
  }
  v3o() {
    return this.s5e_1.v3o();
  }
  w3o() {
    return this.s5e_1.d3e_1;
  }
  toString() {
    return 'GlyphGraphicsPath(glpyhIndex=' + this.r5e_1 + ', "' + toSvgPathString(this.s5e_1) + '")';
  }
  hashCode() {
    var result = this.r5e_1;
    result = imul(result, 31) + this.s5e_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphGraphicsPath))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphGraphicsPath ? other : THROW_CCE();
    if (!(this.r5e_1 === tmp0_other_with_cast.r5e_1))
      return false;
    if (!this.s5e_1.equals(tmp0_other_with_cast.s5e_1))
      return false;
    return true;
  }
}
class Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box) {
    boxApply(this, $box);
    this.q5e_1 = $outer;
    this.j5e_1 = index;
    this.k5e_1 = xMin;
    this.l5e_1 = yMin;
    this.m5e_1 = xMax;
    this.n5e_1 = yMax;
    this.o5e_1 = advanceWidth;
    var tmp = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Glyph.metrics1px.<anonymous>' call
    var xMin_0 = this.k5e_1;
    var yMin_0 = this.l5e_1;
    var xMax_0 = this.m5e_1;
    var yMax_0 = this.n5e_1;
    if (xMin_0 === 0 && yMin_0 === 0 && xMax_0 === 0 && yMax_0 === 0) {
      var sClipOffset = this.q5e_1.a57_1.r5d_1;
      var glyphIDToClipOffset = this.q5e_1.a57_1.s5d_1;
      var tmp_0;
      if (!(sClipOffset == null) && glyphIDToClipOffset.cp(this.j5e_1)) {
        var clipOffset = glyphIDToClipOffset.d1(this.j5e_1);
        tmp_0 = this.q5e_1.s58(sClipOffset.x1p(clipOffset));
      } else {
        var tmp137_safe_receiver = this.c5f();
        var tmp138_safe_receiver = tmp137_safe_receiver == null ? null : tmp137_safe_receiver.u5e();
        tmp_0 = tmp138_safe_receiver == null ? null : tmp138_safe_receiver.d5f();
      }
      var bounds = tmp_0;
      if (!(bounds == null)) {
        xMin_0 = numberToInt(bounds.v25());
        xMax_0 = numberToInt(bounds.w25());
        yMin_0 = numberToInt(bounds.x25());
        yMax_0 = numberToInt(bounds.y25());
      }
    }
    var size = this.q5e_1.i56_1;
    var scale = this.q5e_1.j4q(size);
    tmp.p5e_1 = new GlyphMetrics(size, true, -1, Companion_getInstance_4().x2d(xMin_0 * scale, yMin_0 * scale, xMax_0 * scale, yMax_0 * scale), this.o5e_1 * scale);
  }
  c5f() {
    return this.q5e_1.y56_1.d1(this.j5e_1);
  }
  e5f() {
    return this.q5e_1.w56_1.c3(this.j5e_1);
  }
}
class CompositeGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, refs, advanceWidth, $box) {
    if ($box === VOID)
      $box = {};
    $box.q5f_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.n5f_1 = refs;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.n5f_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.font.CompositeGlyph.paths.<anonymous>' call
      var gpath = item.w5d_1.o21().s5e_1;
      // Inline function 'kotlin.also' call
      var this_1 = new GlyphGraphicsPath(item.w5d_1.j5e_1, new VectorPath(IntArrayList.n2j(gpath.x3d_1.e1()), DoubleArrayList.j2k(gpath.y3d_1.e1())));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.CompositeGlyph.paths.<anonymous>.<anonymous>' call
      var m = Companion_getInstance_5().a29().w29(item.z5d_1, item.c5e_1).c2a(item.x5d_1, -item.y5d_1 | 0);
      this_1.s5e_1.u3p(item.w5d_1.o21().s5e_1, m);
      destination.h(this_1);
    }
    tmp.o5f_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>' call
    var commandsSize = 0;
    var dataSize = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_2 = this.o5f_1;
    var n = 0;
    while (n < this_2.e1()) {
      // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var gpath_0 = this_2.d1(_unary__edvuaz);
      commandsSize = commandsSize + gpath_0.s5e_1.x3d_1.e1() | 0;
      dataSize = dataSize + gpath_0.s5e_1.y3d_1.e1() | 0;
    }
    // Inline function 'kotlin.also' call
    var this_3 = new GlyphGraphicsPath(index, new VectorPath(IntArrayList.n2j(commandsSize), DoubleArrayList.j2k(dataSize)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_4 = this.o5f_1;
    var n_0 = 0;
    while (n_0 < this_4.e1()) {
      // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var it = this_4.d1(_unary__edvuaz_0);
      this_3.s5e_1.v3p(it.s5e_1);
    }
    tmp_0.p5f_1 = this_3;
  }
  toString() {
    return 'CompositeGlyph[' + this.o5e_1 + '](' + toString_0(this.n5f_1) + ')';
  }
  o21() {
    return this.p5f_1;
  }
}
class CFFGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, advanceWidth, path, $box) {
    if ($box === VOID)
      $box = {};
    $box.b5g_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.z5f_1 = path;
    this.a5g_1 = listOf_0(this.z5f_1);
  }
  o21() {
    return this.z5f_1;
  }
}
class SimpleGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, contoursIndices, flags, xPos, yPos, advanceWidth, dummy, $box) {
    if ($box === VOID)
      $box = {};
    dummy = dummy === VOID ? false : dummy;
    $box.r5g_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.k5g_1 = contoursIndices;
    this.l5g_1 = flags;
    this.m5g_1 = xPos;
    this.n5g_1 = yPos;
    this.o5g_1 = dummy;
    var tmp = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>' call
    var commandSize = 0;
    var dataSize = 0;
    // Inline function 'korlibs.image.font.SimpleGlyph.forEachContour' call
    this.r5g_1;
    var inductionVariable = 0;
    var last = this.k5g_1.length - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var cstart = this.k5g_1[n] + 1 | 0;
        var cend = this.k5g_1[n + 1 | 0];
        var csize = (cend - cstart | 0) + 1 | 0;
        // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>' call
        commandSize = commandSize + (1 + imul(csize, 2) | 0) | 0;
        dataSize = dataSize + (2 + imul(csize, 8) | 0) | 0;
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.also' call
    var this_0 = new GlyphGraphicsPath(index, new VectorPath(IntArrayList.n2j(commandSize), DoubleArrayList.j2k(dataSize)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.image.font.SimpleGlyph.forEachContour' call
    var this_1 = this.r5g_1;
    var inductionVariable_0 = 0;
    var last_0 = this.k5g_1.length - 1 | 0;
    if (inductionVariable_0 < last_0)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var cstart_0 = this.k5g_1[n_0] + 1 | 0;
        var cend_0 = this.k5g_1[n_0 + 1 | 0];
        var csize_0 = (cend_0 - cstart_0 | 0) + 1 | 0;
        // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>.<anonymous>' call
        var curr = this.s5g(cend_0, this_1.e55_1[0]);
        var next = this.s5g(cstart_0, this_1.e55_1[1]);
        if (curr.v5d_1) {
          this_0.u3d(Vector2D.a28(curr.t5d_1, -curr.u5d_1 | 0));
        } else if (next.v5d_1) {
          this_0.u3d(Vector2D.a28(next.t5d_1, -next.u5d_1 | 0));
        } else {
          this_0.u3d(Vector2D.a28(imul(curr.t5d_1 + next.t5d_1 | 0, numberToInt(0.5)), -numberToInt((curr.u5d_1 + next.u5d_1 | 0) * 0.5) | 0));
        }
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < csize_0)
          do {
            var cpos = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var prev = curr;
            curr = next;
            next = this.s5g(cstart_0 + ((cpos + 1 | 0) % csize_0 | 0) | 0, this_1.e55_1[(cpos + 2 | 0) % 3 | 0]);
            if (curr.v5d_1) {
              this_0.h3e(Vector2D.a28(curr.t5d_1, -curr.u5d_1 | 0));
            } else {
              var prev2X = prev.t5d_1;
              var prev2Y = prev.u5d_1;
              var next2X = next.t5d_1;
              var next2Y = next.u5d_1;
              if (!prev.v5d_1) {
                prev2X = numberToInt((curr.t5d_1 + prev.t5d_1 | 0) * 0.5);
                prev2Y = numberToInt((curr.u5d_1 + prev.u5d_1 | 0) * 0.5);
                this_0.h3e(Vector2D.a28(prev2X, -prev2Y | 0));
              }
              if (!next.v5d_1) {
                next2X = numberToInt((curr.t5d_1 + next.t5d_1 | 0) * 0.5);
                next2Y = numberToInt((curr.u5d_1 + next.u5d_1 | 0) * 0.5);
              }
              this_0.h3e(Vector2D.a28(prev2X, -prev2Y | 0));
              this_0.i3e(Vector2D.a28(curr.t5d_1, -curr.u5d_1 | 0), Vector2D.a28(next2X, -next2Y | 0));
            }
          }
           while (inductionVariable_1 < csize_0);
        this_0.c6();
      }
       while (inductionVariable_0 < last_0);
    tmp.p5g_1 = this_0;
    this.q5g_1 = listOf_0(this.p5g_1);
  }
  toString() {
    return 'SimpleGlyph' + (this.o5g_1 ? 'Dummy' : '') + '[' + this.j5e_1 + '](advance=' + this.o5e_1 + ') : ' + this.p5g_1.toString();
  }
  t5g(n) {
    return !((this.l5g_1[n] & 1) === 0);
  }
  s5g(n, out) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.contour.<anonymous>' call
    out.t5d_1 = this.m5g_1[n];
    out.u5d_1 = this.n5g_1[n];
    out.v5d_1 = this.t5g(n);
    return out;
  }
  o21() {
    return this.p5g_1;
  }
}
class BaseTtfFont$readCblc$Subtable {
  constructor(firstGlyphIndex, lastGlyphIndex, additionalOffsetToIndexSubtable) {
    this.u5g_1 = firstGlyphIndex;
    this.v5g_1 = lastGlyphIndex;
    this.w5g_1 = additionalOffsetToIndexSubtable;
  }
  x5g() {
    return this.v5g_1 - this.u5g_1 | 0;
  }
  toString() {
    return 'Subtable(firstGlyphIndex=' + this.u5g_1 + ', lastGlyphIndex=' + this.v5g_1 + ', additionalOffsetToIndexSubtable=' + this.w5g_1 + ')';
  }
  hashCode() {
    var result = this.u5g_1;
    result = imul(result, 31) + this.v5g_1 | 0;
    result = imul(result, 31) + this.w5g_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCblc$Subtable))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCblc$Subtable ? other : THROW_CCE();
    if (!(this.u5g_1 === tmp0_other_with_cast.u5g_1))
      return false;
    if (!(this.v5g_1 === tmp0_other_with_cast.v5g_1))
      return false;
    if (!(this.w5g_1 === tmp0_other_with_cast.w5g_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readSbix$StrikeInfo {
  constructor(ppem, ppi, strikeOffset, offsets) {
    this.y5g_1 = ppem;
    this.z5g_1 = ppi;
    this.a5h_1 = strikeOffset;
    this.b5h_1 = offsets;
  }
  toString() {
    return 'StrikeInfo(ppem=' + this.y5g_1 + ', ppi=' + this.z5g_1 + ', strikeOffset=' + this.a5h_1 + ', offsets=' + this.b5h_1.toString() + ')';
  }
  hashCode() {
    var result = this.y5g_1;
    result = imul(result, 31) + this.z5g_1 | 0;
    result = imul(result, 31) + this.a5h_1 | 0;
    result = imul(result, 31) + this.b5h_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readSbix$StrikeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readSbix$StrikeInfo ? other : THROW_CCE();
    if (!(this.y5g_1 === tmp0_other_with_cast.y5g_1))
      return false;
    if (!(this.z5g_1 === tmp0_other_with_cast.z5g_1))
      return false;
    if (!(this.a5h_1 === tmp0_other_with_cast.a5h_1))
      return false;
    if (!this.b5h_1.equals(tmp0_other_with_cast.b5h_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readCoverage$RangeInfo {
  constructor(start, endInclusive, index) {
    this.c5h_1 = start;
    this.d5h_1 = endInclusive;
    this.e5h_1 = index;
    this.f5h_1 = (this.d5h_1 - this.c5h_1 | 0) + 1 | 0;
  }
  toString() {
    return 'RangeInfo(start=' + this.c5h_1 + ', endInclusive=' + this.d5h_1 + ', index=' + this.e5h_1 + ')';
  }
  hashCode() {
    var result = this.c5h_1;
    result = imul(result, 31) + this.d5h_1 | 0;
    result = imul(result, 31) + this.e5h_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCoverage$RangeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCoverage$RangeInfo ? other : THROW_CCE();
    if (!(this.c5h_1 === tmp0_other_with_cast.c5h_1))
      return false;
    if (!(this.d5h_1 === tmp0_other_with_cast.d5h_1))
      return false;
    if (!(this.e5h_1 === tmp0_other_with_cast.e5h_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readCmap$EncodingRecord {
  constructor(platformId, encodingId, offset) {
    this.g5h_1 = platformId;
    this.h5h_1 = encodingId;
    this.i5h_1 = offset;
  }
  toString() {
    return 'EncodingRecord(platformId=' + this.g5h_1 + ', encodingId=' + this.h5h_1 + ', offset=' + this.i5h_1 + ')';
  }
  hashCode() {
    var result = this.g5h_1;
    result = imul(result, 31) + this.h5h_1 | 0;
    result = imul(result, 31) + this.i5h_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCmap$EncodingRecord))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCmap$EncodingRecord ? other : THROW_CCE();
    if (!(this.g5h_1 === tmp0_other_with_cast.g5h_1))
      return false;
    if (!(this.h5h_1 === tmp0_other_with_cast.h5h_1))
      return false;
    if (!(this.i5h_1 === tmp0_other_with_cast.i5h_1))
      return false;
    return true;
  }
}
class Companion_18 {
  k5h(num, den) {
    return insert16(insert16(0, num, 0), den, 16);
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_25 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_4();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.cc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = element.p5h_1;
      destination.e3(tmp$ret$0, element);
    }
    tmp.r5h_1 = destination;
  }
  d1(index) {
    var tmp0_elvis_lhs = this.r5h_1.c3(index);
    return tmp0_elvis_lhs == null ? DataFormat_UNKNOWN_getInstance() : tmp0_elvis_lhs;
  }
}
class DataFormat extends Enum {
  constructor(name, ordinal, id, indexBytes) {
    super(name, ordinal);
    this.p5h_1 = id;
    this.q5h_1 = indexBytes;
  }
}
class EXIF {
  constructor() {
    EXIF_instance = this;
    this.s5h_1 = Companion_getInstance_14().mw('EXIF');
  }
  t5h(ss, info, debug, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readExifBase__4npesx.bind(VOID, this, ss, info, debug), $completion);
  }
  u5h(ss, info, debug, $completion, $super) {
    info = info === VOID ? new ImageInfo() : info;
    debug = debug === VOID ? false : debug;
    return $super === VOID ? this.t5h(ss, info, debug, $completion) : $super.t5h.call(this, ss, info, debug, $completion);
  }
}
class Direction extends Enum {}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.v5h_1 = function_0;
  }
  ui(a, b) {
    return this.v5h_1(a, b);
  }
  compare(a, b) {
    return this.ui(a, b);
  }
  k4() {
    return this.v5h_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.k4(), other.k4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.k4());
  }
}
class ImageAnimation {
  constructor(frames, direction, name, layers) {
    var tmp;
    if (layers === VOID) {
      // Inline function 'kotlin.collections.sortedBy' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList.h1();
      var tmp0_iterator = frames.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
        var list = element.c5i_1;
        addAll(destination, list);
      }
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
      var tmp0_iterator_0 = destination.a1();
      while (tmp0_iterator_0.b1()) {
        var item = tmp0_iterator_0.c1();
        // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
        var tmp$ret$3 = item.e5i_1;
        destination_0.h(tmp$ret$3);
      }
      var this_0 = distinct(destination_0);
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_0 = ImageAnimation$_init_$lambda_bxp50i;
      var tmp$ret$6 = new sam$kotlin_Comparator$0(tmp_0);
      tmp = sortedWith(this_0, tmp$ret$6);
    } else {
      tmp = layers;
    }
    layers = tmp;
    this.o5i_1 = frames;
    this.p5i_1 = direction;
    this.q5i_1 = name;
    this.r5i_1 = layers;
    var tmp_1 = this;
    var tmp0_elvis_lhs = firstOrNull_0(this.o5i_1);
    tmp_1.s5i_1 = tmp0_elvis_lhs == null ? ImageFrame.t5i(0) : tmp0_elvis_lhs;
  }
}
class Companion_20 {
  u5i(bitmaps) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(bitmaps.length);
    var inductionVariable = 0;
    var last = bitmaps.length;
    while (inductionVariable < last) {
      var item = bitmaps[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.invoke.<anonymous>' call
      var tmp$ret$0 = Companion_instance_29.v5i(item);
      destination.h(tmp$ret$0);
    }
    return new ImageData(destination);
  }
}
class sam$kotlin_Comparator$0_0 {
  constructor(function_0) {
    this.w5i_1 = function_0;
  }
  ui(a, b) {
    return this.w5i_1(a, b);
  }
  compare(a, b) {
    return this.ui(a, b);
  }
  k4() {
    return this.w5i_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.k4(), other.k4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.k4());
  }
}
class ImageData {
  constructor(frames, loopCount, width, height, layers, animations, name) {
    loopCount = loopCount === VOID ? 0 : loopCount;
    var tmp;
    if (width === VOID) {
      var tmp171_safe_receiver = firstOrNull_0(frames);
      var tmp0_elvis_lhs = tmp171_safe_receiver == null ? null : tmp171_safe_receiver.m2i();
      tmp = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    } else {
      tmp = width;
    }
    width = tmp;
    var tmp_0;
    if (height === VOID) {
      var tmp172_safe_receiver = firstOrNull_0(frames);
      var tmp1_elvis_lhs = tmp172_safe_receiver == null ? null : tmp172_safe_receiver.n2i();
      tmp_0 = tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs;
    } else {
      tmp_0 = height;
    }
    height = tmp_0;
    layers = layers === VOID ? fastArrayListOf([]) : layers;
    animations = animations === VOID ? fastArrayListOf([]) : animations;
    name = name === VOID ? null : name;
    this.z5i_1 = new Mixin();
    this.a5j_1 = frames;
    this.b5j_1 = loopCount;
    this.c5j_1 = width;
    this.d5j_1 = height;
    this.e5j_1 = layers;
    this.f5j_1 = animations;
    this.g5j_1 = name;
    this.h5j_1 = new ImageAnimation(this.a5j_1, Direction_FORWARD_getInstance(), 'default');
    var tmp_1 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.f5j_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.cc(capacity);
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.format.ImageData.animationsByName.<anonymous>' call
      var tmp$ret$0 = element.q5i_1;
      destination.e3(tmp$ret$0, element);
    }
    tmp_1.i5j_1 = destination;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = this.a5j_1;
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.cc(capacity_0);
    var tmp0_iterator_0 = this_1.a1();
    while (tmp0_iterator_0.b1()) {
      var element_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.image.format.ImageData.framesByName.<anonymous>' call
      var tmp$ret$3 = element_0.o3();
      destination_0.e3(tmp$ret$3, element_0);
    }
    tmp_2.j5j_1 = destination_0;
    var tmp_3 = this;
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_2 = this.a5j_1;
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_4 = ImageData$framesSortedByPriority$lambda;
    var tmp$ret$6 = new sam$kotlin_Comparator$0_0(tmp_4);
    tmp_3.k5j_1 = sortedWith(this_2, tmp$ret$6);
  }
  vx(_set____db54di) {
    this.z5i_1.vx(_set____db54di);
  }
  wx() {
    return this.z5i_1.wx();
  }
  l5j() {
    var tmp173_safe_receiver = firstOrNull_0(this.k5j_1);
    var tmp0_elvis_lhs = tmp173_safe_receiver == null ? null : tmp173_safe_receiver.x5i();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException.l('No bitmap found');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  toString() {
    return 'ImageData(' + toString_0(this.a5j_1) + ')';
  }
}
class Companion_21 {
  m5j(bitmaps) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(bitmaps, 10));
    var tmp0_iterator = bitmaps.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.format.Companion.invoke.<anonymous>' call
      var tmp$ret$0 = Companion_instance_26.u5i([item]);
      destination.h(tmp$ret$0);
    }
    return new ImageDataContainer(destination);
  }
  u5i(bitmaps) {
    return Companion_instance_27.m5j(toList_1(bitmaps));
  }
}
class ImageDataContainer {
  constructor(imageDatas) {
    this.n5j_1 = imageDatas;
    var tmp = this;
    tmp.o5j_1 = lazy(ImageDataContainer$imageDatasByName$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.p5j_1 = lazy(ImageDataContainer$default$delegate$lambda(this));
  }
  q5j() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o5j_1;
    imageDatasByName$factory();
    return this_0.r1();
  }
  r5j() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p5j_1;
    default$factory();
    return this_0.r1();
  }
}
class Companion_22 {
  constructor() {
    Companion_instance_28 = this;
    this.d4s_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.e4s_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.f4s_1 = new ImageDecodingProps(VOID, VOID, VOID, false);
  }
}
class ImageDecodingProps {
  constructor(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    Companion_getInstance_38();
    filename = filename === VOID ? 'unknown' : filename;
    width = width === VOID ? null : width;
    height = height === VOID ? null : height;
    premultiplied = premultiplied === VOID ? null : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? false : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? null : requestedMaxSize;
    debug = debug === VOID ? false : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? false : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? true : tryNativeDecode;
    format = format === VOID ? get_RegisteredImageFormats() : format;
    out = out === VOID ? null : out;
    extra = extra === VOID ? null : extra;
    this.s5j_1 = filename;
    this.t5j_1 = width;
    this.u5j_1 = height;
    this.v5j_1 = premultiplied;
    this.w5j_1 = asumePremultiplied;
    this.x5j_1 = requestedMaxSize;
    this.y5j_1 = debug;
    this.z5j_1 = preferKotlinDecoder;
    this.a5k_1 = tryNativeDecode;
    this.b5k_1 = format;
    this.c5k_1 = out;
    this.d5k_1 = extra;
  }
  vx(_set____db54di) {
    this.d5k_1 = _set____db54di;
  }
  wx() {
    return this.d5k_1;
  }
  e5k() {
    return this;
  }
  f5k() {
    var tmp0_elvis_lhs = this.v5j_1;
    return tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs;
  }
  g5k(filename) {
    return this.h5k(filename);
  }
  i5k(file) {
    return this.g5k(get_baseName(file));
  }
  j5k(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    return new ImageDecodingProps(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  }
  h5k(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra, $super) {
    filename = filename === VOID ? this.s5j_1 : filename;
    width = width === VOID ? this.t5j_1 : width;
    height = height === VOID ? this.u5j_1 : height;
    premultiplied = premultiplied === VOID ? this.v5j_1 : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? this.w5j_1 : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? this.x5j_1 : requestedMaxSize;
    debug = debug === VOID ? this.y5j_1 : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? this.z5j_1 : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? this.a5k_1 : tryNativeDecode;
    format = format === VOID ? this.b5k_1 : format;
    out = out === VOID ? this.c5k_1 : out;
    extra = extra === VOID ? this.d5k_1 : extra;
    return $super === VOID ? this.j5k(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) : $super.j5k.call(this, filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  }
  toString() {
    return 'ImageDecodingProps(filename=' + this.s5j_1 + ', width=' + this.t5j_1 + ', height=' + this.u5j_1 + ', premultiplied=' + this.v5j_1 + ', asumePremultiplied=' + this.w5j_1 + ', requestedMaxSize=' + this.x5j_1 + ', debug=' + this.y5j_1 + ', preferKotlinDecoder=' + this.z5j_1 + ', tryNativeDecode=' + this.a5k_1 + ', format=' + toString(this.b5k_1) + ', out=' + toString(this.c5k_1) + ', extra=' + toString(this.d5k_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.s5j_1);
    result = imul(result, 31) + (this.t5j_1 == null ? 0 : this.t5j_1) | 0;
    result = imul(result, 31) + (this.u5j_1 == null ? 0 : this.u5j_1) | 0;
    result = imul(result, 31) + (this.v5j_1 == null ? 0 : getBooleanHashCode(this.v5j_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w5j_1) | 0;
    result = imul(result, 31) + (this.x5j_1 == null ? 0 : this.x5j_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y5j_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z5j_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a5k_1) | 0;
    result = imul(result, 31) + (this.b5k_1 == null ? 0 : hashCode(this.b5k_1)) | 0;
    result = imul(result, 31) + (this.c5k_1 == null ? 0 : hashCode(this.c5k_1)) | 0;
    result = imul(result, 31) + (this.d5k_1 == null ? 0 : hashCode(this.d5k_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ImageDecodingProps))
      return false;
    var tmp0_other_with_cast = other instanceof ImageDecodingProps ? other : THROW_CCE();
    if (!(this.s5j_1 === tmp0_other_with_cast.s5j_1))
      return false;
    if (!(this.t5j_1 == tmp0_other_with_cast.t5j_1))
      return false;
    if (!(this.u5j_1 == tmp0_other_with_cast.u5j_1))
      return false;
    if (!(this.v5j_1 == tmp0_other_with_cast.v5j_1))
      return false;
    if (!(this.w5j_1 === tmp0_other_with_cast.w5j_1))
      return false;
    if (!(this.x5j_1 == tmp0_other_with_cast.x5j_1))
      return false;
    if (!(this.y5j_1 === tmp0_other_with_cast.y5j_1))
      return false;
    if (!(this.z5j_1 === tmp0_other_with_cast.z5j_1))
      return false;
    if (!(this.a5k_1 === tmp0_other_with_cast.a5k_1))
      return false;
    if (!equals(this.b5k_1, tmp0_other_with_cast.b5k_1))
      return false;
    if (!equals(this.c5k_1, tmp0_other_with_cast.c5k_1))
      return false;
    if (!equals(this.d5k_1, tmp0_other_with_cast.d5k_1))
      return false;
    return true;
  }
}
class ImageFormat {
  static l5k(exts, mimeType) {
    mimeType = mimeType === VOID ? 'image/' + first_2(exts) : mimeType;
    var $this = createThis(this);
    $this.a5c_1 = mimeType;
    var tmp = $this;
    tmp.b5c_1 = lazy(ImageFormat$decodingProps$delegate$lambda($this));
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(exts.length);
    var inductionVariable = 0;
    var last = exts.length;
    while (inductionVariable < last) {
      var item = exts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.ImageFormat.extensions.<anonymous>' call
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var this_0 = item.toLowerCase();
      var tmp$ret$3 = toString_0(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      destination.h(tmp$ret$3);
    }
    tmp_0.c5c_1 = toSet(destination);
    return $this;
  }
  e5k() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b5c_1;
    decodingProps$factory();
    return this_0.r1();
  }
  n5k(s, props) {
    return this.m5k(s, props).r5j();
  }
  o5k(s, props) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      // Inline function 'korlibs.image.format.ImageFormat.decodeHeader.<anonymous>' call
      var bmp = this.k5k(s, props);
      // Inline function 'kotlin.apply' call
      var this_0 = new ImageInfo();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.format.ImageFormat.decodeHeader.<anonymous>.<anonymous>' call
      this_0.q5k_1 = bmp.l3x_1;
      this_0.r5k_1 = bmp.m3x_1;
      this_0.s5k_1 = bmp.n3x_1;
      tmp = this_0;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (true) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  k5k(s, props) {
    return this.n5k(s, props).l5j();
  }
  t5k(s, props) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      // Inline function 'korlibs.image.format.ImageFormat.check.<anonymous>' call
      tmp = !(this.o5k(s, props) == null);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (true) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  u5k(s, props) {
    return this.k5k(s, props);
  }
  d5c(s, props, $super) {
    props = props === VOID ? Companion_getInstance_38().d4s_1 : props;
    return $super === VOID ? this.u5k(s, props) : $super.u5k.call(this, s, props);
  }
  v5k(data, props) {
    return this.k5k(openSync(data), props);
  }
  w5k(data, props, $completion) {
    return this.v5k(data, props);
  }
  x5k(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq.bind(VOID, this, file, props), $completion);
  }
  toString() {
    return 'ImageFormat(' + toString_0(this.c5c_1) + ')';
  }
}
class ImageDecoderNotFoundException extends Exception {}
class ImageFormats extends ImageFormat {
  static c5l(formats) {
    var $this = this.l5k(['']);
    $this.b5l_1 = atomic$ref$1(minus(listFormats(formats), $this));
    return $this;
  }
  static d5l(formats) {
    return this.c5l(toList_1(formats));
  }
  e5l(_set____db54di) {
    var this_0 = this.b5l_1;
    _formats$factory();
    this_0.kotlinx$atomicfu$value = _set____db54di;
    return Unit_instance;
  }
  f5l() {
    // Inline function 'kotlinx.atomicfu.AtomicRef.getValue' call
    var this_0 = this.b5l_1;
    _formats$factory_0();
    return this_0.kotlinx$atomicfu$value;
  }
  g5l() {
    return this.f5l();
  }
  toString() {
    return 'ImageFormats(' + this.g5l().e1() + ')' + toString_0(this.g5l());
  }
  o5k(s, props) {
    if (this.g5l().g1())
      return null;
    var _iterator__ex2g4s = this.g5l().a1();
    $l$loop_0: while (_iterator__ex2g4s.b1()) {
      var format = _iterator__ex2g4s.c1();
      var tmp;
      try {
        var tmp0_elvis_lhs = format.o5k(sliceStart_0(s), props);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp = tmp_0;
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          if (e instanceof CancellationException)
            throw e;
          continue $l$loop_0;
        } else {
          throw $p;
        }
      }
      return tmp;
    }
    return null;
  }
  m5k(s, props) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.image.format.ImageFormats.readImageTyped' call
      var _iterator__ex2g4s = this.g5l().a1();
      while (_iterator__ex2g4s.b1()) {
        var format = _iterator__ex2g4s.c1();
        if (format.t5k(sliceStart_0(s), props)) {
          // Inline function 'korlibs.image.format.ImageFormats.readImageContainer.<anonymous>' call
          var s_0 = sliceStart_0(s);
          tmp$ret$1 = format.m5k(sliceStart_0(s_0), props);
          break $l$block;
        }
      }
      throw UnsupportedOperationException.aa('No suitable image format : MAGIC:' + readString_0(sliceStart_0(s), 4, ASCII_getInstance()) + '(' + get_hex_0(readBytes(sliceStart_0(s), 4)) + ') (' + toString_2(readBytes(sliceStart_0(s), 4), ASCII_getInstance()) + ')');
    }
    return tmp$ret$1;
  }
}
class ImageFormatsMutable extends ImageFormats {
  static m5l() {
    var $this = this.d5l([]);
    $this.l5l_1 = new NonRecursiveLock();
    return $this;
  }
  static n5l(formats) {
    var $this = this.m5l();
    $this.o5l(formats.slice());
    return $this;
  }
  o5l(formats) {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.l5l_1.y1u_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    this.e5l(minus(plus_0(this.f5l(), formats), this));
    return this;
  }
}
class Companion_23 {
  p5l(bitmap, time, targetX, targetY, main, includeInAtlas, name, index) {
    return ImageFrame.q5l(index, time, fastArrayListOf([new ImageFrameLayer(new ImageLayer(0, null, Type_NORMAL_getInstance()), slice(bitmap, VOID, name), targetX, targetY, main, includeInAtlas)]));
  }
  v5i(bitmap, time, targetX, targetY, main, includeInAtlas, name, index, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    name = name === VOID ? null : name;
    index = index === VOID ? 0 : index;
    return $super === VOID ? this.p5l(bitmap, time, targetX, targetY, main, includeInAtlas, name, index) : $super.p5l.call(this, bitmap, new Duration(time), targetX, targetY, main, includeInAtlas, name, index);
  }
}
class ImageFrame {
  static t5i(index, fastTime, layerData) {
    fastTime = fastTime === VOID ? get_fastSeconds(0) : fastTime;
    layerData = layerData === VOID ? emptyList() : layerData;
    var $this = createThis(this);
    $this.z5h_1 = new Mixin();
    $this.a5i_1 = index;
    $this.b5i_1 = fastTime;
    $this.c5i_1 = layerData;
    $this.d5i_1 = firstOrNull_0($this.c5i_1);
    return $this;
  }
  vx(_set____db54di) {
    this.z5h_1.vx(_set____db54di);
  }
  wx() {
    return this.z5h_1.wx();
  }
  r5l() {
    return toDuration_0(this.b5i_1);
  }
  static q5l(index, time, layerData) {
    layerData = layerData === VOID ? emptyList() : layerData;
    return this.t5i(index, get_fast(time), layerData);
  }
  s5l() {
    var tmp177_safe_receiver = this.d5i_1;
    var tmp0_elvis_lhs = tmp177_safe_receiver == null ? null : tmp177_safe_receiver.n5i_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      tmp = get_Bitmaps_transparent();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  t5l() {
    var tmp178_safe_receiver = this.d5i_1;
    var tmp0_elvis_lhs = tmp178_safe_receiver == null ? null : tmp178_safe_receiver.f5i_1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  u5l() {
    var tmp179_safe_receiver = this.d5i_1;
    var tmp0_elvis_lhs = tmp179_safe_receiver == null ? null : tmp179_safe_receiver.g5i_1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  y5i() {
    var tmp180_safe_receiver = this.d5i_1;
    var tmp0_elvis_lhs = tmp180_safe_receiver == null ? null : tmp180_safe_receiver.h5i_1;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  m2i() {
    return this.s5l().b3g_1;
  }
  n2i() {
    return this.s5l().c3g_1;
  }
  x5i() {
    var tmp182_safe_receiver = this.d5i_1;
    var tmp0_elvis_lhs = tmp182_safe_receiver == null ? null : tmp182_safe_receiver.x5i();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      tmp = get_bmp(tmp$ret$0);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  o3() {
    return this.s5l().w3f_1;
  }
  toString() {
    return 'ImageFrame(' + this.s5l().toString() + ', time=' + Duration__toString_impl_8d916b(this.r5l()) + ', targetX=' + this.t5l() + ', targetY=' + this.u5l() + ', main=' + this.y5i() + ')';
  }
}
class ImageFrameLayer {
  constructor(layer, slice, targetX, targetY, main, includeInAtlas, tilemap, ninePatchSlice) {
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    tilemap = tilemap === VOID ? null : tilemap;
    ninePatchSlice = ninePatchSlice === VOID ? null : ninePatchSlice;
    this.e5i_1 = layer;
    this.f5i_1 = targetX;
    this.g5i_1 = targetY;
    this.h5i_1 = main;
    this.i5i_1 = includeInAtlas;
    this.j5i_1 = tilemap;
    this.k5i_1 = ninePatchSlice;
    this.l5i_1 = null;
    this.m5i_1 = null;
    this.n5i_1 = slice;
  }
  m2i() {
    return this.n5i_1.b3g_1;
  }
  n2i() {
    return this.n5i_1.c3g_1;
  }
  x5i() {
    if (get_bmp(this.n5i_1).l3x_1 === this.m2i() && get_bmp(this.n5i_1).m3x_1 === this.n2i())
      return get_bmp(this.n5i_1);
    if (this.l5i_1 == null)
      this.l5i_1 = extract_0(this.n5i_1);
    return ensureNotNull(this.l5i_1);
  }
}
class ImageInfo {
  constructor() {
    this.p5k_1 = new Mixin();
    this.q5k_1 = 0;
    this.r5k_1 = 0;
    this.s5k_1 = 8;
  }
  vx(_set____db54di) {
    this.p5k_1.vx(_set____db54di);
  }
  wx() {
    return this.p5k_1.wx();
  }
  toString() {
    var tmp = this.q5k_1;
    var tmp_0 = this.r5k_1;
    var tmp_1 = this.s5k_1;
    var tmp183_safe_receiver = this.wx();
    return 'ImageInfo(width=' + tmp + ', height=' + tmp_0 + ', bpp=' + tmp_1 + ', extra=' + toString(tmp183_safe_receiver == null ? null : toMap_0(tmp183_safe_receiver)) + ')';
  }
}
class Companion_24 {
  constructor() {
    Companion_instance_30 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v5l_1 = [Type_NORMAL_getInstance(), Type_GROUP_getInstance(), Type_TILEMAP_getInstance()];
  }
}
class Type extends Enum {}
class ImageLayer {
  constructor(index, name, type) {
    type = type === VOID ? Type_NORMAL_getInstance() : type;
    this.w5h_1 = index;
    this.x5h_1 = name;
    this.y5h_1 = type;
  }
}
class NativeImageFormatProvider {
  y5l(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_0.bind(VOID, this, data, props), $completion);
  }
  s5m(_this__u8e3s4, props) {
    return this.u5m(_this__u8e3s4, props);
  }
  u5m(image, props) {
    return this.t5m(toBitmap_0(image.m3v()), props);
  }
  r5m(vfs, path, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_1.bind(VOID, this, vfs, path, props), $completion);
  }
  w5k(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeSuspend__fioeme.bind(VOID, this, data, props), $completion);
  }
  v5m(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq_0.bind(VOID, this, file, props), $completion);
  }
  x5k(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq_1.bind(VOID, this, file, props), $completion);
  }
  l4b(width, height, premultiplied) {
    return BitmapNativeImage.a5n(Bitmap32.e3x(width, height, VOID, premultiplied == null ? true : premultiplied));
  }
  k4b(bmp) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.l4b(bmp.l3x_1, bmp.m3x_1, bmp.r3x_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.NativeImageFormatProvider.copy.<anonymous>' call
    // Inline function 'korlibs.image.bitmap.context2d' call
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = this_0.p3x_1;
    if (true) {
      this_0.y3x();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = this_0.h45(true);
      try {
        // Inline function 'korlibs.image.format.NativeImageFormatProvider.copy.<anonymous>.<anonymous>' call
        ctx.b5n(bmp, Companion_getInstance_6().g25_1);
      }finally {
        ctx.d18();
      }
    }finally {
      result = true ? this_0.a3y(rect) : 0;
    }
    return this_0;
  }
  w5m(bmp) {
    return BitmapNativeImage.q5m(bmp);
  }
  t5m(_this__u8e3s4, props) {
    var tmp;
    var tmp_0;
    if (_this__u8e3s4 instanceof NativeImage) {
      tmp_0 = !props.w5j_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = props.v5j_1 == null || props.v5j_1 === _this__u8e3s4.r3x_1;
    } else {
      tmp = false;
    }
    if (tmp) {
      return _this__u8e3s4;
    }
    var out = _this__u8e3s4.i45();
    if (props.w5j_1) {
      asumePremultiplied(out);
    } else if (!_this__u8e3s4.r3x_1 && props.v5j_1 === false) {
      out.q48();
    } else if (_this__u8e3s4.r3x_1 && props.v5j_1 === true) {
      out.p48();
    }
    return this.w5m(out);
  }
  w5l(_this__u8e3s4, props) {
    return new NativeImageResult(this.t5m(_this__u8e3s4, props));
  }
}
class BaseNativeImageFormatProvider extends NativeImageFormatProvider {
  y5l(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt.bind(VOID, this, data, props), $completion);
  }
  z5l(bmp) {
    return BitmapNativeImage.q5m(bmp);
  }
  x5l(bmp, props) {
    var bmp32 = bmp.i45();
    return new NativeImageResult(this.z5l(props.w5j_1 ? asumePremultiplied(bmp32) : props.f5k() ? bmp32.m48() : bmp32.n48()));
  }
  l4b(width, height, premultiplied) {
    return this.z5l(Bitmap32.e3x(width, height, VOID, premultiplied == null ? true : premultiplied));
  }
  k4b(bmp) {
    return this.z5l(bmp);
  }
}
class NativeImageResult {
  constructor(image, originalWidth, originalHeight) {
    originalWidth = originalWidth === VOID ? image.l3x_1 : originalWidth;
    originalHeight = originalHeight === VOID ? image.m3x_1 : originalHeight;
    this.x5m_1 = image;
    this.y5m_1 = originalWidth;
    this.z5m_1 = originalHeight;
  }
  toString() {
    return 'NativeImageResult(image=' + this.x5m_1.toString() + ', originalWidth=' + this.y5m_1 + ', originalHeight=' + this.z5m_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.x5m_1);
    result = imul(result, 31) + this.y5m_1 | 0;
    result = imul(result, 31) + this.z5m_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NativeImageResult))
      return false;
    var tmp0_other_with_cast = other instanceof NativeImageResult ? other : THROW_CCE();
    if (!equals(this.x5m_1, tmp0_other_with_cast.x5m_1))
      return false;
    if (!(this.y5m_1 === tmp0_other_with_cast.y5m_1))
      return false;
    if (!(this.z5m_1 === tmp0_other_with_cast.z5m_1))
      return false;
    return true;
  }
}
class BitmapNativeImage extends NativeImage {
  static a5n(bitmap) {
    var $this = this.j4b(bitmap.l3x_1, bitmap.m3x_1, bitmap, bitmap.r3x_1);
    $this.o5m_1 = bitmap;
    $this.p5m_1 = $this.o5m_1.b3x_1;
    return $this;
  }
  o3() {
    return 'BitmapNativeImage';
  }
  static q5m(bitmap) {
    return this.a5n(bitmap.i45());
  }
  h45(antialiasing) {
    return this.o5m_1.h45(antialiasing);
  }
  x3x() {
    return this.o5m_1;
  }
  i3y(x, y, width, height, out, offset) {
    return this.o5m_1.i3y(x, y, width, height, out, offset);
  }
  k3y(x, y, width, height, out, offset) {
    return this.o5m_1.k3y(x, y, width, height, out, offset);
  }
  l3y(x, y, v) {
    return this.o5m_1.l3y(x, y, v);
  }
  j3y(x, y) {
    return this.o5m_1.j3y(x, y);
  }
}
class Companion_25 {
  constructor() {
    Companion_instance_31 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_5();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.cc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = element.e5n_1;
      destination.e3(tmp$ret$0, element);
    }
    tmp.g5n_1 = destination;
  }
}
class InterlacedPass {
  constructor(startingRow, startingCol, rowIncrement, colIncrement, blockHeight, blockWidth) {
    this.h5n_1 = startingRow;
    this.i5n_1 = startingCol;
    this.j5n_1 = rowIncrement;
    this.k5n_1 = colIncrement;
    this.l5n_1 = blockHeight;
    this.m5n_1 = blockWidth;
    var tmp = this;
    // Inline function 'kotlin.math.log2' call
    var x = this.k5n_1;
    var tmp$ret$0 = log2(x);
    tmp.n5n_1 = numberToInt(tmp$ret$0);
  }
  toString() {
    return 'InterlacedPass(startingRow=' + this.h5n_1 + ', startingCol=' + this.i5n_1 + ', rowIncrement=' + this.j5n_1 + ', colIncrement=' + this.k5n_1 + ', blockHeight=' + this.l5n_1 + ', blockWidth=' + this.m5n_1 + ')';
  }
  hashCode() {
    var result = this.h5n_1;
    result = imul(result, 31) + this.i5n_1 | 0;
    result = imul(result, 31) + this.j5n_1 | 0;
    result = imul(result, 31) + this.k5n_1 | 0;
    result = imul(result, 31) + this.l5n_1 | 0;
    result = imul(result, 31) + this.m5n_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InterlacedPass))
      return false;
    var tmp0_other_with_cast = other instanceof InterlacedPass ? other : THROW_CCE();
    if (!(this.h5n_1 === tmp0_other_with_cast.h5n_1))
      return false;
    if (!(this.i5n_1 === tmp0_other_with_cast.i5n_1))
      return false;
    if (!(this.j5n_1 === tmp0_other_with_cast.j5n_1))
      return false;
    if (!(this.k5n_1 === tmp0_other_with_cast.k5n_1))
      return false;
    if (!(this.l5n_1 === tmp0_other_with_cast.l5n_1))
      return false;
    if (!(this.m5n_1 === tmp0_other_with_cast.m5n_1))
      return false;
    return true;
  }
}
class Colorspace extends Enum {
  constructor(name, ordinal, id, nchannels) {
    super(name, ordinal);
    this.e5n_1 = id;
    this.f5n_1 = nchannels;
  }
}
class Header {
  constructor(width, height, bitsPerChannel, colorspace, compressionmethod, filtermethod, interlacemethod) {
    this.o5n_1 = width;
    this.p5n_1 = height;
    this.q5n_1 = bitsPerChannel;
    this.r5n_1 = colorspace;
    this.s5n_1 = compressionmethod;
    this.t5n_1 = filtermethod;
    this.u5n_1 = interlacemethod;
    var tmp = this;
    var tmp_0;
    switch (this.r5n_1.n3_1) {
      case 0:
        tmp_0 = 1;
        break;
      case 2:
        tmp_0 = 1;
        break;
      case 3:
        tmp_0 = 2;
        break;
      case 1:
        tmp_0 = 3;
        break;
      case 4:
        tmp_0 = 4;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.v5n_1 = tmp_0;
    this.w5n_1 = imul(imul(this.o5n_1, this.v5n_1), this.q5n_1) / 8 | 0;
  }
}
class DecodingContext {
  constructor(header) {
    this.x5n_1 = header;
    this.y5n_1 = _UByteArrayInt___init__impl__xif7bu_0(this.x5n_1.w5n_1);
    this.z5n_1 = _UByteArrayInt___init__impl__xif7bu_0(this.x5n_1.w5n_1);
    this.a5o_1 = Companion_instance_11.t48(this.x5n_1.o5n_1);
  }
  k5o() {
    var temp = this.z5n_1;
    this.z5n_1 = this.y5n_1;
    this.y5n_1 = temp;
  }
}
class PNG$readCommon$readChunk$slambda {
  constructor($data, $info) {
    this.l5o_1 = $data;
    this.m5o_1 = $info;
  }
  pd($completion) {
    return EXIF_getInstance().u5h(openAsync(readAll_0(this.l5o_1)), this.m5o_1, VOID, $completion);
  }
}
class PNG extends ImageFormat {
  static n5o() {
    PNG_instance = null;
    var $this = this.l5k(['png']);
    PNG_instance = $this;
    $this.e5o_1 = -1991225785;
    $this.f5o_1 = 218765834;
    $this.g5o_1 = listOf([new InterlacedPass(0, 0, 8, 8, 8, 8), new InterlacedPass(0, 4, 8, 8, 8, 4), new InterlacedPass(4, 0, 8, 4, 4, 4), new InterlacedPass(0, 2, 4, 4, 4, 2), new InterlacedPass(2, 0, 4, 2, 2, 2), new InterlacedPass(0, 1, 2, 2, 2, 1), new InterlacedPass(1, 0, 2, 1, 1, 1)]);
    $this.h5o_1 = listOf_0(new InterlacedPass(0, 0, 1, 1, 1, 1));
    return $this;
  }
  o5k(s, props) {
    var tmp;
    try {
      var info = new ImageInfo();
      var tmp_0 = readCommon(this, s, true, info);
      var header = tmp_0 instanceof Header ? tmp_0 : THROW_CCE();
      tmp = info;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var t = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  m5k(s, props) {
    var tmp = Companion_instance_27;
    var tmp_0 = readCommon$default(this, s, false);
    return tmp.u5i([tmp_0 instanceof Bitmap ? tmp_0 : THROW_CCE()]);
  }
  o5o(a, b, c) {
    var p = (a + b | 0) - c | 0;
    var pa = abs(p - a | 0);
    var pb = abs(p - b | 0);
    var pc = abs(p - c | 0);
    return pa <= pb && pa <= pc ? a : pb <= pc ? b : c;
  }
  i5o(filter, p, c, bpp, size) {
    switch (filter) {
      case 0:
        break;
      case 1:
        var inductionVariable = bpp;
        if (inductionVariable < size)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n, UByteArrayInt__get_impl_px6q8a(c, n) + UByteArrayInt__get_impl_px6q8a(c, n - bpp | 0) | 0);
          }
           while (inductionVariable < size);
        break;
      case 2:
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < size)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_0, UByteArrayInt__get_impl_px6q8a(c, n_0) + UByteArrayInt__get_impl_px6q8a(p, n_0) | 0);
          }
           while (inductionVariable_0 < size);
        break;
      case 3:
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < bpp)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_1, UByteArrayInt__get_impl_px6q8a(c, n_1) + (UByteArrayInt__get_impl_px6q8a(p, n_1) / 2 | 0) | 0);
          }
           while (inductionVariable_1 < bpp);
        var inductionVariable_2 = bpp;
        if (inductionVariable_2 < size)
          do {
            var n_2 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_2, UByteArrayInt__get_impl_px6q8a(c, n_2) + ((UByteArrayInt__get_impl_px6q8a(c, n_2 - bpp | 0) + UByteArrayInt__get_impl_px6q8a(p, n_2) | 0) / 2 | 0) | 0);
          }
           while (inductionVariable_2 < size);
        break;
      case 4:
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < bpp)
          do {
            var n_3 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_3, UByteArrayInt__get_impl_px6q8a(c, n_3) + UByteArrayInt__get_impl_px6q8a(p, n_3) | 0);
          }
           while (inductionVariable_3 < bpp);
        var inductionVariable_4 = bpp;
        if (inductionVariable_4 < size)
          do {
            var n_4 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_4, UByteArrayInt__get_impl_px6q8a(c, n_4) + this.o5o(UByteArrayInt__get_impl_px6q8a(c, n_4 - bpp | 0), UByteArrayInt__get_impl_px6q8a(p, n_4), UByteArrayInt__get_impl_px6q8a(p, n_4 - bpp | 0)) | 0);
          }
           while (inductionVariable_4 < size);
        break;
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'Filter: ' + filter;
        throw NotImplementedError.od('An operation is not implemented: ' + reason);
    }
  }
  j5o(filter, p, c, bpp, size, $super) {
    size = size === VOID ? _UByteArrayInt___get_size__impl__bcjnte(c) : size;
    var tmp;
    if ($super === VOID) {
      this.i5o(filter, p, c, bpp, size);
      tmp = Unit_instance;
    } else {
      tmp = $super.i5o.call(this, filter, new UByteArrayInt(p), new UByteArrayInt(c), bpp, size);
    }
    return tmp;
  }
}
class BaseFiller {
  s5o(data, offset, x0, x1, y) {
    var yFloat = y;
    var inductionVariable = x0;
    if (inductionVariable <= x1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaPremultipliedArray__set_impl_7fwbby(data, offset + n | 0, this.r5o(n, yFloat));
      }
       while (!(n === x1));
  }
  t5o(bmp, rect) {
    var cols = _RgbaPremultipliedArray___init__impl__lx83hy(bmp.b3x_1);
    var inductionVariable = rect.x25();
    var last = rect.y25();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var offset = imul(y, bmp.l3x_1);
        this.s5o(cols, offset, rect.v25(), rect.w25() - 1 | 0, y);
      }
       while (inductionVariable < last);
  }
  u5o(bmp, rect, $super) {
    rect = rect === VOID ? bmp.d3x_1 : rect;
    var tmp;
    if ($super === VOID) {
      this.t5o(bmp, rect);
      tmp = Unit_instance;
    } else {
      tmp = $super.t5o.call(this, bmp, rect);
    }
    return tmp;
  }
}
class ColorFiller extends BaseFiller {
  constructor() {
    super();
    this.p5o_1 = _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().u3y_1);
  }
  q5o(fill, state) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.ColorFiller.set.<anonymous>' call
    this.p5o_1 = _RGBA___get_premultiplied__impl__3bulqc(_RGBA___get_color__impl__8x3sb3(fill));
    return this;
  }
  r5o(x, y) {
    return this.p5o_1;
  }
  s5o(data, offset, x0, x1, y) {
    RgbaPremultipliedArray__fill_impl_sem38t(data, this.p5o_1, offset + x0 | 0, (offset + x1 | 0) + 1 | 0);
  }
}
class Companion_26 {
  constructor() {
    this.v5o_1 = 256;
  }
}
class GradientFiller extends BaseFiller {
  constructor() {
    super();
    this.w5o_1 = Companion_instance_14.o4o(256);
  }
  y5o(fill, state) {
    fill.z5o(this.w5o_1);
    this.x5o_1 = fill.a5p(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_5().x28_1.p2a(fill.v5c_1).p2a(state.n4q_1));
    return this;
  }
  b5p(x, y) {
    return _get_fill__d6ivc8(this).c5p(Vector2D.g2a(x, y));
  }
  r5o(x, y) {
    return color(this, this.b5p(x, y));
  }
}
class BitmapFiller extends BaseFiller {
  constructor() {
    super();
    this.d5p_1 = _CycleMethodPair___init__impl__y6jlco_0(CycleMethod_NO_CYCLE_getInstance(), CycleMethod_NO_CYCLE_getInstance());
    this.e5p_1 = 0.0;
    this.f5p_1 = 0.0;
    this.g5p_1 = 0.0;
    this.h5p_1 = 0.0;
    var tmp = this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    tmp.i5p_1 = get_bmp(tmp$ret$0);
    this.j5p_1 = Companion_getInstance_5().x28_1;
    this.k5p_1 = true;
    this.l5p_1 = Companion_getInstance_5().x28_1;
  }
  m5p(fill, state) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.BitmapFiller.set.<anonymous>' call
    this.d5p_1 = _CycleMethodPair___init__impl__y6jlco_0(fill.p5p_1, fill.q5p_1);
    _set_texture__qu271y(this, fill.t5p_1);
    this.j5p_1 = fill.o5p_1;
    this.k5p_1 = fill.r5p_1;
    this.l5p_1 = Companion_getInstance_5().x28_1.i2a(state.n4q_1).i2a(fill.o5p_1).j2a();
    return this;
  }
  u5p(x, y) {
    return this.i5p_1.r3y(x, y);
  }
  v5p(x, y) {
    return this.i5p_1.b47(numberToInt(x), numberToInt(y));
  }
  r5o(x, y) {
    var mat = this.l5p_1;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p = Vector2D.g2a(x, y);
      if (mat.t25()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.n27(mat.p29(p.e25_1, p.f25_1), mat.s29(p.e25_1, p.f25_1));
    }
    var this_0 = tmp$ret$0;
    var that = Vector2D.g2a(this.g5p_1, this.h5p_1);
    var p_0 = Vector2D.n27(this_0.e25_1 * that.e25_1, this_0.f25_1 * that.f25_1);
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_1 = CycleMethodPair__apply_impl_g3sekg(this.d5p_1, p_0);
    var that_0 = Vector2D.g2a(this.e5p_1, this.f5p_1);
    var t = Vector2D.n27(this_1.e25_1 * that_0.e25_1, this_1.f25_1 * that_0.f25_1);
    return this.k5p_1 ? _RGBA___get_premultiplied__impl__3bulqc(this.u5p(t.e25_1, t.f25_1)) : _RGBA___get_premultiplied__impl__3bulqc(this.v5p(t.e25_1, t.f25_1));
  }
}
class NoneFiller extends BaseFiller {
  constructor() {
    NoneFiller_instance = null;
    super();
    NoneFiller_instance = this;
  }
  r5o(x, y) {
    return _RGBAPremultiplied___init__impl__uos02x(0);
  }
  s5o(data, offset, x0, x1, y) {
    return Unit_instance;
  }
}
class Companion_27 {}
class TransformedPaint {}
class GradientPaint {
  constructor(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) {
    stops = stops === VOID ? DoubleArrayList.j2k() : stops;
    colors = colors === VOID ? IntArrayList.n2j() : colors;
    cycle = cycle === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycle;
    transform = transform === VOID ? Companion_getInstance_5().x28_1 : transform;
    interpolationMethod = interpolationMethod === VOID ? GradientInterpolationMethod_NORMAL_getInstance() : interpolationMethod;
    units = units === VOID ? GradientUnits_OBJECT_BOUNDING_BOX_getInstance() : units;
    startAngle = startAngle === VOID ? Companion_getInstance_8().v24_1 : startAngle;
    this.l5c_1 = kind;
    this.m5c_1 = x0;
    this.n5c_1 = y0;
    this.o5c_1 = r0;
    this.p5c_1 = x1;
    this.q5c_1 = y1;
    this.r5c_1 = r1;
    this.s5c_1 = stops;
    this.t5c_1 = colors;
    this.u5c_1 = cycle;
    this.v5c_1 = transform;
    this.w5c_1 = interpolationMethod;
    this.x5c_1 = units;
    this.y5c_1 = startAngle;
    var tmp = this;
    var tmp_0 = Companion_getInstance_5().x28_1.d2a(-this.m5c_1, -this.n5c_1).y29(1.0 / clamp_1(Companion_getInstance_6().a2f(this.m5c_1, this.n5c_1, this.p5c_1, this.q5c_1), 1.0, 16000.0));
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_8();
    var x0_0 = this.m5c_1;
    var y0_0 = this.n5c_1;
    var x1_0 = this.p5c_1;
    var y1_0 = this.q5c_1;
    var up = Companion_getInstance_6().k25_1;
    var tmp$ret$0 = Angle_between(x0_0, y0_0, x1_0, y1_0, up);
    tmp.z5c_1 = tmp_0.v29(Angle__unaryMinus_impl_7901fr(tmp$ret$0));
    this.a5d_1 = this.v5c_1.j2a();
    this.b5d_1 = Companion_getInstance_5().x28_1.i2a(this.z5c_1).i2a(this.a5d_1);
    this.c5d_1 = 2 * this.o5c_1 * this.r5c_1;
    this.d5d_1 = this.w5p(this.o5c_1);
    this.e5d_1 = this.w5p(this.r5c_1);
    this.f5d_1 = this.n5c_1 - this.q5c_1;
    this.g5d_1 = this.o5c_1 - this.r5c_1;
    this.h5d_1 = this.m5c_1 - this.p5c_1;
    this.i5d_1 = 1.0 / (this.w5p(this.o5c_1 - this.r5c_1) - this.w5p(this.m5c_1 - this.p5c_1) - this.w5p(this.n5c_1 - this.q5c_1));
  }
  r50() {
    return this.v5c_1;
  }
  z5o(out) {
    return _fillColors(Companion_instance_33, _RgbaPremultipliedArray___get_ints__impl__i1gpd7(out), this.s5c_1, this.t5c_1, true);
  }
  j5d(stop, color) {
    return this.x5p(stop, color);
  }
  x5p(stop, color) {
    this.s5c_1.r2k(stop);
    this.t5c_1.w2j(_RGBA___get_value__impl__hhco8v(color));
    return this;
  }
  c5p(p) {
    var tmp;
    switch (this.l5c_1.n3_1) {
      case 2:
        var tmp$ret$0;
        $l$block: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          var this_0 = this.a5d_1;
          if (this_0.t25()) {
            tmp$ret$0 = p;
            break $l$block;
          }
          tmp$ret$0 = Vector2D.n27(this_0.p29(p.e25_1, p.f25_1), this_0.s29(p.e25_1, p.f25_1));
        }

        var p_0 = tmp$ret$0;
        tmp = Angle__div_impl_ut2btd(Companion_getInstance_6().n2g(Vector2D.n27(this.m5c_1, this.n5c_1), p_0), get_degrees(360));
        break;
      case 1:
        var tmp$ret$1;
        $l$block_0: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          var this_1 = this.a5d_1;
          if (this_1.t25()) {
            tmp$ret$1 = p;
            break $l$block_0;
          }
          tmp$ret$1 = Vector2D.n27(this_1.p29(p.e25_1, p.f25_1), this_1.s29(p.e25_1, p.f25_1));
        }

        var _destruct__k2r9zo = tmp$ret$1;
        var x = _destruct__k2r9zo.fl();
        var y = _destruct__k2r9zo.gl();
        var tmp_0 = -this.r5c_1 * this.g5d_1 + this.h5d_1 * (this.p5c_1 - x) + this.f5d_1 * (this.q5c_1 - y);
        // Inline function 'kotlin.math.sqrt' call

        var x_0 = this.e5d_1 * (this.w5p(this.m5c_1 - x) + this.w5p(this.n5c_1 - y)) - this.c5d_1 * ((this.m5c_1 - x) * (this.p5c_1 - x) + (this.n5c_1 - y) * (this.q5c_1 - y)) + this.d5d_1 * (this.w5p(this.p5c_1 - x) + this.w5p(this.q5c_1 - y)) - this.w5p(this.p5c_1 * this.n5c_1 - x * this.n5c_1 - this.m5c_1 * this.q5c_1 + x * this.q5c_1 + this.m5c_1 * y - this.p5c_1 * y);
        tmp = 1.0 - (tmp_0 - Math.sqrt(x_0)) * this.i5d_1;
        break;
      default:
        tmp = this.b5d_1.o29(p);
        break;
    }
    return this.u5c_1.a5q(tmp);
  }
  w5p(_this__u8e3s4) {
    return _this__u8e3s4 * _this__u8e3s4;
  }
  sx() {
    return this.a5p(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.v5c_1);
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.GradientPaint.toString.<anonymous>' call
    var tmp;
    switch (this.l5c_1.n3_1) {
      case 0:
        tmp = 'LinearGradient([' + this.m5c_1 + ', ' + this.n5c_1 + '], [' + this.p5c_1 + ', ' + this.q5c_1 + ']';
        break;
      case 1:
        tmp = 'RadialGradient([' + this.m5c_1 + ', ' + this.n5c_1 + ', ' + this.o5c_1 + '], [' + this.p5c_1 + ', ' + this.q5c_1 + ', ' + this.r5c_1 + ']';
        break;
      case 2:
        tmp = 'ConicGradient([' + this.m5c_1 + ', ' + this.n5c_1 + ']';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    this_0.ob(tmp);
    this_0.ob(', stops=' + this.s5c_1.toString() + ', colors=' + colorsToString_0(this, this.t5c_1) + ', cycle=' + this.u5c_1.toString() + ', transform=' + this.v5c_1.toString() + ', interpolationMethod=' + this.w5c_1.toString() + ', units=' + this.x5c_1.toString() + ')');
    return this_0.toString();
  }
  b5q(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) {
    return new GradientPaint(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle);
  }
  a5p(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle, $super) {
    kind = kind === VOID ? this.l5c_1 : kind;
    x0 = x0 === VOID ? this.m5c_1 : x0;
    y0 = y0 === VOID ? this.n5c_1 : y0;
    r0 = r0 === VOID ? this.o5c_1 : r0;
    x1 = x1 === VOID ? this.p5c_1 : x1;
    y1 = y1 === VOID ? this.q5c_1 : y1;
    r1 = r1 === VOID ? this.r5c_1 : r1;
    stops = stops === VOID ? this.s5c_1 : stops;
    colors = colors === VOID ? this.t5c_1 : colors;
    cycle = cycle === VOID ? this.u5c_1 : cycle;
    transform = transform === VOID ? this.v5c_1 : transform;
    interpolationMethod = interpolationMethod === VOID ? this.w5c_1 : interpolationMethod;
    units = units === VOID ? this.x5c_1 : units;
    startAngle = startAngle === VOID ? this.y5c_1 : startAngle;
    return $super === VOID ? this.b5q(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) : $super.b5q.call(this, kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, new Angle(startAngle));
  }
  hashCode() {
    var result = this.l5c_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.m5c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n5c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o5c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p5c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q5c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r5c_1) | 0;
    result = imul(result, 31) + this.s5c_1.hashCode() | 0;
    result = imul(result, 31) + this.t5c_1.hashCode() | 0;
    result = imul(result, 31) + this.u5c_1.hashCode() | 0;
    result = imul(result, 31) + this.v5c_1.hashCode() | 0;
    result = imul(result, 31) + this.w5c_1.hashCode() | 0;
    result = imul(result, 31) + this.x5c_1.hashCode() | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.y5c_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GradientPaint))
      return false;
    var tmp0_other_with_cast = other instanceof GradientPaint ? other : THROW_CCE();
    if (!this.l5c_1.equals(tmp0_other_with_cast.l5c_1))
      return false;
    if (!equals(this.m5c_1, tmp0_other_with_cast.m5c_1))
      return false;
    if (!equals(this.n5c_1, tmp0_other_with_cast.n5c_1))
      return false;
    if (!equals(this.o5c_1, tmp0_other_with_cast.o5c_1))
      return false;
    if (!equals(this.p5c_1, tmp0_other_with_cast.p5c_1))
      return false;
    if (!equals(this.q5c_1, tmp0_other_with_cast.q5c_1))
      return false;
    if (!equals(this.r5c_1, tmp0_other_with_cast.r5c_1))
      return false;
    if (!this.s5c_1.equals(tmp0_other_with_cast.s5c_1))
      return false;
    if (!this.t5c_1.equals(tmp0_other_with_cast.t5c_1))
      return false;
    if (!this.u5c_1.equals(tmp0_other_with_cast.u5c_1))
      return false;
    if (!this.v5c_1.equals(tmp0_other_with_cast.v5c_1))
      return false;
    if (!this.w5c_1.equals(tmp0_other_with_cast.w5c_1))
      return false;
    if (!this.x5c_1.equals(tmp0_other_with_cast.x5c_1))
      return false;
    if (!equals(this.y5c_1, tmp0_other_with_cast.y5c_1))
      return false;
    return true;
  }
}
class GradientKind extends Enum {}
class GradientInterpolationMethod extends Enum {}
class GradientUnits extends Enum {}
class NonePaint {
  sx() {
    return this;
  }
}
class BitmapPaint {
  constructor(bitmap, transform, cycleX, cycleY, smooth, units) {
    transform = transform === VOID ? Companion_getInstance_5().x28_1 : transform;
    cycleX = cycleX === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycleX;
    cycleY = cycleY === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycleY;
    smooth = smooth === VOID ? true : smooth;
    units = units === VOID ? GradientUnits_OBJECT_BOUNDING_BOX_getInstance() : units;
    this.n5p_1 = bitmap;
    this.o5p_1 = transform;
    this.p5p_1 = cycleX;
    this.q5p_1 = cycleY;
    this.r5p_1 = smooth;
    this.s5p_1 = units;
    this.t5p_1 = this.n5p_1.x3x();
  }
  r50() {
    return this.o5p_1;
  }
  c5q() {
    return this.p5p_1.d5q();
  }
  e5q() {
    return this.q5p_1.d5q();
  }
  sx() {
    return this.f5q(VOID, this.o5p_1);
  }
  toString() {
    return 'BitmapPaint(' + toString_0(this.n5p_1) + ', cycle=(' + this.p5p_1.toString() + ', ' + this.q5p_1.toString() + '), smooth=' + this.r5p_1 + ', transform=' + this.o5p_1.toString() + ')';
  }
  g5q(bitmap, transform, cycleX, cycleY, smooth, units) {
    return new BitmapPaint(bitmap, transform, cycleX, cycleY, smooth, units);
  }
  f5q(bitmap, transform, cycleX, cycleY, smooth, units, $super) {
    bitmap = bitmap === VOID ? this.n5p_1 : bitmap;
    transform = transform === VOID ? this.o5p_1 : transform;
    cycleX = cycleX === VOID ? this.p5p_1 : cycleX;
    cycleY = cycleY === VOID ? this.q5p_1 : cycleY;
    smooth = smooth === VOID ? this.r5p_1 : smooth;
    units = units === VOID ? this.s5p_1 : units;
    return $super === VOID ? this.g5q(bitmap, transform, cycleX, cycleY, smooth, units) : $super.g5q.call(this, bitmap, transform, cycleX, cycleY, smooth, units);
  }
  hashCode() {
    var result = hashCode(this.n5p_1);
    result = imul(result, 31) + this.o5p_1.hashCode() | 0;
    result = imul(result, 31) + this.p5p_1.hashCode() | 0;
    result = imul(result, 31) + this.q5p_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r5p_1) | 0;
    result = imul(result, 31) + this.s5p_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapPaint))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapPaint ? other : THROW_CCE();
    if (!equals(this.n5p_1, tmp0_other_with_cast.n5p_1))
      return false;
    if (!this.o5p_1.equals(tmp0_other_with_cast.o5p_1))
      return false;
    if (!this.p5p_1.equals(tmp0_other_with_cast.p5p_1))
      return false;
    if (!this.q5p_1.equals(tmp0_other_with_cast.q5p_1))
      return false;
    if (!(this.r5p_1 === tmp0_other_with_cast.r5p_1))
      return false;
    if (!this.s5p_1.equals(tmp0_other_with_cast.s5p_1))
      return false;
    return true;
  }
}
class Companion_28 {
  constructor() {
    Companion_instance_34 = this;
    var tmp = this;
    var tmp263_font = get_DefaultTtfFont();
    tmp.v5q_1 = new Style(tmp263_font, 16.0);
  }
}
class Line {
  static f5r(nodes, defaultLineStyle) {
    defaultLineStyle = defaultLineStyle === VOID ? null : defaultLineStyle;
    var $this = createThis(this);
    $this.h5q_1 = new Mixin();
    $this.i5q_1 = nodes;
    $this.j5q_1 = defaultLineStyle;
    var tmp = $this;
    tmp.k5q_1 = lazy(RichTextData$Line$defaultStyle$delegate$lambda($this));
    var tmp_0 = $this;
    tmp_0.l5q_1 = lazy(RichTextData$Line$defaultLastStyle$delegate$lambda($this));
    var tmp_1 = $this;
    tmp_1.m5q_1 = lazy(RichTextData$Line$text$delegate$lambda($this));
    var tmp_2 = $this;
    tmp_2.n5q_1 = lazy(RichTextData$Line$width$delegate$lambda($this));
    var tmp_3 = $this;
    tmp_3.o5q_1 = lazy(RichTextData$Line$maxLineHeight$delegate$lambda($this));
    var tmp_4 = $this;
    tmp_4.p5q_1 = lazy(RichTextData$Line$maxHeight$delegate$lambda($this));
    var tmp_5 = $this;
    tmp_5.q5q_1 = lazy(RichTextData$Line$allFonts$delegate$lambda($this));
    return $this;
  }
  vx(_set____db54di) {
    this.h5q_1.vx(_set____db54di);
  }
  wx() {
    return this.h5q_1.wx();
  }
  static g5r(nodes) {
    return this.f5r(toList_1(nodes));
  }
  x5q() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.k5q_1;
    defaultStyle$factory();
    return this_0.r1();
  }
  h5r() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.l5q_1;
    defaultLastStyle$factory();
    return this_0.r1();
  }
  w5q() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m5q_1;
    text$factory();
    return this_0.r1();
  }
  m2i() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.n5q_1;
    width$factory_0();
    return this_0.r1();
  }
  i5r() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o5q_1;
    maxLineHeight$factory();
    return this_0.r1();
  }
  j5r() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p5q_1;
    maxHeight$factory();
    return this_0.r1();
  }
  k5r() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q5q_1;
    allFonts$factory_0();
    return this_0.r1();
  }
  l5r() {
    var out = toDeque(this.i5q_1);
    $l$loop_2: while (true) {
      var first = firstOrNull(out);
      var last = lastOrNull_1(out);
      if (first instanceof TextNode) {
        if (isBlank(first.s5q_1)) {
          out.nk();
          continue $l$loop_2;
        }
        // Inline function 'kotlin.text.trimStart' call
        var this_0 = first.s5q_1;
        var trimmed = toString_0(trimStart(isCharSequence(this_0) ? this_0 : THROW_CCE()));
        if (!(trimmed === first.s5q_1)) {
          out.nk();
          out.n2l(first.m5r(trimmed));
          continue $l$loop_2;
        }
      }
      if (last instanceof TextNode) {
        if (isBlank(last.s5q_1)) {
          out.pk();
          continue $l$loop_2;
        }
        // Inline function 'kotlin.text.trimEnd' call
        var this_1 = last.s5q_1;
        var trimmed_0 = toString_0(trimEnd(isCharSequence(this_1) ? this_1 : THROW_CCE()));
        if (!(trimmed_0 === last.s5q_1)) {
          out.pk();
          out.m2l(last.m5r(trimmed_0));
          continue $l$loop_2;
        }
      }
      break $l$loop_2;
    }
    return Line.f5r(toList(out));
  }
  toString() {
    return 'Line(nodes=' + toString_0(this.i5q_1) + ', defaultLineStyle=' + toString(this.j5q_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.i5q_1);
    result = imul(result, 31) + (this.j5q_1 == null ? 0 : this.j5q_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Line))
      return false;
    var tmp0_other_with_cast = other instanceof Line ? other : THROW_CCE();
    if (!equals(this.i5q_1, tmp0_other_with_cast.i5q_1))
      return false;
    if (!equals(this.j5q_1, tmp0_other_with_cast.j5q_1))
      return false;
    return true;
  }
}
class Node {}
function get_lineHeight() {
  return this.n2i();
}
class Style {
  constructor(font, textSize, italic, bold, underline, color, canBreak) {
    Companion_getInstance_44();
    textSize = textSize === VOID ? 16.0 : textSize;
    italic = italic === VOID ? false : italic;
    bold = bold === VOID ? false : bold;
    underline = underline === VOID ? false : underline;
    color = color === VOID ? null : color;
    canBreak = canBreak === VOID ? true : canBreak;
    this.y5q_1 = font;
    this.z5q_1 = textSize;
    this.a5r_1 = italic;
    this.b5r_1 = bold;
    this.c5r_1 = underline;
    this.d5r_1 = color;
    this.e5r_1 = canBreak;
  }
  n5r(font, textSize, italic, bold, underline, color, canBreak) {
    return new Style(font, textSize, italic, bold, underline, color, canBreak);
  }
  o5r(font, textSize, italic, bold, underline, color, canBreak, $super) {
    font = font === VOID ? this.y5q_1 : font;
    textSize = textSize === VOID ? this.z5q_1 : textSize;
    italic = italic === VOID ? this.a5r_1 : italic;
    bold = bold === VOID ? this.b5r_1 : bold;
    underline = underline === VOID ? this.c5r_1 : underline;
    color = color === VOID ? this.d5r_1 : color;
    canBreak = canBreak === VOID ? this.e5r_1 : canBreak;
    var tmp;
    if ($super === VOID) {
      tmp = this.n5r(font, textSize, italic, bold, underline, color, canBreak);
    } else {
      var tmp_0 = $super.n5r;
      var tmp_1 = color;
      tmp = tmp_0.call(this, font, textSize, italic, bold, underline, tmp_1 == null ? null : new RGBA(tmp_1), canBreak);
    }
    return tmp;
  }
  toString() {
    var tmp = toString_0(this.y5q_1);
    var tmp_0 = this.d5r_1;
    return 'Style(font=' + tmp + ', textSize=' + this.z5q_1 + ', italic=' + this.a5r_1 + ', bold=' + this.b5r_1 + ', underline=' + this.c5r_1 + ', color=' + toString(tmp_0 == null ? null : new RGBA(tmp_0)) + ', canBreak=' + this.e5r_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.y5q_1);
    result = imul(result, 31) + getNumberHashCode(this.z5q_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a5r_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.b5r_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.c5r_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.d5r_1;
    if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = RGBA__hashCode_impl_h59qf6(this.d5r_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.e5r_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Style))
      return false;
    var tmp0_other_with_cast = other instanceof Style ? other : THROW_CCE();
    if (!equals(this.y5q_1, tmp0_other_with_cast.y5q_1))
      return false;
    if (!equals(this.z5q_1, tmp0_other_with_cast.z5q_1))
      return false;
    if (!(this.a5r_1 === tmp0_other_with_cast.a5r_1))
      return false;
    if (!(this.b5r_1 === tmp0_other_with_cast.b5r_1))
      return false;
    if (!(this.c5r_1 === tmp0_other_with_cast.c5r_1))
      return false;
    var tmp = this.d5r_1;
    var tmp_0 = tmp == null ? null : new RGBA(tmp);
    var tmp_1 = tmp0_other_with_cast.d5r_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new RGBA(tmp_1)))
      return false;
    if (!(this.e5r_1 === tmp0_other_with_cast.e5r_1))
      return false;
    return true;
  }
}
class TextNode {
  constructor(text, style) {
    style = style === VOID ? Companion_getInstance_44().v5q_1 : style;
    this.r5q_1 = new Mixin();
    this.s5q_1 = text;
    this.t5q_1 = style;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!contains_0(this.s5q_1, _Char___init__impl__6a9atx(10))) {
      // Inline function 'korlibs.image.text.TextNode.<anonymous>' call
      var message = 'Single RichTextData nodes cannot have line breaks';
      throw IllegalArgumentException.l(toString_0(message));
    }
    var tmp = this;
    tmp.u5q_1 = lazy(RichTextData$TextNode$bounds$delegate$lambda(this));
  }
  vx(_set____db54di) {
    this.r5q_1.vx(_set____db54di);
  }
  wx() {
    return this.r5q_1.wx();
  }
  w5q() {
    return this.s5q_1;
  }
  d5f() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u5q_1;
    bounds$factory();
    return this_0.r1();
  }
  m2i() {
    return this.d5f().m2i();
  }
  g4p() {
    return this.d5f().g4p();
  }
  n2i() {
    return this.d5f().l4y();
  }
  p5r(text, style) {
    return new TextNode(text, style);
  }
  m5r(text, style, $super) {
    text = text === VOID ? this.s5q_1 : text;
    style = style === VOID ? this.t5q_1 : style;
    return $super === VOID ? this.p5r(text, style) : $super.p5r.call(this, text, style);
  }
  toString() {
    return 'TextNode(text=' + this.s5q_1 + ', style=' + this.t5q_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.s5q_1);
    result = imul(result, 31) + this.t5q_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextNode))
      return false;
    var tmp0_other_with_cast = other instanceof TextNode ? other : THROW_CCE();
    if (!(this.s5q_1 === tmp0_other_with_cast.s5q_1))
      return false;
    if (!this.t5q_1.equals(tmp0_other_with_cast.t5q_1))
      return false;
    return true;
  }
}
class Companion_29 {
  constructor() {
    Companion_instance_35 = this;
    this.q5r_1 = Regex.oh('\\W+');
  }
  r5r(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof TextNode) {
      tmp = _this__u8e3s4.m5r(VOID, _this__u8e3s4.t5q_1.o5r(VOID, VOID, VOID, VOID, VOID, VOID, false));
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  s5r(maxLineWidth, line, addNode) {
    var chunk = RichTextData.a5s([Line.f5r(plus(listOf_0(this.r5r(addNode)), line.i5q_1))]).b5s(maxLineWidth, true);
    var nodes = first_0(chunk.u5r_1).i5q_1;
    return Line.f5r(plus_1(drop(nodes, 1), first_0(nodes)));
  }
  c5s(text) {
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(text) === 0)
      return emptyList();
    var parts = this.d5s(text);
    if (parts.e1() === 1) {
      return splitInChunks(text, 1);
    } else {
      return parts;
    }
  }
  d5s(text) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = splitKeep(text, this.q5r_1);
    var destination = ArrayList.h1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.text.Companion.tokenize.<anonymous>' call
      var tmp;
      // Inline function 'kotlin.text.matches' call
      if (Companion_getInstance_45().q5r_1.ph(element)) {
        // Inline function 'kotlin.text.map' call
        // Inline function 'kotlin.text.mapTo' call
        var destination_0 = ArrayList.w(charSequenceLength(element));
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(element)) {
          var item = charSequenceGet(element, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.image.text.Companion.tokenize.<anonymous>.<anonymous>' call
          var tmp$ret$1 = toString_1(item);
          destination_0.h(tmp$ret$1);
        }
        tmp = destination_0;
      } else {
        tmp = listOf_0(element);
      }
      var list = tmp;
      addAll(destination, list);
    }
    return destination;
  }
}
class RichTextData {
  static e5s(lines, defaultStyle) {
    Companion_getInstance_45();
    var tmp;
    if (defaultStyle === VOID) {
      var tmp260_safe_receiver = firstOrNull_0(lines);
      var tmp0_elvis_lhs = tmp260_safe_receiver == null ? null : tmp260_safe_receiver.x5q();
      tmp = tmp0_elvis_lhs == null ? Companion_getInstance_44().v5q_1 : tmp0_elvis_lhs;
    } else {
      tmp = defaultStyle;
    }
    defaultStyle = tmp;
    var $this = createThis(this);
    $this.t5r_1 = new Mixin();
    $this.u5r_1 = lines;
    $this.v5r_1 = defaultStyle;
    var tmp_0 = $this;
    tmp_0.w5r_1 = lazy(RichTextData$text$delegate$lambda($this));
    var tmp_1 = $this;
    tmp_1.x5r_1 = lazy(RichTextData$width$delegate$lambda($this));
    var tmp_2 = $this;
    tmp_2.y5r_1 = lazy(RichTextData$height$delegate$lambda($this));
    var tmp_3 = $this;
    tmp_3.z5r_1 = lazy(RichTextData$allFonts$delegate$lambda($this));
    return $this;
  }
  vx(_set____db54di) {
    this.t5r_1.vx(_set____db54di);
  }
  wx() {
    return this.t5r_1.wx();
  }
  f5s(elements) {
    return this.u5r_1.x2(elements);
  }
  x2(elements) {
    return this.f5s(elements);
  }
  d1(index) {
    return this.u5r_1.d1(index);
  }
  g5s(element) {
    return this.u5r_1.l1(element);
  }
  l1(element) {
    if (!(element instanceof Line))
      return -1;
    return this.g5s(element instanceof Line ? element : THROW_CCE());
  }
  g1() {
    return this.u5r_1.g1();
  }
  a1() {
    return this.u5r_1.a1();
  }
  y2() {
    return this.u5r_1.y2();
  }
  i1(index) {
    return this.u5r_1.i1(index);
  }
  z2(fromIndex, toIndex) {
    return this.u5r_1.z2(fromIndex, toIndex);
  }
  e1() {
    return this.u5r_1.e1();
  }
  static a5s(lines) {
    Companion_getInstance_45();
    return this.e5s(toList_1(lines));
  }
  static h5s(text, style) {
    Companion_getInstance_45();
    // Inline function 'kotlin.collections.map' call
    var this_0 = split(text, ['\n']);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.text.RichTextData.<init>.<anonymous>' call
      var tmp$ret$0 = Line.g5r([new TextNode(item, style)]);
      destination.h(tmp$ret$0);
    }
    return this.e5s(destination);
  }
  static i5s(text, font, textSize, italic, bold, underline, color, canBreak) {
    Companion_getInstance_45();
    font = font === VOID ? Companion_getInstance_44().v5q_1.y5q_1 : font;
    textSize = textSize === VOID ? Companion_getInstance_44().v5q_1.z5q_1 : textSize;
    italic = italic === VOID ? Companion_getInstance_44().v5q_1.a5r_1 : italic;
    bold = bold === VOID ? Companion_getInstance_44().v5q_1.b5r_1 : bold;
    underline = underline === VOID ? Companion_getInstance_44().v5q_1.c5r_1 : underline;
    color = color === VOID ? Companion_getInstance_44().v5q_1.d5r_1 : color;
    canBreak = canBreak === VOID ? Companion_getInstance_44().v5q_1.e5r_1 : canBreak;
    return this.h5s(text, new Style(font, textSize, italic, bold, underline, color, canBreak));
  }
  m2i() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x5r_1;
    width$factory();
    return this_0.r1();
  }
  n2i() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y5r_1;
    height$factory();
    return this_0.r1();
  }
  k5r() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z5r_1;
    allFonts$factory();
    return this_0.r1();
  }
  l5r() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.u5r_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.text.RichTextData.trimSpaces.<anonymous>' call
      var tmp$ret$0 = item.l5r();
      destination.h(tmp$ret$0);
    }
    return RichTextData.e5s(destination);
  }
  j5s(maxLineWidth, maxHeight, includePartialLines, ellipsis, trimSpaces, includeFirstLineAlways) {
    var out = this;
    var removedWords = false;
    if (!(maxLineWidth === Infinity)) {
      out = out.k5s(maxLineWidth);
    }
    if (!(maxHeight === Infinity)) {
      // Inline function 'kotlin.also' call
      var this_0 = out.l5s(maxHeight, includePartialLines, includeFirstLineAlways);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.text.RichTextData.limit.<anonymous>' call
      if (!this_0.equals(out))
        removedWords = true;
      out = this_0;
    }
    var tmp;
    if (!(maxLineWidth === Infinity) && !(ellipsis == null) && removedWords) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !out.u5r_1.g1();
    } else {
      tmp = false;
    }
    if (tmp) {
      var line = last(out.u5r_1);
      var lastLine = Companion_getInstance_45().s5r(maxLineWidth, last(out.u5r_1), new TextNode(ellipsis, line.h5r()));
      out = RichTextData.e5s(plus_1(dropLast(out, 1), lastLine));
    }
    if (trimSpaces) {
      out = out.l5r();
    }
    return out;
  }
  l5s(maxHeight, includePartialLines, includeFirstLineAlways) {
    var currentHeight = 0.0;
    // Inline function 'kotlin.collections.arrayListOf' call
    var outLines = ArrayList.h1();
    var _iterator__ex2g4s = this.u5r_1.a1();
    $l$loop: while (_iterator__ex2g4s.b1()) {
      var line = _iterator__ex2g4s.c1();
      currentHeight = currentHeight + line.i5r();
      if (currentHeight >= maxHeight) {
        if (includePartialLines || (includeFirstLineAlways && outLines.g1())) {
          // Inline function 'kotlin.collections.plusAssign' call
          outLines.h(line);
        }
        break $l$loop;
      }
      // Inline function 'kotlin.collections.plusAssign' call
      outLines.h(line);
    }
    return RichTextData.e5s(outLines);
  }
  b5s(maxLineWidth, splitLetters) {
    var maxLineWidth_0 = coerceAtLeast_0(maxLineWidth, 0.1);
    // Inline function 'kotlin.collections.arrayListOf' call
    var outLines = ArrayList.h1();
    var currentLineWidth = {_v: 0.0};
    // Inline function 'kotlin.collections.arrayListOf' call
    var currentLine = ArrayList.h1();
    var _iterator__ex2g4s = this.u5r_1.a1();
    done: while (_iterator__ex2g4s.b1()) {
      var line = _iterator__ex2g4s.c1();
      // Inline function 'kotlin.also' call
      var this_0 = TGenDeque.l2l();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.text.RichTextData.wordWrap.<anonymous>' call
      this_0.o2l(line.i5q_1);
      var deque = this_0;
      $l$loop: while (true) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!!deque.g1()) {
          break $l$loop;
        }
        var node = deque.nk();
        var width = node.m2i();
        if (currentLineWidth._v >= maxLineWidth_0) {
          wordWrap$finishLine(currentLine, outLines, currentLineWidth);
        }
        var fullyFitsInLine = width <= maxLineWidth_0;
        var fitsInRemainingLine = currentLineWidth._v + width <= maxLineWidth_0;
        var tmp;
        if (node instanceof TextNode) {
          tmp = (node.t5q_1.e5r_1 && (!fullyFitsInLine || splitLetters));
        } else {
          tmp = false;
        }
        if (tmp) {
          var division = Companion_getInstance_45().c5s(node.s5q_1);
          if (division.e1() === 1) {
            if (!fitsInRemainingLine) {
              wordWrap$finishLine(currentLine, outLines, currentLineWidth);
            }
            wordWrap$addNode(currentLine, currentLineWidth, node);
          } else {
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList.w(collectionSizeOrDefault(division, 10));
            var tmp0_iterator = division.a1();
            while (tmp0_iterator.b1()) {
              var item = tmp0_iterator.c1();
              // Inline function 'korlibs.image.text.RichTextData.wordWrap.<anonymous>' call
              var tmp$ret$4 = node.m5r(item);
              destination.h(tmp$ret$4);
            }
            deque.q2l(destination);
          }
        } else {
          if (!fitsInRemainingLine) {
            wordWrap$finishLine(currentLine, outLines, currentLineWidth);
            wordWrap$addNode(currentLine, currentLineWidth, node);
          } else {
            wordWrap$addNode(currentLine, currentLineWidth, node);
          }
        }
      }
      wordWrap$finishLine(currentLine, outLines, currentLineWidth);
    }
    return RichTextData.e5s(outLines);
  }
  k5s(maxLineWidth, splitLetters, $super) {
    splitLetters = splitLetters === VOID ? false : splitLetters;
    return $super === VOID ? this.b5s(maxLineWidth, splitLetters) : $super.b5s.call(this, maxLineWidth, splitLetters);
  }
  toString() {
    return 'RichTextData(lines=' + toString_0(this.u5r_1) + ', defaultStyle=' + this.v5r_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.u5r_1);
    result = imul(result, 31) + this.v5r_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RichTextData))
      return false;
    var tmp0_other_with_cast = other instanceof RichTextData ? other : THROW_CCE();
    if (!equals(this.u5r_1, tmp0_other_with_cast.u5r_1))
      return false;
    if (!this.v5r_1.equals(tmp0_other_with_cast.v5r_1))
      return false;
    return true;
  }
}
class Placement {
  constructor(text, pos, size, font, fillStyle, stroke) {
    this.n5s_1 = text;
    this.o5s_1 = pos;
    this.p5s_1 = size;
    this.q5s_1 = font;
    this.r5s_1 = fillStyle;
    this.s5s_1 = stroke;
  }
  toString() {
    return 'Placement(text=' + this.n5s_1 + ', pos=' + this.o5s_1.toString() + ', size=' + this.p5s_1 + ', font=' + toString_0(this.q5s_1) + ', fillStyle=' + toString(this.r5s_1) + ', stroke=' + toString(this.s5s_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.n5s_1);
    result = imul(result, 31) + this.o5s_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.p5s_1) | 0;
    result = imul(result, 31) + hashCode(this.q5s_1) | 0;
    result = imul(result, 31) + (this.r5s_1 == null ? 0 : hashCode(this.r5s_1)) | 0;
    result = imul(result, 31) + (this.s5s_1 == null ? 0 : this.s5s_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Placement))
      return false;
    var tmp0_other_with_cast = other instanceof Placement ? other : THROW_CCE();
    if (!(this.n5s_1 === tmp0_other_with_cast.n5s_1))
      return false;
    if (!this.o5s_1.equals(tmp0_other_with_cast.o5s_1))
      return false;
    if (!equals(this.p5s_1, tmp0_other_with_cast.p5s_1))
      return false;
    if (!equals(this.q5s_1, tmp0_other_with_cast.q5s_1))
      return false;
    if (!equals(this.r5s_1, tmp0_other_with_cast.r5s_1))
      return false;
    if (!equals(this.s5s_1, tmp0_other_with_cast.s5s_1))
      return false;
    return true;
  }
}
class RichTextDataPlacements {
  constructor(placements) {
    placements = placements === VOID ? fastArrayListOf([]) : placements;
    this.m5s_1 = placements;
  }
  u5s(elements) {
    return this.m5s_1.x2(elements);
  }
  x2(elements) {
    return this.u5s(elements);
  }
  d1(index) {
    return this.m5s_1.d1(index);
  }
  v5s(element) {
    return this.m5s_1.l1(element);
  }
  l1(element) {
    if (!(element instanceof Placement))
      return -1;
    return this.v5s(element instanceof Placement ? element : THROW_CCE());
  }
  g1() {
    return this.m5s_1.g1();
  }
  a1() {
    return this.m5s_1.a1();
  }
  y2() {
    return this.m5s_1.y2();
  }
  i1(index) {
    return this.m5s_1.i1(index);
  }
  z2(fromIndex, toIndex) {
    return this.m5s_1.z2(fromIndex, toIndex);
  }
  e1() {
    return this.m5s_1.e1();
  }
  toString() {
    return 'RichTextDataPlacements(placements=' + this.m5s_1.toString() + ')';
  }
  hashCode() {
    return this.m5s_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RichTextDataPlacements))
      return false;
    var tmp0_other_with_cast = other instanceof RichTextDataPlacements ? other : THROW_CCE();
    if (!this.m5s_1.equals(tmp0_other_with_cast.m5s_1))
      return false;
    return true;
  }
}
class Companion_30 {
  constructor() {
    Companion_instance_36 = this;
    this.c5t_1 = _VerticalAlign___init__impl__f42kfq(0.0);
    this.d5t_1 = _VerticalAlign___init__impl__f42kfq(0.5);
    this.e5t_1 = _VerticalAlign___init__impl__f42kfq(1.0);
    this.f5t_1 = _VerticalAlign___init__impl__f42kfq(Infinity);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g5t_1 = [new VerticalAlign(this.c5t_1), new VerticalAlign(this.d5t_1), new VerticalAlign(this.f5t_1), new VerticalAlign(this.e5t_1)];
    this.h5t_1 = toList_1(this.g5t_1);
  }
}
class VerticalAlign {
  constructor(ratio) {
    Companion_getInstance_46();
    this.i5t_1 = ratio;
  }
  toString() {
    return VerticalAlign__toString_impl_hcpnn2(this.i5t_1);
  }
  hashCode() {
    return VerticalAlign__hashCode_impl_vx8hj7(this.i5t_1);
  }
  equals(other) {
    return VerticalAlign__equals_impl_xp13z(this.i5t_1, other);
  }
}
class Companion_31 {
  constructor() {
    Companion_instance_37 = this;
    this.w5s_1 = _HorizontalAlign___init__impl__ad654o(-1.0 / 2048.0);
    this.x5s_1 = _HorizontalAlign___init__impl__ad654o(0.0);
    this.y5s_1 = _HorizontalAlign___init__impl__ad654o(0.5);
    this.z5s_1 = _HorizontalAlign___init__impl__ad654o(1.0);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a5t_1 = [new HorizontalAlign(this.x5s_1), new HorizontalAlign(this.y5s_1), new HorizontalAlign(this.z5s_1), new HorizontalAlign(this.w5s_1)];
    this.b5t_1 = toList_1(this.a5t_1);
  }
}
class HorizontalAlign {
  constructor(ratio) {
    Companion_getInstance_47();
    this.j5t_1 = ratio;
  }
  toString() {
    return HorizontalAlign__toString_impl_toflc0(this.j5t_1);
  }
  hashCode() {
    return HorizontalAlign__hashCode_impl_7x9oj5(this.j5t_1);
  }
  equals(other) {
    return HorizontalAlign__equals_impl_hkfbhv(this.j5t_1, other);
  }
}
class Companion_32 {
  constructor() {
    Companion_instance_38 = this;
    this.f4w_1 = listOf([new HorizontalAlign(Companion_getInstance_47().x5s_1), new HorizontalAlign(Companion_getInstance_47().y5s_1), new HorizontalAlign(Companion_getInstance_47().z5s_1), new HorizontalAlign(Companion_getInstance_47().w5s_1)]);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.f4w_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.text.Companion.TOP.<anonymous>' call
      var it = item.j5t_1;
      var tmp$ret$0 = new TextAlignment(it, Companion_getInstance_46().c5t_1);
      destination.h(tmp$ret$0);
    }
    tmp.g4w_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.f4w_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.a1();
    while (tmp0_iterator_0.b1()) {
      var item_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.image.text.Companion.BASELINE.<anonymous>' call
      var it_0 = item_0.j5t_1;
      var tmp$ret$3 = new TextAlignment(it_0, Companion_getInstance_46().f5t_1);
      destination_0.h(tmp$ret$3);
    }
    tmp_0.h4w_1 = destination_0;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_2 = this.f4w_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList.w(collectionSizeOrDefault(this_2, 10));
    var tmp0_iterator_1 = this_2.a1();
    while (tmp0_iterator_1.b1()) {
      var item_1 = tmp0_iterator_1.c1();
      // Inline function 'korlibs.image.text.Companion.MIDDLE.<anonymous>' call
      var it_1 = item_1.j5t_1;
      var tmp$ret$6 = new TextAlignment(it_1, Companion_getInstance_46().d5t_1);
      destination_1.h(tmp$ret$6);
    }
    tmp_1.i4w_1 = destination_1;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.map' call
    var this_3 = this.f4w_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList.w(collectionSizeOrDefault(this_3, 10));
    var tmp0_iterator_2 = this_3.a1();
    while (tmp0_iterator_2.b1()) {
      var item_2 = tmp0_iterator_2.c1();
      // Inline function 'korlibs.image.text.Companion.BOTTOM.<anonymous>' call
      var it_2 = item_2.j5t_1;
      var tmp$ret$9 = new TextAlignment(it_2, Companion_getInstance_46().e5t_1);
      destination_2.h(tmp$ret$9);
    }
    tmp_2.j4w_1 = destination_2;
    this.k4w_1 = plus(plus(plus(this.g4w_1, this.h4w_1), this.i4w_1), this.j4w_1);
    this.l4w_1 = this.g4w_1.d1(0);
    this.m4w_1 = this.g4w_1.d1(1);
    this.n4w_1 = this.g4w_1.d1(2);
    this.o4w_1 = this.g4w_1.d1(3);
    this.p4w_1 = this.h4w_1.d1(0);
    this.q4w_1 = this.h4w_1.d1(1);
    this.r4w_1 = this.h4w_1.d1(2);
    this.s4w_1 = this.h4w_1.d1(3);
    this.t4w_1 = this.g4w_1.d1(0);
    this.u4w_1 = this.g4w_1.d1(1);
    this.v4w_1 = this.g4w_1.d1(2);
    this.w4w_1 = this.g4w_1.d1(3);
    this.x4w_1 = this.i4w_1.d1(0);
    this.y4w_1 = this.i4w_1.d1(1);
    this.z4w_1 = this.i4w_1.d1(2);
    this.a4x_1 = this.i4w_1.d1(3);
    this.b4x_1 = this.j4w_1.d1(0);
    this.c4x_1 = this.j4w_1.d1(1);
    this.d4x_1 = this.j4w_1.d1(2);
    this.e4x_1 = this.j4w_1.d1(3);
  }
  k5t(horizontal, vertical) {
    var tmp;
    if (equals(horizontal, Companion_getInstance_47().x5s_1)) {
      tmp = 0;
    } else if (equals(horizontal, Companion_getInstance_47().y5s_1)) {
      tmp = 1;
    } else if (equals(horizontal, Companion_getInstance_47().z5s_1)) {
      tmp = 2;
    } else if (equals(horizontal, Companion_getInstance_47().w5s_1)) {
      tmp = 3;
    } else {
      return new TextAlignment(horizontal, vertical);
    }
    var horizontalIndex = tmp;
    return equals(vertical, Companion_getInstance_46().c5t_1) ? this.g4w_1.d1(horizontalIndex) : equals(vertical, Companion_getInstance_46().f5t_1) ? this.h4w_1.d1(horizontalIndex) : equals(vertical, Companion_getInstance_46().d5t_1) ? this.i4w_1.d1(horizontalIndex) : equals(vertical, Companion_getInstance_46().e5t_1) ? this.j4w_1.d1(horizontalIndex) : new TextAlignment(horizontal, vertical);
  }
}
class TextAlignment {
  constructor(horizontal, vertical) {
    Companion_getInstance_48();
    this.d4y_1 = horizontal;
    this.e4y_1 = vertical;
    this.f4y_1 = Anchor2D.s24(_HorizontalAlign___get_ratioFake__impl__h46z0d(this.d4y_1), _VerticalAlign___get_ratioFake__impl__1h2fwv(this.e4y_1));
  }
  toString() {
    return VerticalAlign__toString_impl_hcpnn2(this.e4y_1) + '_' + HorizontalAlign__toString_impl_toflc0(this.d4y_1);
  }
  hashCode() {
    var result = HorizontalAlign__hashCode_impl_7x9oj5(this.d4y_1);
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.e4y_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextAlignment))
      return false;
    var tmp0_other_with_cast = other instanceof TextAlignment ? other : THROW_CCE();
    if (!equals(this.d4y_1, tmp0_other_with_cast.d4y_1))
      return false;
    if (!equals(this.e4y_1, tmp0_other_with_cast.e4y_1))
      return false;
    return true;
  }
}
class TextRenderer {}
function get_version() {
  return 0;
}
class LineStats {
  constructor(maxLineHeight, maxX, bounds) {
    maxLineHeight = maxLineHeight === VOID ? 0.0 : maxLineHeight;
    maxX = maxX === VOID ? 0.0 : maxX;
    bounds = bounds === VOID ? Companion_getInstance_7().e26() : bounds;
    this.h4y_1 = maxLineHeight;
    this.i4y_1 = maxX;
    this.j4y_1 = bounds;
  }
  k4y(align) {
    return HorizontalAlign__getOffsetX_impl_urzzxf(align, this.i4y_1) + BoundsBuilder__xminOr_impl_k3l1m2(this.j4y_1, 0.0);
  }
  z50(dx) {
    this.i4y_1 = this.i4y_1 + dx;
  }
  n5t(fontMetrics) {
    var tmp = this;
    // Inline function 'kotlin.math.max' call
    var a = this.h4y_1;
    var b = fontMetrics.g4p();
    tmp.h4y_1 = Math.max(a, b);
  }
  o5t() {
  }
  c2q() {
    this.i4y_1 = 0.0;
    this.j4y_1 = Companion_getInstance_7().z25_1;
    this.h4y_1 = 0.0;
  }
  toString() {
    return 'LineStats(maxLineHeight=' + this.h4y_1 + ', maxX=' + this.i4y_1 + ', bounds=' + BoundsBuilder__toString_impl_fmvxh7(this.j4y_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.h4y_1);
    result = imul(result, 31) + getNumberHashCode(this.i4y_1) | 0;
    result = imul(result, 31) + BoundsBuilder__hashCode_impl_649zbo(this.j4y_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LineStats))
      return false;
    var tmp0_other_with_cast = other instanceof LineStats ? other : THROW_CCE();
    if (!equals(this.h4y_1, tmp0_other_with_cast.h4y_1))
      return false;
    if (!equals(this.i4y_1, tmp0_other_with_cast.i4y_1))
      return false;
    if (!equals(this.j4y_1, tmp0_other_with_cast.j4y_1))
      return false;
    return true;
  }
}
class BoundBuilderTextRendererActions extends TextRendererActions {
  constructor() {
    super();
    this.x4x_1 = Companion_getInstance_7().e26();
    this.y4x_1 = Companion_getInstance_7().e26();
    this.z4x_1 = 0;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.a4y_1 = ArrayList.h1();
    this.b4y_1 = new LineStats();
  }
  c4y() {
    return this.z4x_1;
  }
  p5t() {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var tmp0_iterator = this.a4y_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      var tmp = sum;
      // Inline function 'korlibs.image.text.BoundBuilderTextRendererActions.<get-totalMaxLineHeight>.<anonymous>' call
      sum = tmp + element.h4y_1;
    }
    return sum;
  }
  p50(align, line) {
    var tmp0_elvis_lhs = getOrNull_1(this.a4y_1, line);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return HorizontalAlign__getOffsetX_impl_urzzxf(align, 0.0);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var line_0 = tmp;
    return HorizontalAlign__getOffsetX_impl_urzzxf(align, line_0.i4y_1);
  }
  g4y(align, fontMetrics) {
    return VerticalAlign__getOffsetYRespectBaseline_impl_62po5b(align, fontMetrics, this.p5t());
  }
  c2q() {
    super.c2q();
    this.z4x_1 = 0;
    this.y4x_1 = Companion_getInstance_7().z25_1;
    this.x4x_1 = Companion_getInstance_7().z25_1;
    this.b4y_1.c2q();
    this.a4y_1.h3();
  }
  d50(reader, codePoint) {
    var g = this.x50(reader, codePoint);
    add_0(this, g.e4q_1);
    this.b4y_1.n5t(this.g50_1);
    return g;
  }
  z50(x) {
    super.z50(x);
    this.b4y_1.z50(x);
  }
  a51(y, end) {
    super.a51(y, end);
    this.z4x_1 = this.z4x_1 + 1 | 0;
    this.b4y_1.n5t(this.g50_1);
    this.b4y_1.o5t();
    this.a4y_1.h(this.b4y_1);
    this.b4y_1 = new LineStats();
  }
}
class LineInfo {
  constructor(maxTop, minBottom, maxLineHeight) {
    maxTop = maxTop === VOID ? 0.0 : maxTop;
    minBottom = minBottom === VOID ? 0.0 : minBottom;
    maxLineHeight = maxLineHeight === VOID ? 0.0 : maxLineHeight;
    this.q5t_1 = maxTop;
    this.r5t_1 = minBottom;
    this.s5t_1 = maxLineHeight;
  }
  toString() {
    return 'LineInfo(maxTop=' + this.q5t_1 + ', minBottom=' + this.r5t_1 + ', maxLineHeight=' + this.s5t_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.q5t_1);
    result = imul(result, 31) + getNumberHashCode(this.r5t_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s5t_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LineInfo))
      return false;
    var tmp0_other_with_cast = other instanceof LineInfo ? other : THROW_CCE();
    if (!equals(this.q5t_1, tmp0_other_with_cast.q5t_1))
      return false;
    if (!equals(this.r5t_1, tmp0_other_with_cast.r5t_1))
      return false;
    if (!equals(this.s5t_1, tmp0_other_with_cast.s5t_1))
      return false;
    return true;
  }
}
class Entry_0 {
  constructor(tex, x, y, sx, sy, rot) {
    var tmp;
    if (tex === VOID) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      tmp = get_Bitmaps_transparent();
    } else {
      tmp = tex;
    }
    tex = tmp;
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    sx = sx === VOID ? 1.0 : sx;
    sy = sy === VOID ? 1.0 : sy;
    rot = rot === VOID ? get_radians(0) : rot;
    this.t5t_1 = tex;
    this.u5t_1 = x;
    this.v5t_1 = y;
    this.w5t_1 = sx;
    this.x5t_1 = sy;
    this.y5t_1 = rot;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.Entry.toString.<anonymous>' call
    this_0.ob('Entry(');
    this_0.ob("'" + this.t5t_1.w3f_1 + "', " + numberToInt(this.u5t_1) + ', ' + numberToInt(this.v5t_1) + ', ' + this.t5t_1.b3g_1 + ', ' + this.t5t_1.c3g_1);
    if (!(this.w5t_1 === 1.0)) {
      this_0.ob(', sx=' + get_niceStr_0(this.w5t_1));
    }
    if (!(this.x5t_1 === 1.0)) {
      this_0.ob(', sy=' + get_niceStr_0(this.x5t_1));
    }
    if (!equals(this.y5t_1, get_radians(0))) {
      this_0.ob(', rot=' + get_niceStr_0(_Angle___get_degrees__impl__qg56vw(this.y5t_1)));
    }
    this_0.ob(')');
    return this_0.toString();
  }
  hashCode() {
    var result = this.t5t_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.u5t_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v5t_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w5t_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.x5t_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.y5t_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry_0))
      return false;
    var tmp0_other_with_cast = other instanceof Entry_0 ? other : THROW_CCE();
    if (!this.t5t_1.equals(tmp0_other_with_cast.t5t_1))
      return false;
    if (!equals(this.u5t_1, tmp0_other_with_cast.u5t_1))
      return false;
    if (!equals(this.v5t_1, tmp0_other_with_cast.v5t_1))
      return false;
    if (!equals(this.w5t_1, tmp0_other_with_cast.w5t_1))
      return false;
    if (!equals(this.x5t_1, tmp0_other_with_cast.x5t_1))
      return false;
    if (!equals(this.y5t_1, tmp0_other_with_cast.y5t_1))
      return false;
    return true;
  }
}
class Text2TextRendererActions extends TextRendererActions {
  constructor() {
    super();
    this.j5u_1 = Companion_getInstance_48().l4w_1;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.k5u_1 = ArrayList.h1();
    this.l5u_1 = doubleArrayListOf(new Float64Array([]));
    this.m5u_1 = doubleArrayListOf(new Float64Array([]));
    this.n5u_1 = doubleArrayListOf(new Float64Array([]));
    this.o5u_1 = doubleArrayListOf(new Float64Array([]));
    this.p5u_1 = doubleArrayListOf(new Float64Array([]));
    this.q5u_1 = new DoubleVectorArrayList(4);
    this.r5u_1 = MatrixTransform.g2b();
  }
  s5u() {
    return this.j5u_1.e4y_1;
  }
  e1() {
    return this.l5u_1.e1();
  }
  t5u() {
    var out = arrayListOf([new LineInfo()]);
    // Inline function 'korlibs.math.geom.fastForEachGeneric' call
    var this_0 = this.q5u_1;
    var inductionVariable = 0;
    var last = this_0.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.text.Text2TextRendererActions.getLineInfos.<anonymous>' call
        var line = numberToInt(this_0.p27(n, 0));
        while (out.e1() <= line) {
          out.h(new LineInfo());
        }
        var lineInfo = out.d1(line);
        var top = this_0.p27(n, 1);
        var bottom = this_0.p27(n, 2);
        var lineHeight = this_0.p27(n, 3);
        var tmp = lineInfo;
        // Inline function 'kotlin.math.max' call
        var a = lineInfo.q5t_1;
        tmp.q5t_1 = Math.max(a, top);
        var tmp_0 = lineInfo;
        // Inline function 'kotlin.math.min' call
        var a_0 = lineInfo.r5t_1;
        tmp_0.r5t_1 = Math.min(a_0, bottom);
        var tmp_1 = lineInfo;
        // Inline function 'kotlin.math.max' call
        var a_1 = lineInfo.s5t_1;
        tmp_1.s5t_1 = Math.max(a_1, lineHeight);
      }
       while (inductionVariable < last);
    return out;
  }
  u5u(n) {
    return n >= this.e1() ? Companion_getInstance_4().a26_1 : Companion_getInstance_4().x2d(this.l5u_1.d1(n), this.m5u_1.d1(n), this.l5u_1.d1(n) + this.k5u_1.d1(n).b3g_1 * this.n5u_1.d1(n), this.m5u_1.d1(n) + this.k5u_1.d1(n).c3g_1 * this.o5u_1.d1(n));
  }
  l3a() {
    if (this.e1() === 0) {
      return Companion_getInstance_4().a26_1;
    }
    var bb = Companion_getInstance_7().e26();
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, this.u5u(n));
      }
       while (inductionVariable < last);
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  v5u(n, out) {
    out.t5t_1 = this.k5u_1.d1(n);
    out.u5t_1 = this.l5u_1.d1(n);
    out.v5t_1 = this.m5u_1.d1(n);
    out.w5t_1 = this.n5u_1.d1(n);
    out.x5t_1 = this.o5u_1.d1(n);
    var tmp = out;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    Companion_getInstance_8();
    var ratio = this.p5u_1.d1(n);
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio_0 = toRatio_0(ratio);
    var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    tmp.y5t_1 = _Angle___init__impl__g23q1m(tmp$ret$0);
    return out;
  }
  w5u() {
    this.w50(Companion_getInstance_6().g25_1);
    this.k5u_1.h3();
    this.l5u_1.h3();
    this.m5u_1.h3();
    this.n5u_1.h3();
    this.o5u_1.h3();
    this.p5u_1.h3();
    this.q5u_1.h3();
    this.u50(0);
  }
  d50(reader, codePoint) {
    var tmp = this.t50();
    var bf = isInterface(tmp, BitmapFont) ? tmp : THROW_CCE();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.io.lang.keep' call
      var tmp0_elvis_lhs = reader == null ? null : reader.vv_1;
      var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      try {
        // Inline function 'korlibs.image.text.Text2TextRendererActions.put.<anonymous>' call
        tmp$ret$1 = this.x50(reader, codePoint);
        break $l$block;
      }finally {
        if (reader == null)
          null;
        else {
          reader.vv_1 = old;
        }
      }
    }
    var m = tmp$ret$1;
    var g = bf.d1(codePoint);
    var x = g.u4o_1;
    var tmp_0 = g.v4o_1;
    var tmp295_subject = this.s5u();
    var y = tmp_0 - (equals(tmp295_subject, Companion_getInstance_46().f5t_1) ? bf.b3h() : bf.g4p() * _VerticalAlign___get_ratio__impl__b3ilr8(this.s5u()));
    var fontScale = this.j50_1 / bf.f4p();
    this.r5u_1 = get_immutable(this.r50()).k2a();
    this.k5u_1.h(g.t4o_1);
    this.l5u_1.nz(this.tw().e25_1 + this.r50().p29(x, y) * fontScale);
    this.m5u_1.nz(this.tw().f25_1 + this.r50().s29(x, y) * fontScale);
    this.n5u_1.nz(this.r5u_1.y2a_1 * fontScale);
    this.o5u_1.nz(this.r5u_1.z2a_1 * fontScale);
    this.p5u_1.nz(Ratio__toDouble_impl_o7epze(_Angle___get_ratio__impl__ap3on4(this.r5u_1.c2b_1)));
    this.q5u_1.p2k(this.o50(), this.g50_1.q4p_1, this.g50_1.u4p_1, this.g50_1.g4p());
    return m;
  }
}
class CreateWStringTextRenderer$2 {
  constructor($getVersion, $handler) {
    this.x5u_1 = $getVersion;
    this.y5u_1 = $handler;
  }
  l5t() {
    return this.x5u_1();
  }
  z5u(_this__u8e3s4, text, size, defaultFont) {
    _this__u8e3s4.c2q();
    _this__u8e3s4.v50(defaultFont, size);
    var reader = new WStringReader(text);
    while (reader.cw()) {
      var c = _WChar___get_codePoint__impl__c8brwu(reader.fw());
      var c1 = _WChar___get_codePoint__impl__c8brwu(reader.dw(1));
      var startPos = reader.vv_1;
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(10);
      if (c === Char__toInt_impl_vasixd(this_0)) {
        _this__u8e3s4.a51(_this__u8e3s4.g4p(), false);
      } else {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.io.lang.keep' call
          var tmp0_elvis_lhs = reader == null ? null : reader.vv_1;
          var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
          try {
            // Inline function 'korlibs.image.text.<no name provided>.run.<anonymous>' call
            tmp$ret$2 = _this__u8e3s4.x50(reader, c);
            break $l$block;
          }finally {
            if (reader == null)
              null;
            else {
              reader.vv_1 = old;
            }
          }
        }
        var g = tmp$ret$2;
        _this__u8e3s4.y50(Companion_getInstance_5().x28_1);
        this.y5u_1(_this__u8e3s4, reader, c, g, g.f4q_1 + _this__u8e3s4.i4q(c, c1));
      }
      if (reader.vv_1 <= startPos) {
        reader.hw(1);
      }
    }
    _this__u8e3s4.a51(_this__u8e3s4.g4p(), true);
  }
  m5t(_this__u8e3s4, text, size, defaultFont) {
    return this.z5u(_this__u8e3s4, text instanceof WString ? text : THROW_CCE(), size, defaultFont);
  }
}
class CreateStringTextRenderer$2 {
  constructor($getVersion, $handler) {
    var tmp = this;
    tmp.a5v_1 = CreateWStringTextRenderer($getVersion, CreateStringTextRenderer$o$wstring$lambda($handler));
  }
  l5t() {
    return this.a5v_1.l5t();
  }
  b5v(_this__u8e3s4, text, size, defaultFont) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.<no name provided>.run.<anonymous>' call
    this.a5v_1.m5t(_this__u8e3s4, Companion_getInstance_11().mw(text), size, defaultFont);
  }
  m5t(_this__u8e3s4, text, size, defaultFont) {
    return this.b5v(_this__u8e3s4, (!(text == null) ? typeof text === 'string' : false) ? text : THROW_CCE(), size, defaultFont);
  }
}
class SegmentHandler {
  constructor() {
    this.c5v_1 = intArrayListOf(new Int32Array([]));
    this.d5v_1 = intArrayListOf(new Int32Array([]));
    this.c2q();
  }
  e1() {
    return this.c5v_1.e1();
  }
  c2q() {
    this.c5v_1.h3();
    this.d5v_1.h3();
  }
  h3m(x0, x1) {
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var xmin = this.c5v_1.qx(n);
        var xmax = this.d5v_1.qx(n);
        if (overlaps(this, xmin, xmax, x0, x1)) {
          // Inline function 'kotlin.math.min' call
          var tmp$ret$0 = Math.min(x0, xmin);
          this.c5v_1.a2k(n, tmp$ret$0);
          // Inline function 'kotlin.math.max' call
          var tmp$ret$1 = Math.max(x1, xmax);
          this.d5v_1.a2k(n, tmp$ret$1);
          return Unit_instance;
        }
      }
       while (inductionVariable < last);
    this.c5v_1.t2j(x0);
    this.d5v_1.t2j(x1);
  }
}
class ScanlineWriter {
  constructor($outer) {
    this.p5v_1 = $outer;
    this.e5v_1 = get_DEFAULT(Companion_getInstance_49());
    this.f5v_1 = NoneFiller_getInstance();
    this.g5v_1 = -1;
    this.h5v_1 = -1;
    this.i5v_1 = new Float32Array(this.e1());
    this.j5v_1 = new Int32Array(this.e1());
    this.k5v_1 = Companion_instance_14.o4o(this.e1());
    this.l5v_1 = Companion_instance_14.o4o(this.e1());
    this.m5v_1 = new SegmentHandler();
    this.n5v_1 = 0;
    this.o5v_1 = 1.0;
  }
  e1() {
    return this.p5v_1.s5v_1.l3x_1;
  }
  c5w() {
    return this.p5v_1.s5v_1.l3x_1 - 1 | 0;
  }
  c2q() {
    // Inline function 'korlibs.image.vector.SegmentHandler.forEachFast' call
    var this_0 = this.m5v_1;
    var inductionVariable = 0;
    var last = this_0.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.vector.ScanlineWriter.reset.<anonymous>' call
        var xmin = this_0.c5v_1.qx(n);
        var xmax = this_0.d5v_1.qx(n);
        fill_0(this.i5v_1, 0.0, xmin, xmax + 1 | 0);
        fill(this.j5v_1, 0, xmin, xmax + 1 | 0);
      }
       while (inductionVariable < last);
    this.n5v_1 = 0;
    this.m5v_1.c2q();
  }
  d5w(x0, x1, y0) {
    if (this.c5w() < 1)
      return Unit_instance;
    var x0_0 = coerceIn(x0, 0, imul(this.c5w(), 20));
    var x1_0 = coerceIn(x1, 0, imul(this.c5w(), 20));
    var a = x0_0 / 20 | 0;
    var b = x1_0 / 20 | 0;
    var y = y0 / 20 | 0;
    var i0 = coerceIn(a, 0, this.c5w());
    var i1 = coerceIn(b, 0, this.c5w());
    var i0m = x0_0 % 20 | 0;
    var i1m = x1_0 % 20 | 0;
    if (!(this.h5v_1 === y)) {
      if (y >= 0) {
        this.lc();
      }
      this.h5v_1 = y;
      this.c2q();
    }
    if (!(this.g5v_1 === y0)) {
      this.g5v_1 = y0;
      this.n5v_1 = this.n5v_1 + 1 | 0;
    }
    if (i1 > i0) {
      this.m5v_1.h3m(i0, i1);
      this.e5w(i0, 1.0 - i0m / 20);
      var inductionVariable = i0 + 1 | 0;
      if (inductionVariable < i1)
        do {
          var x = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.e5w(x, 1.0);
        }
         while (inductionVariable < i1);
      if (!(i1m === 0)) {
        this.e5w(i1, i1m / 20);
      }
    }
  }
  e5w(x, ratio) {
    var mask = 1 << this.n5v_1;
    if ((this.j5v_1[x] & mask) === 0) {
      this.j5v_1[x] = this.j5v_1[x] | mask;
      var _array__4zh2yp = this.i5v_1;
      _array__4zh2yp[x] = _array__4zh2yp[x] + ratio;
    }
  }
  lc() {
    var containsUpper = this.p5v_1.s5v_1.m3x_1;
    var containsArg = this.h5v_1;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      return Unit_instance;
    var galpha = clamp01_0(this.o5v_1);
    var scale_0 = 1.0 / this.n5v_1 * galpha;
    // Inline function 'korlibs.image.vector.SegmentHandler.forEachFast' call
    var this_0 = this.m5v_1;
    var inductionVariable = 0;
    var last = this_0.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.vector.ScanlineWriter.flush.<anonymous>' call
        var xmin = this_0.c5v_1.qx(n);
        var xmax = this_0.d5v_1.qx(n);
        var x = xmin;
        var count = (xmax - xmin | 0) + 1 | 0;
        this.f5v_1.s5o(this.l5v_1, 0, xmin, xmax, this.h5v_1);
        var inductionVariable_0 = xmin;
        if (inductionVariable_0 <= xmax)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var _array__4zh2yp = this.i5v_1;
            var _index_0__fvwizt = n_0;
            _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] * scale_0;
          }
           while (!(n_0 === xmax));
        scale(this.l5v_1, xmin, this.i5v_1, xmin, count);
        var index = this.p5v_1.s5v_1.g3y(0, this.h5v_1) + x | 0;
        if (this.p5v_1.s5v_1.r3x_1) {
          arraycopy(this.p5v_1.s5v_1.b3x_1, index, _RgbaPremultipliedArray___get_ints__impl__i1gpd7(this.k5v_1), x, count);
        } else {
          premultiply(_RgbaArray___init__impl__oib4y4(this.p5v_1.s5v_1.b3x_1), index, this.k5v_1, x, count);
        }
        this.e5v_1.f5w(this.k5v_1, x, this.l5v_1, x, count);
        if (this.p5v_1.s5v_1.r3x_1) {
          arraycopy(_RgbaPremultipliedArray___get_ints__impl__i1gpd7(this.k5v_1), x, this.p5v_1.s5v_1.b3x_1, index, count);
        } else {
          depremultiply(this.k5v_1, x, _RgbaArray___init__impl__oib4y4(this.p5v_1.s5v_1.b3x_1), index, count);
        }
      }
       while (inductionVariable < last);
  }
}
class Renderer {
  constructor() {
    this.r5w_1 = false;
    this.s5w_1 = 0;
  }
  lc() {
    return Unit_instance;
  }
  u5w() {
    var _unary__edvuaz = this.s5w_1;
    this.s5w_1 = _unary__edvuaz + 1 | 0;
    return _unary__edvuaz;
  }
  v5w() {
    this.s5w_1 = this.s5w_1 - 1 | 0;
    if (this.s5w_1 === 0) {
      this.lc();
    }
  }
  w5w(state, fill, winding) {
    var rstate = state;
    if (fill && !this.y5w(state.x4q_1)) {
      rstate = state.sx();
      rstate.x4q_1 = toBitmapPaint(rstate.x4q_1, state);
    }
    this.q5w(rstate, fill, winding);
  }
  x5w(state, fill, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.w5w(state, fill, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.w5w.call(this, state, fill, winding);
    }
    return tmp;
  }
  q5w(state, fill, winding) {
    return Unit_instance;
  }
  y5w(_this__u8e3s4) {
    return true;
  }
  z5w(image, pos, size, transform) {
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.renderer.Renderer.drawImage.<anonymous>' call
    if (transform.n29().equals(MatrixType_IDENTITY_getInstance())) {
      this_0.z3o(pos, size);
    } else {
      this_0.g3p(transform, Renderer$drawImage$lambda(pos, size));
    }
    this.x5w(new State(transform, VOID, this_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new BitmapPaint(image, scaled(Companion_getInstance_5().x28_1, size.r2f(toFloat(image.e1()))).b2a(pos))), true);
  }
  d18() {
    this.lc();
  }
}
class Bitmap32Context2d extends Renderer {
  constructor(bmp, antialiasing) {
    super();
    this.s5v_1 = bmp;
    this.t5v_1 = antialiasing;
    this.u5v_1 = this.s5v_1.d3x_1.k2f();
    this.v5v_1 = new Rasterizer();
    this.w5v_1 = new ColorFiller();
    this.x5v_1 = new GradientFiller();
    this.y5v_1 = new BitmapFiller();
    this.z5v_1 = new ScanlineWriter(this);
    this.a5w_1 = new VectorPath(VOID, VOID, Winding_EVEN_ODD_getInstance());
    this.b5w_1 = new StrokeToFill();
  }
  m2i() {
    return this.s5v_1.l3x_1;
  }
  n2i() {
    return this.s5v_1.m3x_1;
  }
  q5w(state, fill, winding) {
    var style = fill ? state.x4q_1 : state.w4q_1;
    var tmp;
    if (style instanceof NonePaint) {
      tmp = NoneFiller_getInstance();
    } else {
      if (style instanceof RGBA) {
        tmp = this.w5v_1.q5o(style.m4e_1, state);
      } else {
        if (style instanceof GradientPaint) {
          tmp = this.x5v_1.y5o(style, state);
        } else {
          if (style instanceof BitmapPaint) {
            tmp = this.y5v_1.m5p(style, state);
          } else {
            throw NotImplementedError.od();
          }
        }
      }
    }
    var filler = tmp;
    this.z5v_1.e5v_1 = state.e4r_1;
    this.v5v_1.c2q();
    this.v5v_1.g5w_1 = this.r5w_1;
    var doingStroke = !fill;
    var tmp_0;
    if (fill) {
      tmp_0 = state.p4q_1;
    } else {
      this.a5w_1.h3();
      var tmp306_$receiver = state.p4q_1;
      var tmp307_lineWidth = state.t5w();
      var tmp308_joins = state.u4q_1;
      var tmp309_startCap = state.s4q_1;
      var tmp310_endCap = state.t4q_1;
      var tmp311_miterLimit = state.v4q_1;
      var tmp312_temp = this.b5w_1;
      var tmp313_outFill = this.a5w_1;
      var tmp314_lineDash = state.f4r_1;
      var tmp315_lineDashOffset = state.g4r_1;
      tmp_0 = strokeToFill(tmp306_$receiver, tmp307_lineWidth, tmp308_joins, tmp309_startCap, tmp310_endCap, tmp311_miterLimit, tmp314_lineDash, tmp315_lineDashOffset, tmp312_temp, tmp313_outFill);
    }
    var fillPath = tmp_0;
    if (!(state.o4q_1 == null)) {
      this.v5v_1.k5w_1.m3l_1 = ensureNotNull(state.o4q_1).z3d_1;
      // Inline function 'korlibs.math.geom.shape.emitPoints2' call
      var this_0 = ensureNotNull(state.o4q_1);
      var i = Vector2D.y27();
      var l = Vector2D.y27();
      // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
      if (false) {
        this.v5v_1.k5w_1.c6();
      }
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
      var n = 0;
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_1 = this_0.x3d_1;
      var n_0 = 0;
      while (n_0 < this_1.e1()) {
        // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
        var _unary__edvuaz = n_0;
        n_0 = _unary__edvuaz + 1 | 0;
        switch (this_1.qx(_unary__edvuaz)) {
          case 0:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_0 = n;
            n = _unary__edvuaz_0 + 1 | 0;
            var tmp_1 = this_0.y3d_1.d1(_unary__edvuaz_0);
            var _unary__edvuaz_1 = n;
            n = _unary__edvuaz_1 + 1 | 0;
            var it = Vector2D.n27(tmp_1, this_0.y3d_1.d1(_unary__edvuaz_1));
            i = it;
            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var x = it.fl();
            var y = it.gl();
            this.v5v_1.k5w_1.p3m(x, y, true);
            l = it;
            break;
          case 1:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_2 = n;
            n = _unary__edvuaz_2 + 1 | 0;
            var tmp_2 = this_0.y3d_1.d1(_unary__edvuaz_2);
            var _unary__edvuaz_3 = n;
            n = _unary__edvuaz_3 + 1 | 0;
            var it_0 = Vector2D.n27(tmp_2, this_0.y3d_1.d1(_unary__edvuaz_3));
            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var x_0 = it_0.fl();
            var y_0 = it_0.gl();
            this.v5v_1.k5w_1.p3m(x_0, y_0, false);
            l = it_0;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 2:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_4 = n;
            n = _unary__edvuaz_4 + 1 | 0;
            var tmp_3 = this_0.y3d_1.d1(_unary__edvuaz_4);
            var _unary__edvuaz_5 = n;
            n = _unary__edvuaz_5 + 1 | 0;
            var c = Vector2D.n27(tmp_3, this_0.y3d_1.d1(_unary__edvuaz_5));
            var _unary__edvuaz_6 = n;
            n = _unary__edvuaz_6 + 1 | 0;
            var tmp_4 = this_0.y3d_1.d1(_unary__edvuaz_6);
            var _unary__edvuaz_7 = n;
            n = _unary__edvuaz_7 + 1 | 0;
            var a = Vector2D.n27(tmp_4, this_0.y3d_1.d1(_unary__edvuaz_7));
            var sum = Companion_getInstance_6().q2g(l, c) + Companion_getInstance_6().q2g(c, a);
            // Inline function 'korlibs.math.geom.shape.approximateCurve' call

            // Inline function 'kotlin.math.max' call

            var a_0 = numberToInt(sum);
            var rcurveSteps = Math.max(a_0, 20);
            var dt = 1.0 / rcurveSteps;
            var lastPos = {_v: Vector2D.y27()};
            var prevPos = {_v: Vector2D.y27()};
            var emittedCount = {_v: 0};
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

            var ratio = Companion_getInstance_9().kx_1;
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

            lastPos._v = Companion_getInstance_1().u3b(l, c, a, ratio);
            var nStart = false ? 0 : 1;
            var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
            var inductionVariable = nStart;
            if (inductionVariable <= nEnd)
              do {
                var n_1 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                var it_1 = Companion_getInstance_1().u3b(l, c, a, ratio_0);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                var x_1 = it_1.fl();
                var y_1 = it_1.gl();
                this.v5v_1.k5w_1.p3m(x_1, y_1, false);
                emittedCount._v = emittedCount._v + 1 | 0;
                lastPos._v = prevPos._v;
                prevPos._v = it_1;
              }
               while (!(n_1 === nEnd));
            l = a;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 3:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_8 = n;
            n = _unary__edvuaz_8 + 1 | 0;
            var tmp_5 = this_0.y3d_1.d1(_unary__edvuaz_8);
            var _unary__edvuaz_9 = n;
            n = _unary__edvuaz_9 + 1 | 0;
            var c0 = Vector2D.n27(tmp_5, this_0.y3d_1.d1(_unary__edvuaz_9));
            var _unary__edvuaz_10 = n;
            n = _unary__edvuaz_10 + 1 | 0;
            var tmp_6 = this_0.y3d_1.d1(_unary__edvuaz_10);
            var _unary__edvuaz_11 = n;
            n = _unary__edvuaz_11 + 1 | 0;
            var c1 = Vector2D.n27(tmp_6, this_0.y3d_1.d1(_unary__edvuaz_11));
            var _unary__edvuaz_12 = n;
            n = _unary__edvuaz_12 + 1 | 0;
            var tmp_7 = this_0.y3d_1.d1(_unary__edvuaz_12);
            var _unary__edvuaz_13 = n;
            n = _unary__edvuaz_13 + 1 | 0;
            var a_1 = Vector2D.n27(tmp_7, this_0.y3d_1.d1(_unary__edvuaz_13));
            var sum_0 = Companion_getInstance_6().q2g(l, c0) + Companion_getInstance_6().q2g(c0, c1) + Companion_getInstance_6().q2g(c1, a_1);
            // Inline function 'korlibs.math.geom.shape.approximateCurve' call

            // Inline function 'kotlin.math.max' call

            var a_2 = numberToInt(sum_0);
            var rcurveSteps_0 = Math.max(a_2, 20);
            var dt_0 = 1.0 / rcurveSteps_0;
            var lastPos_0 = {_v: Vector2D.y27()};
            var prevPos_0 = {_v: Vector2D.y27()};
            var emittedCount_0 = {_v: 0};
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

            var ratio_1 = Companion_getInstance_9().kx_1;
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

            lastPos_0._v = Companion_getInstance_1().t3b(l, c0, c1, a_1, ratio_1);
            var nStart_0 = false ? 0 : 1;
            var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
            var inductionVariable_0 = nStart_0;
            if (inductionVariable_0 <= nEnd_0)
              do {
                var n_2 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                var it_2 = Companion_getInstance_1().t3b(l, c0, c1, a_1, ratio_2);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                var x_2 = it_2.fl();
                var y_2 = it_2.gl();
                this.v5v_1.k5w_1.p3m(x_2, y_2, false);
                emittedCount_0._v = emittedCount_0._v + 1 | 0;
                lastPos_0._v = prevPos_0._v;
                prevPos_0._v = it_2;
              }
               while (!(n_2 === nEnd_0));
            l = a_1;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 4:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var destruct = i;
            var x_3 = destruct.fl();
            var y_3 = destruct.gl();
            this.v5v_1.k5w_1.p3m(x_3, y_3, false);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            if (true) {
              this.v5v_1.k5w_1.c6();
            }

            break;
        }
      }
      // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
      if (false) {
        this.v5v_1.k5w_1.c6();
      }
    }
    var tmp_8 = this.v5v_1.j5w_1;
    tmp_8.m3l_1 = winding == null ? ensureNotNull(state.p4q_1).z3d_1 : winding;
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i_0 = Vector2D.y27();
    var l_0 = Vector2D.y27();
    // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
    if (false) {
      this.v5v_1.j5w_1.c6();
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n_3 = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_2 = fillPath.x3d_1;
    var n_4 = 0;
    while (n_4 < this_2.e1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz_14 = n_4;
      n_4 = _unary__edvuaz_14 + 1 | 0;
      switch (this_2.qx(_unary__edvuaz_14)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_15 = n_3;
          n_3 = _unary__edvuaz_15 + 1 | 0;
          var tmp_9 = fillPath.y3d_1.d1(_unary__edvuaz_15);
          var _unary__edvuaz_16 = n_3;
          n_3 = _unary__edvuaz_16 + 1 | 0;
          var it_3 = Vector2D.n27(tmp_9, fillPath.y3d_1.d1(_unary__edvuaz_16));
          i_0 = it_3;
          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var x_4 = it_3.fl();
          var y_4 = it_3.gl();
          if (doingStroke) {
            if (true) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.v5v_1.j5w_1.p3m(x_4, y_4, true);
          l_0 = it_3;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_17 = n_3;
          n_3 = _unary__edvuaz_17 + 1 | 0;
          var tmp_10 = fillPath.y3d_1.d1(_unary__edvuaz_17);
          var _unary__edvuaz_18 = n_3;
          n_3 = _unary__edvuaz_18 + 1 | 0;
          var it_4 = Vector2D.n27(tmp_10, fillPath.y3d_1.d1(_unary__edvuaz_18));
          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var x_5 = it_4.fl();
          var y_5 = it_4.gl();
          if (doingStroke) {
            if (false) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.v5v_1.j5w_1.p3m(x_5, y_5, false);
          l_0 = it_4;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_19 = n_3;
          n_3 = _unary__edvuaz_19 + 1 | 0;
          var tmp_11 = fillPath.y3d_1.d1(_unary__edvuaz_19);
          var _unary__edvuaz_20 = n_3;
          n_3 = _unary__edvuaz_20 + 1 | 0;
          var c_0 = Vector2D.n27(tmp_11, fillPath.y3d_1.d1(_unary__edvuaz_20));
          var _unary__edvuaz_21 = n_3;
          n_3 = _unary__edvuaz_21 + 1 | 0;
          var tmp_12 = fillPath.y3d_1.d1(_unary__edvuaz_21);
          var _unary__edvuaz_22 = n_3;
          n_3 = _unary__edvuaz_22 + 1 | 0;
          var a_3 = Vector2D.n27(tmp_12, fillPath.y3d_1.d1(_unary__edvuaz_22));
          var sum_1 = Companion_getInstance_6().q2g(l_0, c_0) + Companion_getInstance_6().q2g(c_0, a_3);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_4 = numberToInt(sum_1);
          var rcurveSteps_1 = Math.max(a_4, 20);
          var dt_1 = 1.0 / rcurveSteps_1;
          var lastPos_1 = {_v: Vector2D.y27()};
          var prevPos_1 = {_v: Vector2D.y27()};
          var emittedCount_1 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_3 = Companion_getInstance_9().kx_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_1._v = Companion_getInstance_1().u3b(l_0, c_0, a_3, ratio_3);
          var nStart_1 = false ? 0 : 1;
          var nEnd_1 = true ? rcurveSteps_1 : rcurveSteps_1 - 1 | 0;
          var inductionVariable_1 = nStart_1;
          if (inductionVariable_1 <= nEnd_1)
            do {
              var n_5 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var ratio_4 = _Ratio___init__impl__9mwvn2_0(n_5 * dt_1);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_5 = Companion_getInstance_1().u3b(l_0, c_0, a_3, ratio_4);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
              var x_6 = it_5.fl();
              var y_6 = it_5.gl();
              if (doingStroke) {
                if (false) {
                  renderFinal$flush(this, filler, state, winding, fillPath);
                }
              }
              this.v5v_1.j5w_1.p3m(x_6, y_6, false);
              emittedCount_1._v = emittedCount_1._v + 1 | 0;
              lastPos_1._v = prevPos_1._v;
              prevPos_1._v = it_5;
            }
             while (!(n_5 === nEnd_1));
          l_0 = a_3;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_23 = n_3;
          n_3 = _unary__edvuaz_23 + 1 | 0;
          var tmp_13 = fillPath.y3d_1.d1(_unary__edvuaz_23);
          var _unary__edvuaz_24 = n_3;
          n_3 = _unary__edvuaz_24 + 1 | 0;
          var c0_0 = Vector2D.n27(tmp_13, fillPath.y3d_1.d1(_unary__edvuaz_24));
          var _unary__edvuaz_25 = n_3;
          n_3 = _unary__edvuaz_25 + 1 | 0;
          var tmp_14 = fillPath.y3d_1.d1(_unary__edvuaz_25);
          var _unary__edvuaz_26 = n_3;
          n_3 = _unary__edvuaz_26 + 1 | 0;
          var c1_0 = Vector2D.n27(tmp_14, fillPath.y3d_1.d1(_unary__edvuaz_26));
          var _unary__edvuaz_27 = n_3;
          n_3 = _unary__edvuaz_27 + 1 | 0;
          var tmp_15 = fillPath.y3d_1.d1(_unary__edvuaz_27);
          var _unary__edvuaz_28 = n_3;
          n_3 = _unary__edvuaz_28 + 1 | 0;
          var a_5 = Vector2D.n27(tmp_15, fillPath.y3d_1.d1(_unary__edvuaz_28));
          var sum_2 = Companion_getInstance_6().q2g(l_0, c0_0) + Companion_getInstance_6().q2g(c0_0, c1_0) + Companion_getInstance_6().q2g(c1_0, a_5);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_6 = numberToInt(sum_2);
          var rcurveSteps_2 = Math.max(a_6, 20);
          var dt_2 = 1.0 / rcurveSteps_2;
          var lastPos_2 = {_v: Vector2D.y27()};
          var prevPos_2 = {_v: Vector2D.y27()};
          var emittedCount_2 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_5 = Companion_getInstance_9().kx_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_2._v = Companion_getInstance_1().t3b(l_0, c0_0, c1_0, a_5, ratio_5);
          var nStart_2 = false ? 0 : 1;
          var nEnd_2 = true ? rcurveSteps_2 : rcurveSteps_2 - 1 | 0;
          var inductionVariable_2 = nStart_2;
          if (inductionVariable_2 <= nEnd_2)
            do {
              var n_6 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var ratio_6 = _Ratio___init__impl__9mwvn2_0(n_6 * dt_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_6 = Companion_getInstance_1().t3b(l_0, c0_0, c1_0, a_5, ratio_6);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
              var x_7 = it_6.fl();
              var y_7 = it_6.gl();
              if (doingStroke) {
                if (false) {
                  renderFinal$flush(this, filler, state, winding, fillPath);
                }
              }
              this.v5v_1.j5w_1.p3m(x_7, y_7, false);
              emittedCount_2._v = emittedCount_2._v + 1 | 0;
              lastPos_2._v = prevPos_2._v;
              prevPos_2._v = it_6;
            }
             while (!(n_6 === nEnd_2));
          l_0 = a_5;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var destruct_0 = i_0;
          var x_8 = destruct_0.fl();
          var y_8 = destruct_0.gl();
          if (doingStroke) {
            if (false) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.v5v_1.j5w_1.p3m(x_8, y_8, false);
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          if (true) {
            this.v5v_1.j5w_1.c6();
          }

          break;
      }
    }
    // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
    if (false) {
      this.v5v_1.j5w_1.c6();
    }
    renderFinal$flush(this, filler, state, winding, fillPath);
  }
}
class CompositeOperation$Companion$invoke$1 {
  constructor($func) {
    this.a5x_1 = $func;
  }
  f5w(dst, dstN, src, srcN, count) {
    return this.a5x_1(new RgbaPremultipliedArray(dst), dstN, new RgbaPremultipliedArray(src), srcN, count);
  }
}
class Companion_33 {
  constructor() {
    Companion_instance_39 = this;
    var tmp = this;
    var tmp_0 = Companion_getInstance_49();
    tmp.b5x_1 = tmp_0.c5x(CompositeOperation$Companion$UNIMPLEMENTED$lambda);
  }
  c5x(func) {
    return new CompositeOperation$Companion$invoke$1(func);
  }
}
class Companion_34 {
  h3p() {
    return CompositeMode_SOURCE_OVER_getInstance();
  }
}
class CompositeMode extends Enum {
  constructor(name, ordinal, op) {
    super(name, ordinal);
    this.f5x_1 = op;
  }
  f5w(dst, dstN, src, srcN, count) {
    this.f5x_1.f5w(dst, dstN, src, srcN, count);
  }
}
class BlendMode extends Enum {}
class State {
  constructor(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) {
    transform = transform === VOID ? Companion_getInstance_5().x28_1 : transform;
    clip = clip === VOID ? null : clip;
    path = path === VOID ? new VectorPath() : path;
    lineScaleMode = lineScaleMode === VOID ? LineScaleMode_NORMAL_getInstance() : lineScaleMode;
    lineWidth = lineWidth === VOID ? 1.0 : lineWidth;
    startLineCap = startLineCap === VOID ? LineCap_BUTT_getInstance() : startLineCap;
    endLineCap = endLineCap === VOID ? LineCap_BUTT_getInstance() : endLineCap;
    lineJoin = lineJoin === VOID ? LineJoin_MITER_getInstance() : lineJoin;
    miterLimit = miterLimit === VOID ? 10.0 : miterLimit;
    strokeStyle = strokeStyle === VOID ? new RGBA(get_DefaultPaint()) : strokeStyle;
    fillStyle = fillStyle === VOID ? new RGBA(get_DefaultPaint()) : fillStyle;
    fontRegistry = fontRegistry === VOID ? null : fontRegistry;
    font = font === VOID ? null : font;
    fontSize = fontSize === VOID ? 24.0 : fontSize;
    verticalAlign = verticalAlign === VOID ? Companion_getInstance_46().f5t_1 : verticalAlign;
    horizontalAlign = horizontalAlign === VOID ? Companion_getInstance_47().x5s_1 : horizontalAlign;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    globalCompositeOperation = globalCompositeOperation === VOID ? CompositeMode_SOURCE_OVER_getInstance() : globalCompositeOperation;
    lineDash = lineDash === VOID ? null : lineDash;
    lineDashOffset = lineDashOffset === VOID ? 0.0 : lineDashOffset;
    this.n4q_1 = transform;
    this.o4q_1 = clip;
    this.p4q_1 = path;
    this.q4q_1 = lineScaleMode;
    this.r4q_1 = lineWidth;
    this.s4q_1 = startLineCap;
    this.t4q_1 = endLineCap;
    this.u4q_1 = lineJoin;
    this.v4q_1 = miterLimit;
    this.w4q_1 = strokeStyle;
    this.x4q_1 = fillStyle;
    this.y4q_1 = fontRegistry;
    this.z4q_1 = font;
    this.a4r_1 = fontSize;
    this.b4r_1 = verticalAlign;
    this.c4r_1 = horizontalAlign;
    this.d4r_1 = globalAlpha;
    this.e4r_1 = globalCompositeOperation;
    this.f4r_1 = lineDash;
    this.g4r_1 = lineDashOffset;
    var tmp = this;
    tmp.h4r_1 = lazy(Context2d$State$transformTransform$delegate$lambda(this));
  }
  g5x() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.h4r_1;
    transformTransform$factory();
    return this_0.r1();
  }
  t5w() {
    var tmp = this.r4q_1;
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = this.g5x().i2b();
    return tmp * Math.abs(this_0);
  }
  a4z(value) {
    this.s4q_1 = value;
    this.t4q_1 = value;
  }
  t4y() {
    return this.s4q_1;
  }
  sx() {
    var tmp = this.n4q_1;
    var tmp319_safe_receiver = this.o4q_1;
    var tmp_0 = tmp319_safe_receiver == null ? null : tmp319_safe_receiver.sx();
    var tmp_1 = this.p4q_1.sx();
    var tmp320_safe_receiver = this.f4r_1;
    return this.h5x(tmp, tmp_0, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp320_safe_receiver == null ? null : tmp320_safe_receiver.sx());
  }
  i5x(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) {
    return new State(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset);
  }
  h5x(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset, $super) {
    transform = transform === VOID ? this.n4q_1 : transform;
    clip = clip === VOID ? this.o4q_1 : clip;
    path = path === VOID ? this.p4q_1 : path;
    lineScaleMode = lineScaleMode === VOID ? this.q4q_1 : lineScaleMode;
    lineWidth = lineWidth === VOID ? this.r4q_1 : lineWidth;
    startLineCap = startLineCap === VOID ? this.s4q_1 : startLineCap;
    endLineCap = endLineCap === VOID ? this.t4q_1 : endLineCap;
    lineJoin = lineJoin === VOID ? this.u4q_1 : lineJoin;
    miterLimit = miterLimit === VOID ? this.v4q_1 : miterLimit;
    strokeStyle = strokeStyle === VOID ? this.w4q_1 : strokeStyle;
    fillStyle = fillStyle === VOID ? this.x4q_1 : fillStyle;
    fontRegistry = fontRegistry === VOID ? this.y4q_1 : fontRegistry;
    font = font === VOID ? this.z4q_1 : font;
    fontSize = fontSize === VOID ? this.a4r_1 : fontSize;
    verticalAlign = verticalAlign === VOID ? this.b4r_1 : verticalAlign;
    horizontalAlign = horizontalAlign === VOID ? this.c4r_1 : horizontalAlign;
    globalAlpha = globalAlpha === VOID ? this.d4r_1 : globalAlpha;
    globalCompositeOperation = globalCompositeOperation === VOID ? this.e4r_1 : globalCompositeOperation;
    lineDash = lineDash === VOID ? this.f4r_1 : lineDash;
    lineDashOffset = lineDashOffset === VOID ? this.g4r_1 : lineDashOffset;
    return $super === VOID ? this.i5x(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) : $super.i5x.call(this, transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, new VerticalAlign(verticalAlign), new HorizontalAlign(horizontalAlign), globalAlpha, globalCompositeOperation, lineDash, lineDashOffset);
  }
  toString() {
    return 'State(transform=' + this.n4q_1.toString() + ', clip=' + toString(this.o4q_1) + ', path=' + this.p4q_1.toString() + ', lineScaleMode=' + this.q4q_1.toString() + ', lineWidth=' + this.r4q_1 + ', startLineCap=' + this.s4q_1.toString() + ', endLineCap=' + this.t4q_1.toString() + ', lineJoin=' + this.u4q_1.toString() + ', miterLimit=' + this.v4q_1 + ', strokeStyle=' + toString_0(this.w4q_1) + ', fillStyle=' + toString_0(this.x4q_1) + ', fontRegistry=' + toString(this.y4q_1) + ', font=' + toString(this.z4q_1) + ', fontSize=' + this.a4r_1 + ', verticalAlign=' + VerticalAlign__toString_impl_hcpnn2(this.b4r_1) + ', horizontalAlign=' + HorizontalAlign__toString_impl_toflc0(this.c4r_1) + ', globalAlpha=' + this.d4r_1 + ', globalCompositeOperation=' + toString_0(this.e4r_1) + ', lineDash=' + toString(this.f4r_1) + ', lineDashOffset=' + this.g4r_1 + ')';
  }
  hashCode() {
    var result = this.n4q_1.hashCode();
    result = imul(result, 31) + (this.o4q_1 == null ? 0 : this.o4q_1.hashCode()) | 0;
    result = imul(result, 31) + this.p4q_1.hashCode() | 0;
    result = imul(result, 31) + this.q4q_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.r4q_1) | 0;
    result = imul(result, 31) + this.s4q_1.hashCode() | 0;
    result = imul(result, 31) + this.t4q_1.hashCode() | 0;
    result = imul(result, 31) + this.u4q_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.v4q_1) | 0;
    result = imul(result, 31) + hashCode(this.w4q_1) | 0;
    result = imul(result, 31) + hashCode(this.x4q_1) | 0;
    result = imul(result, 31) + (this.y4q_1 == null ? 0 : hashCode(this.y4q_1)) | 0;
    result = imul(result, 31) + (this.z4q_1 == null ? 0 : hashCode(this.z4q_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.a4r_1) | 0;
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.b4r_1) | 0;
    result = imul(result, 31) + HorizontalAlign__hashCode_impl_7x9oj5(this.c4r_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d4r_1) | 0;
    result = imul(result, 31) + hashCode(this.e4r_1) | 0;
    result = imul(result, 31) + (this.f4r_1 == null ? 0 : hashCode(this.f4r_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.g4r_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof State))
      return false;
    var tmp0_other_with_cast = other instanceof State ? other : THROW_CCE();
    if (!this.n4q_1.equals(tmp0_other_with_cast.n4q_1))
      return false;
    if (!equals(this.o4q_1, tmp0_other_with_cast.o4q_1))
      return false;
    if (!this.p4q_1.equals(tmp0_other_with_cast.p4q_1))
      return false;
    if (!this.q4q_1.equals(tmp0_other_with_cast.q4q_1))
      return false;
    if (!equals(this.r4q_1, tmp0_other_with_cast.r4q_1))
      return false;
    if (!this.s4q_1.equals(tmp0_other_with_cast.s4q_1))
      return false;
    if (!this.t4q_1.equals(tmp0_other_with_cast.t4q_1))
      return false;
    if (!this.u4q_1.equals(tmp0_other_with_cast.u4q_1))
      return false;
    if (!equals(this.v4q_1, tmp0_other_with_cast.v4q_1))
      return false;
    if (!equals(this.w4q_1, tmp0_other_with_cast.w4q_1))
      return false;
    if (!equals(this.x4q_1, tmp0_other_with_cast.x4q_1))
      return false;
    if (!equals(this.y4q_1, tmp0_other_with_cast.y4q_1))
      return false;
    if (!equals(this.z4q_1, tmp0_other_with_cast.z4q_1))
      return false;
    if (!equals(this.a4r_1, tmp0_other_with_cast.a4r_1))
      return false;
    if (!equals(this.b4r_1, tmp0_other_with_cast.b4r_1))
      return false;
    if (!equals(this.c4r_1, tmp0_other_with_cast.c4r_1))
      return false;
    if (!equals(this.d4r_1, tmp0_other_with_cast.d4r_1))
      return false;
    if (!equals(this.e4r_1, tmp0_other_with_cast.e4r_1))
      return false;
    if (!equals(this.f4r_1, tmp0_other_with_cast.f4r_1))
      return false;
    if (!equals(this.g4r_1, tmp0_other_with_cast.g4r_1))
      return false;
    return true;
  }
}
class Context2d {
  constructor(renderer, defaultFontRegistry, defaultFont) {
    defaultFontRegistry = defaultFontRegistry === VOID ? null : defaultFontRegistry;
    defaultFont = defaultFont === VOID ? null : defaultFont;
    this.j45_1 = renderer;
    this.k45_1 = defaultFontRegistry;
    this.l45_1 = defaultFont;
    this.m45_1 = new State(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.k45_1, this.l45_1);
    this.n45_1 = _TGenStack___init__impl__yynjgt();
    this.o45_1 = Vector2D.y27();
    this.p45_1 = Vector2D.y27();
  }
  j5x() {
    return this.j45_1.m2i();
  }
  k5x() {
    return this.j45_1.n2i();
  }
  l5x(state, fill, winding) {
    return this.j45_1.w5w(state, fill, winding);
  }
  m5x(state, fill, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.l5x(state, fill, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.l5x.call(this, state, fill, winding);
    }
    return tmp;
  }
  n5x(image, pos, size, transform) {
    return this.j45_1.z5w(image, pos, size, transform);
  }
  o5x() {
    return this.j45_1.d18();
  }
  p5x() {
    return this.j45_1.u5w();
  }
  q5x() {
    return this.j45_1.v5w();
  }
  m2i() {
    return this.j5x();
  }
  n2i() {
    return this.k5x();
  }
  d18() {
    this.o5x();
  }
  r5x() {
    return this.p5x();
  }
  s5x() {
    return this.q5x();
  }
  t5x(value) {
    this.m45_1.q4q_1 = value;
  }
  z4y(value) {
    this.m45_1.r4q_1 = value;
  }
  s4y() {
    return this.m45_1.r4q_1;
  }
  a4z(value) {
    this.m45_1.a4z(value);
  }
  t4y() {
    return this.m45_1.t4y();
  }
  c4z(value) {
    this.m45_1.v4q_1 = value;
  }
  v4y() {
    return this.m45_1.v4q_1;
  }
  u5x(value) {
    this.m45_1.s4q_1 = value;
  }
  v5x(value) {
    this.m45_1.t4q_1 = value;
  }
  b4z(value) {
    this.m45_1.u4q_1 = value;
  }
  u4y() {
    return this.m45_1.u4q_1;
  }
  w5x(value) {
    this.m45_1.w4q_1 = value;
  }
  x5x() {
    return this.m45_1.w4q_1;
  }
  k4r(value) {
    this.m45_1.x4q_1 = value;
  }
  j4r() {
    return this.m45_1.x4q_1;
  }
  t50() {
    return this.m45_1.z4q_1;
  }
  f4p() {
    return this.m45_1.a4r_1;
  }
  s5u() {
    return this.m45_1.b4r_1;
  }
  y5x() {
    return this.m45_1.c4r_1;
  }
  z5x() {
    return Companion_getInstance_48().k5t(this.y5x(), this.s5u());
  }
  d4z(value) {
    this.m45_1.f4r_1 = value;
  }
  w4y() {
    return this.m45_1.f4r_1;
  }
  e4z(value) {
    this.m45_1.g4r_1 = value;
  }
  x4y() {
    return this.m45_1.g4r_1;
  }
  y4y() {
    TGenStack__push_impl_9yh33t(this.n45_1, this.m45_1.sx());
  }
  g4z() {
    this.m45_1 = TGenStack__pop_impl_qisxa0(this.n45_1);
  }
  m5h(sx, sy) {
    this.m45_1.n4q_1 = this.m45_1.n4q_1.z29(sx, sy);
  }
  i4r(sx, sy, $super) {
    sy = sy === VOID ? sx : sy;
    var tmp;
    if ($super === VOID) {
      this.m5h(sx, sy);
      tmp = Unit_instance;
    } else {
      tmp = $super.m5h.call(this, sx, sy);
    }
    return tmp;
  }
  q50(tx, ty) {
    this.m45_1.n4q_1 = this.m45_1.n4q_1.h2a(tx, ty);
  }
  s50(m) {
    this.m45_1.n4q_1 = this.m45_1.n4q_1.i2a(m);
  }
  a5y(_set____db54di) {
    this.o45_1 = _set____db54di;
  }
  b5y() {
    return this.o45_1;
  }
  c5y(_set____db54di) {
    this.p45_1 = _set____db54di;
  }
  w3o() {
    return this.p45_1;
  }
  v3o() {
    return this.m45_1.p4q_1.v3o();
  }
  c6() {
    this.m45_1.p4q_1.c6();
    this.c5y(this.b5y());
  }
  u3d(p) {
    this.m45_1.p4q_1.u3d(trans(this, p));
    this.c5y(p);
    this.a5y(p);
  }
  h3e(p) {
    this.m45_1.p4q_1.h3e(trans(this, p));
    this.c5y(p);
  }
  i3e(c, a) {
    this.m45_1.p4q_1.i3e(trans(this, c), trans(this, a));
    this.c5y(a);
  }
  v3d(c1, c2, a) {
    this.m45_1.p4q_1.v3d(trans(this, c1), trans(this, c2), trans(this, a));
    this.c5y(a);
  }
  l5h(path) {
    if (this.g1())
      this.m45_1.p4q_1.z3d_1 = path.z3d_1;
    write_0(this, path);
  }
  k51(d) {
    d.j51(this);
  }
  l4r(x, y, width, height) {
    this.f4x();
    this.a3p(x, y, width, height);
    this.o4y();
  }
  f4x() {
    this.m45_1.p4q_1 = new VectorPath();
  }
  n4y() {
    if (!equals(this.m45_1.w4q_1, NonePaint_instance)) {
      this.m5x(this.m45_1, false);
    }
  }
  d5y(winding) {
    if (!equals(this.m45_1.x4q_1, NonePaint_instance)) {
      this.l5x(this.m45_1, true, winding);
    }
  }
  o4y(winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.d5y(winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.d5y.call(this, winding);
    }
    return tmp;
  }
  e5y(paint, winding) {
    if (paint == null)
      return Unit_instance;
    // Inline function 'korlibs.image.vector.Context2d.fillStyle' call
    var oldStyle = this.j4r();
    this.k4r(paint);
    try {
      // Inline function 'korlibs.image.vector.Context2d.fill.<anonymous>' call
      this.d5y(winding);
    }finally {
      this.k4r(oldStyle);
    }
  }
  r4y(paint, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.e5y(paint, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.e5y.call(this, paint, winding);
    }
    return tmp;
  }
  f4z(paint) {
    // Inline function 'korlibs.image.vector.Context2d.strokeStyle' call
    var oldStyle = this.x5x();
    this.w5x(paint);
    try {
      // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
      this.n4y();
    }finally {
      this.w5x(oldStyle);
    }
  }
  f5y(path, winding) {
    if (!(path == null)) {
      if (this.m45_1.o4q_1 == null) {
        this.m45_1.o4q_1 = new VectorPath();
      }
      ensureNotNull(this.m45_1.o4q_1).h3();
      ensureNotNull(this.m45_1.o4q_1).z3d_1 = winding;
      ensureNotNull(this.m45_1.o4q_1).v3p(path);
      if (path === this.m45_1.p4q_1) {
        path.h3();
      }
    } else {
      this.m45_1.o4q_1 = null;
    }
  }
  g5y(path, winding, $super) {
    path = path === VOID ? this.m45_1.p4q_1 : path;
    winding = winding === VOID ? Winding_NON_ZERO_getInstance() : winding;
    var tmp;
    if ($super === VOID) {
      this.f5y(path, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.f5y.call(this, path, winding);
    }
    return tmp;
  }
  h5y(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd) {
    var paint_0 = paint == null ? fill ? this.j4r() : this.x5x() : paint;
    return font == null ? null : drawText(font, this, size, text, paint_0, pos, fill, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd);
  }
  t5s(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd, $super) {
    pos = pos === VOID ? Companion_getInstance_6().g25_1 : pos;
    fill = fill === VOID ? true : fill;
    paint = paint === VOID ? null : paint;
    font = font === VOID ? this.t50() : font;
    size = size === VOID ? this.f4p() : size;
    var tmp;
    if (renderer === VOID) {
      var tmp_0 = get_DefaultStringTextRenderer();
      tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
    } else {
      tmp = renderer;
    }
    renderer = tmp;
    align = align === VOID ? this.z5x() : align;
    outMetrics = outMetrics === VOID ? null : outMetrics;
    fillStyle = fillStyle === VOID ? null : fillStyle;
    stroke = stroke === VOID ? null : stroke;
    textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
    textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
    return $super === VOID ? this.h5y(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd) : $super.h5y.call(this, text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd);
  }
  m4r(image, pos, size) {
    return this.n5x(image, pos, size, this.m45_1.n4q_1);
  }
  b5n(image, pos, size, $super) {
    size = size === VOID ? toFloat(image.e1()) : size;
    var tmp;
    if ($super === VOID) {
      this.m4r(image, pos, size);
      tmp = Unit_instance;
    } else {
      tmp = $super.m4r.call(this, image, pos, size);
    }
    return tmp;
  }
}
class Companion_35 {
  constructor() {
    Companion_instance_41 = this;
    this.i5y_1 = values_6();
  }
}
class CycleMethod extends Enum {
  d5q() {
    return !this.equals(CycleMethod_NO_CYCLE_getInstance()) && !this.equals(CycleMethod_NO_CYCLE_CLAMP_getInstance());
  }
  a5q(ratio) {
    var tmp;
    switch (this.n3_1) {
      case 0:
        tmp = ratio;
        break;
      case 1:
        tmp = clamp01_0(ratio);
        break;
      case 2:
        // Inline function 'korlibs.math.fract' call

        tmp = ratio - toIntFloor(ratio);
        break;
      case 3:
        var part = umod(ratio, 2.0);
        tmp = part > 1.0 ? 2.0 - part : part;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  j5y(ratio) {
    return this.a5q(ratio);
  }
}
class ColorizedBeziers {
  constructor(beziers) {
    this.k5y_1 = beziers;
    var tmp = this;
    tmp.l5y_1 = lazy(ColorizedBeziers$red$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.m5y_1 = lazy(ColorizedBeziers$green$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.n5y_1 = lazy(ColorizedBeziers$blue$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.o5y_1 = lazy(ColorizedBeziers$allProjected$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.p5y_1 = lazy(ColorizedBeziers$redProjected$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.q5y_1 = lazy(ColorizedBeziers$greenProjected$delegate$lambda(this));
    var tmp_5 = this;
    tmp_5.r5y_1 = lazy(ColorizedBeziers$blueProjected$delegate$lambda(this));
  }
  c5z() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.l5y_1;
    red$factory();
    return this_0.r1();
  }
  d5z() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m5y_1;
    green$factory();
    return this_0.r1();
  }
  e5z() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.n5y_1;
    blue$factory();
    return this_0.r1();
  }
  s5y() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o5y_1;
    allProjected$factory();
    return this_0.r1();
  }
  x5y() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p5y_1;
    redProjected$factory();
    return this_0.r1();
  }
  y5y() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q5y_1;
    greenProjected$factory();
    return this_0.r1();
  }
  z5y() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.r5y_1;
    blueProjected$factory();
    return this_0.r1();
  }
}
class ColoredBezier {
  constructor(bezier, color) {
    this.a5z_1 = bezier;
    this.b5z_1 = color;
  }
  toString() {
    return 'ColoredBezier(bezier=' + this.a5z_1.toString() + ', color=' + RGBA__toString_impl_4lw6dp(this.b5z_1) + ')';
  }
  hashCode() {
    var result = this.a5z_1.hashCode();
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.b5z_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColoredBezier))
      return false;
    var tmp0_other_with_cast = other instanceof ColoredBezier ? other : THROW_CCE();
    if (!this.a5z_1.equals(tmp0_other_with_cast.a5z_1))
      return false;
    if (!(this.b5z_1 === tmp0_other_with_cast.b5z_1))
      return false;
    return true;
  }
}
class ProjectCurvesLookup {
  constructor(beziers) {
    this.t5y_1 = beziers;
    this.u5y_1 = new ProjectedPoint();
    this.v5y_1 = Companion_getInstance_2().a29();
  }
  w5y(point) {
    return Companion_getInstance_6().q2g(point, this.a3d(point));
  }
  a3d(point) {
    if (this.t5y_1.g1())
      return Vector2D.a28(0, 0);
    var minDistSq = Infinity;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.t5y_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.image.vector.ProjectCurvesLookup.closest.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var dist = this_0.d1(_unary__edvuaz).l3c().y26(point);
      if (dist < minDistSq) {
        minDistSq = dist;
      }
    }
    var bminDistSq = Infinity;
    var out = Vector2D.y27();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.t5y_1;
    var n_0 = 0;
    while (n_0 < this_1.e1()) {
      $l$block: {
        // Inline function 'korlibs.image.vector.ProjectCurvesLookup.closest.<anonymous>' call
        var _unary__edvuaz_0 = n_0;
        n_0 = _unary__edvuaz_0 + 1 | 0;
        var it = this_1.d1(_unary__edvuaz_0);
        if (it.l3c().x26(point) > minDistSq) {
          break $l$block;
        }
        it.y3c(point, this.u5y_1);
        if (this.u5y_1.o3b_1 < bminDistSq) {
          bminDistSq = this.u5y_1.o3b_1;
          out = this.u5y_1.m3b_1;
        }
      }
    }
    return out;
  }
}
class Shape {}
function getPath(path) {
  return path;
}
function getPath$default(path, $super) {
  path = path === VOID ? new VectorPath() : path;
  return $super === VOID ? this.f5z(path) : getPath(path);
}
function get_bounds() {
  return this.g5z(true);
}
class StyledShape {}
function get_path() {
  return null;
}
function getBounds(includeStrokes) {
  var tmp345_safe_receiver = this.o21();
  var tmp;
  if (tmp345_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.StyledShape.getBounds.<anonymous>' call
    tmp = _BoundsBuilder___get_bounds__impl__s1l1gx(plus_2(Companion_getInstance_7().e26(), tmp345_safe_receiver));
  }
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? Companion_getInstance_4().d26() : tmp0_elvis_lhs;
}
function getPath_0(path) {
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.StyledShape.getPath.<anonymous>' call
  var tmp347_safe_receiver = this.o21();
  if (tmp347_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    path.v3p(tmp347_safe_receiver);
  }
  return path;
}
function draw(c) {
  // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
  var t = c.m45_1.n4q_1;
  try {
    // Inline function 'korlibs.image.vector.StyledShape.draw.<anonymous>' call
    c.f4x();
    var tmp348_safe_receiver = this.o21();
    if (tmp348_safe_receiver == null)
      null;
    else {
      draw_0(tmp348_safe_receiver, c);
    }
    if (!(this.o5z() == null)) {
      draw_0(ensureNotNull(this.o5z()), c);
      c.g5y();
    }
    c.s50(get_immutable(this.r50()));
    this.s5z(c);
  }finally {
    c.m45_1.n4q_1 = t;
  }
}
function drawInternal(c) {
}
class FillShape {
  constructor(path, clip, paint, transform, globalAlpha) {
    transform = transform === VOID ? Companion_getInstance_5().x28_1 : transform;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.h5z_1 = path;
    this.i5z_1 = clip;
    this.j5z_1 = paint;
    this.k5z_1 = transform;
    this.l5z_1 = globalAlpha;
    var tmp = this;
    tmp.m5z_1 = lazy(FillShape$pathCurvesList$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.n5z_1 = lazy(FillShape$clipCurvesList$delegate$lambda(this));
  }
  o21() {
    return this.h5z_1;
  }
  o5z() {
    return this.i5z_1;
  }
  r50() {
    return this.k5z_1;
  }
  p5z() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m5z_1;
    pathCurvesList$factory();
    return this_0.r1();
  }
  q5z() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.n5z_1;
    clipCurvesList$factory();
    return this_0.r1();
  }
  r5z() {
    return this.p5z().e1() === 1 && get_isConvex(first_0(this.p5z())) && this.q5z() == null;
  }
  s5z(c) {
    c.e5y(this.j5z_1, this.h5z_1.z3d_1);
  }
  toString() {
    return 'FillShape(path=' + this.h5z_1.toString() + ', clip=' + toString(this.i5z_1) + ', paint=' + toString_0(this.j5z_1) + ', transform=' + this.k5z_1.toString() + ', globalAlpha=' + this.l5z_1 + ')';
  }
  hashCode() {
    var result = this.h5z_1.hashCode();
    result = imul(result, 31) + (this.i5z_1 == null ? 0 : this.i5z_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.j5z_1) | 0;
    result = imul(result, 31) + this.k5z_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.l5z_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FillShape))
      return false;
    var tmp0_other_with_cast = other instanceof FillShape ? other : THROW_CCE();
    if (!this.h5z_1.equals(tmp0_other_with_cast.h5z_1))
      return false;
    if (!equals(this.i5z_1, tmp0_other_with_cast.i5z_1))
      return false;
    if (!equals(this.j5z_1, tmp0_other_with_cast.j5z_1))
      return false;
    if (!this.k5z_1.equals(tmp0_other_with_cast.k5z_1))
      return false;
    if (!equals(this.l5z_1, tmp0_other_with_cast.l5z_1))
      return false;
    return true;
  }
}
class CompoundShape {
  constructor(components) {
    this.t5z_1 = components;
  }
  g5z(includeStrokes) {
    var bb = Companion_getInstance_7().e26();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.t5z_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.image.vector.CompoundShape.getBounds.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.d1(_unary__edvuaz);
      bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, it.g5z(includeStrokes));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  j51(c) {
    $l$block: {
      // Inline function 'korlibs.image.vector.Context2d.buffering' call
      c.r5x();
      try {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var this_0 = this.t5z_1;
        var n = 0;
        while (n < this_0.e1()) {
          // Inline function 'korlibs.image.vector.CompoundShape.draw.<anonymous>.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          this_0.d1(_unary__edvuaz).j51(c);
        }
        break $l$block;
      }finally {
        c.s5x();
      }
    }
    return Unit_instance;
  }
  f5z(path) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.CompoundShape.getPath.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.t5z_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.image.vector.CompoundShape.getPath.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.d1(_unary__edvuaz).f5z(path);
    }
    return path;
  }
  toString() {
    return 'CompoundShape(\n  ' + joinToString(this.t5z_1, ',\n  ') + '\n)';
  }
}
class PolylineShape {
  constructor(path, clip, paint, transform, strokeInfo, globalAlpha) {
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.v5z_1 = path;
    this.w5z_1 = clip;
    this.x5z_1 = paint;
    this.y5z_1 = transform;
    this.z5z_1 = strokeInfo;
    this.a60_1 = globalAlpha;
    this.b60_1 = thickness$factory(this.z5z_1);
    this.c60_1 = scaleMode$factory(this.z5z_1);
    this.d60_1 = startCap$factory(this.z5z_1);
    this.e60_1 = endCap$factory(this.z5z_1);
    this.f60_1 = join$factory(this.z5z_1);
    this.g60_1 = miterLimit$factory(this.z5z_1);
    this.h60_1 = dash$factory(this.z5z_1);
    this.i60_1 = dashOffset$factory(this.z5z_1);
    var tmp = this;
    tmp.j60_1 = lazy(PolylineShape$fillShape$delegate$lambda(this));
  }
  o21() {
    return this.v5z_1;
  }
  o5z() {
    return this.w5z_1;
  }
  r50() {
    return this.y5z_1;
  }
  g5z(includeStrokes) {
    var tmp352_safe_receiver = BoundsBuilder__boundsOrNull_impl_se9lyg(plus_2(Companion_getInstance_7().e26(), this.v5z_1));
    var bounds = tmp352_safe_receiver == null ? null : get_mutable(tmp352_safe_receiver);
    if (includeStrokes) {
      // Inline function 'kotlin.math.max' call
      var a = this.z5z_1.d38_1 / 2.0;
      var halfThickness = Math.max(a, 0.0);
      if (bounds == null)
        null;
      else
        bounds.r3r(halfThickness, halfThickness);
    }
    var tmp0_elvis_lhs = bounds == null ? null : bounds.a2e();
    return tmp0_elvis_lhs == null ? Companion_getInstance_4().a26_1 : tmp0_elvis_lhs;
  }
  k60(c) {
    c.t5x(this.z5z_1.f38_1);
    c.z4y(this.z5z_1.d38_1);
    c.u5x(this.z5z_1.g38_1);
    c.v5x(this.z5z_1.h38_1);
    c.b4z(this.z5z_1.i38_1);
    c.c4z(this.z5z_1.j38_1);
    c.d4z(this.z5z_1.k38_1);
    c.e4z(this.z5z_1.l38_1);
  }
  s5z(c) {
    this.k60(c);
    c.f4z(this.x5z_1);
  }
  toString() {
    return 'PolylineShape(path=' + this.v5z_1.toString() + ', clip=' + toString(this.w5z_1) + ', paint=' + toString_0(this.x5z_1) + ', transform=' + this.y5z_1.toString() + ', strokeInfo=' + this.z5z_1.toString() + ', globalAlpha=' + this.a60_1 + ')';
  }
  hashCode() {
    var result = this.v5z_1.hashCode();
    result = imul(result, 31) + (this.w5z_1 == null ? 0 : this.w5z_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.x5z_1) | 0;
    result = imul(result, 31) + this.y5z_1.hashCode() | 0;
    result = imul(result, 31) + this.z5z_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.a60_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PolylineShape))
      return false;
    var tmp0_other_with_cast = other instanceof PolylineShape ? other : THROW_CCE();
    if (!this.v5z_1.equals(tmp0_other_with_cast.v5z_1))
      return false;
    if (!equals(this.w5z_1, tmp0_other_with_cast.w5z_1))
      return false;
    if (!equals(this.x5z_1, tmp0_other_with_cast.x5z_1))
      return false;
    if (!this.y5z_1.equals(tmp0_other_with_cast.y5z_1))
      return false;
    if (!this.z5z_1.equals(tmp0_other_with_cast.z5z_1))
      return false;
    if (!equals(this.a60_1, tmp0_other_with_cast.a60_1))
      return false;
    return true;
  }
}
class TextShape {
  m60() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.l60_1;
    primitiveShapes$factory();
    return this_0.r1();
  }
}
class EmptyShape {
  g5z(includeStrokes) {
    return Companion_getInstance_4().d26();
  }
  j51(c) {
    return Unit_instance;
  }
}
class ShapeBuilder extends Context2d {
  constructor(width, height) {
    super(Companion_getInstance_52());
    var tmp = this;
    tmp.f4v_1 = width == null ? 256 : width;
    var tmp_0 = this;
    tmp_0.g4v_1 = height == null ? 256 : height;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_1.h4v_1 = ArrayList.h1();
  }
  j5x() {
    return this.f4v_1;
  }
  k5x() {
    return this.g4v_1;
  }
  l5x(state, fill, winding) {
    if (state.p4q_1.g1())
      return Unit_instance;
    // Inline function 'kotlin.also' call
    var this_0 = state.p4q_1.sx();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.ShapeBuilder.rendererRender.<anonymous>' call
    var tmp = this_0;
    tmp.z3d_1 = winding == null ? this_0.z3d_1 : winding;
    var path = this_0;
    var tmp367_safe_receiver = state.o4q_1;
    var tmp368_safe_receiver = tmp367_safe_receiver == null ? null : tmp367_safe_receiver.sx();
    var tmp_0;
    if (tmp368_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.vector.ShapeBuilder.rendererRender.<anonymous>' call
      var tmp_1 = tmp368_safe_receiver;
      tmp_1.z3d_1 = winding == null ? tmp368_safe_receiver.z3d_1 : winding;
      tmp_0 = tmp368_safe_receiver;
    }
    var clip = tmp_0;
    var transform = state.n4q_1;
    if (fill) {
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = this.h4v_1;
      var element = new FillShape(path, clip, state.x4q_1.sx(), transform, state.d4r_1);
      this_1.h(element);
    } else {
      // Inline function 'kotlin.collections.plusAssign' call
      var this_2 = this.h4v_1;
      var tmp_2 = state.w4q_1.sx();
      var tmp369_thickness = state.r4q_1;
      var tmp370_scaleMode = state.q4q_1;
      var tmp371_startCap = state.s4q_1;
      var tmp372_endCap = state.t4q_1;
      var tmp373_join = state.u4q_1;
      var tmp374_dash = state.f4r_1;
      var tmp375_dashOffset = state.g4r_1;
      var tmp376_miterLimit = state.v4q_1;
      var element_0 = new PolylineShape(path, clip, tmp_2, transform, new StrokeInfo(tmp369_thickness, true, tmp370_scaleMode, tmp371_startCap, tmp372_endCap, tmp373_join, tmp376_miterLimit, tmp374_dash, tmp375_dashOffset), state.d4r_1);
      this_2.h(element_0);
    }
  }
  n5x(image, pos, size, transform) {
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.ShapeBuilder.rendererDrawImage.<anonymous>' call
    this_0.z3o(pos, size);
    this.m5x(new State(transform, VOID, this_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new BitmapPaint(image, scaled(Companion_getInstance_5().x28_1, size.r2f(toFloat(image.e1()))).b2a(pos))), true);
  }
  o5x() {
  }
  p5x() {
    return 0;
  }
  q5x() {
  }
  i4v() {
    return this.h4v_1.e1() === 1 ? first_0(this.h4v_1) : new CompoundShape(toList(this.h4v_1));
  }
  j51(c) {
    c.k51(this.i4v());
  }
}
class SvgPath {
  u5z(path, separator, decimalPlaces) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var parts = ArrayList.h1();
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.x3d_1;
    var n_0 = 0;
    while (n_0 < this_0.e1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.qx(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.y3d_1.d1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.n27(tmp, path.y3d_1.d1(_unary__edvuaz_1));
          var x = destruct.fl();
          var y = destruct.gl();
          // Inline function 'kotlin.collections.plusAssign' call

          var element = 'M' + toSvgPathString$fixX(x, decimalPlaces) + ' ' + toSvgPathString$fixY(y, decimalPlaces);
          parts.h(element);
          break;
        case 1:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.y3d_1.d1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.n27(tmp_0, path.y3d_1.d1(_unary__edvuaz_3));
          var x_0 = destruct_0.fl();
          var y_0 = destruct_0.gl();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_0 = 'L' + toSvgPathString$fixX(x_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y_0, decimalPlaces);
          parts.h(element_0);
          break;
        case 2:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.y3d_1.d1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var destruct_1 = Vector2D.n27(tmp_1, path.y3d_1.d1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.y3d_1.d1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_2 = Vector2D.n27(tmp_2, path.y3d_1.d1(_unary__edvuaz_7));
          var x1 = destruct_1.fl();
          var y1 = destruct_1.gl();
          var x2 = destruct_2.fl();
          var y2 = destruct_2.gl();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_1 = 'Q' + toSvgPathString$fixX(x1, decimalPlaces) + ' ' + toSvgPathString$fixY(y1, decimalPlaces) + ', ' + toSvgPathString$fixX(x2, decimalPlaces) + ' ' + toSvgPathString$fixY(y2, decimalPlaces);
          parts.h(element_1);
          break;
        case 3:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.y3d_1.d1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var destruct_3 = Vector2D.n27(tmp_3, path.y3d_1.d1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.y3d_1.d1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var destruct_4 = Vector2D.n27(tmp_4, path.y3d_1.d1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.y3d_1.d1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_5 = Vector2D.n27(tmp_5, path.y3d_1.d1(_unary__edvuaz_13));
          var x1_0 = destruct_3.fl();
          var y1_0 = destruct_3.gl();
          var x2_0 = destruct_4.fl();
          var y2_0 = destruct_4.gl();
          var x3 = destruct_5.fl();
          var y3 = destruct_5.gl();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_2 = 'C' + toSvgPathString$fixX(x1_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y1_0, decimalPlaces) + ', ' + toSvgPathString$fixX(x2_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y2_0, decimalPlaces) + ', ' + toSvgPathString$fixX(x3, decimalPlaces) + ' ' + toSvgPathString$fixY(y3, decimalPlaces);
          parts.h(element_2);
          break;
        case 4:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          // Inline function 'kotlin.collections.plusAssign' call

          parts.h('Z');
          break;
      }
    }
    return joinToString(parts, '');
  }
}
class Rasterizer extends RastScale {
  constructor() {
    super();
    this.g5w_1 = false;
    this.h5w_1 = 2;
    this.i5w_1 = 1;
    this.j5w_1 = new PolygonScanline();
    this.k5w_1 = new PolygonScanline();
    this.l5w_1 = new IntSegmentSet();
    this.m5w_1 = new IntSegmentSet();
    this.n5w_1 = new IntSegmentSet();
    this.o5w_1 = IntArrayList.n2j(1024);
  }
  c2q() {
    this.j5w_1.c2q();
    this.k5w_1.c2q();
  }
  n60(bounds, quality, stats, winding, callback) {
    if (stats == null)
      null;
    else {
      stats.c2q();
    }
    var xmin = this.d3m(bounds.v25());
    var xmax = this.d3m(bounds.w25());
    var tempRect = this.j5w_1.l3a();
    // Inline function 'kotlin.math.max' call
    var a = bounds.x25();
    var b = tempRect.x25();
    var tmp$ret$0 = Math.max(a, b);
    var startY = this.d3m(tmp$ret$0);
    // Inline function 'kotlin.math.min' call
    var a_0 = bounds.y25();
    var b_0 = tempRect.y25();
    var tmp$ret$1 = Math.min(a_0, b_0);
    var endY = this.d3m(tmp$ret$1);
    var func = Rasterizer$rasterizeFill$lambda(xmax, xmin, this, callback);
    this.o5w_1.h3();
    var q = quality;
    var yCount = imul(((endY - startY | 0) / this.v3m() | 0) + 1 | 0, q);
    var inductionVariable = 0;
    var last = (yCount + q | 0) - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = startY + ((imul(n, this.v3m()) / this.i5w_1 | 0) / q | 0) | 0;
        this.o5w_1.t2j(y);
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>' call
    var edgesEmitted = 0;
    var edgesChecked = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.o5w_1;
    var n_0 = 0;
    while (n_0 < this_0.e1()) {
      // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      var y_0 = this_0.qx(_unary__edvuaz);
      this.j5w_1.q3m(y_0, winding, this.l5w_1);
      edgesChecked = edgesChecked + this.j5w_1.b3m_1 | 0;
      if (this.k5w_1.o27()) {
        this.k5w_1.q3m(y_0, this.k5w_1.m3l_1, this.m5w_1);
        edgesChecked = edgesChecked + this.k5w_1.b3m_1 | 0;
        this.n5w_1.c38(this.l5w_1, this.m5w_1);
      }
      // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
      var this_1 = this.k5w_1.o27() ? this.n5w_1 : this.l5w_1;
      var inductionVariable_0 = 0;
      var last_0 = this_1.e1();
      if (inductionVariable_0 < last_0)
        do {
          var n_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>.<anonymous>.<anonymous>' call
          func(this_1.u37_1.qx(n_1), this_1.v37_1.qx(n_1), y_0);
          edgesEmitted = edgesEmitted + 1 | 0;
        }
         while (inductionVariable_0 < last_0);
    }
    var tmp;
    if (stats == null) {
      tmp = null;
    } else {
      stats.r60(edgesChecked, edgesEmitted, yCount);
      tmp = Unit_instance;
    }
  }
  p5w(bounds, quality, stats, winding, callback, $super) {
    quality = quality === VOID ? this.h5w_1 : quality;
    stats = stats === VOID ? null : stats;
    winding = winding === VOID ? Winding_NON_ZERO_getInstance() : winding;
    var tmp;
    if ($super === VOID) {
      this.n60(bounds, quality, stats, winding, callback);
      tmp = Unit_instance;
    } else {
      tmp = $super.n60.call(this, bounds, quality, stats, winding, callback);
    }
    return tmp;
  }
}
class DummyRenderer extends Renderer {
  constructor(width, height) {
    Companion_getInstance_52();
    super();
    this.u60_1 = width;
    this.v60_1 = height;
  }
  m2i() {
    return this.u60_1;
  }
  n2i() {
    return this.v60_1;
  }
}
class Companion_36 extends DummyRenderer {
  constructor() {
    Companion_instance_42 = null;
    super(128, 128);
    Companion_instance_42 = this;
  }
}
class HtmlCanvas {
  t3v(width, height) {
    if (Companion_getInstance_10().iu()) {
      // Inline function 'kotlin.error' call
      var message = 'Canvas not available on Node.JS';
      throw IllegalStateException.w4(toString_0(message));
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var out = document.createElement('canvas');
    out.width = width;
    out.height = height;
    return toLike(out);
  }
}
class HtmlImage {
  r61(width, height) {
    return HtmlCanvas_instance.t3v(width, height);
  }
  s61(bmpData, bmpWidth, bmpHeight, canvas) {
    var pixelCount = _RgbaArray___get_size__impl__imxef8(bmpData);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ctx = canvas.getContext('2d');
    var idata = ctx.createImageData(bmpWidth, bmpHeight);
    var idataData = idata.data;
    var m = 0;
    var inductionVariable = 0;
    if (inductionVariable < pixelCount)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = RgbaArray__get_impl_nzyo1o(bmpData, n);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz = m;
        m = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz] = _RGBA___get_r__impl__duz7mo(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_0 = m;
        m = _unary__edvuaz_0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_0] = _RGBA___get_g__impl__o8pukr(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_1 = m;
        m = _unary__edvuaz_1 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_1] = _RGBA___get_b__impl__m6tl80(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_2 = m;
        m = _unary__edvuaz_2 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_2] = _RGBA___get_a__impl__6msvu7(c);
      }
       while (inductionVariable < pixelCount);
    ctx.putImageData(idata, 0.0, 0.0);
    return canvas;
  }
  t61(bmp, canvas) {
    return this.s61(_RgbaArray___init__impl__oib4y4(bmp.n48().b3x_1), bmp.l3x_1, bmp.m3x_1, canvas);
  }
  w60(bmp) {
    return this.t61(bmp, this.r61(bmp.l3x_1, bmp.m3x_1));
  }
}
class NonBrowserNativeImageFormatProvider extends BaseNativeImageFormatProvider {
  constructor() {
    NonBrowserNativeImageFormatProvider_instance = null;
    super();
    NonBrowserNativeImageFormatProvider_instance = this;
  }
}
class HtmlNativeImageFormatProvider extends NativeImageFormatProvider {
  constructor() {
    HtmlNativeImageFormatProvider_instance = null;
    super();
    HtmlNativeImageFormatProvider_instance = this;
  }
  y5l(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_2.bind(VOID, this, data, props), $completion);
  }
  r5m(vfs, path, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_3.bind(VOID, this, vfs, path, props), $completion);
  }
  l4b(width, height, premultiplied) {
    return HtmlNativeImage.q61(HtmlCanvas_instance.t3v(width, height));
  }
  k4b(bmp) {
    return HtmlNativeImage.q61(HtmlImage_instance.w60(bmp.x3x()));
  }
}
class HtmlNativeImage extends NativeImage {
  static z61(texSourceBase, width, height) {
    var $this = this.j4b(width, height, texSourceBase, true);
    $this.l61_1 = texSourceBase;
    $this.m61_1 = $this.l61_1;
    var tmp = $this;
    tmp.n61_1 = lazy(HtmlNativeImage$lazyCanvasElement$delegate$lambda($this, width, height));
    var tmp_0 = $this;
    tmp_0.o61_1 = lazy(HtmlNativeImage$ctx$delegate$lambda($this));
    $this.p61_1 = Monotonic_instance.ej();
    return $this;
  }
  o3() {
    return 'HtmlNativeImage';
  }
  static w61(img) {
    return this.z61(img, img.width, img.height);
  }
  static q61(canvas) {
    return this.z61(canvas, canvas.width, canvas.height);
  }
  y61() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.n61_1;
    lazyCanvasElement$factory();
    return this_0.r1();
  }
  a62() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o61_1;
    ctx$factory();
    return this_0.r1();
  }
  i3y(x, y, width, height, out, offset) {
    if (width <= 0 || height <= 0)
      return Unit_instance;
    var size = imul(width, height);
    var tmp = this.l61_1;
    if (tmp instanceof HTMLVideoElement) {
      var now = Monotonic_instance.ej();
      var elapsedTime = ValueTimeMark__minus_impl_f87sko(now, this.p61_1);
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$1 = toDuration(16, DurationUnit_MILLISECONDS_getInstance());
      if (Duration__compareTo_impl_pchp0f(elapsedTime, tmp$ret$1) >= 0) {
        this.p61_1 = now;
        this.a62().clearRect(0.0, 0.0, width, height);
        this.a62().drawImage(this.l61_1, 0.0, 0.0);
      }
    }
    var idata = this.a62().getImageData(x, y, width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var data = asInt32Array(idata.data.buffer);
    arraycopy(data, 0, out, offset, size);
    if (get_isBigEndian()) {
      bswap32(out, offset, size);
    }
    if (!this.s3x_1) {
      premultiply(_RgbaArray___init__impl__oib4y4(out), offset, _RgbaPremultipliedArray___init__impl__lx83hy(out), offset, imul(width, height));
    }
  }
  k3y(x, y, width, height, out, offset) {
    if (width <= 0 || height <= 0)
      return Unit_instance;
    var size = imul(width, height);
    var idata = this.a62().createImageData(width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var data = asInt32Array(idata.data.buffer);
    arraycopy(out, offset, data, 0, size);
    if (!this.s3x_1) {
      depremultiply(_RgbaPremultipliedArray___init__impl__lx83hy(data), 0, _RgbaArray___init__impl__oib4y4(data), 0, imul(width, height));
    }
    if (get_isBigEndian()) {
      bswap32(data, 0, size);
    }
    this.a62().putImageData(idata, x, y);
  }
  h45(antialiasing) {
    return new Context2d(new CanvasContext2dRenderer(this.y61()));
  }
  b62(type, quality) {
    return this.y61().toDataURL(type, quality);
  }
  c62(type, quality, $super) {
    type = type === VOID ? 'image/png' : type;
    quality = quality === VOID ? null : quality;
    return $super === VOID ? this.b62(type, quality) : $super.b62.call(this, type, quality);
  }
}
class BrowserImage {
  u61(bytes, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeToCanvas__71sobd.bind(VOID, this, bytes, props), $completion);
  }
  e62(img) {
    return this.x61(img, img.width, img.height);
  }
  x61(img, width, height) {
    var canvas = HtmlCanvas_instance.t3v(width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ctx = canvas.getContext('2d');
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    ctx.drawImage(img, 0.0, 0.0);
    return canvas;
  }
  v61(jsUrl, props, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.j19();
    // Inline function 'korlibs.image.format.BrowserImage.loadImage.<anonymous>' call
    if (Companion_getInstance_10().iu()) {
      // Inline function 'kotlin.error' call
      var message = 'Canvas not available on NodeJS';
      throw IllegalStateException.w4(toString_0(message));
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var img = document.createElement('img');
    img.onload = BrowserImage$loadImage$lambda(cancellable, img);
    img.onerror = BrowserImage$loadImage$lambda_0(cancellable, jsUrl);
    img.src = jsUrl;
    return cancellable.v16();
  }
  d62(jsUrl, props, $completion, $super) {
    props = props === VOID ? Companion_getInstance_38().d4s_1 : props;
    return $super === VOID ? this.v61(jsUrl, props, $completion) : $super.v61.call(this, jsUrl, props, $completion);
  }
  p3v(jsUrl, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loadCanvas__xw76hi.bind(VOID, this, jsUrl), $completion);
  }
}
class CanvasContext2dRenderer extends Renderer {
  constructor(canvas) {
    super();
    this.h62_1 = canvas;
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i62_1 = this.h62_1.getContext('2d');
    this.j62_1 = NaN;
    this.k62_1 = null;
  }
  m2i() {
    return this.h62_1.width;
  }
  n2i() {
    return this.h62_1.height;
  }
  o62(_this__u8e3s4, paint) {
    var grad = _this__u8e3s4;
    var inductionVariable = 0;
    var last = paint.s5c_1.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var stop = paint.s5c_1.qx(n);
        var color = paint.t5c_1.qx(n);
        grad.addColorStop(stop, _RGBA___get_htmlStringSimple__impl__l4nu0u(_RGBA___init__impl__lqpay5(color)));
      }
       while (inductionVariable < last);
    return _this__u8e3s4;
  }
  m62(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof NonePaint) {
      tmp = 'none';
    } else {
      if (_this__u8e3s4 instanceof RGBA) {
        tmp = _RGBA___get_htmlColor__impl__bzw5k6(_RGBA___get_color__impl__8x3sb3(_this__u8e3s4.m4e_1));
      } else {
        if (_this__u8e3s4 instanceof GradientPaint) {
          var tmp_0;
          switch (_this__u8e3s4.l5c_1.n3_1) {
            case 0:
              tmp_0 = this.o62(this.i62_1.createLinearGradient(_this__u8e3s4.m5c_1, _this__u8e3s4.n5c_1, _this__u8e3s4.p5c_1, _this__u8e3s4.q5c_1), _this__u8e3s4);
              break;
            case 1:
              tmp_0 = this.o62(this.i62_1.createRadialGradient(_this__u8e3s4.m5c_1, _this__u8e3s4.n5c_1, _this__u8e3s4.o5c_1, _this__u8e3s4.p5c_1, _this__u8e3s4.q5c_1, _this__u8e3s4.r5c_1), _this__u8e3s4);
              break;
            case 2:
              var tmp_1;
              if (!equals(this.i62_1.createConicGradient, undefined)) {
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$1 = this.i62_1.createConicGradient(_Angle___get_radians__impl__n00yt5(_this__u8e3s4.y5c_1), _this__u8e3s4.m5c_1, _this__u8e3s4.n5c_1);
                tmp_1 = this.o62(tmp$ret$1, _this__u8e3s4);
              } else {
                tmp_1 = 'fuchsia';
              }

              tmp_0 = tmp_1;
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          tmp = tmp_0;
        } else {
          if (_this__u8e3s4 instanceof BitmapPaint) {
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$3 = toHtmlNative(_this__u8e3s4.n5p_1).m61_1;
            tmp = this.i62_1.createPattern(tmp$ret$3, _this__u8e3s4.c5q() && _this__u8e3s4.e5q() ? 'repeat' : _this__u8e3s4.c5q() ? 'repeat-x' : _this__u8e3s4.e5q() ? 'repeat-y' : 'no-repeat');
          } else {
            tmp = 'black';
          }
        }
      }
    }
    return tmp;
  }
  p62(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.n3_1) {
      case 0:
        tmp = 'clear';
        break;
      case 1:
        tmp = 'copy';
        break;
      case 2:
        tmp = 'source-over';
        break;
      case 3:
        tmp = 'destination-over';
        break;
      case 4:
        tmp = 'source-in';
        break;
      case 5:
        tmp = 'destination-in';
        break;
      case 6:
        tmp = 'source-out';
        break;
      case 7:
        tmp = 'destination-out';
        break;
      case 8:
        tmp = 'source-atop';
        break;
      case 9:
        tmp = 'destination-atop';
        break;
      case 10:
        tmp = 'xor';
        break;
      case 11:
        tmp = 'lighter';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  q62(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.n3_1) {
      case 0:
        tmp = 'normal';
        break;
      case 1:
        tmp = 'multiply';
        break;
      case 2:
        tmp = 'screen';
        break;
      case 3:
        tmp = 'overlay';
        break;
      case 4:
        tmp = 'darken';
        break;
      case 5:
        tmp = 'lighten';
        break;
      case 6:
        tmp = 'color-dodge';
        break;
      case 7:
        tmp = 'color-burn';
        break;
      case 8:
        tmp = 'hard-light';
        break;
      case 9:
        tmp = 'soft-light';
        break;
      case 10:
        tmp = 'difference';
        break;
      case 11:
        tmp = 'exclusion';
        break;
      case 12:
        tmp = 'hue';
        break;
      case 13:
        tmp = 'saturation';
        break;
      case 14:
        tmp = 'color';
        break;
      case 15:
        tmp = 'luminosity';
        break;
      default:
        // Inline function 'kotlin.text.lowercase' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = _this__u8e3s4.m3_1.toLowerCase();
        break;
    }
    return tmp;
  }
  l62(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof CompositeMode) {
      tmp = this.p62(_this__u8e3s4);
    } else {
      if (_this__u8e3s4 instanceof BlendMode) {
        tmp = this.q62(_this__u8e3s4);
      } else {
        tmp = 'source-over';
      }
    }
    return tmp;
  }
  n62(_this__u8e3s4, m) {
    _this__u8e3s4.transform(m.c29_1, m.d29_1, m.e29_1, m.f29_1, m.g29_1, m.h29_1);
  }
  z5w(image, pos, size, transform) {
    this.i62_1.save();
    try {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      this.i62_1.setTransform(transform.c29_1, transform.d29_1, transform.e29_1, transform.f29_1, transform.g29_1, transform.h29_1);
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp = ensureNative(image);
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = (tmp instanceof HtmlNativeImage ? tmp : THROW_CCE()).m61_1;
      this.i62_1.drawImage(tmp$ret$2, pos.e25_1, pos.f25_1, size.j26_1, size.k26_1);
    }finally {
      this.i62_1.restore();
    }
  }
  r62(path) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.x3d_1;
    var n_0 = 0;
    while (n_0 < this_0.e1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.qx(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.y3d_1.d1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.n27(tmp, path.y3d_1.d1(_unary__edvuaz_1));
          var x = destruct.fl();
          var y = destruct.gl();
          this.i62_1.moveTo(x, y);
          break;
        case 1:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.y3d_1.d1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.n27(tmp_0, path.y3d_1.d1(_unary__edvuaz_3));
          var x_0 = destruct_0.fl();
          var y_0 = destruct_0.gl();
          this.i62_1.lineTo(x_0, y_0);
          break;
        case 2:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.y3d_1.d1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var destruct_1 = Vector2D.n27(tmp_1, path.y3d_1.d1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.y3d_1.d1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_2 = Vector2D.n27(tmp_2, path.y3d_1.d1(_unary__edvuaz_7));
          var cx = destruct_1.fl();
          var cy = destruct_1.gl();
          var ax = destruct_2.fl();
          var ay = destruct_2.gl();
          this.i62_1.quadraticCurveTo(cx, cy, ax, ay);
          break;
        case 3:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.y3d_1.d1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var destruct_3 = Vector2D.n27(tmp_3, path.y3d_1.d1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.y3d_1.d1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var destruct_4 = Vector2D.n27(tmp_4, path.y3d_1.d1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.y3d_1.d1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_5 = Vector2D.n27(tmp_5, path.y3d_1.d1(_unary__edvuaz_13));
          var cx1 = destruct_3.fl();
          var cy1 = destruct_3.gl();
          var cx2 = destruct_4.fl();
          var cy2 = destruct_4.gl();
          var ax_0 = destruct_5.fl();
          var ay_0 = destruct_5.gl();
          this.i62_1.bezierCurveTo(cx1, cy1, cx2, cy2, ax_0, ay_0);
          break;
        case 4:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          this.i62_1.closePath();
          break;
      }
    }
  }
  q5w(state, fill, winding) {
    if (state.p4q_1.g1())
      return Unit_instance;
    $l$block: {
      // Inline function 'korlibs.image.format.CanvasContext2dRenderer.keep' call
      this.i62_1.save();
      try {
        setState(this, state, fill, false);
        var clip = state.o4q_1;
        if (!(clip == null)) {
          this.i62_1.beginPath();
          this.r62(clip);
          this.i62_1.clip(this.s62(winding == null ? clip.z3d_1 : winding));
        }
        this.i62_1.beginPath();
        this.r62(state.p4q_1);
        this.n62(this.i62_1, state.n4q_1);
        if (fill) {
          transformPaint(this, state.x4q_1);
          this.i62_1.fill(this.s62(winding == null ? state.p4q_1.z3d_1 : winding));
        } else {
          transformPaint(this, state.w4q_1);
          var lineDash = state.f4r_1;
          if (!(lineDash == null)) {
            this.i62_1.lineDashOffset = state.g4r_1;
            // Inline function 'kotlin.collections.toTypedArray' call
            // Inline function 'korlibs.datastructure.mapDouble' call
            // Inline function 'kotlin.also' call
            var this_0 = DoubleArrayList.j2k();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.datastructure.mapDouble.<anonymous>' call
            var _iterator__ex2g4s = lineDash.a1();
            while (_iterator__ex2g4s.b1()) {
              var v = _iterator__ex2g4s.c1();
              // Inline function 'korlibs.image.format.CanvasContext2dRenderer.renderFinal.<anonymous>.<anonymous>' call
              this_0.nz(v);
            }
            var tmp$ret$3 = copyToArray(this_0);
            this.i62_1.setLineDash(tmp$ret$3);
          }
          this.i62_1.stroke();
        }
        break $l$block;
      }finally {
        this.i62_1.restore();
      }
    }
  }
  s62(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.n3_1) {
      case 1:
        // Inline function 'org.w3c.dom.NONZERO' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'nonzero';
        break;
      case 0:
        // Inline function 'org.w3c.dom.EVENODD' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'evenodd';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
}
//endregion
function get_isLow(_this__u8e3s4) {
  return _this__u8e3s4.h2t() <= 0.25;
}
var GrowMethod_GROW_IMAGE_instance;
var GrowMethod_NEW_IMAGES_instance;
var GrowMethod_entriesInitialized;
function GrowMethod_initEntries() {
  if (GrowMethod_entriesInitialized)
    return Unit_instance;
  GrowMethod_entriesInitialized = true;
  GrowMethod_GROW_IMAGE_instance = new GrowMethod('GROW_IMAGE', 0);
  GrowMethod_NEW_IMAGES_instance = new GrowMethod('NEW_IMAGES', 1);
}
function reconstructWithSize($this, width, height) {
  var slices = toList($this.l3w_1);
  $this.d3w_1 = Companion_instance_0.m3e(width, height);
  $this.j3w_1 = Bitmap32.e3x(width, height, VOID, $this.f3w_1);
  $this.k3w_1.h3();
  $this.k3w_1.h($this.j3w_1);
  $this.m3w_1.h3();
  $this.l3w_1.h3();
  var _iterator__ex2g4s = slices.a1();
  while (_iterator__ex2g4s.b1()) {
    var entry = _iterator__ex2g4s.c1();
    $this.f3x(entry.b3w_1, entry.c3w_1, entry.b3w_1.w3f_1);
  }
}
function growAtlas($this, bmp) {
  switch ($this.h3w_1.n3_1) {
    case 0:
      reconstructWithSize($this, imul($this.m2i(), 2), imul($this.n2i(), 2));
      break;
    case 1:
      if (bmp.b3g_1 > $this.m2i() || bmp.c3g_1 > $this.n2i()) {
        // Inline function 'kotlin.error' call
        var message = 'Atlas is too small (' + $this.m2i() + 'x' + $this.n2i() + ') to hold a slice of (' + bmp.b3g_1 + 'x' + bmp.c3g_1 + ')';
        throw IllegalStateException.w4(toString_0(message));
      }

      $this.d3w_1 = Companion_instance_0.m3e($this.m2i(), $this.n2i());
      $this.j3w_1 = Bitmap32.e3x($this.m2i(), $this.n2i(), VOID, $this.f3w_1);
      $this.k3w_1.h($this.j3w_1);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
}
function GrowMethod_NEW_IMAGES_getInstance() {
  GrowMethod_initEntries();
  return GrowMethod_NEW_IMAGES_instance;
}
function set_baseMipmapLevel(_this__u8e3s4, _set____db54di) {
  _init_properties_Bitmap_kt__y1ku1b();
  var this_0 = baseMipmapLevel$delegate;
  var property = baseMipmapLevel$factory();
  var tmp0_elvis_lhs = this_0.xx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_baseMipmapLevel(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = baseMipmapLevel$delegate;
    var property = baseMipmapLevel$factory_0();
    var tmp = _this__u8e3s4.wx();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.xx_1;
      tmp_0 = tmp0_safe_receiver.c3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.yx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.xx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.xx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var baseMipmapLevel$delegate;
function set_maxMipmapLevel(_this__u8e3s4, _set____db54di) {
  _init_properties_Bitmap_kt__y1ku1b();
  var this_0 = maxMipmapLevel$delegate;
  var property = maxMipmapLevel$factory();
  var tmp0_elvis_lhs = this_0.xx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_maxMipmapLevel(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = maxMipmapLevel$delegate;
    var property = maxMipmapLevel$factory_0();
    var tmp = _this__u8e3s4.wx();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.xx_1;
      tmp_0 = tmp0_safe_receiver.c3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.yx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.xx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.xx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var maxMipmapLevel$delegate;
function Bitmap$tempInts$delegate$lambda(this$0) {
  return function () {
    return new Int32Array(imul(this$0.l3x_1, 2));
  };
}
function readPixelsUnsafe(_this__u8e3s4, x, y, width, height) {
  _init_properties_Bitmap_kt__y1ku1b();
  var out = new Int32Array(imul(width, height));
  _this__u8e3s4.i3y(x, y, width, height, out, 0);
  return out;
}
function mipmaps(_this__u8e3s4, enable) {
  enable = enable === VOID ? true : enable;
  _init_properties_Bitmap_kt__y1ku1b();
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.mipmaps.<anonymous>' call
  _this__u8e3s4.w3x_1 = enable;
  return _this__u8e3s4;
}
function NativeImageContext2d(width, height, antialiased, block) {
  antialiased = antialiased === VOID ? true : antialiased;
  _init_properties_Bitmap_kt__y1ku1b();
  // Inline function 'korlibs.image.bitmap.context2d' call
  var this_0 = NativeImage_0(width, height, true);
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = this_0.p3x_1;
  if (false) {
    this_0.y3x();
  }
  var result;
  try {
    // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
    var ctx = this_0.h45(antialiased);
    try {
      // Inline function 'korlibs.image.bitmap.NativeImageContext2d.<anonymous>' call
      block(ctx);
    }finally {
      ctx.d18();
    }
  }finally {
    result = false ? this_0.a3y(rect) : 0;
  }
  return this_0;
}
function asumePremultiplied(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  _this__u8e3s4.r3x_1 = true;
  _this__u8e3s4.s3x_1 = true;
  return _this__u8e3s4;
}
function baseMipmapLevel$delegate$lambda() {
  _init_properties_Bitmap_kt__y1ku1b();
  return null;
}
function maxMipmapLevel$delegate$lambda() {
  _init_properties_Bitmap_kt__y1ku1b();
  return null;
}
function baseMipmapLevel$factory() {
  return getPropertyCallableRef('baseMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_baseMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_baseMipmapLevel(receiver, value);
  });
}
function baseMipmapLevel$factory_0() {
  return getPropertyCallableRef('baseMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_baseMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_baseMipmapLevel(receiver, value);
  });
}
function maxMipmapLevel$factory() {
  return getPropertyCallableRef('maxMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_maxMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_maxMipmapLevel(receiver, value);
  });
}
function maxMipmapLevel$factory_0() {
  return getPropertyCallableRef('maxMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_maxMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_maxMipmapLevel(receiver, value);
  });
}
function tempInts$factory() {
  return getPropertyCallableRef('tempInts', 1, KProperty1, function (receiver) {
    return receiver.d3y();
  }, null);
}
var properties_initialized_Bitmap_kt_sxrn69;
function _init_properties_Bitmap_kt__y1ku1b() {
  if (!properties_initialized_Bitmap_kt_sxrn69) {
    properties_initialized_Bitmap_kt_sxrn69 = true;
    baseMipmapLevel$delegate = new Property(VOID, baseMipmapLevel$delegate$lambda);
    maxMipmapLevel$delegate = new Property(VOID, maxMipmapLevel$delegate$lambda);
  }
}
function *_generator_invoke__zhh2q8($this, $this$iterator, $completion) {
  var inductionVariable = 0;
  var last = $this.q45_1.i2f();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = $this$iterator.ll(new RGBA($this.q45_1.r45(n)), $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
     while (inductionVariable < last);
  return Unit_instance;
}
var Companion_instance_5;
function Companion_getInstance_15() {
  if (Companion_instance_5 === VOID)
    new Companion();
  return Companion_instance_5;
}
function Bitmap32$iterator$slambda_0(this$0) {
  var i = new Bitmap32$iterator$slambda(this$0);
  var l = function ($this$iterator, $completion) {
    return i.z46($this$iterator, $completion);
  };
  l.$arity = 1;
  return l;
}
function isFullyTransparent(_this__u8e3s4) {
  var bmp = get_bmp(_this__u8e3s4);
  var data = _RgbaArray___init__impl__oib4y4(get_bmp(_this__u8e3s4).b3x_1);
  var width = _this__u8e3s4.w25() - _this__u8e3s4.v25() | 0;
  var inductionVariable = _this__u8e3s4.x25();
  var last = _this__u8e3s4.y25();
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var index = bmp.g3y(_this__u8e3s4.v25(), y);
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(index >= 0 && index <= (_RgbaArray___get_size__impl__imxef8(data) - width | 0))) {
        // Inline function 'korlibs.image.bitmap.isFullyTransparent.<anonymous>' call
        var message = 'left=' + _this__u8e3s4.v25() + ', top=' + _this__u8e3s4.x25() + ', right=' + _this__u8e3s4.w25() + ', bottom=' + _this__u8e3s4.y25();
        throw IllegalStateException.w4(toString_0(message));
      }
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < width)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (!(_RGBA___get_a__impl__6msvu7(RgbaArray__get_impl_nzyo1o(data, index + n | 0)) === 0))
            return false;
        }
         while (inductionVariable_0 < width);
    }
     while (inductionVariable < last);
  return true;
}
function expandBorder(_this__u8e3s4, area, border) {
  return expandBorder_0(_this__u8e3s4, area.x25(), area.v25(), area.y25(), area.w25(), border);
}
function expandBorder_0(_this__u8e3s4, areaTop, areaLeft, areaBottom, areaRight, border) {
  var data = _this__u8e3s4.b3x_1;
  var x0Index = _this__u8e3s4.g3y(areaLeft, areaTop);
  var x1Index = _this__u8e3s4.g3y(areaRight - 1 | 0, areaTop);
  var areaWidth = areaRight - areaLeft | 0;
  var areaHeight = areaBottom - areaTop | 0;
  var inductionVariable = 0;
  if (inductionVariable < areaHeight)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var x0Color = data[x0Index];
      var x1Color = data[x1Index];
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < border)
        do {
          var m = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          data[(x0Index - m | 0) - 1 | 0] = x0Color;
          data[(x1Index + m | 0) + 1 | 0] = x1Color;
        }
         while (inductionVariable_0 < border);
      x0Index = x0Index + _this__u8e3s4.l3x_1 | 0;
      x1Index = x1Index + _this__u8e3s4.l3x_1 | 0;
    }
     while (inductionVariable < areaHeight);
  var inductionVariable_1 = 0;
  if (inductionVariable_1 < border)
    do {
      var m_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var x = areaLeft - border | 0;
      var npixels = areaWidth + imul(border, 2) | 0;
      arraycopy(data, _this__u8e3s4.g3y(x, areaTop), data, _this__u8e3s4.g3y(x, (areaTop - m_0 | 0) - 1 | 0), npixels);
      arraycopy(data, _this__u8e3s4.g3y(x, areaBottom - 1 | 0), data, _this__u8e3s4.g3y(x, areaBottom + m_0 | 0), npixels);
    }
     while (inductionVariable_1 < border);
}
var Companion_instance_6;
function Companion_getInstance_16() {
  return Companion_instance_6;
}
var BitmapChannel_RED_instance;
var BitmapChannel_GREEN_instance;
var BitmapChannel_BLUE_instance;
var BitmapChannel_ALPHA_instance;
var Companion_instance_7;
function Companion_getInstance_17() {
  BitmapChannel_initEntries();
  if (Companion_instance_7 === VOID)
    new Companion_1();
  return Companion_instance_7;
}
function values() {
  return [BitmapChannel_RED_getInstance(), BitmapChannel_GREEN_getInstance(), BitmapChannel_BLUE_getInstance(), BitmapChannel_ALPHA_getInstance()];
}
var BitmapChannel_entriesInitialized;
function BitmapChannel_initEntries() {
  if (BitmapChannel_entriesInitialized)
    return Unit_instance;
  BitmapChannel_entriesInitialized = true;
  BitmapChannel_RED_instance = new BitmapChannel('RED', 0, 0);
  BitmapChannel_GREEN_instance = new BitmapChannel('GREEN', 1, 1);
  BitmapChannel_BLUE_instance = new BitmapChannel('BLUE', 2, 2);
  BitmapChannel_ALPHA_instance = new BitmapChannel('ALPHA', 3, 3);
  Companion_getInstance_17();
}
function BitmapChannel_RED_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_RED_instance;
}
function BitmapChannel_GREEN_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_GREEN_instance;
}
function BitmapChannel_BLUE_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_BLUE_instance;
}
function BitmapChannel_ALPHA_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_ALPHA_instance;
}
function get_bounds_0(_this__u8e3s4) {
  return _this__u8e3s4.t3f_1;
}
function get_bmp(_this__u8e3s4) {
  return get_container(_this__u8e3s4);
}
function get_container(_this__u8e3s4) {
  return _this__u8e3s4.b3h();
}
function slice(_this__u8e3s4, bounds, name, orientation, padding) {
  bounds = bounds === VOID ? RectangleInt.u2e(0, 0, _this__u8e3s4.l3x_1, _this__u8e3s4.m3x_1) : bounds;
  name = name === VOID ? null : name;
  orientation = orientation === VOID ? Companion_getInstance_0().i3f_1 : orientation;
  padding = padding === VOID ? Companion_getInstance_3().p28_1 : padding;
  var left = clamp(bounds.v25(), 0, _this__u8e3s4.l3x_1);
  var top = clamp(bounds.x25(), 0, _this__u8e3s4.m3x_1);
  return new RectSlice(_this__u8e3s4, Companion_instance_1.y2d(left, top, clamp(bounds.w25(), left, _this__u8e3s4.l3x_1), clamp(bounds.y25(), top, _this__u8e3s4.m3x_1)), orientation, padding, name);
}
function extract_0(_this__u8e3s4) {
  var w = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.u3f_1) ? _this__u8e3s4.t3f_1.s2e_1 : _this__u8e3s4.t3f_1.t2e_1;
  var h = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.u3f_1) ? _this__u8e3s4.t3f_1.t2e_1 : _this__u8e3s4.t3f_1.s2e_1;
  var tmp = get_container(_this__u8e3s4).g45(w + _this__u8e3s4.v3f_1.n28() | 0, h + _this__u8e3s4.v3f_1.o28() | 0);
  var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
  var raw = extractUntransformed(_this__u8e3s4).f45(_this__u8e3s4.u3f_1);
  raw.t44(0, 0, out, _this__u8e3s4.v3f_1.t28_1, _this__u8e3s4.v3f_1.q28_1, raw.l3x_1, raw.m3x_1);
  return out;
}
function sliceWithSize(_this__u8e3s4, x, y, width, height, name, orientation, padding) {
  name = name === VOID ? null : name;
  orientation = orientation === VOID ? Companion_getInstance_0().i3f_1 : orientation;
  padding = padding === VOID ? Companion_getInstance_3().p28_1 : padding;
  return slice(_this__u8e3s4, RectangleInt.u2e(x, y, width, height), name, orientation, padding);
}
function extractUntransformed(_this__u8e3s4) {
  var tmp = get_container(_this__u8e3s4).g45(_this__u8e3s4.t3f_1.s2e_1, _this__u8e3s4.t3f_1.t2e_1);
  var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
  get_container(_this__u8e3s4).q44(_this__u8e3s4.t3f_1.q2e_1, _this__u8e3s4.t3f_1.r2e_1, out, 0, 0, _this__u8e3s4.t3f_1.s2e_1, _this__u8e3s4.t3f_1.t2e_1);
  return out;
}
function get_Bitmaps_transparent() {
  _init_properties_Bitmaps_kt__92w93i();
  return Bitmaps_transparent;
}
var Bitmaps_transparent;
function get_Bitmaps_white() {
  _init_properties_Bitmaps_kt__92w93i();
  return Bitmaps_white;
}
var Bitmaps_white;
var Bitmaps_instance;
function Bitmaps_getInstance() {
  return Bitmaps_instance;
}
var properties_initialized_Bitmaps_kt_qcuk18;
function _init_properties_Bitmaps_kt__92w93i() {
  if (!properties_initialized_Bitmaps_kt_qcuk18) {
    properties_initialized_Bitmaps_kt_qcuk18 = true;
    Bitmaps_transparent = slice(Companion_getInstance_15().t45(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().x3y_1)), VOID, 'transparent');
    Bitmaps_white = slice(Companion_getInstance_15().t45(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().s3y_1)), VOID, 'white');
  }
}
var Companion_instance_8;
function Companion_getInstance_18() {
  return Companion_instance_8;
}
function setFromBitmap$getAlpha(_this__u8e3s4, x, y, min) {
  return _this__u8e3s4.w44(x, y) ? _RGBA___get_a__impl__6msvu7(_this__u8e3s4.j3y(x, y)) >= min : false;
}
function setFromBitmap$pass(this$0, x, y, dx, dy, d) {
  if (this$0.o49(x + dx | 0, y + dy | 0) + d < this$0.o49(x, y)) {
    this$0.k49(x, y, x + dx | 0, y + dy | 0);
    // Inline function 'kotlin.math.hypot' call
    var x_0 = x - this$0.l49(x, y) | 0;
    var y_0 = y - this$0.m49(x, y) | 0;
    var tmp$ret$0 = hypot(x_0, y_0);
    this$0.n49(x, y, tmp$ret$0);
  }
}
function distanceMap(_this__u8e3s4, out, thresold) {
  out = out === VOID ? new DistanceBitmap(_this__u8e3s4.l3x_1, _this__u8e3s4.m3x_1) : out;
  thresold = thresold === VOID ? 0.5 : thresold;
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.distanceMap.<anonymous>' call
  out.q49(_this__u8e3s4, thresold);
  return out;
}
function index4($this, x, y) {
  return imul($this.g3y(x, y), 4);
}
function NativeImageOrBitmap32(width, height, native, premultiplied) {
  native = native === VOID ? true : native;
  premultiplied = premultiplied === VOID ? null : premultiplied;
  var tmp;
  if (native) {
    tmp = NativeImage_0(width, height, premultiplied);
  } else {
    tmp = Bitmap32.e3x(width, height, VOID, premultiplied == null ? true : premultiplied);
  }
  return tmp;
}
function ensureNative(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof NativeImage) {
    tmp = _this__u8e3s4;
  } else {
    tmp = get_nativeImageFormatProvider().k4b(_this__u8e3s4);
  }
  return tmp;
}
function NativeImage_0(width, height, premultiplied) {
  premultiplied = premultiplied === VOID ? null : premultiplied;
  return get_nativeImageFormatProvider().l4b(width, height, premultiplied);
}
var Companion_instance_9;
function Companion_getInstance_19() {
  if (Companion_instance_9 === VOID)
    Companion_3.a4c();
  return Companion_instance_9;
}
function applyEffect(_this__u8e3s4, effect) {
  var safeBorder = get_safeBorder(effect);
  var out = Companion_getInstance_15().u45(_this__u8e3s4.l3x_1 + imul(safeBorder, 2) | 0, _this__u8e3s4.m3x_1 + imul(safeBorder, 2) | 0, _this__u8e3s4.r3x_1);
  out.l47(_this__u8e3s4, safeBorder, safeBorder);
  applyEffectInline(out, effect);
  return out;
}
function get_safeBorder(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 == null ? null : _this__u8e3s4.a4d();
  return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
}
function applyEffectInline(_this__u8e3s4, effect) {
  if (effect == null)
    return Unit_instance;
  if (!(effect.t4c_1 === 0)) {
    blurInplace(_this__u8e3s4, effect.t4c_1);
  }
  if (!(effect.w4c_1 === 0) || !(effect.u4c_1 === 0) || !(effect.v4c_1 === 0)) {
    dropShadowInplace(_this__u8e3s4, effect.u4c_1, effect.v4c_1, effect.w4c_1, effect.x4c_1);
  }
  if (!(effect.y4c_1 === 0)) {
    borderInline(_this__u8e3s4, effect.y4c_1, effect.z4c_1);
  }
}
function blurInplace(_this__u8e3s4, r) {
  var r_0 = coerceAtMost(coerceAtMost(r, (_this__u8e3s4.l3x_1 / 2 | 0) - 1 | 0), (_this__u8e3s4.m3x_1 / 2 | 0) - 1 | 0);
  var t1 = Bitmap8.l48(_this__u8e3s4.l3x_1, _this__u8e3s4.m3x_1);
  var t2 = Bitmap8.l48(_this__u8e3s4.l3x_1, _this__u8e3s4.m3x_1);
  var inductionVariable = 0;
  if (inductionVariable < 4)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var channel = Companion_getInstance_17().d1(n);
      _this__u8e3s4.p47(channel, t1);
      arraycopy_0(t1.x46(), 0, t2.x46(), 0, t2.i2f());
      gaussBlur(t1.x46(), t2.x46(), _this__u8e3s4.l3x_1, _this__u8e3s4.m3x_1, r_0);
      _this__u8e3s4.o47(channel, t2);
    }
     while (inductionVariable < 4);
}
function gaussBlur(scl, tcl, w, h, r) {
  var a = 0;
  var b = 0;
  var c = 0;
  // Inline function 'korlibs.image.bitmap.effect.boxesForGaussN3' call
  var n = 3;
  // Inline function 'kotlin.math.sqrt' call
  var x = 12.0 * r * r / n + 1;
  var wIdeal = Math.sqrt(x);
  var wl = toIntFloor_0(wIdeal);
  if ((wl % 2 | 0) === 0) {
    wl = wl - 1 | 0;
  }
  var wu = wl + 2 | 0;
  var mIdeal = (12.0 * r * r - imul(imul(n, wl), wl) - imul(imul(4, n), wl) - imul(3, n)) / (imul(-4, wl) - 4 | 0);
  var m = round(mIdeal);
  // Inline function 'korlibs.image.bitmap.effect.gaussBlur.<anonymous>' call
  a = 0 < m ? wl : wu;
  b = 1 < m ? wl : wu;
  c = 2 < m ? wl : wu;
  boxBlur(scl, tcl, w, h, (a - 1 | 0) / 2 | 0);
  boxBlur(tcl, scl, w, h, (b - 1 | 0) / 2 | 0);
  boxBlur(scl, tcl, w, h, (c - 1 | 0) / 2 | 0);
}
function boxBlur(scl, tcl, w, h, r) {
  arraycopy_0(scl, 0, tcl, 0, scl.length);
  boxBlurH(tcl, scl, w, h, r);
  boxBlurT(scl, tcl, w, h, r);
}
function boxBlurH(scl, tcl, w, h, r) {
  var arr = (r + r | 0) + 1 | 0;
  var inductionVariable = 0;
  if (inductionVariable < h)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ti = imul(i, w);
      var li = ti;
      var ri = ti + r | 0;
      var fv = getU8(scl, ti);
      var lv = getU8(scl, (ti + w | 0) - 1 | 0);
      var v = imul(r + 1 | 0, fv);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < r)
        do {
          var j = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          v = v + getU8(scl, ti + j | 0) | 0;
        }
         while (inductionVariable_0 < r);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= r)
        do {
          var j_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var tmp = v;
          var _unary__edvuaz = ri;
          ri = _unary__edvuaz + 1 | 0;
          v = tmp + (getU8(scl, _unary__edvuaz) - fv | 0) | 0;
          var _unary__edvuaz_0 = ti;
          ti = _unary__edvuaz_0 + 1 | 0;
          tcl[_unary__edvuaz_0] = toByte(v / arr | 0);
        }
         while (!(j_0 === r));
      var inductionVariable_2 = r + 1 | 0;
      var last = w - r | 0;
      if (inductionVariable_2 < last)
        do {
          var j_1 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var tmp_0 = v;
          var _unary__edvuaz_1 = ri;
          ri = _unary__edvuaz_1 + 1 | 0;
          var tmp_1 = getU8(scl, _unary__edvuaz_1);
          var _unary__edvuaz_2 = li;
          li = _unary__edvuaz_2 + 1 | 0;
          v = tmp_0 + (tmp_1 - getU8(scl, _unary__edvuaz_2) | 0) | 0;
          var _unary__edvuaz_3 = ti;
          ti = _unary__edvuaz_3 + 1 | 0;
          tcl[_unary__edvuaz_3] = toByte(v / arr | 0);
        }
         while (inductionVariable_2 < last);
      var inductionVariable_3 = w - r | 0;
      if (inductionVariable_3 < w)
        do {
          var j_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          var tmp_2 = v;
          var _unary__edvuaz_4 = li;
          li = _unary__edvuaz_4 + 1 | 0;
          v = tmp_2 + (lv - getU8(scl, _unary__edvuaz_4) | 0) | 0;
          var _unary__edvuaz_5 = ti;
          ti = _unary__edvuaz_5 + 1 | 0;
          tcl[_unary__edvuaz_5] = toByte(v / arr | 0);
        }
         while (inductionVariable_3 < w);
    }
     while (inductionVariable < h);
}
function boxBlurT(scl, tcl, w, h, r) {
  var arr = (r + r | 0) + 1 | 0;
  var inductionVariable = 0;
  if (inductionVariable < w)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ti = i;
      var li = ti;
      var ri = ti + imul(r, w) | 0;
      var fv = getU8(scl, ti);
      var lv = getU8(scl, ti + imul(w, h - 1 | 0) | 0);
      var v = imul(r + 1 | 0, fv);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < r)
        do {
          var j = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          v = v + getU8(scl, ti + imul(j, w) | 0) | 0;
        }
         while (inductionVariable_0 < r);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= r)
        do {
          var j_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          v = v + (getU8(scl, ri) - fv | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          ri = ri + w | 0;
          ti = ti + w | 0;
        }
         while (!(j_0 === r));
      var inductionVariable_2 = r + 1 | 0;
      var last = h - r | 0;
      if (inductionVariable_2 < last)
        do {
          var j_1 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          v = v + (getU8(scl, ri) - getU8(scl, li) | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          li = li + w | 0;
          ri = ri + w | 0;
          ti = ti + w | 0;
        }
         while (inductionVariable_2 < last);
      var inductionVariable_3 = h - r | 0;
      if (inductionVariable_3 < h)
        do {
          var j_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          v = v + (lv - getU8(scl, li) | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          li = li + w | 0;
          ti = ti + w | 0;
        }
         while (inductionVariable_3 < h);
    }
     while (inductionVariable < w);
}
function blur(_this__u8e3s4, r) {
  var out = Bitmap8.l48(_this__u8e3s4.l3x_1 + imul(r, 2) | 0, _this__u8e3s4.m3x_1 + imul(r, 2) | 0);
  Companion_instance_6.s48(_this__u8e3s4, 0, 0, out, r, r, _this__u8e3s4.l3x_1, _this__u8e3s4.m3x_1);
  blurInplace_0(out, r);
  return out;
}
function blurInplace_0(_this__u8e3s4, r) {
  var r_0 = coerceAtMost(coerceAtMost(r, (_this__u8e3s4.l3x_1 / 2 | 0) - 1 | 0), (_this__u8e3s4.m3x_1 / 2 | 0) - 1 | 0);
  var t2 = Bitmap8.l48(_this__u8e3s4.l3x_1, _this__u8e3s4.m3x_1);
  arraycopy_0(_this__u8e3s4.x46(), 0, t2.x46(), 0, _this__u8e3s4.i2f());
  gaussBlur(t2.x46(), _this__u8e3s4.x46(), _this__u8e3s4.l3x_1, _this__u8e3s4.m3x_1, r_0);
}
function borderInline(_this__u8e3s4, r, color) {
  color = color === VOID ? Colors_getInstance().t3y_1 : color;
  var out = _this__u8e3s4;
  var distance = distanceMap(out);
  var inductionVariable = 0;
  var last = out.m3x_1;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = out.l3x_1;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var dist = distance.o49(x, y);
          if (dist < (r + 1 | 0)) {
            var alpha = dist >= r ? 1.0 - dist % 1.0 : 1.0;
            var rcolor = alpha === 1.0 ? color : RGBA__withAf_impl_dpdu32(color, _RGBA___get_af__impl__vu36qv(color) * alpha);
            out.a47(x, y, Companion_getInstance_22().b4d(rcolor, out.b47(x, y)));
          }
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
}
function dropShadowInplace(_this__u8e3s4, x, y, r, color) {
  color = color === VOID ? Colors_getInstance().t3y_1 : color;
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.effect.dropShadowInplace.<anonymous>' call
  var copy = _this__u8e3s4.sx();
  var pcolor = _RGBA___get_premultiplied__impl__3bulqc(color);
  // Inline function 'kotlin.also' call
  var this_0 = blur(_this__u8e3s4.q47(BitmapChannel_ALPHA_getInstance()), r);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.effect.dropShadowInplace.<anonymous>.<anonymous>' call
  this_0.r3x_1 = true;
  var inductionVariable = 0;
  if (inductionVariable < 256)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      RgbaArray__set_impl_epw2wg(this_0.r46_1, n, Companion_getInstance_22().c4d(imul(_RGBAPremultiplied___get_r__impl__m8nz5i(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_g__impl__fv131x(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_b__impl__dt4tp6(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_a__impl__f0hnd1(pcolor), n) / 255 | 0));
    }
     while (inductionVariable < 256);
  var shadow = this_0.x3x();
  _this__u8e3s4.j47(Colors_getInstance().x3y_1);
  _this__u8e3s4.m47(shadow, x - r | 0, y - r | 0);
  _this__u8e3s4.m47(copy, 0, 0);
  return _this__u8e3s4;
}
var NewSDF_instance;
function NewSDF_getInstance() {
  return NewSDF_instance;
}
function decode(_this__u8e3s4, data, dataOffset, out, outOffset, size, littleEndian) {
  littleEndian = littleEndian === VOID ? true : littleEndian;
  var tmp;
  switch (_this__u8e3s4.m4d()) {
    case 16:
      var tmp_0;
      if (littleEndian) {
        tmp_0 = getU16LE$ref();
      } else {
        tmp_0 = getU16BE$ref();
      }

      tmp = tmp_0;
      break;
    case 24:
      var tmp_1;
      if (littleEndian) {
        tmp_1 = getU24LE$ref();
      } else {
        tmp_1 = getU24BE$ref();
      }

      tmp = tmp_1;
      break;
    case 32:
      var tmp_2;
      if (littleEndian) {
        tmp_2 = getS32LE$ref();
      } else {
        tmp_2 = getS32BE$ref();
      }

      tmp = tmp_2;
      break;
    default:
      throw IllegalArgumentException.l('Unsupported bpp ' + _this__u8e3s4.m4d());
  }
  var readFunc = tmp;
  // Inline function 'korlibs.image.color.decodeInternal' call
  var io = dataOffset;
  var oo = outOffset;
  var bytesPerPixel = get_bytesPerPixel(_this__u8e3s4);
  var outdata = out;
  var Bpp = numberToInt(bytesPerPixel);
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c = readFunc(data, io);
      io = io + Bpp | 0;
      var _unary__edvuaz = oo;
      oo = _unary__edvuaz + 1 | 0;
      RgbaArray__set_impl_epw2wg(outdata, _unary__edvuaz, Companion_getInstance_22().c4d(_this__u8e3s4.n4d(c), _this__u8e3s4.o4d(c), _this__u8e3s4.p4d(c), _this__u8e3s4.q4d(c)));
    }
     while (inductionVariable < size);
}
function get_bytesPerPixel(_this__u8e3s4) {
  return _this__u8e3s4.m4d() / 8;
}
function getU16LE$ref() {
  var l = function (p0, p1) {
    return getU16LE(p0, p1);
  };
  l.callableName = 'getU16LE';
  return l;
}
function getU16BE$ref() {
  var l = function (p0, p1) {
    return getU16BE(p0, p1);
  };
  l.callableName = 'getU16BE';
  return l;
}
function getU24LE$ref() {
  var l = function (p0, p1) {
    return getU24LE(p0, p1);
  };
  l.callableName = 'getU24LE';
  return l;
}
function getU24BE$ref() {
  var l = function (p0, p1) {
    return getU24BE(p0, p1);
  };
  l.callableName = 'getU24BE';
  return l;
}
function getS32LE$ref() {
  var l = function (p0, p1) {
    return getS32LE(p0, p1);
  };
  l.callableName = 'getS32LE';
  return l;
}
function getS32BE$ref() {
  var l = function (p0, p1) {
    return getS32BE(p0, p1);
  };
  l.callableName = 'getS32BE';
  return l;
}
var Colors_instance;
function Colors_getInstance() {
  if (Colors_instance === VOID)
    new Colors();
  return Colors_instance;
}
var MaterialColors_instance;
function MaterialColors_getInstance() {
  if (MaterialColors_instance === VOID)
    new MaterialColors();
  return MaterialColors_instance;
}
var Companion_instance_10;
function Companion_getInstance_20() {
  if (Companion_instance_10 === VOID)
    new Companion_4();
  return Companion_instance_10;
}
function _RgbaArray___init__impl__oib4y4(ints) {
  return ints;
}
function _RgbaArray___get_ints__impl__u2kps1($this) {
  return $this;
}
var Companion_instance_11;
function Companion_getInstance_21() {
  return Companion_instance_11;
}
function RgbaArray__subList_impl_rbyi98($this, fromIndex, toIndex) {
  return new GenericSubList(new RgbaArray($this), fromIndex, toIndex);
}
function RgbaArray__contains_impl_ofn00n($this, element) {
  return contains(_RgbaArray___get_ints__impl__u2kps1($this), _RGBA___get_value__impl__hhco8v(element));
}
function RgbaArray__containsAll_impl_l6gz5c($this, elements) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(elements, Collection)) {
      tmp = elements.g1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var tmp0_iterator = elements.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.color.RgbaArray.containsAll.<anonymous>' call
      var it = element.m4e_1;
      if (!RgbaArray__contains_impl_ofn00n($this, it)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
}
function RgbaArray__containsAll_impl_l6gz5c_0($this, elements) {
  return RgbaArray__containsAll_impl_l6gz5c($this.y4n_1, elements);
}
function RgbaArray__indexOf_impl_d6b5pl($this, element) {
  return indexOf(_RgbaArray___get_ints__impl__u2kps1($this), _RGBA___get_value__impl__hhco8v(element));
}
function RgbaArray__indexOf_impl_d6b5pl_0($this, element) {
  if (!(element instanceof RGBA))
    return -1;
  return RgbaArray__indexOf_impl_d6b5pl($this.y4n_1, element instanceof RGBA ? element.m4e_1 : THROW_CCE());
}
function RgbaArray__isEmpty_impl_nch3ip($this) {
  // Inline function 'kotlin.collections.isEmpty' call
  return _RgbaArray___get_ints__impl__u2kps1($this).length === 0;
}
function RgbaArray__iterator_impl_5wfwsm($this) {
  return RgbaArray__listIterator_impl_m4kjt0_0($this, 0);
}
function RgbaArray__listIterator_impl_m4kjt0($this) {
  return RgbaArray__listIterator_impl_m4kjt0_0($this, 0);
}
function RgbaArray__listIterator_impl_m4kjt0_0($this, index) {
  return new GenericListIterator(new RgbaArray($this), index);
}
function _RgbaArray___get_size__impl__imxef8($this) {
  return _RgbaArray___get_ints__impl__u2kps1($this).length;
}
function RgbaArray__get_impl_nzyo1o($this, index) {
  return _RGBA___init__impl__lqpay5(_RgbaArray___get_ints__impl__u2kps1($this)[index]);
}
function RgbaArray__get_impl_nzyo1o_0($this, index) {
  return new RGBA(RgbaArray__get_impl_nzyo1o($this.y4n_1, index));
}
function RgbaArray__set_impl_epw2wg($this, index, color) {
  _RgbaArray___get_ints__impl__u2kps1($this)[index] = _RGBA___get_value__impl__hhco8v(color);
}
function RgbaArray__toString_impl_vgvk04($this) {
  return 'RgbaArray(' + _RgbaArray___get_size__impl__imxef8($this) + ')';
}
function RgbaArray__hashCode_impl_ht2l65($this) {
  return hashCode($this);
}
function RgbaArray__equals_impl_6qvuf($this, other) {
  if (!(other instanceof RgbaArray))
    return false;
  var tmp0_other_with_cast = other instanceof RgbaArray ? other.y4n_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function blendComponent($this, c1, c2, factor) {
  // Inline function 'kotlin.math.roundToInt' call
  var this_0 = c1 * (1.0 - Ratio__toFloat_impl_1ftup5(factor)) + c2 * Ratio__toFloat_impl_1ftup5(factor);
  return roundToInt(this_0) & 255;
}
function _RGBA___init__impl__lqpay5(value) {
  return value;
}
function _RGBA___get_value__impl__hhco8v($this) {
  return $this;
}
function RGBA__clone_impl_w007z0($this) {
  return new RGBA($this);
}
function _RGBA___get_color__impl__8x3sb3($this) {
  return $this;
}
function _RGBA___get_r__impl__duz7mo($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 0 | 0) & 255;
}
function _RGBA___get_g__impl__o8pukr($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 8 | 0) & 255;
}
function _RGBA___get_b__impl__m6tl80($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 16 | 0) & 255;
}
function _RGBA___get_a__impl__6msvu7($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 24 | 0) & 255;
}
function _RGBA___get_rf__impl__kvz75k($this) {
  return _RGBA___get_r__impl__duz7mo($this) / 255.0;
}
function _RGBA___get_gf__impl__5gcu1f($this) {
  return _RGBA___get_g__impl__o8pukr($this) / 255.0;
}
function _RGBA___get_bf__impl__1xz5yg($this) {
  return _RGBA___get_b__impl__m6tl80($this) / 255.0;
}
function _RGBA___get_af__impl__vu36qv($this) {
  return _RGBA___get_a__impl__6msvu7($this) / 255.0;
}
function _RGBA___get_ad__impl__pt5rdj($this) {
  return _RGBA___get_a__impl__6msvu7($this) / 255.0;
}
function _RGBA___get_rgb__impl__tijaqt($this) {
  return _RGBA___get_value__impl__hhco8v($this) & 16777215;
}
function RGBA__withA_impl_vogscm($this, v) {
  return _RGBA___init__impl__lqpay5(_RGBA___get_value__impl__hhco8v($this) & 16777215 | clampUByte(v) << 24);
}
function RGBA__withAd_impl_cralao($this, v) {
  return RGBA__withA_impl_vogscm($this, d2i(v));
}
function RGBA__withAf_impl_dpdu32($this, v) {
  return RGBA__withA_impl_vogscm($this, f2i(v));
}
function RGBA__concatAd_impl_gwhfm($this, v) {
  return RGBA__withA_impl_vogscm($this, roundToInt(_RGBA___get_a__impl__6msvu7($this) * v));
}
function _RGBA___get_hexString__impl__kocngm($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.tb(9);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.color.RGBA.<get-hexString>.<anonymous>' call
  this_0.pb(_Char___init__impl__6a9atx(35));
  appendHexByte(this_0, _RGBA___get_r__impl__duz7mo($this));
  appendHexByte(this_0, _RGBA___get_g__impl__o8pukr($this));
  appendHexByte(this_0, _RGBA___get_b__impl__m6tl80($this));
  appendHexByte(this_0, _RGBA___get_a__impl__6msvu7($this));
  return this_0.toString();
}
function _RGBA___get_hexStringNoAlpha__impl__j315et($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.tb(7);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.color.RGBA.<get-hexStringNoAlpha>.<anonymous>' call
  this_0.pb(_Char___init__impl__6a9atx(35));
  appendHexByte(this_0, _RGBA___get_r__impl__duz7mo($this));
  appendHexByte(this_0, _RGBA___get_g__impl__o8pukr($this));
  appendHexByte(this_0, _RGBA___get_b__impl__m6tl80($this));
  return this_0.toString();
}
function _RGBA___get_htmlColor__impl__bzw5k6($this) {
  return 'rgba(' + _RGBA___get_r__impl__duz7mo($this) + ', ' + _RGBA___get_g__impl__o8pukr($this) + ', ' + _RGBA___get_b__impl__m6tl80($this) + ', ' + get_niceStr(_RGBA___get_af__impl__vu36qv($this)) + ')';
}
function _RGBA___get_htmlStringSimple__impl__l4nu0u($this) {
  return _RGBA___get_hexStringNoAlpha__impl__j315et($this);
}
function RGBA__toString_impl_4lw6dp($this) {
  return _RGBA___get_hexString__impl__kocngm($this);
}
function RGBA__compareTo_impl_lrfjc1($this, other) {
  return compareTo(_RGBA___get_value__impl__hhco8v($this), _RGBA___get_value__impl__hhco8v(other));
}
function RGBA__compareTo_impl_lrfjc1_0($this, other) {
  return RGBA__compareTo_impl_lrfjc1($this.m4e_1, other instanceof RGBA ? other.m4e_1 : THROW_CCE());
}
function RGBA__premultipliedValue_impl_oja55q($this, premultiplied) {
  return premultiplied ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc($this)) : _RGBA___get_value__impl__hhco8v($this);
}
function _RGBA___get_premultiplied__impl__3bulqc($this) {
  return _RGBA___get_premultipliedFast__impl__qiau4g($this);
}
function _RGBA___get_premultipliedFast__impl__qiau4g($this) {
  var A = _RGBA___get_a__impl__6msvu7($this) + 1 | 0;
  if (A >= 255)
    return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this));
  if (A <= 1)
    return _RGBAPremultiplied___init__impl__uos02x(0);
  var RB = (imul(_RGBA___get_value__impl__hhco8v($this) & 16711935, A) >>> 8 | 0) & 16711935;
  var G = (imul(_RGBA___get_value__impl__hhco8v($this) & 65280, A) >>> 8 | 0) & 65280;
  return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this) & -16777216 | RB | G);
}
function RGBA__times_impl_wehs9n($this, other) {
  return Companion_getInstance_22().c4o($this, other);
}
var Companion_instance_12;
function Companion_getInstance_22() {
  if (Companion_instance_12 === VOID)
    new Companion_6();
  return Companion_instance_12;
}
function RGBA__hashCode_impl_h59qf6($this) {
  return $this;
}
function RGBA__equals_impl_4vjmca($this, other) {
  if (!(other instanceof RGBA))
    return false;
  if (!($this === (other instanceof RGBA ? other.m4e_1 : THROW_CCE())))
    return false;
  return true;
}
function asNonPremultiplied(_this__u8e3s4) {
  return _RGBA___init__impl__lqpay5(_RGBAPremultiplied___get_value__impl__bqfhud(_this__u8e3s4));
}
function _RGBAPremultiplied___init__impl__uos02x(value) {
  return value;
}
function _RGBAPremultiplied___get_value__impl__bqfhud($this) {
  return $this;
}
function _RGBAPremultiplied___init__impl__uos02x_0(r, g, b, a) {
  return _RGBAPremultiplied___init__impl__uos02x(packIntClamped(r, g, b, a));
}
function _RGBAPremultiplied___get_r__impl__m8nz5i($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 0 | 0) & 255;
}
function _RGBAPremultiplied___get_g__impl__fv131x($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 8 | 0) & 255;
}
function _RGBAPremultiplied___get_b__impl__dt4tp6($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 16 | 0) & 255;
}
function _RGBAPremultiplied___get_a__impl__f0hnd1($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0) & 255;
}
function _RGBAPremultiplied___get_rf__impl__pt0c4y($this) {
  return _RGBAPremultiplied___get_r__impl__m8nz5i($this) / 255.0;
}
function _RGBAPremultiplied___get_gf__impl__ivron7($this) {
  return _RGBAPremultiplied___get_g__impl__fv131x($this) / 255.0;
}
function _RGBAPremultiplied___get_bf__impl__qa3on2($this) {
  return _RGBAPremultiplied___get_b__impl__dt4tp6($this) / 255.0;
}
function _RGBAPremultiplied___get_af__impl__euwcjn($this) {
  return _RGBAPremultiplied___get_a__impl__f0hnd1($this) / 255.0;
}
function _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv($this) {
  var alpha = _RGBAPremultiplied___get_a__impl__f0hnd1($this);
  var tmp;
  if (alpha === 0) {
    tmp = Colors_getInstance().x3y_1;
  } else {
    var ialpha = 255.0 / alpha;
    var tmp_0 = Companion_getInstance_22();
    // Inline function 'kotlin.math.roundToInt' call
    var this_0 = _RGBAPremultiplied___get_r__impl__m8nz5i($this) * ialpha;
    var tmp_1 = roundToInt(this_0);
    // Inline function 'kotlin.math.roundToInt' call
    var this_1 = _RGBAPremultiplied___get_g__impl__fv131x($this) * ialpha;
    var tmp_2 = roundToInt(this_1);
    // Inline function 'kotlin.math.roundToInt' call
    var this_2 = _RGBAPremultiplied___get_b__impl__dt4tp6($this) * ialpha;
    var tmp$ret$2 = roundToInt(this_2);
    tmp = tmp_0.c4d(tmp_1, tmp_2, tmp$ret$2, alpha);
  }
  return tmp;
}
function RGBAPremultiplied__scaled256_impl_hjm9ii($this, s) {
  var rb = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) & 16711935, s) >>> 8 | 0) & 16711935;
  var g = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) & 65280, s) >>> 8 | 0) & 65280;
  var a = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0, s) >>> 8 | 0) << 24;
  return _RGBAPremultiplied___init__impl__uos02x(rb | g | a);
}
function RGBAPremultiplied__scaled_impl_qz7lg1($this, alpha) {
  // Inline function 'kotlin.math.roundToInt' call
  var this_0 = clamp01_0(alpha) * 256;
  var tmp$ret$0 = roundToInt(this_0);
  return RGBAPremultiplied__scaled256_impl_hjm9ii($this, tmp$ret$0);
}
var Companion_instance_13;
function Companion_getInstance_23() {
  return Companion_instance_13;
}
function asPremultiplied(_this__u8e3s4) {
  return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v(_this__u8e3s4));
}
function mix(_this__u8e3s4, src) {
  var dst = _this__u8e3s4;
  var srcAf = _RGBAPremultiplied___get_af__impl__euwcjn(src);
  var oneMSrcAf = 1.0 - srcAf;
  // Inline function 'kotlin.math.roundToInt' call
  var this_0 = _RGBAPremultiplied___get_a__impl__f0hnd1(src) + _RGBAPremultiplied___get_a__impl__f0hnd1(dst) * oneMSrcAf;
  var outA = roundToInt(this_0);
  // Inline function 'kotlin.math.roundToInt' call
  var this_1 = _RGBAPremultiplied___get_r__impl__m8nz5i(src) + _RGBAPremultiplied___get_r__impl__m8nz5i(dst) * oneMSrcAf;
  var outR = roundToInt(this_1);
  // Inline function 'kotlin.math.roundToInt' call
  var this_2 = _RGBAPremultiplied___get_g__impl__fv131x(src) + _RGBAPremultiplied___get_g__impl__fv131x(dst) * oneMSrcAf;
  var outG = roundToInt(this_2);
  // Inline function 'kotlin.math.roundToInt' call
  var this_3 = _RGBAPremultiplied___get_b__impl__dt4tp6(src) + _RGBAPremultiplied___get_b__impl__dt4tp6(dst) * oneMSrcAf;
  var outB = roundToInt(this_3);
  return _RGBAPremultiplied___init__impl__uos02x_0(outR, outG, outB, outA);
}
function _RgbaPremultipliedArray___init__impl__lx83hy(ints) {
  return ints;
}
function _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this) {
  return $this;
}
var Companion_instance_14;
function Companion_getInstance_24() {
  return Companion_instance_14;
}
function _RgbaPremultipliedArray___get_size__impl__6lte0e($this) {
  return _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this).length;
}
function RgbaPremultipliedArray__get_impl_1u69ta($this, index) {
  return _RGBAPremultiplied___init__impl__uos02x(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index]);
}
function RgbaPremultipliedArray__set_impl_7fwbby($this, index, color) {
  _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index] = _RGBAPremultiplied___get_value__impl__bqfhud(color);
}
function RgbaPremultipliedArray__fill_impl_sem38t($this, value, start, end) {
  return fill(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this), _RGBAPremultiplied___get_value__impl__bqfhud(value), start, end);
}
function RgbaPremultipliedArray__toString_impl_seal6e($this) {
  return 'RgbaPremultipliedArray(' + _RgbaPremultipliedArray___get_size__impl__6lte0e($this) + ')';
}
function RgbaPremultipliedArray__hashCode_impl_kvnjzv($this) {
  return hashCode($this);
}
function RgbaPremultipliedArray__equals_impl_vav5d5($this, other) {
  if (!(other instanceof RgbaPremultipliedArray))
    return false;
  var tmp0_other_with_cast = other instanceof RgbaPremultipliedArray ? other.p4o_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function scale(color, colorOffset, alpha, alphaOffset, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var a = clamp01_0(alpha[alphaOffset + n | 0]);
      if (a === 1.0)
        continue $l$loop;
      RgbaPremultipliedArray__set_impl_7fwbby(color, colorOffset + n | 0, RGBAPremultiplied__scaled_impl_qz7lg1(RgbaPremultipliedArray__get_impl_1u69ta(color, colorOffset + n | 0), a));
    }
     while (inductionVariable < count);
}
function premultiply(src, srcN, dst, dstN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      RgbaPremultipliedArray__set_impl_7fwbby(dst, dstN + n | 0, _RGBA___get_premultiplied__impl__3bulqc(RgbaArray__get_impl_nzyo1o(src, srcN + n | 0)));
    }
     while (inductionVariable < count);
}
function depremultiply(src, srcN, dst, dstN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = dstN + n | 0;
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = RgbaPremultipliedArray__get_impl_1u69ta(src, srcN + n | 0);
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
      RgbaArray__set_impl_epw2wg(dst, tmp, tmp$ret$0);
    }
     while (inductionVariable < count);
}
function mix_0(dst, dstX, src, srcX, count) {
  return mix_1(dst, dstX, dst, dstX, src, srcX, count);
}
function mix_1(tgt, tgtX, dst, dstX, src, srcX, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var srcC = RgbaPremultipliedArray__get_impl_1u69ta(src, srcX + n | 0);
      RgbaPremultipliedArray__set_impl_7fwbby(tgt, tgtX + n | 0, _RGBAPremultiplied___get_a__impl__f0hnd1(srcC) === 255 ? srcC : Companion_instance_13.n4o(RgbaPremultipliedArray__get_impl_1u69ta(dst, dstX + n | 0), srcC));
    }
     while (inductionVariable < count);
}
function _RGBAf___init__impl__idjpgn(data) {
  return data;
}
function _RGBAf___get_data__impl__yt2t4($this) {
  return $this;
}
function _RGBAf___init__impl__idjpgn_0(r, g, b, a) {
  r = r === VOID ? 1.0 : r;
  g = g === VOID ? 1.0 : g;
  b = b === VOID ? 1.0 : b;
  a = a === VOID ? 1.0 : a;
  // Inline function 'kotlin.floatArrayOf' call
  var tmp$ret$0 = new Float32Array([r, g, b, a]);
  return _RGBAf___init__impl__idjpgn(tmp$ret$0);
}
function _RGBAf___set_r__impl__pz5j5e($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[0] = v;
}
function _RGBAf___get_r__impl__jfq8gq($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[0];
}
function _RGBAf___set_g__impl__c4jj21($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[1] = v;
}
function _RGBAf___get_g__impl__dhoraz($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[1];
}
function _RGBAf___set_b__impl__a2n9pa($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[2] = v;
}
function _RGBAf___get_b__impl__fjl0nq($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[2];
}
function _RGBAf___set_a__impl__iqz7cx($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[3] = v;
}
function _RGBAf___get_a__impl__qnwk97($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[3];
}
var Companion_instance_15;
function Companion_getInstance_25() {
  return Companion_instance_15;
}
function BitmapFont$Glyph$bmp$delegate$lambda(this$0) {
  return function () {
    return extract_0(this$0.t4o_1).x3x();
  };
}
var Companion_instance_16;
function Companion_getInstance_26() {
  return Companion_instance_16;
}
function BitmapFontImpl$naturalFontMetrics$delegate$lambda(this$0) {
  return function () {
    var ascent = this$0.s4r_1;
    var baseline = 0.0;
    var tmp = -this$0.x4r_1;
    var tmp_0 = -this$0.x4r_1;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BitmapFontImpl.naturalFontMetrics$delegate.<anonymous>.<anonymous>' call
    var width = 0.0;
    var _iterator__ex2g4s = this$0.t4r_1.i3().a1();
    while (_iterator__ex2g4s.b1()) {
      var glyph = _iterator__ex2g4s.c1();
      if (!(glyph == null)) {
        // Inline function 'kotlin.math.max' call
        var a = width;
        var b = glyph.t4o_1.b3g_1;
        width = Math.max(a, b);
      }
    }
    var tmp$ret$2 = width;
    return new FontMetrics(this$0.q4r_1, ascent, ascent, baseline, tmp, tmp_0, 0.0, tmp$ret$2);
  };
}
function BitmapFontImpl$anyGlyph$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.t4r_1.d1(this$0.t4r_1.d3().a1().c1());
    return tmp0_elvis_lhs == null ? this$0.c4s() : tmp0_elvis_lhs;
  };
}
function BitmapFontImpl$invalidGlyph$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    return new Glyph(this$0.q4r_1, -1, tmp$ret$0, 0, 0, 0);
  };
}
function *_generator_readBitmapFont__n2ejpo(_this__u8e3s4, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_38().d4s_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  var fntFile = _this__u8e3s4;
  // Inline function 'kotlin.text.trim' call
  var tmp = fntFile.u23(VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var this_0 = tmp;
  var content = toString_0(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  // Inline function 'kotlin.collections.hashMapOf' call
  var textures = HashMap.i8();
  var tmp_0;
  if (startsWith_0(content, _Char___init__impl__6a9atx(60))) {
    var tmp_1 = readBitmapFontXml(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } else if (startsWith_0(content, _Char___init__impl__6a9atx(123))) {
    var tmp_2 = readBitmapFontJson(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    tmp_0 = tmp_2;
  } else if (startsWith(content, 'info')) {
    var tmp_3 = readBitmapFontTxt(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_0 = tmp_3;
  } else {
    var reason = 'Unsupported font type starting with ' + substr_0(content, 0, 16);
    throw NotImplementedError.od('An operation is not implemented: ' + reason);
  }
  return tmp_0;
}
function readBitmapFont(_this__u8e3s4, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_38().d4s_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFont__n2ejpo.bind(VOID, _this__u8e3s4, props, mipmaps, atlas), $completion);
}
function *_generator_readBitmapFontXml__tgdamn(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_38().d4s_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  var xml = Xml(content);
  var tmp60_safe_receiver = firstOrNull(xml.bi('info'));
  var tmp0_elvis_lhs = tmp60_safe_receiver == null ? null : tmp60_safe_receiver.p11('size');
  var fontSize = tmp0_elvis_lhs == null ? 16.0 : tmp0_elvis_lhs;
  var tmp61_safe_receiver = firstOrNull(xml.bi('common'));
  var tmp1_elvis_lhs = tmp61_safe_receiver == null ? null : tmp61_safe_receiver.p11('lineHeight');
  var lineHeight = tmp1_elvis_lhs == null ? 16.0 : tmp1_elvis_lhs;
  var tmp62_safe_receiver = firstOrNull(xml.bi('common'));
  var tmp2_elvis_lhs = tmp62_safe_receiver == null ? null : tmp62_safe_receiver.p11('base');
  var base = tmp2_elvis_lhs == null ? 16.0 : tmp2_elvis_lhs;
  var tmp63_safe_receiver = firstOrNull(xml.bi('distanceField'));
  var distanceField = tmp63_safe_receiver == null ? null : tmp63_safe_receiver.q11('fieldType');
  var _iterator__ex2g4s = get(xml.bi('pages'), 'page').a1();
  while (_iterator__ex2g4s.b1()) {
    var page = _iterator__ex2g4s.c1();
    var id = page.m11('id');
    var file = page.o11('file');
    var texFile = fntFile.p23().bi(file);
    var tmp = readBitmap(texFile, props, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tex = slice(mipmaps(tmp, mipmaps_0));
    // Inline function 'kotlin.collections.set' call
    textures.e3(id, tex);
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get(xml.bi('chars'), 'char');
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator = this_0.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var page_0 = item.m11('page');
    var tmp0_elvis_lhs_0 = textures.c3(page_0);
    var texture = tmp0_elvis_lhs_0 == null ? first(textures.i3()) : tmp0_elvis_lhs_0;
    var tmp_0 = item.m11('id');
    var tmp_1;
    if (atlas == null) {
      tmp_1 = null;
    } else {
      var tmp_2 = texture.j3h(item.m11('x'), item.m11('y'), item.m11('width'), item.m11('height'));
      tmp_1 = atlas.b3y(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
    }
    var tmp65_safe_receiver = tmp_1;
    var tmp1_elvis_lhs_0 = tmp65_safe_receiver == null ? null : tmp65_safe_receiver.b3w_1;
    var tmp$ret$0 = new Glyph(fontSize, tmp_0, tmp1_elvis_lhs_0 == null ? texture.j3h(item.m11('x'), item.m11('y'), item.m11('width'), item.m11('height')) : tmp1_elvis_lhs_0, item.m11('xoffset'), item.m11('yoffset'), item.m11('xadvance'));
    destination.h(tmp$ret$0);
  }
  var glyphs = destination;
  // Inline function 'kotlin.collections.map' call
  var this_1 = get(xml.bi('kernings'), 'kerning');
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
  var tmp0_iterator_0 = this_1.a1();
  while (tmp0_iterator_0.b1()) {
    var item_0 = tmp0_iterator_0.c1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$3 = new Kerning(item_0.m11('first'), item_0.m11('second'), item_0.m11('amount'));
    destination_0.h(tmp$ret$3);
  }
  var kernings = destination_0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList.w(collectionSizeOrDefault(glyphs, 10));
  var tmp0_iterator_1 = glyphs.a1();
  while (tmp0_iterator_1.b1()) {
    var item_1 = tmp0_iterator_1.c1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$6 = to(item_1.s4o_1, item_1);
    destination_1.h(tmp$ret$6);
  }
  var glyphs_0 = toIntMap(toMap(destination_1));
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList.w(collectionSizeOrDefault(kernings, 10));
  var tmp0_iterator_2 = kernings.a1();
  while (tmp0_iterator_2.b1()) {
    var item_2 = tmp0_iterator_2.c1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$9 = to(Companion_instance_15.q4o(item_2.z4o_1, item_2.a4p_1), item_2);
    destination_2.h(tmp$ret$9);
  }
  var kernings_0 = toIntMap(toMap(destination_2));
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), glyphs_0, kernings_0, name, distanceField);
}
function readBitmapFontXml(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_38().d4s_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontXml__tgdamn.bind(VOID, content, fntFile, textures, props, mipmaps, atlas), $completion);
}
function *_generator_readBitmapFontJson__a3fd7w(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_38().d4s_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  var json = get_dyn(Companion_getInstance_12().cz(content));
  var fontSize = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'info'), 'size'), 16.0);
  var lineHeight = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'common'), 'lineHeight'), 16.0);
  var base = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'common'), 'base'), 16.0);
  var distanceField = Dyn__toStringOrNull_impl_7e6cgy(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'distanceField'), 'fieldType'));
  // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
  var this_0 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'pages'));
  var n = 0;
  while (n < this_0.e1()) {
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var id = n;
    var page = this_0.d1(n).y2w_1;
    var file = Dyn__toString_impl_9l0v3s(page);
    var texFile = fntFile.p23().bi(file);
    var tmp = readBitmap(texFile, props, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tex = slice(mipmaps(tmp, mipmaps_0));
    // Inline function 'kotlin.collections.set' call
    textures.e3(id, tex);
    n = n + 1 | 0;
  }
  // Inline function 'kotlin.collections.map' call
  var this_1 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'chars'));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
  var tmp0_iterator = this_1.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var it = item.y2w_1;
    var page_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'page'));
    var tmp0_elvis_lhs = textures.c3(page_0);
    var texture = tmp0_elvis_lhs == null ? first(textures.i3()) : tmp0_elvis_lhs;
    var tmp_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'id'));
    var tmp_1;
    if (atlas == null) {
      tmp_1 = null;
    } else {
      var tmp_2 = texture.j3h(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'height')));
      tmp_1 = atlas.b3y(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
    }
    var tmp43_safe_receiver = tmp_1;
    var tmp1_elvis_lhs = tmp43_safe_receiver == null ? null : tmp43_safe_receiver.b3w_1;
    var tmp$ret$0 = new Glyph(fontSize, tmp_0, tmp1_elvis_lhs == null ? texture.j3h(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'height'))) : tmp1_elvis_lhs, _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'xoffset')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'yoffset')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'xadvance')));
    destination.h(tmp$ret$0);
  }
  var glyphs = destination;
  // Inline function 'kotlin.collections.map' call
  var this_2 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'kernings'));
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.w(collectionSizeOrDefault(this_2, 10));
  var tmp0_iterator_0 = this_2.a1();
  while (tmp0_iterator_0.b1()) {
    var item_0 = tmp0_iterator_0.c1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var it_0 = item_0.y2w_1;
    var tmp$ret$3 = new Kerning(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'first')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'second')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'amount')));
    destination_0.h(tmp$ret$3);
  }
  var kernings = destination_0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList.w(collectionSizeOrDefault(glyphs, 10));
  var tmp0_iterator_1 = glyphs.a1();
  while (tmp0_iterator_1.b1()) {
    var item_1 = tmp0_iterator_1.c1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var tmp$ret$6 = to(item_1.s4o_1, item_1);
    destination_1.h(tmp$ret$6);
  }
  var glyphs_0 = toIntMap(toMap(destination_1));
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList.w(collectionSizeOrDefault(kernings, 10));
  var tmp0_iterator_2 = kernings.a1();
  while (tmp0_iterator_2.b1()) {
    var item_2 = tmp0_iterator_2.c1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var tmp$ret$9 = to(Companion_instance_15.q4o(item_2.z4o_1, item_2.a4p_1), item_2);
    destination_2.h(tmp$ret$9);
  }
  var kernings_0 = toIntMap(toMap(destination_2));
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), glyphs_0, kernings_0, name, distanceField);
}
function readBitmapFontJson(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_38().d4s_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontJson__a3fd7w.bind(VOID, content, fntFile, textures, props, mipmaps, atlas), $completion);
}
function *_generator_readBitmapFontTxt__tgfm88(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_38().d4s_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  // Inline function 'kotlin.collections.arrayListOf' call
  var kernings = ArrayList.h1();
  // Inline function 'kotlin.collections.arrayListOf' call
  var glyphs = ArrayList.h1();
  var lineHeight = 16.0;
  var fontSize = 16.0;
  var base = null;
  var _iterator__ex2g4s = lines(content).a1();
  while (_iterator__ex2g4s.b1()) {
    var rline = _iterator__ex2g4s.c1();
    // Inline function 'kotlin.text.trim' call
    var line = toString_0(trim(isCharSequence(rline) ? rline : THROW_CCE()));
    var map = LinkedHashMap.bc();
    var _iterator__ex2g4s_0 = split_0(line, charArrayOf([_Char___init__impl__6a9atx(32)])).a1();
    while (_iterator__ex2g4s_0.b1()) {
      var part = _iterator__ex2g4s_0.c1();
      var _destruct__k2r9zo = plus(split_0(part, charArrayOf([_Char___init__impl__6a9atx(61)])), listOf(['', '']));
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.d1(0);
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.d1(1);
      // Inline function 'kotlin.collections.set' call
      map.e3(key, value);
    }
    if (startsWith(line, 'info')) {
      // Inline function 'kotlin.math.absoluteValue' call
      var tmp44_safe_receiver = map.c3('size');
      var tmp0_elvis_lhs = tmp44_safe_receiver == null ? null : toDouble(tmp44_safe_receiver);
      var this_0 = tmp0_elvis_lhs == null ? 16.0 : tmp0_elvis_lhs;
      fontSize = Math.abs(this_0);
    } else if (startsWith(line, 'page')) {
      var tmp45_safe_receiver = map.c3('id');
      var tmp1_elvis_lhs = tmp45_safe_receiver == null ? null : toInt_0(tmp45_safe_receiver);
      var id = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      var tmp46_safe_receiver = map.c3('file');
      var tmp2_elvis_lhs = tmp46_safe_receiver == null ? null : unquote(tmp46_safe_receiver);
      var tmp;
      if (tmp2_elvis_lhs == null) {
        var message = 'page without file';
        throw IllegalStateException.w4(toString_0(message));
      } else {
        tmp = tmp2_elvis_lhs;
      }
      var file = tmp;
      // Inline function 'kotlin.collections.set' call
      var tmp_0 = readBitmap(fntFile.p23().bi(file), props, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      var value_0 = slice(mipmaps(tmp_0, mipmaps_0));
      textures.e3(id, value_0);
    } else if (startsWith(line, 'common ')) {
      var tmp47_safe_receiver = map.c3('lineHeight');
      var tmp3_elvis_lhs = tmp47_safe_receiver == null ? null : toDoubleOrNull(tmp47_safe_receiver);
      lineHeight = tmp3_elvis_lhs == null ? 16.0 : tmp3_elvis_lhs;
      var tmp48_safe_receiver = map.c3('base');
      base = tmp48_safe_receiver == null ? null : toDoubleOrNull(tmp48_safe_receiver);
    } else if (startsWith(line, 'char ')) {
      var tmp49_safe_receiver = map.c3('page');
      var tmp4_elvis_lhs = tmp49_safe_receiver == null ? null : toIntOrNull(tmp49_safe_receiver);
      var page = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
      var tmp5_elvis_lhs = textures.c3(page);
      var texture = tmp5_elvis_lhs == null ? first(textures.i3()) : tmp5_elvis_lhs;
      var dmap = get_dyn(map);
      var id_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'id'));
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp52_fontSize = fontSize;
      var tmp53_xoffset = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'xoffset'));
      var tmp54_yoffset = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'yoffset'));
      var tmp55_xadvance = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'xadvance'));
      var tmp_1;
      if (atlas == null) {
        tmp_1 = null;
      } else {
        var tmp_2 = texture.j3h(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'height')), 'glyph-' + toString_1(numberToChar(id_0)));
        tmp_1 = atlas.b3y(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
      }
      var tmp51_safe_receiver = tmp_1;
      var tmp6_elvis_lhs = tmp51_safe_receiver == null ? null : tmp51_safe_receiver.b3w_1;
      var tmp56_texture = tmp6_elvis_lhs == null ? texture.j3h(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'height')), 'glyph-' + toString_1(numberToChar(id_0))) : tmp6_elvis_lhs;
      var element = new Glyph(tmp52_fontSize, id_0, tmp56_texture, tmp53_xoffset, tmp54_yoffset, tmp55_xadvance);
      glyphs.h(element);
    } else if (startsWith(line, 'kerning ')) {
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp57_safe_receiver = map.c3('first');
      var tmp7_elvis_lhs = tmp57_safe_receiver == null ? null : toIntOrNull(tmp57_safe_receiver);
      var tmp_3 = tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs;
      var tmp58_safe_receiver = map.c3('second');
      var tmp8_elvis_lhs = tmp58_safe_receiver == null ? null : toIntOrNull(tmp58_safe_receiver);
      var tmp_4 = tmp8_elvis_lhs == null ? 0 : tmp8_elvis_lhs;
      var tmp59_safe_receiver = map.c3('amount');
      var tmp9_elvis_lhs = tmp59_safe_receiver == null ? null : toIntOrNull(tmp59_safe_receiver);
      var element_0 = new Kerning(tmp_3, tmp_4, tmp9_elvis_lhs == null ? 0 : tmp9_elvis_lhs);
      kernings.h(element_0);
    }
  }
  // Inline function 'korlibs.image.font.Companion.invoke' call
  var fontSize_0 = fontSize;
  var lineHeight_0 = lineHeight;
  var tmp10_elvis_lhs = base;
  var base_0 = tmp10_elvis_lhs == null ? lineHeight : tmp10_elvis_lhs;
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(glyphs, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap.cc(capacity);
  var tmp0_iterator = glyphs.a1();
  while (tmp0_iterator.b1()) {
    var element_1 = tmp0_iterator.c1();
    // Inline function 'korlibs.image.font.readBitmapFontTxt.<anonymous>' call
    var tmp$ret$6 = element_1.s4o_1;
    destination.e3(tmp$ret$6, element_1);
  }
  var glyphs_0 = toIntMap(destination);
  var kernings_0 = associateByInt(kernings, readBitmapFontTxt$lambda);
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize_0), numberToDouble(lineHeight_0), numberToDouble(base_0), glyphs_0, kernings_0, name, null);
}
function readBitmapFontTxt(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_38().d4s_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontTxt__tgfm88.bind(VOID, content, fntFile, textures, props, mipmaps, atlas), $completion);
}
function readBitmapFontTxt$lambda(_unused_var__etf5q3, it) {
  return Companion_instance_15.q4o(it.z4o_1, it.a4p_1);
}
function bmp$factory() {
  return getPropertyCallableRef('bmp', 1, KProperty1, function (receiver) {
    return receiver.e4p();
  }, null);
}
function naturalFontMetrics$factory() {
  return getPropertyCallableRef('naturalFontMetrics', 1, KProperty1, function (receiver) {
    return receiver.m4p();
  }, null);
}
function anyGlyph$factory() {
  return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
    return receiver.l4p();
  }, null);
}
function invalidGlyph$factory() {
  return getPropertyCallableRef('invalidGlyph', 1, KProperty1, function (receiver) {
    return receiver.c4s();
  }, null);
}
var DefaultTtfFontOrNull;
function get_DefaultTtfFont() {
  if (DefaultTtfFontOrNull == null) {
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.ej();
    // Inline function 'korlibs.image.font.<get-DefaultTtfFont>.<anonymous>' call
    var result = TtfFont.r4u(DefaultTtfFontBytes(), 'Default Font');
    var res = new TimedValue(result, ValueTimeMark__elapsedNow_impl_eonqvs(mark));
    DefaultTtfFontOrNull = res.gr_1;
  }
  return ensureNotNull(DefaultTtfFontOrNull);
}
function DefaultTtfFontBytes() {
  return uncompress(fromBase64('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'), Companion_getInstance_13());
}
function get_DefaultTtfFontAsBitmap() {
  return get_lazyBitmapSDF(get_DefaultTtfFont());
}
function renderGlyphToBitmap(_this__u8e3s4, size, codePoint, paint, fill, effect, border, nativeRendering, reader) {
  paint = paint === VOID ? new RGBA(get_DefaultPaint()) : paint;
  fill = fill === VOID ? true : fill;
  effect = effect === VOID ? null : effect;
  border = border === VOID ? 1 : border;
  nativeRendering = nativeRendering === VOID ? true : nativeRendering;
  reader = reader === VOID ? null : reader;
  var font = _this__u8e3s4;
  var fmetrics = _this__u8e3s4.z4p(size);
  var gmetrics = _this__u8e3s4.h4q(size, codePoint, VOID, reader);
  var gx = -gmetrics.v25();
  var gy = gmetrics.n2i() + gmetrics.x25();
  var border2 = imul(border, 2);
  var iwidth = toIntCeil_0(gmetrics.m2i()) + border2 | 0;
  var iheight = toIntCeil_0(gmetrics.n2i()) + border2 | 0;
  var image = nativeRendering ? NativeImage_0(iwidth, iheight) : Bitmap32.e3x(iwidth, iheight, VOID, true);
  // Inline function 'korlibs.image.bitmap.context2d' call
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = image.p3x_1;
  if (true) {
    image.y3x();
  }
  var result;
  try {
    // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
    var ctx = image.h45(true);
    try {
      // Inline function 'korlibs.image.font.renderGlyphToBitmap.<anonymous>' call
      renderGlyphToBitmap$renderGlyph(ctx, paint, font, size, codePoint, gx, border, gy, gmetrics, fill);
    }finally {
      ctx.d18();
    }
  }finally {
    result = true ? image.a3y(rect) : 0;
  }
  var imageOut = applyEffect(image.i45(), effect);
  var glyph = new PlacedGlyphMetrics(codePoint, Vector2D.n27(gx + border, gy + border), gmetrics, fmetrics, Companion_getInstance_5().x28_1, 0, 0);
  var tmp = new TextMetrics();
  var tmp_0 = listOf_0(glyph);
  var tmp_1 = listOf_0(listOf_0(glyph));
  // Inline function 'korlibs.image.vector.buildShape' call
  // Inline function 'kotlin.apply' call
  var this_0 = new ShapeBuilder(iwidth, iheight);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.font.renderGlyphToBitmap.<anonymous>' call
  renderGlyphToBitmap$renderGlyph(this_0, paint, font, size, codePoint, gx, border, gy, gmetrics, fill);
  var tmp$ret$3 = this_0.i4v();
  return new TextToBitmapResult(imageOut, fmetrics, tmp, tmp_0, tmp_1, tmp$ret$3);
}
function PlacedGlyphMetrics$boundsPath$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.shape.buildVectorPath' call
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.PlacedGlyphMetrics.boundsPath$delegate.<anonymous>.<anonymous>' call
    this_0.a3e_1 = false;
    this_0.a3p(this$0.l4v_1.v25(), -this$0.m4v_1.r4p_1, this$0.l4v_1.f4q_1, this$0.m4v_1.g4p());
    return applyTransform(this_0, Companion_getInstance_5().a29().b2a(this$0.k4v_1).i2a(this$0.n4v_1));
  };
}
function PlacedGlyphMetrics$boundsPathCurves$delegate$lambda(this$0) {
  return function () {
    var curves = getCurves(this$0.u4v());
    var tmp;
    if (!(curves.o39_1.e1() === 4)) {
      println('curves=' + curves.o39_1.e1());
      tmp = Unit_instance;
    }
    return curves;
  };
}
function PlacedGlyphMetrics$caretStart$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.Line2D.flipped' call
    var this_0 = this$0.v4v().o39_1.d1(3).k3d();
    var tmp$ret$0 = Line2D.w27(this_0.v27_1, this_0.u27_1);
    return toBezier(tmp$ret$0);
  };
}
function PlacedGlyphMetrics$caretEnd$delegate$lambda(this$0) {
  return function () {
    return this$0.v4v().o39_1.d1(1);
  };
}
function drawText(_this__u8e3s4, ctx, size, text, paint, pos, fill, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd, placed) {
  pos = pos === VOID ? Companion_getInstance_6().g25_1 : pos;
  fill = fill === VOID ? true : fill;
  var tmp;
  if (renderer === VOID) {
    var tmp_0 = get_DefaultStringTextRenderer();
    tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
  } else {
    tmp = renderer;
  }
  renderer = tmp;
  align = align === VOID ? Companion_getInstance_48().p4w_1 : align;
  outMetrics = outMetrics === VOID ? null : outMetrics;
  fillStyle = fillStyle === VOID ? null : fillStyle;
  stroke = stroke === VOID ? null : stroke;
  textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
  textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
  placed = placed === VOID ? null : placed;
  var glyphs = !(outMetrics == null) ? new MultiplePlacedGlyphMetrics() : null;
  var fnt = _this__u8e3s4;
  var doRender = drawText$lambda(fillStyle, stroke, ctx, fill);
  var actions = new drawText$actions$1(renderer, text, size, fnt, align, pos, ctx, paint, textRangeStart, textRangeEnd, doRender, glyphs, placed);
  if (ctx == null)
    null;
  else {
    ctx.f4x();
  }
  invoke(renderer, actions, text, size, _this__u8e3s4);
  doRender();
  if (!(outMetrics == null)) {
    ensureNotNull(glyphs);
    outMetrics.d4w_1 = glyphs.g4x_1;
    outMetrics.e4w_1 = glyphs.h4x_1;
    var fmetrics = _this__u8e3s4.z4p(size);
    outMetrics.b4w_1 = fmetrics;
    var metrics = outMetrics.c4w_1;
    metrics.k4x_1.m4x(fmetrics);
    metrics.l4x_1 = glyphs.h4x_1.e1();
    var tmp_1 = metrics;
    // Inline function 'kotlin.collections.map' call
    var this_0 = glyphs.h4x_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.font.drawText.<anonymous>' call
      var bb = Companion_getInstance_7().e26();
      var _iterator__ex2g4s = item.a1();
      while (_iterator__ex2g4s.b1()) {
        var g = _iterator__ex2g4s.c1();
        bb = plus_2(bb, g.u4v());
      }
      var tmp$ret$0 = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
      destination.h(tmp$ret$0);
    }
    tmp_1.j4x_1 = destination;
    metrics.i4x_1 = _BoundsBuilder___get_bounds__impl__s1l1gx(BoundsBuilder__plus_impl_cz7f7x(Companion_getInstance_7().e26(), metrics.j4x_1));
  }
  return outMetrics;
}
function getTextBounds(_this__u8e3s4, size, text, out, renderer, align) {
  out = out === VOID ? new TextMetrics() : out;
  var tmp;
  if (renderer === VOID) {
    var tmp_0 = get_DefaultStringTextRenderer();
    tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
  } else {
    tmp = renderer;
  }
  renderer = tmp;
  align = align === VOID ? Companion_getInstance_48().l4w_1 : align;
  var actions = new BoundBuilderTextRendererActions();
  invoke(renderer, actions, text, size, _this__u8e3s4);
  _this__u8e3s4.o4p(size, out.k4x_1);
  out.l4x_1 = actions.c4y();
  var bb = Companion_getInstance_7().e26();
  var dy = 0.0;
  var lineBounds = FastArrayList.ny();
  var offsetY = actions.g4y(align.e4y_1, out.k4x_1);
  var _iterator__ex2g4s = actions.a4y_1.a1();
  while (_iterator__ex2g4s.b1()) {
    var line = _iterator__ex2g4s.c1();
    var offsetX = line.k4y(align.d4y_1);
    var rect = new Rectangle(-offsetX, +offsetY + dy - out.l4y(), line.i4y_1, line.h4y_1);
    bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, rect);
    lineBounds.h(rect);
    dy = dy + line.h4y_1;
  }
  out.j4x_1 = lineBounds;
  out.i4x_1 = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  return out;
}
function getTextBoundsWithGlyphs(_this__u8e3s4, size, text, renderer, align) {
  var tmp;
  if (renderer === VOID) {
    var tmp_0 = get_DefaultStringTextRenderer();
    tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
  } else {
    tmp = renderer;
  }
  renderer = tmp;
  align = align === VOID ? Companion_getInstance_48().p4w_1 : align;
  var font = _this__u8e3s4;
  // Inline function 'kotlin.also' call
  var this_0 = new TextMetricsResult();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.font.getTextBoundsWithGlyphs.<anonymous>' call
  var tmp74_pos = Companion_getInstance_6().g25_1;
  drawText(font, null, size, text, null, tmp74_pos, false, renderer, align, this_0);
  return this_0;
}
function renderGlyphToBitmap$renderGlyph(_this__u8e3s4, $paint, font, $size, $codePoint, gx, $border, gy, gmetrics, $fill) {
  _this__u8e3s4.k4r($paint);
  font.n4r(_this__u8e3s4, $size, $codePoint, Vector2D.n27(gx + $border, gy + $border), true, gmetrics);
  if ($fill) {
    _this__u8e3s4.o4y();
  } else {
    _this__u8e3s4.n4y();
  }
}
function drawText$lambda($fillStyle, $stroke, $ctx, $fill) {
  return function () {
    if (!($fillStyle == null) || !($stroke == null)) {
      var tmp67_safe_receiver = $ctx;
      if (tmp67_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
        var fill = $fillStyle;
        var stroke = $stroke;
        // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
        var stroke_0 = stroke == null ? null : stroke.p4y_1;
        var strokeInfo = stroke == null ? null : stroke.q4y_1;
        // Inline function 'korlibs.image.vector.Context2d.fillStroke.<anonymous>' call
        if (!(fill == null)) {
          tmp67_safe_receiver.r4y(fill);
        }
        if (!(stroke_0 == null)) {
          if (!(strokeInfo == null)) {
            $l$block: {
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              if (stroke_0 == null || strokeInfo == null) {
                break $l$block;
              }
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              var lineWidth = strokeInfo.d38_1;
              var lineCap = strokeInfo.g38_1;
              var lineJoin = strokeInfo.i38_1;
              var miterLimit = strokeInfo.j38_1;
              var lineDash = strokeInfo.k38_1;
              var lineDashOffset = strokeInfo.l38_1;
              if (false) {
                tmp67_safe_receiver.f4x();
              }
              // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
              // Inline function 'korlibs.image.vector.Context2d.keep' call
              tmp67_safe_receiver.y4y();
              try {
                // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
                tmp67_safe_receiver.z4y(numberToDouble(lineWidth));
                tmp67_safe_receiver.a4z(lineCap);
                tmp67_safe_receiver.b4z(lineJoin);
                tmp67_safe_receiver.c4z(numberToDouble(miterLimit));
                tmp67_safe_receiver.d4z(lineDash);
                tmp67_safe_receiver.e4z(numberToDouble(lineDashOffset));
                tmp67_safe_receiver.f4z(stroke_0);
              }finally {
                tmp67_safe_receiver.g4z();
              }
            }
          } else {
            // Inline function 'korlibs.image.vector.Context2d.stroke' call
            var lineWidth_0 = tmp67_safe_receiver.s4y();
            var lineCap_0 = tmp67_safe_receiver.t4y();
            var lineJoin_0 = tmp67_safe_receiver.u4y();
            var miterLimit_0 = tmp67_safe_receiver.v4y();
            var lineDash_0 = tmp67_safe_receiver.w4y();
            var lineDashOffset_0 = tmp67_safe_receiver.x4y();
            if (false) {
              tmp67_safe_receiver.f4x();
            }
            // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
            // Inline function 'korlibs.image.vector.Context2d.keep' call
            tmp67_safe_receiver.y4y();
            try {
              // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
              tmp67_safe_receiver.z4y(numberToDouble(lineWidth_0));
              tmp67_safe_receiver.a4z(lineCap_0);
              tmp67_safe_receiver.b4z(lineJoin_0);
              tmp67_safe_receiver.c4z(numberToDouble(miterLimit_0));
              tmp67_safe_receiver.d4z(lineDash_0);
              tmp67_safe_receiver.e4z(numberToDouble(lineDashOffset_0));
              tmp67_safe_receiver.f4z(stroke_0);
            }finally {
              tmp67_safe_receiver.g4z();
            }
          }
        }
      }
    } else {
      if ($fill) {
        var tmp68_safe_receiver = $ctx;
        if (tmp68_safe_receiver == null)
          null;
        else {
          tmp68_safe_receiver.o4y();
        }
      } else {
        var tmp69_safe_receiver = $ctx;
        if (tmp69_safe_receiver == null)
          null;
        else {
          tmp69_safe_receiver.n4y();
        }
      }
    }
    var tmp70_safe_receiver = $ctx;
    if (tmp70_safe_receiver == null)
      null;
    else {
      tmp70_safe_receiver.f4x();
    }
    return Unit_instance;
  };
}
function boundsPath$factory() {
  return getPropertyCallableRef('boundsPath', 1, KProperty1, function (receiver) {
    return receiver.u4v();
  }, null);
}
function boundsPathCurves$factory() {
  return getPropertyCallableRef('boundsPathCurves', 1, KProperty1, function (receiver) {
    return receiver.v4v();
  }, null);
}
function caretStart$factory() {
  return getPropertyCallableRef('caretStart', 1, KProperty1, function (receiver) {
    return receiver.w4v();
  }, null);
}
function caretEnd$factory() {
  return getPropertyCallableRef('caretEnd', 1, KProperty1, function (receiver) {
    return receiver.x4v();
  }, null);
}
function *_generator_readFont__gkiy77(_this__u8e3s4, preload, props, mipmaps, $completion) {
  preload = preload === VOID ? false : preload;
  props = props === VOID ? Companion_getInstance_38().d4s_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  var tmp = _this__u8e3s4.q23(until(0, 16), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var header = tmp;
  var tmp_0;
  switch (getS32BE(header, 0)) {
    case 1953784678:
    case 1330926671:
    case 65536:
      var tmp_1 = readTtfFont(_this__u8e3s4, VOID, VOID, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp_0 = tmp_1;
      break;
    default:
      var tmp_2 = readBitmapFont(_this__u8e3s4, props, mipmaps, VOID, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_0 = tmp_2;
      break;
  }
  return tmp_0;
}
function readFont(_this__u8e3s4, preload, props, mipmaps, $completion) {
  preload = preload === VOID ? false : preload;
  props = props === VOID ? Companion_getInstance_38().d4s_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readFont__gkiy77.bind(VOID, _this__u8e3s4, preload, props, mipmaps), $completion);
}
var SystemFontRegistryOrNull;
function get_lazyBitmap(_this__u8e3s4) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = lazyBitmap$delegate;
    var property = lazyBitmap$factory();
    var tmp0_elvis_lhs = this_0.zx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.ay_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.zx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var lazyBitmap$delegate;
function get_lazyBitmapSDF(_this__u8e3s4) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = lazyBitmapSDF$delegate;
    var property = lazyBitmapSDF$factory();
    var tmp0_elvis_lhs = this_0.zx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.ay_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.zx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var lazyBitmapSDF$delegate;
var Companion_instance_17;
function Companion_getInstance_27() {
  if (Companion_instance_17 === VOID)
    new Companion_11();
  return Companion_instance_17;
}
function LazyBitmapFont$anyGlyph$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.u51_1.d1(this$0.u51_1.d3().a1().c1());
    return tmp0_elvis_lhs == null ? this$0.c4s() : tmp0_elvis_lhs;
  };
}
function LazyBitmapFont$invalidGlyph$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    return new Glyph(this$0.o51_1, -1, tmp$ret$0, 0, 0, 0);
  };
}
function LazyBitmapFont$naturalFontMetrics$delegate$lambda(this$0) {
  return function () {
    var descent = this$0.r51_1.t4p_1 - this$0.r51_1.v4p_1;
    var tmp78_size = this$0.r51_1.p4p_1;
    var tmp79_top = this$0.r51_1.q4p_1;
    var tmp80_ascent = this$0.r51_1.r4p_1;
    var tmp81_baseline = this$0.r51_1.s4p_1;
    var tmp82_maxWidth = this$0.r51_1.w4p_1;
    return new FontMetrics(tmp78_size, tmp79_top, tmp80_ascent, tmp81_baseline, descent, descent, 0.0, tmp82_maxWidth, 0.0);
  };
}
function toLazyBitmapFont(_this__u8e3s4, fontSize, distanceField) {
  distanceField = distanceField === VOID ? null : distanceField;
  _init_properties_LazyBitmapFont_kt__76ptri();
  return new LazyBitmapFont(_this__u8e3s4, fontSize, distanceField);
}
function get_lazyBitmap_0(_this__u8e3s4) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  var tmp;
  if (isInterface(_this__u8e3s4, VectorFont)) {
    tmp = get_lazyBitmap(_this__u8e3s4);
  } else {
    if (isInterface(_this__u8e3s4, BitmapFont)) {
      tmp = _this__u8e3s4;
    } else {
      throw NotImplementedError.od();
    }
  }
  return tmp;
}
function lazyBitmap$delegate$lambda($this$PropertyThis) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  return toLazyBitmapFont($this$PropertyThis, 32.0, null);
}
function lazyBitmapSDF$delegate$lambda($this$PropertyThis) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  return toLazyBitmapFont($this$PropertyThis, 32.0, 'sdf');
}
function lazyBitmap$factory() {
  return getPropertyCallableRef('lazyBitmap', 1, KProperty1, function (receiver) {
    return get_lazyBitmap(receiver);
  }, null);
}
function lazyBitmapSDF$factory() {
  return getPropertyCallableRef('lazyBitmapSDF', 1, KProperty1, function (receiver) {
    return get_lazyBitmapSDF(receiver);
  }, null);
}
function anyGlyph$factory_0() {
  return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
    return receiver.l4p();
  }, null);
}
function invalidGlyph$factory_0() {
  return getPropertyCallableRef('invalidGlyph', 1, KProperty1, function (receiver) {
    return receiver.c4s();
  }, null);
}
function naturalFontMetrics$factory_0() {
  return getPropertyCallableRef('naturalFontMetrics', 1, KProperty1, function (receiver) {
    return receiver.m4p();
  }, null);
}
var properties_initialized_LazyBitmapFont_kt_c74u44;
function _init_properties_LazyBitmapFont_kt__76ptri() {
  if (!properties_initialized_LazyBitmapFont_kt_c74u44) {
    properties_initialized_LazyBitmapFont_kt_c74u44 = true;
    lazyBitmap$delegate = new PropertyThis(VOID, lazyBitmap$delegate$lambda);
    lazyBitmapSDF$delegate = new PropertyThis(VOID, lazyBitmapSDF$delegate$lambda);
  }
}
var Op_version_instance;
var Op_Copyright_instance;
var Op_Notice_instance;
var Op_isFixedPitch_instance;
var Op_FullName_instance;
var Op_ItalicAngle_instance;
var Op_FamilyName_instance;
var Op_UnderlinePosition_instance;
var Op_Weight_instance;
var Op_UnderlineThickness_instance;
var Op_FontBBox_instance;
var Op_PaintType_instance;
var Op_BlueValues_instance;
var Op_CharstringType_instance;
var Op_OtherBlues_instance;
var Op_FontMatrix_instance;
var Op_FamilyBlues_instance;
var Op_StrokeWidth_instance;
var Op_FamilyOtherBlues_instance;
var Op_BlueScale_instance;
var Op_StdHW_instance;
var Op_BlueShift_instance;
var Op_StdVW_instance;
var Op_BlueFuzz_instance;
var Op_StemSnapH_instance;
var Op_UniqueID_instance;
var Op_StemSnapV_instance;
var Op_XUID_instance;
var Op_ForceBold_instance;
var Op_charset_instance;
var Op_Encoding_instance;
var Op_CharStrings_instance;
var Op_LanguageGroup_instance;
var Op_Private_instance;
var Op_ExpansionFactor_instance;
var Op_Subrs_instance;
var Op_initialRandomSeed_instance;
var Op_defaultWidthX_instance;
var Op_SyntheicBase_instance;
var Op_nominalWidthX_instance;
var Op_PostScript_instance;
var Op_vsindex_instance;
var Op_BaseFontName_instance;
var Op_blend_instance;
var Op_BaseFontBlend_instance;
var Op_vstore_instance;
var Op_maxstack_instance;
var Op_ROS_instance;
var Op_CIDFontVersion_instance;
var Op_CIDFontRevision_instance;
var Op_CIDFontType_instance;
var Op_CIDCount_instance;
var Op_UIDBase_instance;
var Op_FDArray_instance;
var Op_FDSelect_instance;
var Op_FontName_instance;
var Companion_instance_18;
function Companion_getInstance_28() {
  Op_initEntries();
  if (Companion_instance_18 === VOID)
    new Companion_12();
  return Companion_instance_18;
}
function values_0() {
  return [Op_version_getInstance(), Op_Copyright_getInstance(), Op_Notice_getInstance(), Op_isFixedPitch_getInstance(), Op_FullName_getInstance(), Op_ItalicAngle_getInstance(), Op_FamilyName_getInstance(), Op_UnderlinePosition_getInstance(), Op_Weight_getInstance(), Op_UnderlineThickness_getInstance(), Op_FontBBox_getInstance(), Op_PaintType_getInstance(), Op_BlueValues_getInstance(), Op_CharstringType_getInstance(), Op_OtherBlues_getInstance(), Op_FontMatrix_getInstance(), Op_FamilyBlues_getInstance(), Op_StrokeWidth_getInstance(), Op_FamilyOtherBlues_getInstance(), Op_BlueScale_getInstance(), Op_StdHW_getInstance(), Op_BlueShift_getInstance(), Op_StdVW_getInstance(), Op_BlueFuzz_getInstance(), Op_StemSnapH_getInstance(), Op_UniqueID_getInstance(), Op_StemSnapV_getInstance(), Op_XUID_getInstance(), Op_ForceBold_getInstance(), Op_charset_getInstance(), Op_Encoding_getInstance(), Op_CharStrings_getInstance(), Op_LanguageGroup_getInstance(), Op_Private_getInstance(), Op_ExpansionFactor_getInstance(), Op_Subrs_getInstance(), Op_initialRandomSeed_getInstance(), Op_defaultWidthX_getInstance(), Op_SyntheicBase_getInstance(), Op_nominalWidthX_getInstance(), Op_PostScript_getInstance(), Op_vsindex_getInstance(), Op_BaseFontName_getInstance(), Op_blend_getInstance(), Op_BaseFontBlend_getInstance(), Op_vstore_getInstance(), Op_maxstack_getInstance(), Op_ROS_getInstance(), Op_CIDFontVersion_getInstance(), Op_CIDFontRevision_getInstance(), Op_CIDFontType_getInstance(), Op_CIDCount_getInstance(), Op_UIDBase_getInstance(), Op_FDArray_getInstance(), Op_FDSelect_getInstance(), Op_FontName_getInstance()];
}
var Op_entriesInitialized;
function Op_initEntries() {
  if (Op_entriesInitialized)
    return Unit_instance;
  Op_entriesInitialized = true;
  Op_version_instance = new Op('version', 0, 0);
  Op_Copyright_instance = new Op('Copyright', 1, 3072);
  Op_Notice_instance = new Op('Notice', 2, 1);
  Op_isFixedPitch_instance = new Op('isFixedPitch', 3, 3073);
  Op_FullName_instance = new Op('FullName', 4, 2);
  Op_ItalicAngle_instance = new Op('ItalicAngle', 5, 3074);
  Op_FamilyName_instance = new Op('FamilyName', 6, 3);
  Op_UnderlinePosition_instance = new Op('UnderlinePosition', 7, 3075);
  Op_Weight_instance = new Op('Weight', 8, 4);
  Op_UnderlineThickness_instance = new Op('UnderlineThickness', 9, 3076);
  Op_FontBBox_instance = new Op('FontBBox', 10, 5);
  Op_PaintType_instance = new Op('PaintType', 11, 3077);
  Op_BlueValues_instance = new Op('BlueValues', 12, 6);
  Op_CharstringType_instance = new Op('CharstringType', 13, 3078);
  Op_OtherBlues_instance = new Op('OtherBlues', 14, 7);
  Op_FontMatrix_instance = new Op('FontMatrix', 15, 3079);
  Op_FamilyBlues_instance = new Op('FamilyBlues', 16, 8);
  Op_StrokeWidth_instance = new Op('StrokeWidth', 17, 3080);
  Op_FamilyOtherBlues_instance = new Op('FamilyOtherBlues', 18, 9);
  Op_BlueScale_instance = new Op('BlueScale', 19, 3081);
  Op_StdHW_instance = new Op('StdHW', 20, 10);
  Op_BlueShift_instance = new Op('BlueShift', 21, 3082);
  Op_StdVW_instance = new Op('StdVW', 22, 11);
  Op_BlueFuzz_instance = new Op('BlueFuzz', 23, 3083);
  Op_StemSnapH_instance = new Op('StemSnapH', 24, 3084);
  Op_UniqueID_instance = new Op('UniqueID', 25, 13);
  Op_StemSnapV_instance = new Op('StemSnapV', 26, 3085);
  Op_XUID_instance = new Op('XUID', 27, 14);
  Op_ForceBold_instance = new Op('ForceBold', 28, 3086);
  Op_charset_instance = new Op('charset', 29, 15);
  Op_Encoding_instance = new Op('Encoding', 30, 16);
  Op_CharStrings_instance = new Op('CharStrings', 31, 17);
  Op_LanguageGroup_instance = new Op('LanguageGroup', 32, 3089);
  Op_Private_instance = new Op('Private', 33, 18);
  Op_ExpansionFactor_instance = new Op('ExpansionFactor', 34, 3090);
  Op_Subrs_instance = new Op('Subrs', 35, 19);
  Op_initialRandomSeed_instance = new Op('initialRandomSeed', 36, 3091);
  Op_defaultWidthX_instance = new Op('defaultWidthX', 37, 20);
  Op_SyntheicBase_instance = new Op('SyntheicBase', 38, 3092);
  Op_nominalWidthX_instance = new Op('nominalWidthX', 39, 21);
  Op_PostScript_instance = new Op('PostScript', 40, 3093);
  Op_vsindex_instance = new Op('vsindex', 41, 22);
  Op_BaseFontName_instance = new Op('BaseFontName', 42, 3094);
  Op_blend_instance = new Op('blend', 43, 23);
  Op_BaseFontBlend_instance = new Op('BaseFontBlend', 44, 3095);
  Op_vstore_instance = new Op('vstore', 45, 24);
  Op_maxstack_instance = new Op('maxstack', 46, 25);
  Op_ROS_instance = new Op('ROS', 47, 3102);
  Op_CIDFontVersion_instance = new Op('CIDFontVersion', 48, 3103);
  Op_CIDFontRevision_instance = new Op('CIDFontRevision', 49, 3104);
  Op_CIDFontType_instance = new Op('CIDFontType', 50, 3105);
  Op_CIDCount_instance = new Op('CIDCount', 51, 3106);
  Op_UIDBase_instance = new Op('UIDBase', 52, 3107);
  Op_FDArray_instance = new Op('FDArray', 53, 3108);
  Op_FDSelect_instance = new Op('FDSelect', 54, 3109);
  Op_FontName_instance = new Op('FontName', 55, 3110);
  Companion_getInstance_28();
}
function Op_version_getInstance() {
  Op_initEntries();
  return Op_version_instance;
}
function Op_Copyright_getInstance() {
  Op_initEntries();
  return Op_Copyright_instance;
}
function Op_Notice_getInstance() {
  Op_initEntries();
  return Op_Notice_instance;
}
function Op_isFixedPitch_getInstance() {
  Op_initEntries();
  return Op_isFixedPitch_instance;
}
function Op_FullName_getInstance() {
  Op_initEntries();
  return Op_FullName_instance;
}
function Op_ItalicAngle_getInstance() {
  Op_initEntries();
  return Op_ItalicAngle_instance;
}
function Op_FamilyName_getInstance() {
  Op_initEntries();
  return Op_FamilyName_instance;
}
function Op_UnderlinePosition_getInstance() {
  Op_initEntries();
  return Op_UnderlinePosition_instance;
}
function Op_Weight_getInstance() {
  Op_initEntries();
  return Op_Weight_instance;
}
function Op_UnderlineThickness_getInstance() {
  Op_initEntries();
  return Op_UnderlineThickness_instance;
}
function Op_FontBBox_getInstance() {
  Op_initEntries();
  return Op_FontBBox_instance;
}
function Op_PaintType_getInstance() {
  Op_initEntries();
  return Op_PaintType_instance;
}
function Op_BlueValues_getInstance() {
  Op_initEntries();
  return Op_BlueValues_instance;
}
function Op_CharstringType_getInstance() {
  Op_initEntries();
  return Op_CharstringType_instance;
}
function Op_OtherBlues_getInstance() {
  Op_initEntries();
  return Op_OtherBlues_instance;
}
function Op_FontMatrix_getInstance() {
  Op_initEntries();
  return Op_FontMatrix_instance;
}
function Op_FamilyBlues_getInstance() {
  Op_initEntries();
  return Op_FamilyBlues_instance;
}
function Op_StrokeWidth_getInstance() {
  Op_initEntries();
  return Op_StrokeWidth_instance;
}
function Op_FamilyOtherBlues_getInstance() {
  Op_initEntries();
  return Op_FamilyOtherBlues_instance;
}
function Op_BlueScale_getInstance() {
  Op_initEntries();
  return Op_BlueScale_instance;
}
function Op_StdHW_getInstance() {
  Op_initEntries();
  return Op_StdHW_instance;
}
function Op_BlueShift_getInstance() {
  Op_initEntries();
  return Op_BlueShift_instance;
}
function Op_StdVW_getInstance() {
  Op_initEntries();
  return Op_StdVW_instance;
}
function Op_BlueFuzz_getInstance() {
  Op_initEntries();
  return Op_BlueFuzz_instance;
}
function Op_StemSnapH_getInstance() {
  Op_initEntries();
  return Op_StemSnapH_instance;
}
function Op_UniqueID_getInstance() {
  Op_initEntries();
  return Op_UniqueID_instance;
}
function Op_StemSnapV_getInstance() {
  Op_initEntries();
  return Op_StemSnapV_instance;
}
function Op_XUID_getInstance() {
  Op_initEntries();
  return Op_XUID_instance;
}
function Op_ForceBold_getInstance() {
  Op_initEntries();
  return Op_ForceBold_instance;
}
function Op_charset_getInstance() {
  Op_initEntries();
  return Op_charset_instance;
}
function Op_Encoding_getInstance() {
  Op_initEntries();
  return Op_Encoding_instance;
}
function Op_CharStrings_getInstance() {
  Op_initEntries();
  return Op_CharStrings_instance;
}
function Op_LanguageGroup_getInstance() {
  Op_initEntries();
  return Op_LanguageGroup_instance;
}
function Op_Private_getInstance() {
  Op_initEntries();
  return Op_Private_instance;
}
function Op_ExpansionFactor_getInstance() {
  Op_initEntries();
  return Op_ExpansionFactor_instance;
}
function Op_Subrs_getInstance() {
  Op_initEntries();
  return Op_Subrs_instance;
}
function Op_initialRandomSeed_getInstance() {
  Op_initEntries();
  return Op_initialRandomSeed_instance;
}
function Op_defaultWidthX_getInstance() {
  Op_initEntries();
  return Op_defaultWidthX_instance;
}
function Op_SyntheicBase_getInstance() {
  Op_initEntries();
  return Op_SyntheicBase_instance;
}
function Op_nominalWidthX_getInstance() {
  Op_initEntries();
  return Op_nominalWidthX_instance;
}
function Op_PostScript_getInstance() {
  Op_initEntries();
  return Op_PostScript_instance;
}
function Op_vsindex_getInstance() {
  Op_initEntries();
  return Op_vsindex_instance;
}
function Op_BaseFontName_getInstance() {
  Op_initEntries();
  return Op_BaseFontName_instance;
}
function Op_blend_getInstance() {
  Op_initEntries();
  return Op_blend_instance;
}
function Op_BaseFontBlend_getInstance() {
  Op_initEntries();
  return Op_BaseFontBlend_instance;
}
function Op_vstore_getInstance() {
  Op_initEntries();
  return Op_vstore_instance;
}
function Op_maxstack_getInstance() {
  Op_initEntries();
  return Op_maxstack_instance;
}
function Op_ROS_getInstance() {
  Op_initEntries();
  return Op_ROS_instance;
}
function Op_CIDFontVersion_getInstance() {
  Op_initEntries();
  return Op_CIDFontVersion_instance;
}
function Op_CIDFontRevision_getInstance() {
  Op_initEntries();
  return Op_CIDFontRevision_instance;
}
function Op_CIDFontType_getInstance() {
  Op_initEntries();
  return Op_CIDFontType_instance;
}
function Op_CIDCount_getInstance() {
  Op_initEntries();
  return Op_CIDCount_instance;
}
function Op_UIDBase_getInstance() {
  Op_initEntries();
  return Op_UIDBase_instance;
}
function Op_FDArray_getInstance() {
  Op_initEntries();
  return Op_FDArray_instance;
}
function Op_FDSelect_getInstance() {
  Op_initEntries();
  return Op_FDSelect_instance;
}
function Op_FontName_getInstance() {
  Op_initEntries();
  return Op_FontName_instance;
}
var Op_hstem_instance;
var Op_vstem_instance;
var Op_and_instance;
var Op_vmoveto_instance;
var Op_or_instance;
var Op_rlineto_instance;
var Op_not_instance;
var Op_hlineto_instance;
var Op_vlineto_instance;
var Op_rrcurveto_instance;
var Op_abs_instance;
var Op_callsubr_instance;
var Op_add_instance;
var Op_return_instance;
var Op_sub_instance;
var Op_div_instance;
var Op_endchar_instance;
var Op_neg_instance;
var Op_cff2vsidx_instance;
var Op_eq_instance;
var Op_cff2blend_instance;
var Op_hstemhm_instance;
var Op_drop_instance;
var Op_hintmask_instance;
var Op_cntrmask_instance;
var Op_put_instance;
var Op_rmoveto_instance;
var Op_get_instance;
var Op_hmoveto_instance;
var Op_ifelse_instance;
var Op_vstemhm_instance;
var Op_random_instance;
var Op_rcurveline_instance;
var Op_mul_instance;
var Op_rlinecurve_instance;
var Op_vvcurveto_instance;
var Op_sqrt_instance;
var Op_hhcurveto_instance;
var Op_dup_instance;
var Op_exch_instance;
var Op_callgsubr_instance;
var Op_index_instance;
var Op_vhcurveto_instance;
var Op_roll_instance;
var Op_hvcurveto_instance;
var Op_hflex_instance;
var Op_flex_instance;
var Op_hflex1_instance;
var Op_flex1_instance;
var Companion_instance_19;
function Companion_getInstance_29() {
  Op_initEntries_0();
  if (Companion_instance_19 === VOID)
    new Companion_13();
  return Companion_instance_19;
}
function values_1() {
  return [Op_hstem_getInstance(), Op_vstem_getInstance(), Op_and_getInstance(), Op_vmoveto_getInstance(), Op_or_getInstance(), Op_rlineto_getInstance(), Op_not_getInstance(), Op_hlineto_getInstance(), Op_vlineto_getInstance(), Op_rrcurveto_getInstance(), Op_abs_getInstance(), Op_callsubr_getInstance(), Op_add_getInstance(), Op_return_getInstance(), Op_sub_getInstance(), Op_div_getInstance(), Op_endchar_getInstance(), Op_neg_getInstance(), Op_cff2vsidx_getInstance(), Op_eq_getInstance(), Op_cff2blend_getInstance(), Op_hstemhm_getInstance(), Op_drop_getInstance(), Op_hintmask_getInstance(), Op_cntrmask_getInstance(), Op_put_getInstance(), Op_rmoveto_getInstance(), Op_get_getInstance(), Op_hmoveto_getInstance(), Op_ifelse_getInstance(), Op_vstemhm_getInstance(), Op_random_getInstance(), Op_rcurveline_getInstance(), Op_mul_getInstance(), Op_rlinecurve_getInstance(), Op_vvcurveto_getInstance(), Op_sqrt_getInstance(), Op_hhcurveto_getInstance(), Op_dup_getInstance(), Op_exch_getInstance(), Op_callgsubr_getInstance(), Op_index_getInstance(), Op_vhcurveto_getInstance(), Op_roll_getInstance(), Op_hvcurveto_getInstance(), Op_hflex_getInstance(), Op_flex_getInstance(), Op_hflex1_getInstance(), Op_flex1_getInstance()];
}
var Op_entriesInitialized_0;
function Op_initEntries_0() {
  if (Op_entriesInitialized_0)
    return Unit_instance;
  Op_entriesInitialized_0 = true;
  Op_hstem_instance = new Op_0('hstem', 0, 1);
  Op_vstem_instance = new Op_0('vstem', 1, 3);
  Op_and_instance = new Op_0('and', 2, 3075);
  Op_vmoveto_instance = new Op_0('vmoveto', 3, 4);
  Op_or_instance = new Op_0('or', 4, 3076);
  Op_rlineto_instance = new Op_0('rlineto', 5, 5);
  Op_not_instance = new Op_0('not', 6, 3077);
  Op_hlineto_instance = new Op_0('hlineto', 7, 6);
  Op_vlineto_instance = new Op_0('vlineto', 8, 7);
  Op_rrcurveto_instance = new Op_0('rrcurveto', 9, 8);
  Op_abs_instance = new Op_0('abs', 10, 3081);
  Op_callsubr_instance = new Op_0('callsubr', 11, 10);
  Op_add_instance = new Op_0('add', 12, 3082);
  Op_return_instance = new Op_0('return', 13, 11);
  Op_sub_instance = new Op_0('sub', 14, 3083);
  Op_div_instance = new Op_0('div', 15, 3084);
  Op_endchar_instance = new Op_0('endchar', 16, 14);
  Op_neg_instance = new Op_0('neg', 17, 3086);
  Op_cff2vsidx_instance = new Op_0('cff2vsidx', 18, 15);
  Op_eq_instance = new Op_0('eq', 19, 3087);
  Op_cff2blend_instance = new Op_0('cff2blend', 20, 16);
  Op_hstemhm_instance = new Op_0('hstemhm', 21, 18);
  Op_drop_instance = new Op_0('drop', 22, 3090);
  Op_hintmask_instance = new Op_0('hintmask', 23, 19);
  Op_cntrmask_instance = new Op_0('cntrmask', 24, 20);
  Op_put_instance = new Op_0('put', 25, 3092);
  Op_rmoveto_instance = new Op_0('rmoveto', 26, 21);
  Op_get_instance = new Op_0('get', 27, 3093);
  Op_hmoveto_instance = new Op_0('hmoveto', 28, 22);
  Op_ifelse_instance = new Op_0('ifelse', 29, 3094);
  Op_vstemhm_instance = new Op_0('vstemhm', 30, 23);
  Op_random_instance = new Op_0('random', 31, 3095);
  Op_rcurveline_instance = new Op_0('rcurveline', 32, 24);
  Op_mul_instance = new Op_0('mul', 33, 3096);
  Op_rlinecurve_instance = new Op_0('rlinecurve', 34, 25);
  Op_vvcurveto_instance = new Op_0('vvcurveto', 35, 26);
  Op_sqrt_instance = new Op_0('sqrt', 36, 3098);
  Op_hhcurveto_instance = new Op_0('hhcurveto', 37, 27);
  Op_dup_instance = new Op_0('dup', 38, 3099);
  Op_exch_instance = new Op_0('exch', 39, 3100);
  Op_callgsubr_instance = new Op_0('callgsubr', 40, 29);
  Op_index_instance = new Op_0('index', 41, 3101);
  Op_vhcurveto_instance = new Op_0('vhcurveto', 42, 30);
  Op_roll_instance = new Op_0('roll', 43, 3102);
  Op_hvcurveto_instance = new Op_0('hvcurveto', 44, 31);
  Op_hflex_instance = new Op_0('hflex', 45, 3106);
  Op_flex_instance = new Op_0('flex', 46, 3107);
  Op_hflex1_instance = new Op_0('hflex1', 47, 3108);
  Op_flex1_instance = new Op_0('flex1', 48, 3109);
  Companion_getInstance_29();
}
function computeSubrBias($this, count) {
  return count < 1240 ? 107 : count < 33900 ? 1131 : 32768;
}
function Op_hstem_getInstance() {
  Op_initEntries_0();
  return Op_hstem_instance;
}
function Op_vstem_getInstance() {
  Op_initEntries_0();
  return Op_vstem_instance;
}
function Op_and_getInstance() {
  Op_initEntries_0();
  return Op_and_instance;
}
function Op_vmoveto_getInstance() {
  Op_initEntries_0();
  return Op_vmoveto_instance;
}
function Op_or_getInstance() {
  Op_initEntries_0();
  return Op_or_instance;
}
function Op_rlineto_getInstance() {
  Op_initEntries_0();
  return Op_rlineto_instance;
}
function Op_not_getInstance() {
  Op_initEntries_0();
  return Op_not_instance;
}
function Op_hlineto_getInstance() {
  Op_initEntries_0();
  return Op_hlineto_instance;
}
function Op_vlineto_getInstance() {
  Op_initEntries_0();
  return Op_vlineto_instance;
}
function Op_rrcurveto_getInstance() {
  Op_initEntries_0();
  return Op_rrcurveto_instance;
}
function Op_abs_getInstance() {
  Op_initEntries_0();
  return Op_abs_instance;
}
function Op_callsubr_getInstance() {
  Op_initEntries_0();
  return Op_callsubr_instance;
}
function Op_add_getInstance() {
  Op_initEntries_0();
  return Op_add_instance;
}
function Op_return_getInstance() {
  Op_initEntries_0();
  return Op_return_instance;
}
function Op_sub_getInstance() {
  Op_initEntries_0();
  return Op_sub_instance;
}
function Op_div_getInstance() {
  Op_initEntries_0();
  return Op_div_instance;
}
function Op_endchar_getInstance() {
  Op_initEntries_0();
  return Op_endchar_instance;
}
function Op_neg_getInstance() {
  Op_initEntries_0();
  return Op_neg_instance;
}
function Op_cff2vsidx_getInstance() {
  Op_initEntries_0();
  return Op_cff2vsidx_instance;
}
function Op_eq_getInstance() {
  Op_initEntries_0();
  return Op_eq_instance;
}
function Op_cff2blend_getInstance() {
  Op_initEntries_0();
  return Op_cff2blend_instance;
}
function Op_hstemhm_getInstance() {
  Op_initEntries_0();
  return Op_hstemhm_instance;
}
function Op_drop_getInstance() {
  Op_initEntries_0();
  return Op_drop_instance;
}
function Op_hintmask_getInstance() {
  Op_initEntries_0();
  return Op_hintmask_instance;
}
function Op_cntrmask_getInstance() {
  Op_initEntries_0();
  return Op_cntrmask_instance;
}
function Op_put_getInstance() {
  Op_initEntries_0();
  return Op_put_instance;
}
function Op_rmoveto_getInstance() {
  Op_initEntries_0();
  return Op_rmoveto_instance;
}
function Op_get_getInstance() {
  Op_initEntries_0();
  return Op_get_instance;
}
function Op_hmoveto_getInstance() {
  Op_initEntries_0();
  return Op_hmoveto_instance;
}
function Op_ifelse_getInstance() {
  Op_initEntries_0();
  return Op_ifelse_instance;
}
function Op_vstemhm_getInstance() {
  Op_initEntries_0();
  return Op_vstemhm_instance;
}
function Op_random_getInstance() {
  Op_initEntries_0();
  return Op_random_instance;
}
function Op_rcurveline_getInstance() {
  Op_initEntries_0();
  return Op_rcurveline_instance;
}
function Op_mul_getInstance() {
  Op_initEntries_0();
  return Op_mul_instance;
}
function Op_rlinecurve_getInstance() {
  Op_initEntries_0();
  return Op_rlinecurve_instance;
}
function Op_vvcurveto_getInstance() {
  Op_initEntries_0();
  return Op_vvcurveto_instance;
}
function Op_sqrt_getInstance() {
  Op_initEntries_0();
  return Op_sqrt_instance;
}
function Op_hhcurveto_getInstance() {
  Op_initEntries_0();
  return Op_hhcurveto_instance;
}
function Op_dup_getInstance() {
  Op_initEntries_0();
  return Op_dup_instance;
}
function Op_exch_getInstance() {
  Op_initEntries_0();
  return Op_exch_instance;
}
function Op_callgsubr_getInstance() {
  Op_initEntries_0();
  return Op_callgsubr_instance;
}
function Op_index_getInstance() {
  Op_initEntries_0();
  return Op_index_instance;
}
function Op_vhcurveto_getInstance() {
  Op_initEntries_0();
  return Op_vhcurveto_instance;
}
function Op_roll_getInstance() {
  Op_initEntries_0();
  return Op_roll_instance;
}
function Op_hvcurveto_getInstance() {
  Op_initEntries_0();
  return Op_hvcurveto_instance;
}
function Op_hflex_getInstance() {
  Op_initEntries_0();
  return Op_hflex_instance;
}
function Op_flex_getInstance() {
  Op_initEntries_0();
  return Op_flex_instance;
}
function Op_hflex1_getInstance() {
  Op_initEntries_0();
  return Op_hflex1_instance;
}
function Op_flex1_getInstance() {
  Op_initEntries_0();
  return Op_flex1_instance;
}
var CFF_instance;
function CFF_getInstance() {
  return CFF_instance;
}
var CharStringType2_instance;
function CharStringType2_getInstance() {
  return CharStringType2_instance;
}
var TtfCIDFont_instance;
function TtfCIDFont_getInstance() {
  if (TtfCIDFont_instance === VOID)
    new TtfCIDFont();
  return TtfCIDFont_instance;
}
var Companion_instance_20;
function Companion_getInstance_30() {
  if (Companion_instance_20 === VOID)
    new Companion_14();
  return Companion_instance_20;
}
function _get_ss__ndcawb($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.r59_1;
  ss$factory();
  return this_0.r1();
}
function BaseTtfFont$Table$ss$delegate$lambda(this$0) {
  return function () {
    return ensureNotNull(this$0.q59_1)();
  };
}
function BaseTtfFont$Companion$readHeaderTables$lambda($$this$run, $table) {
  return function () {
    return $$this$run.w1p($table.o59_1, $table.p59_1);
  };
}
var NameId_COPYRIGHT_instance;
var NameId_NAME_instance;
var NameId_STYLE_instance;
var NameId_UNAME_instance;
var NameId_COMPLETE_NAME_instance;
var NameId_RELEASE_VERSION_instance;
var NameId_POSTSCRIPT_NAME_instance;
var NameId_TRADEMARK_instance;
var NameId_MANUFACTURER_instance;
var NameId_DESIGNER_instance;
var NameId_DESCRIPTION_instance;
var NameId_URL_VENDOR_instance;
var NameId_URL_DESIGNER_instance;
var NameId_LICENSE_DESCRIPTION_instance;
var NameId_LICENSE_URL_instance;
var NameId_RESERVED_15_instance;
var NameId_PREFERRED_FAMILY_instance;
var NameId_PREFERRED_SUBFAMILY_instance;
var NameId_COMPATIBLE_FULL_instance;
var NameId_SAMPLE_TEXT_instance;
var NameId_POSTSCRIPT_CID_instance;
var NameId_WWS_FAMILY_NAME_instance;
var NameId_WWS_SUBFAMILY_NAME_instance;
var NameId_LIGHT_BACKGROUND_instance;
var NameId_DARK_BACKGROUND_instance;
var NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
var Companion_instance_21;
function Companion_getInstance_31() {
  return Companion_instance_21;
}
function values_2() {
  return [NameId_COPYRIGHT_getInstance(), NameId_NAME_getInstance(), NameId_STYLE_getInstance(), NameId_UNAME_getInstance(), NameId_COMPLETE_NAME_getInstance(), NameId_RELEASE_VERSION_getInstance(), NameId_POSTSCRIPT_NAME_getInstance(), NameId_TRADEMARK_getInstance(), NameId_MANUFACTURER_getInstance(), NameId_DESIGNER_getInstance(), NameId_DESCRIPTION_getInstance(), NameId_URL_VENDOR_getInstance(), NameId_URL_DESIGNER_getInstance(), NameId_LICENSE_DESCRIPTION_getInstance(), NameId_LICENSE_URL_getInstance(), NameId_RESERVED_15_getInstance(), NameId_PREFERRED_FAMILY_getInstance(), NameId_PREFERRED_SUBFAMILY_getInstance(), NameId_COMPATIBLE_FULL_getInstance(), NameId_SAMPLE_TEXT_getInstance(), NameId_POSTSCRIPT_CID_getInstance(), NameId_WWS_FAMILY_NAME_getInstance(), NameId_WWS_SUBFAMILY_NAME_getInstance(), NameId_LIGHT_BACKGROUND_getInstance(), NameId_DARK_BACKGROUND_getInstance(), NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance()];
}
var NameId_entriesInitialized;
function NameId_initEntries() {
  if (NameId_entriesInitialized)
    return Unit_instance;
  NameId_entriesInitialized = true;
  NameId_COPYRIGHT_instance = new NameId('COPYRIGHT', 0, 0);
  NameId_NAME_instance = new NameId('NAME', 1, 1);
  NameId_STYLE_instance = new NameId('STYLE', 2, 2);
  NameId_UNAME_instance = new NameId('UNAME', 3, 3);
  NameId_COMPLETE_NAME_instance = new NameId('COMPLETE_NAME', 4, 4);
  NameId_RELEASE_VERSION_instance = new NameId('RELEASE_VERSION', 5, 5);
  NameId_POSTSCRIPT_NAME_instance = new NameId('POSTSCRIPT_NAME', 6, 6);
  NameId_TRADEMARK_instance = new NameId('TRADEMARK', 7, 7);
  NameId_MANUFACTURER_instance = new NameId('MANUFACTURER', 8, 8);
  NameId_DESIGNER_instance = new NameId('DESIGNER', 9, 9);
  NameId_DESCRIPTION_instance = new NameId('DESCRIPTION', 10, 10);
  NameId_URL_VENDOR_instance = new NameId('URL_VENDOR', 11, 11);
  NameId_URL_DESIGNER_instance = new NameId('URL_DESIGNER', 12, 12);
  NameId_LICENSE_DESCRIPTION_instance = new NameId('LICENSE_DESCRIPTION', 13, 13);
  NameId_LICENSE_URL_instance = new NameId('LICENSE_URL', 14, 14);
  NameId_RESERVED_15_instance = new NameId('RESERVED_15', 15, 15);
  NameId_PREFERRED_FAMILY_instance = new NameId('PREFERRED_FAMILY', 16, 16);
  NameId_PREFERRED_SUBFAMILY_instance = new NameId('PREFERRED_SUBFAMILY', 17, 17);
  NameId_COMPATIBLE_FULL_instance = new NameId('COMPATIBLE_FULL', 18, 18);
  NameId_SAMPLE_TEXT_instance = new NameId('SAMPLE_TEXT', 19, 19);
  NameId_POSTSCRIPT_CID_instance = new NameId('POSTSCRIPT_CID', 20, 20);
  NameId_WWS_FAMILY_NAME_instance = new NameId('WWS_FAMILY_NAME', 21, 21);
  NameId_WWS_SUBFAMILY_NAME_instance = new NameId('WWS_SUBFAMILY_NAME', 22, 22);
  NameId_LIGHT_BACKGROUND_instance = new NameId('LIGHT_BACKGROUND', 23, 23);
  NameId_DARK_BACKGROUND_instance = new NameId('DARK_BACKGROUND', 24, 23);
  NameId_VARIATION_POSTSCRIPT_PREFIX_instance = new NameId('VARIATION_POSTSCRIPT_PREFIX', 25, 25);
}
var Colrv1Paint_PaintColrLayers_instance;
var Colrv1Paint_PaintSolid_instance;
var Colrv1Paint_PaintVarSolid_instance;
var Colrv1Paint_PaintLinearGradient_instance;
var Colrv1Paint_PaintVarLinearGradient_instance;
var Colrv1Paint_PaintRadialGradient_instance;
var Colrv1Paint_PaintVarRadialGradient_instance;
var Colrv1Paint_PaintSweepGradient_instance;
var Colrv1Paint_PaintVarSweepGradient_instance;
var Colrv1Paint_PaintGlyph_instance;
var Colrv1Paint_PaintColrGlyph_instance;
var Colrv1Paint_PaintTransform_instance;
var Colrv1Paint_PaintVarTransform_instance;
var Colrv1Paint_PaintTranslate_instance;
var Colrv1Paint_PaintVarTranslate_instance;
var Colrv1Paint_PaintScale_instance;
var Colrv1Paint_PaintVarScale_instance;
var Colrv1Paint_PaintScaleAroundCenter_instance;
var Colrv1Paint_PaintVarScaleAroundCenter_instance;
var Colrv1Paint_PaintScaleUniform_instance;
var Colrv1Paint_PaintVarScaleUniform_instance;
var Colrv1Paint_PaintScaleUniformAroundCenter_instance;
var Colrv1Paint_PaintVarScaleUniformAroundCenter_instance;
var Colrv1Paint_PaintRotate_instance;
var Colrv1Paint_PaintVarRotate_instance;
var Colrv1Paint_PaintRotateAroundCenter_instance;
var Colrv1Paint_PaintVarRotateAroundCenter_instance;
var Colrv1Paint_PaintSkew_instance;
var Colrv1Paint_PaintVarSkew_instance;
var Colrv1Paint_PaintSkewAroundCenter_instance;
var Colrv1Paint_PaintVarSkewAroundCenter_instance;
var Colrv1Paint_PaintComposite_instance;
var Companion_instance_22;
function Companion_getInstance_32() {
  Colrv1Paint_initEntries();
  if (Companion_instance_22 === VOID)
    new Companion_16();
  return Companion_instance_22;
}
function values_3() {
  return [Colrv1Paint_PaintColrLayers_getInstance(), Colrv1Paint_PaintSolid_getInstance(), Colrv1Paint_PaintVarSolid_getInstance(), Colrv1Paint_PaintLinearGradient_getInstance(), Colrv1Paint_PaintVarLinearGradient_getInstance(), Colrv1Paint_PaintRadialGradient_getInstance(), Colrv1Paint_PaintVarRadialGradient_getInstance(), Colrv1Paint_PaintSweepGradient_getInstance(), Colrv1Paint_PaintVarSweepGradient_getInstance(), Colrv1Paint_PaintGlyph_getInstance(), Colrv1Paint_PaintColrGlyph_getInstance(), Colrv1Paint_PaintTransform_getInstance(), Colrv1Paint_PaintVarTransform_getInstance(), Colrv1Paint_PaintTranslate_getInstance(), Colrv1Paint_PaintVarTranslate_getInstance(), Colrv1Paint_PaintScale_getInstance(), Colrv1Paint_PaintVarScale_getInstance(), Colrv1Paint_PaintScaleAroundCenter_getInstance(), Colrv1Paint_PaintVarScaleAroundCenter_getInstance(), Colrv1Paint_PaintScaleUniform_getInstance(), Colrv1Paint_PaintVarScaleUniform_getInstance(), Colrv1Paint_PaintScaleUniformAroundCenter_getInstance(), Colrv1Paint_PaintVarScaleUniformAroundCenter_getInstance(), Colrv1Paint_PaintRotate_getInstance(), Colrv1Paint_PaintVarRotate_getInstance(), Colrv1Paint_PaintRotateAroundCenter_getInstance(), Colrv1Paint_PaintVarRotateAroundCenter_getInstance(), Colrv1Paint_PaintSkew_getInstance(), Colrv1Paint_PaintVarSkew_getInstance(), Colrv1Paint_PaintSkewAroundCenter_getInstance(), Colrv1Paint_PaintVarSkewAroundCenter_getInstance(), Colrv1Paint_PaintComposite_getInstance()];
}
var Colrv1Paint_entriesInitialized;
function Colrv1Paint_initEntries() {
  if (Colrv1Paint_entriesInitialized)
    return Unit_instance;
  Colrv1Paint_entriesInitialized = true;
  Colrv1Paint_PaintColrLayers_instance = new Colrv1Paint('PaintColrLayers', 0);
  Colrv1Paint_PaintSolid_instance = new Colrv1Paint('PaintSolid', 1);
  Colrv1Paint_PaintVarSolid_instance = new Colrv1Paint('PaintVarSolid', 2);
  Colrv1Paint_PaintLinearGradient_instance = new Colrv1Paint('PaintLinearGradient', 3);
  Colrv1Paint_PaintVarLinearGradient_instance = new Colrv1Paint('PaintVarLinearGradient', 4);
  Colrv1Paint_PaintRadialGradient_instance = new Colrv1Paint('PaintRadialGradient', 5);
  Colrv1Paint_PaintVarRadialGradient_instance = new Colrv1Paint('PaintVarRadialGradient', 6);
  Colrv1Paint_PaintSweepGradient_instance = new Colrv1Paint('PaintSweepGradient', 7);
  Colrv1Paint_PaintVarSweepGradient_instance = new Colrv1Paint('PaintVarSweepGradient', 8);
  Colrv1Paint_PaintGlyph_instance = new Colrv1Paint('PaintGlyph', 9);
  Colrv1Paint_PaintColrGlyph_instance = new Colrv1Paint('PaintColrGlyph', 10);
  Colrv1Paint_PaintTransform_instance = new Colrv1Paint('PaintTransform', 11);
  Colrv1Paint_PaintVarTransform_instance = new Colrv1Paint('PaintVarTransform', 12);
  Colrv1Paint_PaintTranslate_instance = new Colrv1Paint('PaintTranslate', 13);
  Colrv1Paint_PaintVarTranslate_instance = new Colrv1Paint('PaintVarTranslate', 14);
  Colrv1Paint_PaintScale_instance = new Colrv1Paint('PaintScale', 15);
  Colrv1Paint_PaintVarScale_instance = new Colrv1Paint('PaintVarScale', 16);
  Colrv1Paint_PaintScaleAroundCenter_instance = new Colrv1Paint('PaintScaleAroundCenter', 17);
  Colrv1Paint_PaintVarScaleAroundCenter_instance = new Colrv1Paint('PaintVarScaleAroundCenter', 18);
  Colrv1Paint_PaintScaleUniform_instance = new Colrv1Paint('PaintScaleUniform', 19);
  Colrv1Paint_PaintVarScaleUniform_instance = new Colrv1Paint('PaintVarScaleUniform', 20);
  Colrv1Paint_PaintScaleUniformAroundCenter_instance = new Colrv1Paint('PaintScaleUniformAroundCenter', 21);
  Colrv1Paint_PaintVarScaleUniformAroundCenter_instance = new Colrv1Paint('PaintVarScaleUniformAroundCenter', 22);
  Colrv1Paint_PaintRotate_instance = new Colrv1Paint('PaintRotate', 23);
  Colrv1Paint_PaintVarRotate_instance = new Colrv1Paint('PaintVarRotate', 24);
  Colrv1Paint_PaintRotateAroundCenter_instance = new Colrv1Paint('PaintRotateAroundCenter', 25);
  Colrv1Paint_PaintVarRotateAroundCenter_instance = new Colrv1Paint('PaintVarRotateAroundCenter', 26);
  Colrv1Paint_PaintSkew_instance = new Colrv1Paint('PaintSkew', 27);
  Colrv1Paint_PaintVarSkew_instance = new Colrv1Paint('PaintVarSkew', 28);
  Colrv1Paint_PaintSkewAroundCenter_instance = new Colrv1Paint('PaintSkewAroundCenter', 29);
  Colrv1Paint_PaintVarSkewAroundCenter_instance = new Colrv1Paint('PaintVarSkewAroundCenter', 30);
  Colrv1Paint_PaintComposite_instance = new Colrv1Paint('PaintComposite', 31);
  Companion_getInstance_32();
}
var Companion_instance_23;
function Companion_getInstance_33() {
  return Companion_instance_23;
}
function NameId_COPYRIGHT_getInstance() {
  NameId_initEntries();
  return NameId_COPYRIGHT_instance;
}
function NameId_NAME_getInstance() {
  NameId_initEntries();
  return NameId_NAME_instance;
}
function NameId_STYLE_getInstance() {
  NameId_initEntries();
  return NameId_STYLE_instance;
}
function NameId_UNAME_getInstance() {
  NameId_initEntries();
  return NameId_UNAME_instance;
}
function NameId_COMPLETE_NAME_getInstance() {
  NameId_initEntries();
  return NameId_COMPLETE_NAME_instance;
}
function NameId_RELEASE_VERSION_getInstance() {
  NameId_initEntries();
  return NameId_RELEASE_VERSION_instance;
}
function NameId_POSTSCRIPT_NAME_getInstance() {
  NameId_initEntries();
  return NameId_POSTSCRIPT_NAME_instance;
}
function NameId_TRADEMARK_getInstance() {
  NameId_initEntries();
  return NameId_TRADEMARK_instance;
}
function NameId_MANUFACTURER_getInstance() {
  NameId_initEntries();
  return NameId_MANUFACTURER_instance;
}
function NameId_DESIGNER_getInstance() {
  NameId_initEntries();
  return NameId_DESIGNER_instance;
}
function NameId_DESCRIPTION_getInstance() {
  NameId_initEntries();
  return NameId_DESCRIPTION_instance;
}
function NameId_URL_VENDOR_getInstance() {
  NameId_initEntries();
  return NameId_URL_VENDOR_instance;
}
function NameId_URL_DESIGNER_getInstance() {
  NameId_initEntries();
  return NameId_URL_DESIGNER_instance;
}
function NameId_LICENSE_DESCRIPTION_getInstance() {
  NameId_initEntries();
  return NameId_LICENSE_DESCRIPTION_instance;
}
function NameId_LICENSE_URL_getInstance() {
  NameId_initEntries();
  return NameId_LICENSE_URL_instance;
}
function NameId_RESERVED_15_getInstance() {
  NameId_initEntries();
  return NameId_RESERVED_15_instance;
}
function NameId_PREFERRED_FAMILY_getInstance() {
  NameId_initEntries();
  return NameId_PREFERRED_FAMILY_instance;
}
function NameId_PREFERRED_SUBFAMILY_getInstance() {
  NameId_initEntries();
  return NameId_PREFERRED_SUBFAMILY_instance;
}
function NameId_COMPATIBLE_FULL_getInstance() {
  NameId_initEntries();
  return NameId_COMPATIBLE_FULL_instance;
}
function NameId_SAMPLE_TEXT_getInstance() {
  NameId_initEntries();
  return NameId_SAMPLE_TEXT_instance;
}
function NameId_POSTSCRIPT_CID_getInstance() {
  NameId_initEntries();
  return NameId_POSTSCRIPT_CID_instance;
}
function NameId_WWS_FAMILY_NAME_getInstance() {
  NameId_initEntries();
  return NameId_WWS_FAMILY_NAME_instance;
}
function NameId_WWS_SUBFAMILY_NAME_getInstance() {
  NameId_initEntries();
  return NameId_WWS_SUBFAMILY_NAME_instance;
}
function NameId_LIGHT_BACKGROUND_getInstance() {
  NameId_initEntries();
  return NameId_LIGHT_BACKGROUND_instance;
}
function NameId_DARK_BACKGROUND_getInstance() {
  NameId_initEntries();
  return NameId_DARK_BACKGROUND_instance;
}
function NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance() {
  NameId_initEntries();
  return NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
}
function Colrv1Paint_PaintColrLayers_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintColrLayers_instance;
}
function Colrv1Paint_PaintSolid_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSolid_instance;
}
function Colrv1Paint_PaintVarSolid_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSolid_instance;
}
function Colrv1Paint_PaintLinearGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintLinearGradient_instance;
}
function Colrv1Paint_PaintVarLinearGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarLinearGradient_instance;
}
function Colrv1Paint_PaintRadialGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRadialGradient_instance;
}
function Colrv1Paint_PaintVarRadialGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRadialGradient_instance;
}
function Colrv1Paint_PaintSweepGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSweepGradient_instance;
}
function Colrv1Paint_PaintVarSweepGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSweepGradient_instance;
}
function Colrv1Paint_PaintGlyph_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintGlyph_instance;
}
function Colrv1Paint_PaintColrGlyph_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintColrGlyph_instance;
}
function Colrv1Paint_PaintTransform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintTransform_instance;
}
function Colrv1Paint_PaintVarTransform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarTransform_instance;
}
function Colrv1Paint_PaintTranslate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintTranslate_instance;
}
function Colrv1Paint_PaintVarTranslate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarTranslate_instance;
}
function Colrv1Paint_PaintScale_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScale_instance;
}
function Colrv1Paint_PaintVarScale_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScale_instance;
}
function Colrv1Paint_PaintScaleAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleAroundCenter_instance;
}
function Colrv1Paint_PaintVarScaleAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleAroundCenter_instance;
}
function Colrv1Paint_PaintScaleUniform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleUniform_instance;
}
function Colrv1Paint_PaintVarScaleUniform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleUniform_instance;
}
function Colrv1Paint_PaintScaleUniformAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleUniformAroundCenter_instance;
}
function Colrv1Paint_PaintVarScaleUniformAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleUniformAroundCenter_instance;
}
function Colrv1Paint_PaintRotate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRotate_instance;
}
function Colrv1Paint_PaintVarRotate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRotate_instance;
}
function Colrv1Paint_PaintRotateAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRotateAroundCenter_instance;
}
function Colrv1Paint_PaintVarRotateAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRotateAroundCenter_instance;
}
function Colrv1Paint_PaintSkew_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSkew_instance;
}
function Colrv1Paint_PaintVarSkew_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSkew_instance;
}
function Colrv1Paint_PaintSkewAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSkewAroundCenter_instance;
}
function Colrv1Paint_PaintVarSkewAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSkewAroundCenter_instance;
}
function Colrv1Paint_PaintComposite_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintComposite_instance;
}
var Companion_instance_24;
function Companion_getInstance_34() {
  return Companion_instance_24;
}
function _FWord___init__impl__2rjyqf(data) {
  return data;
}
function _FWord___get_data__impl__9ys4ze($this) {
  return $this;
}
function FWord__toDouble_impl_53j5qp($this) {
  return _FWord___get_data__impl__9ys4ze($this);
}
function *_generator_readTtfFont__nm5tmd(_this__u8e3s4, onlyReadMetadata, enableLigatures, $completion) {
  onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
  enableLigatures = enableLigatures === VOID ? true : enableLigatures;
  var tmp = _this__u8e3s4.r23($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return TtfFont.r4u(tmp, get_baseName(_this__u8e3s4), onlyReadMetadata, enableLigatures);
}
function readTtfFont(_this__u8e3s4, onlyReadMetadata, enableLigatures, $completion) {
  onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
  enableLigatures = enableLigatures === VOID ? true : enableLigatures;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readTtfFont__nm5tmd.bind(VOID, _this__u8e3s4, onlyReadMetadata, enableLigatures), $completion);
}
function ss$factory() {
  return getPropertyCallableRef('ss', 1, KProperty1, function (receiver) {
    return _get_ss__ndcawb(receiver);
  }, null);
}
var DataFormat_UBYTE_instance;
var DataFormat_STRING_instance;
var DataFormat_USHORT_instance;
var DataFormat_ULONG_instance;
var DataFormat_URATIO_instance;
var DataFormat_SBYTE_instance;
var DataFormat_UNDEFINED_instance;
var DataFormat_SSHORT_instance;
var DataFormat_SLONG_instance;
var DataFormat_SRATIO_instance;
var DataFormat_SFLOAT_instance;
var DataFormat_DFLOAT_instance;
var DataFormat_UNKNOWN_instance;
var Companion_instance_25;
function Companion_getInstance_35() {
  DataFormat_initEntries();
  if (Companion_instance_25 === VOID)
    new Companion_19();
  return Companion_instance_25;
}
function values_4() {
  return [DataFormat_UBYTE_getInstance(), DataFormat_STRING_getInstance(), DataFormat_USHORT_getInstance(), DataFormat_ULONG_getInstance(), DataFormat_URATIO_getInstance(), DataFormat_SBYTE_getInstance(), DataFormat_UNDEFINED_getInstance(), DataFormat_SSHORT_getInstance(), DataFormat_SLONG_getInstance(), DataFormat_SRATIO_getInstance(), DataFormat_SFLOAT_getInstance(), DataFormat_DFLOAT_getInstance(), DataFormat_UNKNOWN_getInstance()];
}
function EXIF$DataFormat$lambda(it) {
  return it;
}
function EXIF$DataFormat$lambda_0(it) {
  return 4;
}
function EXIF$DataFormat$lambda_1(it) {
  return imul(it, 2);
}
function EXIF$DataFormat$lambda_2(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_3(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_4(it) {
  return it;
}
function EXIF$DataFormat$lambda_5(it) {
  return it;
}
function EXIF$DataFormat$lambda_6(it) {
  return imul(it, 2);
}
function EXIF$DataFormat$lambda_7(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_8(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_9(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_10(it) {
  return imul(it, 8);
}
function EXIF$DataFormat$lambda_11(it) {
  return 0;
}
var DataFormat_entriesInitialized;
function DataFormat_initEntries() {
  if (DataFormat_entriesInitialized)
    return Unit_instance;
  DataFormat_entriesInitialized = true;
  DataFormat_UBYTE_instance = new DataFormat('UBYTE', 0, 1, EXIF$DataFormat$lambda);
  DataFormat_STRING_instance = new DataFormat('STRING', 1, 2, EXIF$DataFormat$lambda_0);
  DataFormat_USHORT_instance = new DataFormat('USHORT', 2, 3, EXIF$DataFormat$lambda_1);
  DataFormat_ULONG_instance = new DataFormat('ULONG', 3, 4, EXIF$DataFormat$lambda_2);
  DataFormat_URATIO_instance = new DataFormat('URATIO', 4, 5, EXIF$DataFormat$lambda_3);
  DataFormat_SBYTE_instance = new DataFormat('SBYTE', 5, 6, EXIF$DataFormat$lambda_4);
  DataFormat_UNDEFINED_instance = new DataFormat('UNDEFINED', 6, 7, EXIF$DataFormat$lambda_5);
  DataFormat_SSHORT_instance = new DataFormat('SSHORT', 7, 8, EXIF$DataFormat$lambda_6);
  DataFormat_SLONG_instance = new DataFormat('SLONG', 8, 9, EXIF$DataFormat$lambda_7);
  DataFormat_SRATIO_instance = new DataFormat('SRATIO', 9, 10, EXIF$DataFormat$lambda_8);
  DataFormat_SFLOAT_instance = new DataFormat('SFLOAT', 10, 11, EXIF$DataFormat$lambda_9);
  DataFormat_DFLOAT_instance = new DataFormat('DFLOAT', 11, 12, EXIF$DataFormat$lambda_10);
  DataFormat_UNKNOWN_instance = new DataFormat('UNKNOWN', 12, -1, EXIF$DataFormat$lambda_11);
  Companion_getInstance_35();
}
function *_generator_readExifBase__4npesx($this, ss, info, debug, $completion) {
  var tmp = sliceHere(ss, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var s = tmp;
  var tmp_0 = readString(s, 2, Charsets_instance.tv(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var start = tmp_0;
  var tmp_1;
  switch (start) {
    case 'MM':
      tmp_1 = Endian_BIG_ENDIAN_getInstance();
      break;
    case 'II':
      tmp_1 = Endian_LITTLE_ENDIAN_getInstance();
      break;
    default:
      var message = "Not Exif data (not starting with MM or II but '" + start + "')";
      throw IllegalStateException.w4(toString_0(message));
  }
  var endian = tmp_1;
  var tmp_2 = readU16(s, endian, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tagMark = tmp_2;
  var tmp_3 = readS32(s, endian, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var offsetFirstIFD = tmp_3;
  var tmp_4 = readU16(s, endian, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var nDirEntry = tmp_4;
  if (debug) {
    // Inline function 'korlibs.logger.Logger.error' call
    var this_0 = $this.s5h_1;
    var level = Level_ERROR_getInstance();
    var tmp_5;
    if (this_0.j2t(level)) {
      // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
      var tmp$ret$0 = 'nDirEntry=' + nDirEntry + ', tagMark=' + tagMark + ', offsetFirstFID=' + offsetFirstIFD;
      this_0.k2t(level, tmp$ret$0);
      tmp_5 = Unit_instance;
    }
  }
  var inductionVariable = 0;
  if (inductionVariable < nDirEntry)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tagPos = s.l1r_1.i2();
      var tmp_6 = readU16(s, endian, $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      var tagNumber = tmp_6;
      var tmp_7 = Companion_getInstance_35();
      var tmp_8 = readU16(s, endian, $completion);
      if (tmp_8 === get_COROUTINE_SUSPENDED())
        tmp_8 = yield tmp_8;
      var dataFormat = tmp_7.d1(tmp_8);
      var tmp_9 = readS32(s, endian, $completion);
      if (tmp_9 === get_COROUTINE_SUSPENDED())
        tmp_9 = yield tmp_9;
      var nComponent = tmp_9;
      if (debug) {
        // Inline function 'korlibs.logger.Logger.error' call
        var this_1 = $this.s5h_1;
        var level_0 = Level_ERROR_getInstance();
        var tmp_10;
        if (this_1.j2t(level_0)) {
          // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
          var tmp$ret$2 = 'tagPos=' + get_hex(tagPos) + ', tagNumber=' + get_hex(tagNumber) + ', dataFormat=' + dataFormat.toString() + ', nComponent=' + nComponent + ', size=' + dataFormat.q5h_1(nComponent);
          this_1.k2t(level_0, tmp$ret$2);
          tmp_10 = Unit_instance;
        }
      }
      var tmp_11 = readBytesExact(s, dataFormat.q5h_1(nComponent), $completion);
      if (tmp_11 === get_COROUTINE_SUSPENDED())
        tmp_11 = yield tmp_11;
      var data = tmp_11;
      if (debug) {
        if (dataFormat.equals(DataFormat_STRING_getInstance())) {
          // Inline function 'korlibs.logger.Logger.error' call
          var this_2 = $this.s5h_1;
          var level_1 = Level_ERROR_getInstance();
          var tmp_12;
          if (this_2.j2t(level_1)) {
            // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
            var tmp_13 = sliceStart(s, toLong(readExifBase$readInt(data, endian, 0)), VOID, $completion);
            if (tmp_13 === get_COROUTINE_SUSPENDED())
              tmp_13 = yield tmp_13;
            var tmp_14 = readStringz(tmp_13, nComponent, VOID, $completion);
            if (tmp_14 === get_COROUTINE_SUSPENDED())
              tmp_14 = yield tmp_14;
            var tmp$ret$4 = "  - '" + tmp_14 + "'";
            this_2.k2t(level_1, tmp$ret$4);
            tmp_12 = Unit_instance;
          }
        }
      }
      if (tagNumber === 274) {
        var tmp_15;
        switch (readExifBase$readUShort(data, endian, 0)) {
          case 1:
            // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call

            tmp_15 = Companion_getInstance_0().i3f_1;
            break;
          case 2:
            // Inline function 'korlibs.math.geom.slice.Companion.MIRROR_HORIZONTAL' call

            tmp_15 = Companion_getInstance_0().m3f_1;
            break;
          case 3:
            tmp_15 = Companion_getInstance_0().k3f_1;
            break;
          case 4:
            // Inline function 'korlibs.math.geom.slice.Companion.MIRROR_VERTICAL' call

            tmp_15 = Companion_getInstance_0().o3f_1;
            break;
          case 5:
            tmp_15 = Companion_getInstance_0().p3f_1;
            break;
          case 6:
            tmp_15 = Companion_getInstance_0().j3f_1;
            break;
          case 7:
            tmp_15 = Companion_getInstance_0().n3f_1;
            break;
          case 8:
            tmp_15 = Companion_getInstance_0().l3f_1;
            break;
          default:
            // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call

            tmp_15 = Companion_getInstance_0().i3f_1;
            break;
        }
        set_orientation(info, tmp_15);
      }
      skipToAlign(s, 4, 2);
    }
     while (inductionVariable < nDirEntry);
  return info;
}
function readExifBase$readUShort(data, endian, index) {
  return getU16(data, imul(index, 2), endian.rt());
}
function readExifBase$readInt(data, endian, index) {
  return getS32(data, imul(index, 4), endian.rt());
}
function DataFormat_UBYTE_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UBYTE_instance;
}
function DataFormat_STRING_getInstance() {
  DataFormat_initEntries();
  return DataFormat_STRING_instance;
}
function DataFormat_USHORT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_USHORT_instance;
}
function DataFormat_ULONG_getInstance() {
  DataFormat_initEntries();
  return DataFormat_ULONG_instance;
}
function DataFormat_URATIO_getInstance() {
  DataFormat_initEntries();
  return DataFormat_URATIO_instance;
}
function DataFormat_SBYTE_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SBYTE_instance;
}
function DataFormat_UNDEFINED_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UNDEFINED_instance;
}
function DataFormat_SSHORT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SSHORT_instance;
}
function DataFormat_SLONG_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SLONG_instance;
}
function DataFormat_SRATIO_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SRATIO_instance;
}
function DataFormat_SFLOAT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SFLOAT_instance;
}
function DataFormat_DFLOAT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_DFLOAT_instance;
}
function DataFormat_UNKNOWN_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UNKNOWN_instance;
}
var EXIF_instance;
function EXIF_getInstance() {
  if (EXIF_instance === VOID)
    new EXIF();
  return EXIF_instance;
}
var Direction_ONCE_FORWARD_instance;
var Direction_ONCE_REVERSE_instance;
var Direction_FORWARD_instance;
var Direction_REVERSE_instance;
var Direction_PING_PONG_instance;
var Direction_entriesInitialized;
function Direction_initEntries() {
  if (Direction_entriesInitialized)
    return Unit_instance;
  Direction_entriesInitialized = true;
  Direction_ONCE_FORWARD_instance = new Direction('ONCE_FORWARD', 0);
  Direction_ONCE_REVERSE_instance = new Direction('ONCE_REVERSE', 1);
  Direction_FORWARD_instance = new Direction('FORWARD', 2);
  Direction_REVERSE_instance = new Direction('REVERSE', 3);
  Direction_PING_PONG_instance = new Direction('PING_PONG', 4);
}
function ImageAnimation$_init_$lambda_bxp50i(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
  var tmp = a.w5h_1;
  // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
  var tmp$ret$1 = b.w5h_1;
  return compareValues(tmp, tmp$ret$1);
}
function Direction_FORWARD_getInstance() {
  Direction_initEntries();
  return Direction_FORWARD_instance;
}
var Companion_instance_26;
function Companion_getInstance_36() {
  return Companion_instance_26;
}
function ImageData$framesSortedByPriority$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.ImageData.framesSortedByPriority.<anonymous>' call
  var tmp;
  if (b.y5i()) {
    tmp = 2147483647;
  } else {
    tmp = imul(imul(b.x5i().l3x_1, b.x5i().m3x_1), imul(b.x5i().n3x_1, b.x5i().n3x_1));
  }
  var tmp_0 = tmp;
  // Inline function 'korlibs.image.format.ImageData.framesSortedByPriority.<anonymous>' call
  var tmp_1;
  if (a.y5i()) {
    tmp_1 = 2147483647;
  } else {
    tmp_1 = imul(imul(a.x5i().l3x_1, a.x5i().m3x_1), imul(a.x5i().n3x_1, a.x5i().n3x_1));
  }
  var tmp$ret$1 = tmp_1;
  return compareValues(tmp_0, tmp$ret$1);
}
var Companion_instance_27;
function Companion_getInstance_37() {
  return Companion_instance_27;
}
function ImageDataContainer$imageDatasByName$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this$0.n5j_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.cc(capacity);
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.format.ImageDataContainer.imageDatasByName$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = element.g5j_1;
      destination.e3(tmp$ret$0, element);
    }
    return destination;
  };
}
function ImageDataContainer$default$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.q5j().c3(null);
    return tmp0_elvis_lhs == null ? first_0(this$0.n5j_1) : tmp0_elvis_lhs;
  };
}
function imageDatasByName$factory() {
  return getPropertyCallableRef('imageDatasByName', 1, KProperty1, function (receiver) {
    return receiver.q5j();
  }, null);
}
function default$factory() {
  return getPropertyCallableRef('default', 1, KProperty1, function (receiver) {
    return receiver.r5j();
  }, null);
}
var tilesetBorder$delegate;
var Companion_instance_28;
function Companion_getInstance_38() {
  if (Companion_instance_28 === VOID)
    new Companion_22();
  return Companion_instance_28;
}
function *_generator_decode__skqvkq($this, file, props, $completion) {
  var tmp = readAsSyncStream(file, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.k5k(tmp, props.i5k(file));
}
function ImageFormat$decodingProps$delegate$lambda(this$0) {
  return function () {
    return toProps(this$0);
  };
}
function toProps(_this__u8e3s4, props) {
  props = props === VOID ? Companion_getInstance_38().d4s_1 : props;
  _init_properties_ImageFormat_kt__44biio();
  return props.h5k(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, _this__u8e3s4);
}
function tilesetBorder$delegate$lambda() {
  _init_properties_ImageFormat_kt__44biio();
  return 1;
}
function decodingProps$factory() {
  return getPropertyCallableRef('decodingProps', 1, KProperty1, function (receiver) {
    return receiver.e5k();
  }, null);
}
var properties_initialized_ImageFormat_kt_anr6ua;
function _init_properties_ImageFormat_kt__44biio() {
  if (!properties_initialized_ImageFormat_kt_anr6ua) {
    properties_initialized_ImageFormat_kt_anr6ua = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = tilesetBorder$delegate$lambda;
    tilesetBorder$delegate = new Property(null, default_0);
  }
}
function listFormats(_this__u8e3s4) {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList.h1();
  var tmp0_iterator = _this__u8e3s4.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'korlibs.image.format.listFormats.<anonymous>' call
    var list = listFormats_0(element);
    addAll(destination, list);
  }
  return toMutableSet(destination);
}
function listFormats_0(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ImageFormats) {
    tmp = _this__u8e3s4.g5l();
  } else {
    tmp = setOf_0(_this__u8e3s4);
  }
  return tmp;
}
function _formats$factory() {
  return getPropertyCallableRef('_formats', 1, KMutableProperty1, function (receiver) {
    return receiver.f5l();
  }, function (receiver, value) {
    return receiver.e5l(value);
  });
}
function _formats$factory_0() {
  return getPropertyCallableRef('_formats', 1, KMutableProperty1, function (receiver) {
    return receiver.f5l();
  }, function (receiver, value) {
    return receiver.e5l(value);
  });
}
var Companion_instance_29;
function Companion_getInstance_39() {
  return Companion_instance_29;
}
var Type_NORMAL_instance;
var Type_GROUP_instance;
var Type_TILEMAP_instance;
var Companion_instance_30;
function Companion_getInstance_40() {
  Type_initEntries();
  if (Companion_instance_30 === VOID)
    new Companion_24();
  return Companion_instance_30;
}
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_NORMAL_instance = new Type('NORMAL', 0);
  Type_GROUP_instance = new Type('GROUP', 1);
  Type_TILEMAP_instance = new Type('TILEMAP', 2);
  Companion_getInstance_40();
}
function Type_NORMAL_getInstance() {
  Type_initEntries();
  return Type_NORMAL_instance;
}
function Type_GROUP_getInstance() {
  Type_initEntries();
  return Type_GROUP_instance;
}
function Type_TILEMAP_getInstance() {
  Type_initEntries();
  return Type_TILEMAP_instance;
}
function set_orientation(_this__u8e3s4, _set____db54di) {
  _init_properties_ImageOrientation_kt__rodtsl();
  var this_0 = orientation$delegate;
  var property = orientation$factory();
  var tmp = _set____db54di;
  var value = tmp == null ? null : new SliceOrientation(tmp);
  var tmp0_elvis_lhs = this_0.xx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_orientation(_this__u8e3s4) {
  _init_properties_ImageOrientation_kt__rodtsl();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = orientation$delegate;
    var property = orientation$factory_0();
    var tmp = _this__u8e3s4.wx();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.xx_1;
      tmp_0 = tmp0_safe_receiver.c3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.yx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.xx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.xx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      var tmp_2 = r;
      tmp$ret$0 = tmp_2 == null ? null : tmp_2.r3f_1;
      break $l$block;
    }
    var tmp_3 = res;
    tmp$ret$0 = tmp_3 == null ? null : tmp_3.r3f_1;
  }
  return tmp$ret$0;
}
var orientation$delegate;
function orientation$delegate$lambda() {
  _init_properties_ImageOrientation_kt__rodtsl();
  return null;
}
function orientation$factory() {
  return getPropertyCallableRef('orientation', 1, KMutableProperty1, function (receiver) {
    var tmp = get_orientation(receiver);
    return tmp == null ? null : new SliceOrientation(tmp);
  }, function (receiver, value) {
    var tmp = value;
    return set_orientation(receiver, tmp == null ? null : tmp.r3f_1);
  });
}
function orientation$factory_0() {
  return getPropertyCallableRef('orientation', 1, KMutableProperty1, function (receiver) {
    var tmp = get_orientation(receiver);
    return tmp == null ? null : new SliceOrientation(tmp);
  }, function (receiver, value) {
    var tmp = value;
    return set_orientation(receiver, tmp == null ? null : tmp.r3f_1);
  });
}
var properties_initialized_ImageOrientation_kt_37wzbr;
function _init_properties_ImageOrientation_kt__rodtsl() {
  if (!properties_initialized_ImageOrientation_kt_37wzbr) {
    properties_initialized_ImageOrientation_kt_37wzbr = true;
    orientation$delegate = new Property(VOID, orientation$delegate$lambda);
  }
}
function get_imageLoadingLogger() {
  _init_properties_KorioExt_kt__tiega5();
  return imageLoadingLogger;
}
var imageLoadingLogger;
function readBitmapSlice(_this__u8e3s4, name, atlas, props, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  props = props === VOID ? Companion_getInstance_38().d4s_1 : props;
  return readBitmapSlice_0(_this__u8e3s4, props, name, atlas, $completion);
}
function readBitmap(_this__u8e3s4, props, $completion) {
  props = props === VOID ? Companion_getInstance_38().d4s_1 : props;
  return _readBitmap(_this__u8e3s4, VOID, props.e5k(), $completion);
}
function *_generator_readBitmapSlice__1cfrfr(_this__u8e3s4, bprops, name, atlas, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  var tmp = readBitmap(_this__u8e3s4, bprops, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var result = tmp;
  return !(atlas == null) ? atlas.i3x(result.i45(), Unit_instance, name).b3w_1 : slice(result, VOID, name);
}
function readBitmapSlice_0(_this__u8e3s4, bprops, name, atlas, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapSlice__1cfrfr.bind(VOID, _this__u8e3s4, bprops, name, atlas), $completion);
}
function *_generator__readBitmap__syf68g(file, bytes, props, $completion) {
  file = file === VOID ? null : file;
  bytes = bytes === VOID ? null : bytes;
  props = props === VOID ? Companion_getInstance_38().d4s_1 : props;
  var prop = !(file == null) ? props.i5k(file) : props;
  var rformats = !prop.a5k_1 ? listOf_0(prop.b5k_1) : prop.b5k_1 == null ? listOf_0(null) : prop.z5j_1 ? listOf([prop.b5k_1, null]) : listOf([null, prop.b5k_1]);
  var lastError = null;
  var _iterator__ex2g4s = rformats.a1();
  while (_iterator__ex2g4s.b1()) {
    var format = _iterator__ex2g4s.c1();
    try {
      var rformat = format == null ? get_nativeImageFormatProvider() : format;
      var tmp;
      if (!(bytes == null)) {
        var tmp_0 = rformat.w5k(bytes, prop, $completion);
        if (tmp_0 === get_COROUTINE_SUSPENDED())
          tmp_0 = yield tmp_0;
        tmp = tmp_0;
      } else if (!(file == null)) {
        var tmp_1 = rformat.x5k(file, prop, $completion);
        if (tmp_1 === get_COROUTINE_SUSPENDED())
          tmp_1 = yield tmp_1;
        tmp = tmp_1;
      } else {
        throw NotImplementedError.od();
      }
      var bmp = tmp;
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.format._readBitmap.<anonymous>' call
      if (prop.w5j_1) {
        asumePremultiplied(bmp);
      }
      return bmp;
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        lastError = e;
        if (e instanceof CancellationException)
          throw e;
        else {
          var tmp_2;
          if (e instanceof FileNotFoundException) {
            tmp_2 = true;
          } else {
            tmp_2 = e instanceof ImageDecoderNotFoundException;
          }
          if (!tmp_2) {
            // Inline function 'korlibs.logger.Logger.info' call
            var this_0 = get_imageLoadingLogger();
            var level = Level_INFO_getInstance();
            var tmp_3;
            if (this_0.j2t(level)) {
              // Inline function 'korlibs.image.format._readBitmap.<anonymous>' call
              this_0.k2t(level, e);
              tmp_3 = Unit_instance;
            }
          }
        }
      } else {
        throw $p;
      }
    }
  }
  throw ensureNotNull(lastError);
}
function _readBitmap(file, bytes, props, $completion) {
  file = file === VOID ? null : file;
  bytes = bytes === VOID ? null : bytes;
  props = props === VOID ? Companion_getInstance_38().d4s_1 : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator__readBitmap__syf68g.bind(VOID, file, bytes, props), $completion);
}
function *_generator_readBitmap__ml2xmr(_this__u8e3s4, props, $completion) {
  props = props === VOID ? new ImageDecodingProps('file.bin') : props;
  var tmp = readAll(_this__u8e3s4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = _readBitmap(VOID, tmp, props.e5k(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function readBitmap_0(_this__u8e3s4, props, $completion) {
  props = props === VOID ? new ImageDecodingProps('file.bin') : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmap__ml2xmr.bind(VOID, _this__u8e3s4, props), $completion);
}
var properties_initialized_KorioExt_kt_kjvlu9;
function _init_properties_KorioExt_kt__tiega5() {
  if (!properties_initialized_KorioExt_kt_kjvlu9) {
    properties_initialized_KorioExt_kt_kjvlu9 = true;
    imageLoadingLogger = Companion_getInstance_14().mw('ImageLoading');
  }
}
function *_generator_decodeInternal__jnwsgt($this, data, props, $completion) {
  if (props.w5j_1 || props.v5j_1 === false) {
    return $this.w5l(get_RegisteredImageFormats().v5k(data, props), props);
  }
  var tmp = decodeBytes(Companion_instance_4, data, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.x5l(toBitmap(tmp), props);
}
function *_generator_decodeInternal__jnwsgt_0($this, data, props, $completion) {
  if (props.w5j_1 || props.v5j_1 === false) {
    return $this.w5l(get_RegisteredImageFormats().v5k(data, props), props);
  }
  var tmp = decodeBytes(Companion_instance_4, data, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var image = tmp;
  return $this.w5l($this.s5m(image, props), props);
}
function *_generator_decodeInternal__jnwsgt_1($this, vfs, path, props, $completion) {
  var tmp = vfs.e23(path).s23($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.y5l(tmp, props, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function *_generator_decodeSuspend__fioeme($this, data, props, $completion) {
  var tmp = $this.y5l(data, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.x5m_1;
}
function *_generator_decode__skqvkq_0($this, file, props, $completion) {
  var tmp = $this.r5m(file.i21(), file.o21(), props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.x5m_1;
}
function *_generator_decode__skqvkq_1($this, file, props, $completion) {
  var tmp = getUnderlyingUnscapedFile(file, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.v5m(tmp, props, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function toBitmap(_this__u8e3s4) {
  return toBitmap_0(_this__u8e3s4.m3v());
}
function toBitmap_0(_this__u8e3s4) {
  return Bitmap32.e3x(_this__u8e3s4.h3v_1, _this__u8e3s4.i3v_1, _this__u8e3s4.j3v_1, _this__u8e3s4.k3v_1);
}
var Colorspace_GRAYSCALE_instance;
var Colorspace_RGB_instance;
var Colorspace_INDEXED_instance;
var Colorspace_GRAYSCALE_ALPHA_instance;
var Colorspace_RGBA_instance;
var Companion_instance_31;
function Companion_getInstance_41() {
  Colorspace_initEntries();
  if (Companion_instance_31 === VOID)
    new Companion_25();
  return Companion_instance_31;
}
function values_5() {
  return [Colorspace_GRAYSCALE_getInstance(), Colorspace_RGB_getInstance(), Colorspace_INDEXED_getInstance(), Colorspace_GRAYSCALE_ALPHA_getInstance(), Colorspace_RGBA_getInstance()];
}
var Colorspace_entriesInitialized;
function Colorspace_initEntries() {
  if (Colorspace_entriesInitialized)
    return Unit_instance;
  Colorspace_entriesInitialized = true;
  Colorspace_GRAYSCALE_instance = new Colorspace('GRAYSCALE', 0, 0, 1);
  Colorspace_RGB_instance = new Colorspace('RGB', 1, 2, 3);
  Colorspace_INDEXED_instance = new Colorspace('INDEXED', 2, 3, 1);
  Colorspace_GRAYSCALE_ALPHA_instance = new Colorspace('GRAYSCALE_ALPHA', 3, 4, 2);
  Colorspace_RGBA_instance = new Colorspace('RGBA', 4, 6, 4);
  Companion_getInstance_41();
}
function readCommon($this, s, readHeader, info) {
  var magic = readS32BE(s);
  if (!(magic === -1991225785))
    throw IllegalArgumentException.l('Invalid PNG file magic: ' + get_hex(magic) + '!=' + get_hex(-1991225785));
  readS32BE(s);
  var pheader = {_v: null};
  var pngdata = ByteArrayBuilder.xs();
  var rgbPalette = _UByteArrayInt___init__impl__xif7bu_0(768);
  var tmp = 0;
  var tmp_0 = new Int8Array(256);
  while (tmp < 256) {
    tmp_0[tmp] = -1;
    tmp = tmp + 1 | 0;
  }
  var aPalette = _UByteArrayInt___init__impl__xif7bu(tmp_0);
  var paletteCount = {_v: 0};
  while (!get_eof(s) && readCommon$readChunk(s, pheader, info, paletteCount, rgbPalette, aPalette, readHeader, pngdata)) {
  }
  if (readHeader)
    return pheader._v;
  var tmp0_elvis_lhs = pheader._v;
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException.l('PNG without header!');
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var header = tmp_1;
  var width = header.o5n_1;
  var height = header.p5n_1;
  var outputSizeHint = imul(imul(1 + width | 0, height), header.v5n_1);
  var databb = uncompress(pngdata.ct(), Companion_getInstance_13());
  var databbp = 0;
  var context = new DecodingContext(header);
  var bpp = context.x5n_1.v5n_1;
  var row32 = context.a5o_1;
  var tmp_2;
  if (header.v5n_1 === 1) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, paletteCount._v);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.a2_1;
    var last = this_0.b2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.format.PNG.readCommon.<anonymous>' call
        var it = item;
        var tmp$ret$1 = _RGBA___get_value__impl__hhco8v(Companion_getInstance_22().c4d(UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(it, 3) + 0 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(it, 3) + 1 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(it, 3) + 2 | 0), UByteArrayInt__get_impl_px6q8a(aPalette, it)));
        destination.h(tmp$ret$1);
      }
       while (!(item === last));
    tmp_2 = Bitmap8.l48(width, height, VOID, _RgbaArray___init__impl__oib4y4(toIntArray_0(destination)));
  } else {
    tmp_2 = Bitmap32.e3x(width, height, VOID, false);
  }
  var bmp = tmp_2;
  var bmp8 = bmp instanceof Bitmap8 ? bmp : null;
  var bmp32 = bmp instanceof Bitmap32 ? bmp : null;
  var passes = header.u5n_1 === 1 ? $this.g5o_1 : $this.h5o_1;
  var _iterator__ex2g4s = passes.a1();
  while (_iterator__ex2g4s.b1()) {
    var pass = _iterator__ex2g4s.c1();
    var progression = step(until(pass.h5n_1, height), pass.j5n_1);
    var inductionVariable_0 = progression.a2_1;
    var last_0 = progression.b2_1;
    var step_0 = progression.c2_1;
    if (step_0 > 0 && inductionVariable_0 <= last_0 || (step_0 < 0 && last_0 <= inductionVariable_0))
      do {
        var row = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + step_0 | 0;
        var col = pass.i5n_1;
        var colIncrement = pass.k5n_1;
        var pixelsInThisRow = width >>> pass.n5n_1 | 0;
        var bytesInThisRow = imul(imul(pixelsInThisRow, header.v5n_1), header.q5n_1) / 8 | 0;
        var _unary__edvuaz = databbp;
        databbp = _unary__edvuaz + 1 | 0;
        var filter = databb[_unary__edvuaz] & 255;
        var currentRow = context.z5n_1;
        var lastRow = context.y5n_1;
        arraycopy_0(databb, databbp, asByteArray(currentRow), 0, bytesInThisRow);
        databbp = databbp + bytesInThisRow | 0;
        if (!(bmp8 == null)) {
          $this.j5o(filter, lastRow, currentRow, header.v5n_1);
          switch (header.q5n_1) {
            case 1:
              var inductionVariable_1 = 0;
              if (inductionVariable_1 < width)
                do {
                  var n = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x = col + n | 0;
                  var y = row;
                  var color = extract(UByteArrayInt__getOrElse_impl_f0pf72(currentRow, n / 8 | 0, 0), 7 - imul(n % 8 | 0, 1) | 0, 1);
                  bmp.p3y(x, y, color);
                }
                 while (inductionVariable_1 < width);
              break;
            case 2:
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < width)
                do {
                  var n_0 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x_0 = col + n_0 | 0;
                  var y_0 = row;
                  var color_0 = extract(UByteArrayInt__getOrElse_impl_f0pf72(currentRow, n_0 / 4 | 0, 0), 6 - imul(n_0 % 4 | 0, 2) | 0, 2);
                  bmp.p3y(x_0, y_0, color_0);
                }
                 while (inductionVariable_2 < width);
              break;
            case 4:
              var inductionVariable_3 = 0;
              if (inductionVariable_3 < width)
                do {
                  var n_1 = inductionVariable_3;
                  inductionVariable_3 = inductionVariable_3 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x_1 = col + n_1 | 0;
                  var y_1 = row;
                  var color_1 = extract(UByteArrayInt__getOrElse_impl_f0pf72(currentRow, n_1 / 2 | 0, 0), 4 - imul(n_1 % 2 | 0, 4) | 0, 4);
                  bmp.p3y(x_1, y_1, color_1);
                }
                 while (inductionVariable_3 < width);
              break;
            case 8:
              bmp8.a49(col, row, asByteArray(currentRow), width, colIncrement);
              break;
            default:
              // Inline function 'kotlin.error' call

              var message = 'Unsupported header.bitsPerChannel=' + header.q5n_1;
              throw IllegalStateException.w4(toString_0(message));
          }
        } else if (!(bmp32 == null)) {
          if (header.q5n_1 === 8) {
            $this.i5o(filter, lastRow, currentRow, bpp, bytesInThisRow);
            switch (bpp) {
              case 3:
                decode(Companion_getInstance_20(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                break;
              case 4:
                decode(Companion_getInstance_22(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                break;
              default:
                // Inline function 'kotlin.TODO' call

                var reason = 'Bytes: ' + bpp;
                throw NotImplementedError.od('An operation is not implemented: ' + reason);
            }
            bmp32.r48(col, row, row32, width, colIncrement);
          } else {
            // Inline function 'kotlin.error' call
            var message_0 = 'Unsupported header.bitsPerChannel=' + header.q5n_1;
            throw IllegalStateException.w4(toString_0(message_0));
          }
        }
        context.k5o();
      }
       while (!(row === last_0));
  }
  return bmp;
}
function readCommon$default($this, s, readHeader, info, $super) {
  info = info === VOID ? new ImageInfo() : info;
  return readCommon($this, s, readHeader, info);
}
function readCommon$readChunk(_this__u8e3s4, pheader, $info, paletteCount, rgbPalette, aPalette, $readHeader, pngdata) {
  if (get_eof(_this__u8e3s4))
    return false;
  var length = readS32BE(_this__u8e3s4);
  var type = readStringz_0(_this__u8e3s4, 4);
  var data = readStream(_this__u8e3s4, toLong(length));
  var crc = readS32BE(_this__u8e3s4);
  switch (type) {
    case 'IHDR':
      // Inline function 'kotlin.run' call

      // Inline function 'kotlin.contracts.contract' call

      // Inline function 'korlibs.image.format.PNG.readCommon.readChunk.<anonymous>' call

      // Inline function 'kotlin.also' call

      var tmp = readS32BE(data);
      var tmp_0 = readS32BE(data);
      var tmp_1 = readU8(data);
      var tmp0_elvis_lhs = Companion_getInstance_41().g5n_1.c3(readU8(data));
      var this_0 = new Header(tmp, tmp_0, tmp_1, tmp0_elvis_lhs == null ? Colorspace_RGBA_getInstance() : tmp0_elvis_lhs, readU8(data), readU8(data), readU8(data));
      // Inline function 'kotlin.contracts.contract' call

      // Inline function 'korlibs.image.format.PNG.readCommon.readChunk.<anonymous>.<anonymous>' call

      $info.q5k_1 = this_0.o5n_1;
      $info.r5k_1 = this_0.p5n_1;
      $info.s5k_1 = imul(this_0.q5n_1, this_0.r5n_1.f5n_1);
      pheader._v = this_0;
      break;
    case 'PLTE':
      // Inline function 'kotlin.math.max' call

      var a = paletteCount._v;
      var b = data.a().i2() / 3 | 0;
      paletteCount._v = Math.max(a, b);
      data.q13(asByteArray(rgbPalette), 0, data.a().i2());
      break;
    case 'tRNS':
      // Inline function 'kotlin.math.max' call

      var a_0 = paletteCount._v;
      var b_0 = data.a().i2();
      paletteCount._v = Math.max(a_0, b_0);
      data.q13(asByteArray(aPalette), 0, data.a().i2());
      break;
    case 'IDAT':
      if ($readHeader) {
        return false;
      }

      pngdata.at(readAll_0(data));
      break;
    case 'eXIf':
      runBlockingNoSuspensions(PNG$readCommon$readChunk$slambda_0(data, $info));
      break;
    case 'IEND':
      return false;
  }
  return true;
}
function PNG$readCommon$readChunk$slambda_0($data, $info) {
  var i = new PNG$readCommon$readChunk$slambda($data, $info);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function Colorspace_GRAYSCALE_getInstance() {
  Colorspace_initEntries();
  return Colorspace_GRAYSCALE_instance;
}
function Colorspace_RGB_getInstance() {
  Colorspace_initEntries();
  return Colorspace_RGB_instance;
}
function Colorspace_INDEXED_getInstance() {
  Colorspace_initEntries();
  return Colorspace_INDEXED_instance;
}
function Colorspace_GRAYSCALE_ALPHA_getInstance() {
  Colorspace_initEntries();
  return Colorspace_GRAYSCALE_ALPHA_instance;
}
function Colorspace_RGBA_getInstance() {
  Colorspace_initEntries();
  return Colorspace_RGBA_instance;
}
var PNG_instance;
function PNG_getInstance() {
  if (PNG_instance === VOID)
    PNG.n5o();
  return PNG_instance;
}
function get_RegisteredImageFormats() {
  _init_properties_RegisteredImageFormats_kt__dq34zn();
  return RegisteredImageFormats;
}
var RegisteredImageFormats;
var properties_initialized_RegisteredImageFormats_kt_ribwxx;
function _init_properties_RegisteredImageFormats_kt__dq34zn() {
  if (!properties_initialized_RegisteredImageFormats_kt_ribwxx) {
    properties_initialized_RegisteredImageFormats_kt_ribwxx = true;
    RegisteredImageFormats = ImageFormatsMutable.n5l([PNG_getInstance()]);
  }
}
var WEBP_WASM_BASE64_ZLIB;
function sumPacked4MulR(a, b, mul) {
  var dstRB = imul(b & 16711935, mul) >>> 8 | 0;
  var dstGA = imul((b >>> 8 | 0) & 16711935, mul) >>> 8 | 0;
  var r = ((a >>> 0 | 0) & 255) + ((dstRB >>> 0 | 0) & 255) | 0;
  var g = ((a >>> 8 | 0) & 255) + ((dstGA >>> 0 | 0) & 255) | 0;
  var b_0 = ((a >>> 16 | 0) & 255) + ((dstRB >>> 16 | 0) & 255) | 0;
  var a_0 = ((a >>> 24 | 0) & 255) + ((dstGA >>> 16 | 0) & 255) | 0;
  return packIntClamped(r, g, b_0, a_0);
}
function d2i(v) {
  return toIntRound(clamp01(v) * 255);
}
function f2i(v) {
  return toIntRound_0(clamp01_0(v) * 255);
}
function packIntUnchecked(r, g, b, a) {
  return (r & 255) << 0 | (g & 255) << 8 | (b & 255) << 16 | (a & 255) << 24;
}
function packIntClamped(r, g, b, a) {
  return clampUByte(r) | clampUByte(g) << 8 | clampUByte(b) << 16 | clampUByte(a) << 24;
}
var Companion_instance_32;
function Companion_getInstance_42() {
  return Companion_instance_32;
}
function _get_fill__d6ivc8($this) {
  var tmp = $this.x5o_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('fill');
  }
}
function color($this, ratio) {
  return RgbaPremultipliedArray__get_impl_1u69ta($this.w5o_1, numberToInt(clamp01_0(ratio) * 255));
}
function _set_texture__qu271y($this, value) {
  $this.i5p_1 = value;
  $this.e5p_1 = $this.i5p_1.l3x_1;
  $this.f5p_1 = $this.i5p_1.m3x_1;
  $this.g5p_1 = 1.0 / $this.e5p_1;
  $this.h5p_1 = 1.0 / $this.f5p_1;
}
var NoneFiller_instance;
function NoneFiller_getInstance() {
  if (NoneFiller_instance === VOID)
    new NoneFiller();
  return NoneFiller_instance;
}
function toFiller(_this__u8e3s4, state) {
  var tmp;
  if (_this__u8e3s4 instanceof NonePaint) {
    tmp = NoneFiller_getInstance();
  } else {
    if (_this__u8e3s4 instanceof RGBA) {
      // Inline function 'kotlin.also' call
      var this_0 = new ColorFiller();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
      this_0.q5o(_this__u8e3s4.m4e_1, state);
      tmp = this_0;
    } else {
      if (_this__u8e3s4 instanceof GradientPaint) {
        // Inline function 'kotlin.also' call
        var this_1 = new GradientFiller();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
        this_1.y5o(_this__u8e3s4, state);
        tmp = this_1;
      } else {
        if (_this__u8e3s4 instanceof BitmapPaint) {
          // Inline function 'kotlin.also' call
          var this_2 = new BitmapFiller();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
          this_2.m5p(_this__u8e3s4, state);
          tmp = this_2;
        } else {
          throw NotImplementedError.od();
        }
      }
    }
  }
  return tmp;
}
function colorInt(_this__u8e3s4, $this, premultiplied) {
  return premultiplied ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(_this__u8e3s4)) : _RGBA___get_value__impl__hhco8v(_this__u8e3s4);
}
function _fillColors($this, out, stops, colors, premultiplied) {
  var numberOfStops = stops.e1();
  var NCOLORS = out.length;
  switch (numberOfStops) {
    case 0:
    case 1:
      var color = numberOfStops === 0 ? Colors_getInstance().u40_1 : _RGBA___init__impl__lqpay5(colors.kk());
      var pcolor = colorInt(color, $this, premultiplied);
      var inductionVariable = 0;
      if (inductionVariable < NCOLORS)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          out[n] = pcolor;
        }
         while (inductionVariable < NCOLORS);
      break;
    default:
      var inductionVariable_0 = 0;
      var last = _fillColors$stopN(stops, NCOLORS, 0);
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          out[n_0] = colorInt(_RGBA___init__impl__lqpay5(colors.kk()), $this, premultiplied);
        }
         while (inductionVariable_0 < last);
      var inductionVariable_1 = 0;
      var last_0 = numberOfStops - 1 | 0;
      if (inductionVariable_1 < last_0)
        do {
          var n_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var stop0 = _fillColors$stopN(stops, NCOLORS, n_1 + 0 | 0);
          var stop1 = _fillColors$stopN(stops, NCOLORS, n_1 + 1 | 0);
          var color0 = _RGBA___init__impl__lqpay5(colors.qx(n_1 + 0 | 0));
          var color1 = _RGBA___init__impl__lqpay5(colors.qx(n_1 + 1 | 0));
          var inductionVariable_2 = stop0;
          if (inductionVariable_2 < stop1)
            do {
              var s = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var ratio = _Ratio___init__impl__9mwvn2(s - stop0 | 0, stop1 - stop0 | 0);
              out[s] = colorInt(Companion_getInstance_22().j4o(color0, color1, ratio), $this, premultiplied);
            }
             while (inductionVariable_2 < stop1);
        }
         while (inductionVariable_1 < last_0);
      var inductionVariable_3 = _fillColors$stopN(stops, NCOLORS, numberOfStops - 1 | 0);
      if (inductionVariable_3 < NCOLORS)
        do {
          var n_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          out[n_2] = colorInt(_RGBA___init__impl__lqpay5(colors.c2k()), $this, premultiplied);
        }
         while (inductionVariable_3 < NCOLORS);
      break;
  }
}
function _fillColors$stopN($stops, NCOLORS, n) {
  return numberToInt($stops.d1(n) * NCOLORS);
}
var Companion_instance_33;
function Companion_getInstance_43() {
  return Companion_instance_33;
}
function colorsToString($this, colors) {
  return '[' + joinToString(new RgbaArray(colors), ', ', VOID, VOID, VOID, VOID, GradientPaint$colorsToString$lambda) + ']';
}
function colorsToString_0($this, colors) {
  return colorsToString($this, _RgbaArray___init__impl__oib4y4(colors.g2k()));
}
function GradientPaint$colorsToString$lambda(it) {
  return _RGBA___get_hexString__impl__kocngm(it.m4e_1);
}
var GradientKind_LINEAR_instance;
var GradientKind_RADIAL_instance;
var GradientKind_SWEEP_instance;
var GradientKind_entriesInitialized;
function GradientKind_initEntries() {
  if (GradientKind_entriesInitialized)
    return Unit_instance;
  GradientKind_entriesInitialized = true;
  GradientKind_LINEAR_instance = new GradientKind('LINEAR', 0);
  GradientKind_RADIAL_instance = new GradientKind('RADIAL', 1);
  GradientKind_SWEEP_instance = new GradientKind('SWEEP', 2);
}
var GradientInterpolationMethod_LINEAR_instance;
var GradientInterpolationMethod_NORMAL_instance;
var GradientInterpolationMethod_entriesInitialized;
function GradientInterpolationMethod_initEntries() {
  if (GradientInterpolationMethod_entriesInitialized)
    return Unit_instance;
  GradientInterpolationMethod_entriesInitialized = true;
  GradientInterpolationMethod_LINEAR_instance = new GradientInterpolationMethod('LINEAR', 0);
  GradientInterpolationMethod_NORMAL_instance = new GradientInterpolationMethod('NORMAL', 1);
}
var GradientUnits_USER_SPACE_ON_USE_instance;
var GradientUnits_OBJECT_BOUNDING_BOX_instance;
var GradientUnits_entriesInitialized;
function GradientUnits_initEntries() {
  if (GradientUnits_entriesInitialized)
    return Unit_instance;
  GradientUnits_entriesInitialized = true;
  GradientUnits_USER_SPACE_ON_USE_instance = new GradientUnits('USER_SPACE_ON_USE', 0);
  GradientUnits_OBJECT_BOUNDING_BOX_instance = new GradientUnits('OBJECT_BOUNDING_BOX', 1);
}
var NonePaint_instance;
function NonePaint_getInstance() {
  return NonePaint_instance;
}
function get_DefaultPaint() {
  return Colors_getInstance().t3y_1;
}
function GradientKind_LINEAR_getInstance() {
  GradientKind_initEntries();
  return GradientKind_LINEAR_instance;
}
function GradientKind_RADIAL_getInstance() {
  GradientKind_initEntries();
  return GradientKind_RADIAL_instance;
}
function GradientInterpolationMethod_NORMAL_getInstance() {
  GradientInterpolationMethod_initEntries();
  return GradientInterpolationMethod_NORMAL_instance;
}
function GradientUnits_OBJECT_BOUNDING_BOX_getInstance() {
  GradientUnits_initEntries();
  return GradientUnits_OBJECT_BOUNDING_BOX_instance;
}
function RichTextData$Line$defaultStyle$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var this_0 = this$0.i5q_1;
    var destination = ArrayList.h1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      if (element instanceof TextNode) {
        destination.h(element);
      }
    }
    var tmp261_safe_receiver = firstOrNull_0(destination);
    var tmp0_elvis_lhs = tmp261_safe_receiver == null ? null : tmp261_safe_receiver.t5q_1;
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this$0.j5q_1 : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? Companion_getInstance_44().v5q_1 : tmp1_elvis_lhs;
  };
}
function RichTextData$Line$defaultLastStyle$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var this_0 = this$0.i5q_1;
    var destination = ArrayList.h1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      if (element instanceof TextNode) {
        destination.h(element);
      }
    }
    var tmp262_safe_receiver = lastOrNull_0(destination);
    var tmp0_elvis_lhs = tmp262_safe_receiver == null ? null : tmp262_safe_receiver.t5q_1;
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this$0.j5q_1 : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? Companion_getInstance_44().v5q_1 : tmp1_elvis_lhs;
  };
}
function RichTextData$Line$text$delegate$lambda$lambda(it) {
  var tmp0_elvis_lhs = it.w5q();
  return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
}
function RichTextData$Line$text$delegate$lambda(this$0) {
  return function () {
    return joinToString(this$0.i5q_1, '', VOID, VOID, VOID, VOID, RichTextData$Line$text$delegate$lambda$lambda);
  };
}
function RichTextData$Line$width$delegate$lambda(this$0) {
  return function () {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this$0.i5q_1.g1()) {
      // Inline function 'kotlin.collections.sumOf' call
      var sum = 0;
      var tmp0_iterator = this$0.i5q_1.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        var tmp_0 = sum;
        // Inline function 'korlibs.image.text.Line.width$delegate.<anonymous>.<anonymous>' call
        sum = tmp_0 + element.m2i();
      }
      tmp = sum;
    } else {
      tmp = 0.0;
    }
    return tmp;
  };
}
function RichTextData$Line$maxLineHeight$delegate$lambda(this$0) {
  return function () {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this$0.i5q_1.g1()) {
      // Inline function 'kotlin.collections.maxOf' call
      var iterator = this$0.i5q_1.a1();
      if (!iterator.b1())
        throw NoSuchElementException.k6();
      // Inline function 'korlibs.image.text.Line.maxLineHeight$delegate.<anonymous>.<anonymous>' call
      var maxValue = iterator.c1().g4p();
      while (iterator.b1()) {
        // Inline function 'korlibs.image.text.Line.maxLineHeight$delegate.<anonymous>.<anonymous>' call
        var v = iterator.c1().g4p();
        // Inline function 'kotlin.comparisons.maxOf' call
        var a = maxValue;
        maxValue = Math.max(a, v);
      }
      tmp = maxValue;
    } else {
      tmp = (new TextNode('', this$0.x5q())).g4p();
    }
    return tmp;
  };
}
function RichTextData$Line$maxHeight$delegate$lambda(this$0) {
  return function () {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this$0.i5q_1.g1()) {
      // Inline function 'kotlin.collections.maxOf' call
      var iterator = this$0.i5q_1.a1();
      if (!iterator.b1())
        throw NoSuchElementException.k6();
      // Inline function 'korlibs.image.text.Line.maxHeight$delegate.<anonymous>.<anonymous>' call
      var maxValue = iterator.c1().n2i();
      while (iterator.b1()) {
        // Inline function 'korlibs.image.text.Line.maxHeight$delegate.<anonymous>.<anonymous>' call
        var v = iterator.c1().n2i();
        // Inline function 'kotlin.comparisons.maxOf' call
        var a = maxValue;
        maxValue = Math.max(a, v);
      }
      tmp = maxValue;
    } else {
      tmp = (new TextNode('', this$0.x5q())).n2i();
    }
    return tmp;
  };
}
function RichTextData$Line$allFonts$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.mutableSetOf' call
    var this_0 = LinkedHashSet.j1();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.Line.allFonts$delegate.<anonymous>.<anonymous>' call
    var _iterator__ex2g4s = this$0.i5q_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var node = _iterator__ex2g4s.c1();
      if (node instanceof TextNode) {
        this_0.h(node.t5q_1.y5q_1);
      }
    }
    return this_0;
  };
}
var Companion_instance_34;
function Companion_getInstance_44() {
  if (Companion_instance_34 === VOID)
    new Companion_28();
  return Companion_instance_34;
}
function RichTextData$TextNode$bounds$delegate$lambda(this$0) {
  return function () {
    return getTextBounds(this$0.t5q_1.y5q_1, this$0.t5q_1.z5q_1, this$0.s5q_1);
  };
}
var Companion_instance_35;
function Companion_getInstance_45() {
  if (Companion_instance_35 === VOID)
    new Companion_29();
  return Companion_instance_35;
}
function wordWrap$addNode(currentLine, currentLineWidth, node) {
  var lastNode = lastOrNull_0(currentLine);
  var tmp;
  var tmp_0;
  var tmp_1;
  var tmp_2;
  var tmp_3;
  var tmp_4;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!currentLine.g1()) {
    tmp_4 = node instanceof TextNode;
  } else {
    tmp_4 = false;
  }
  if (tmp_4) {
    tmp_3 = lastNode instanceof TextNode;
  } else {
    tmp_3 = false;
  }
  if (tmp_3) {
    tmp_2 = lastNode.m5r(node.s5q_1).equals(node);
  } else {
    tmp_2 = false;
  }
  if (tmp_2) {
    tmp_1 = node.t5q_1.e5r_1;
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    // Inline function 'kotlin.text.isNotBlank' call
    var this_0 = node.s5q_1;
    tmp_0 = !isBlank(this_0);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    // Inline function 'kotlin.text.isNotBlank' call
    var this_1 = lastNode.s5q_1;
    tmp = !isBlank(this_1);
  } else {
    tmp = false;
  }
  if (tmp) {
    removeLast(currentLine);
    currentLineWidth._v = currentLineWidth._v - lastNode.d5f().m2i();
    return wordWrap$addNode(currentLine, currentLineWidth, node.m5r(lastNode.s5q_1 + node.s5q_1));
  } else {
    currentLine.h(node);
    currentLineWidth._v = currentLineWidth._v + node.m2i();
  }
}
function wordWrap$finishLine(currentLine, outLines, currentLineWidth) {
  if (currentLine.g1())
    return Unit_instance;
  // Inline function 'kotlin.collections.plusAssign' call
  var element = Line.f5r(toList(currentLine));
  outLines.h(element);
  currentLine.h3();
  currentLineWidth._v = 0.0;
}
function RichTextData$text$delegate$lambda$lambda(it) {
  return it.w5q();
}
function RichTextData$text$delegate$lambda(this$0) {
  return function () {
    return joinToString(this$0.u5r_1, '\n', VOID, VOID, VOID, VOID, RichTextData$text$delegate$lambda$lambda);
  };
}
function RichTextData$width$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.maxOf' call
    var iterator = this$0.u5r_1.a1();
    if (!iterator.b1())
      throw NoSuchElementException.k6();
    // Inline function 'korlibs.image.text.RichTextData.width$delegate.<anonymous>.<anonymous>' call
    var maxValue = iterator.c1().m2i();
    while (iterator.b1()) {
      // Inline function 'korlibs.image.text.RichTextData.width$delegate.<anonymous>.<anonymous>' call
      var v = iterator.c1().m2i();
      // Inline function 'kotlin.comparisons.maxOf' call
      var a = maxValue;
      maxValue = Math.max(a, v);
    }
    return maxValue;
  };
}
function RichTextData$height$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var tmp0_iterator = this$0.u5r_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      var tmp = sum;
      // Inline function 'korlibs.image.text.RichTextData.height$delegate.<anonymous>.<anonymous>' call
      sum = tmp + element.i5r();
    }
    return sum;
  };
}
function RichTextData$allFonts$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.mutableSetOf' call
    var this_0 = LinkedHashSet.j1();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.RichTextData.allFonts$delegate.<anonymous>.<anonymous>' call
    var _iterator__ex2g4s = this$0.u5r_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var line = _iterator__ex2g4s.c1();
      this_0.f1(line.k5r());
    }
    return this_0;
  };
}
function width$factory() {
  return getPropertyCallableRef('width', 1, KProperty1, function (receiver) {
    return receiver.m2i();
  }, null);
}
function height$factory() {
  return getPropertyCallableRef('height', 1, KProperty1, function (receiver) {
    return receiver.n2i();
  }, null);
}
function allFonts$factory() {
  return getPropertyCallableRef('allFonts', 1, KProperty1, function (receiver) {
    return receiver.k5r();
  }, null);
}
function defaultStyle$factory() {
  return getPropertyCallableRef('defaultStyle', 1, KProperty1, function (receiver) {
    return receiver.x5q();
  }, null);
}
function defaultLastStyle$factory() {
  return getPropertyCallableRef('defaultLastStyle', 1, KProperty1, function (receiver) {
    return receiver.h5r();
  }, null);
}
function text$factory() {
  return getPropertyCallableRef('text', 1, KProperty1, function (receiver) {
    return receiver.w5q();
  }, null);
}
function width$factory_0() {
  return getPropertyCallableRef('width', 1, KProperty1, function (receiver) {
    return receiver.m2i();
  }, null);
}
function maxLineHeight$factory() {
  return getPropertyCallableRef('maxLineHeight', 1, KProperty1, function (receiver) {
    return receiver.i5r();
  }, null);
}
function maxHeight$factory() {
  return getPropertyCallableRef('maxHeight', 1, KProperty1, function (receiver) {
    return receiver.j5r();
  }, null);
}
function allFonts$factory_0() {
  return getPropertyCallableRef('allFonts', 1, KProperty1, function (receiver) {
    return receiver.k5r();
  }, null);
}
function bounds$factory() {
  return getPropertyCallableRef('bounds', 1, KProperty1, function (receiver) {
    return receiver.d5f();
  }, null);
}
function drawRichText(_this__u8e3s4, text, bounds, wordWrap, includePartialLines, ellipsis, fill, stroke, align, includeFirstLineAlways, textRangeStart, textRangeEnd) {
  bounds = bounds === VOID ? Companion_getInstance_4().u2d(0, 0, _this__u8e3s4.m2i(), _this__u8e3s4.n2i()) : bounds;
  wordWrap = wordWrap === VOID ? true : wordWrap;
  includePartialLines = includePartialLines === VOID ? false : includePartialLines;
  ellipsis = ellipsis === VOID ? null : ellipsis;
  fill = fill === VOID ? null : fill;
  stroke = stroke === VOID ? null : stroke;
  align = align === VOID ? Companion_getInstance_48().l4w_1 : align;
  includeFirstLineAlways = includeFirstLineAlways === VOID ? true : includeFirstLineAlways;
  textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
  textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
  var result = place(text, bounds, wordWrap, includePartialLines, ellipsis, fill, stroke, align, includeFirstLineAlways);
  var n = 0;
  var metrics = new TextMetricsResult();
  var _iterator__ex2g4s = result.m5s_1.a1();
  while (_iterator__ex2g4s.b1()) {
    var place_0 = _iterator__ex2g4s.c1();
    var tmp275_text = place_0.n5s_1;
    var tmp276_pos = place_0.o5s_1;
    var tmp277_size = place_0.p5s_1;
    var tmp278_font = place_0.q5s_1;
    var tmp279_fillStyle = place_0.r5s_1;
    var tmp280_stroke = place_0.s5s_1;
    var tmp281_align = Companion_getInstance_48().p4w_1;
    var tmp282_textRangeStart = textRangeStart - n | 0;
    var tmp283_textRangeEnd = textRangeEnd - n | 0;
    var tmp284_renderer = get_DefaultStringTextRenderer();
    _this__u8e3s4.t5s(tmp275_text, tmp276_pos, VOID, VOID, tmp278_font, tmp277_size, tmp284_renderer, tmp281_align, metrics, tmp279_fillStyle, tmp280_stroke, tmp282_textRangeStart, tmp283_textRangeEnd);
    n = n + metrics.d4w_1.e1() | 0;
  }
  return n;
}
function place(_this__u8e3s4, bounds, wordWrap, includePartialLines, ellipsis, fill, stroke, align, includeFirstLineAlways, out) {
  wordWrap = wordWrap === VOID ? true : wordWrap;
  includePartialLines = includePartialLines === VOID ? false : includePartialLines;
  ellipsis = ellipsis === VOID ? null : ellipsis;
  fill = fill === VOID ? null : fill;
  stroke = stroke === VOID ? null : stroke;
  align = align === VOID ? Companion_getInstance_48().l4w_1 : align;
  includeFirstLineAlways = includeFirstLineAlways === VOID ? true : includeFirstLineAlways;
  out = out === VOID ? new RichTextDataPlacements() : out;
  var text = _this__u8e3s4;
  out.m5s_1.h3();
  if (text.u5r_1.g1())
    return out;
  var tmp272_maxLineWidth = wordWrap ? bounds.q25_1 : Infinity;
  var tmp273_maxHeight = bounds.r25_1;
  var rtext = text.j5s(tmp272_maxLineWidth, tmp273_maxHeight, includePartialLines, ellipsis, true, includeFirstLineAlways);
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!rtext.u5r_1.g1()) {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var tmp0_iterator = dropLast(rtext.u5r_1, 1).a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      var tmp_0 = sum;
      // Inline function 'korlibs.image.text.place.<anonymous>' call
      sum = tmp_0 + element.i5r();
    }
    tmp = sum + last(rtext.u5r_1).j5r();
  } else {
    tmp = 0.0;
  }
  var totalHeight = tmp;
  var y = {_v: bounds.p25_1 + (bounds.r25_1 - totalHeight) * _VerticalAlign___get_ratioFake0__impl__5adpb3(align.e4y_1)};
  var _iterator__ex2g4s = rtext.u5r_1.a1();
  while (_iterator__ex2g4s.b1()) {
    var line = _iterator__ex2g4s.c1();
    var x = {_v: bounds.o25_1 - HorizontalAlign__getOffsetX_impl_urzzxf(align.d4y_1, line.m2i()) + HorizontalAlign__getOffsetX_impl_urzzxf(align.d4y_1, bounds.q25_1)};
    var wordSpacing = equals(align.d4y_1, Companion_getInstance_47().w5s_1) ? (bounds.q25_1 - line.m2i()) / (line.i5q_1.e1() - 1) : 0.0;
    y._v = y._v + line.j5r();
    var _iterator__ex2g4s_0 = line.i5q_1.a1();
    while (_iterator__ex2g4s_0.b1()) {
      var node = _iterator__ex2g4s_0.c1();
      if (node instanceof TextNode) {
        if (node.t5q_1.b5r_1) {
          place$render(out, node, x, y, fill, stroke, 1.0, 0.0);
        }
        place$render(out, node, x, y, fill, stroke, 0.0, 0.0);
        x._v = x._v + node.m2i();
        x._v = x._v + wordSpacing;
      }
    }
    y._v = y._v + (line.i5r() - line.j5r());
  }
  return out;
}
function place$render($out, node, x, y, $fill, $stroke, dx, dy) {
  var tmp = Vector2D.n27(x._v + dx, y._v + dy);
  var tmp0_elvis_lhs = node.t5q_1.d5r_1;
  var tmp_0;
  var tmp_1 = tmp0_elvis_lhs;
  if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
    tmp_0 = $fill;
  } else {
    var tmp_2 = tmp0_elvis_lhs;
    tmp_0 = tmp_2 == null ? null : new RGBA(tmp_2);
  }
  $out.m5s_1.h(new Placement(node.s5q_1, tmp, node.t5q_1.z5q_1, node.t5q_1.y5q_1, tmp_0, $stroke));
}
function _VerticalAlign___init__impl__f42kfq(ratio) {
  return ratio;
}
function _VerticalAlign___get_ratio__impl__b3ilr8($this) {
  return $this;
}
function _VerticalAlign___get_ratioFake__impl__1h2fwv($this) {
  return equals($this, Companion_getInstance_46().f5t_1) ? 1.0 : _VerticalAlign___get_ratio__impl__b3ilr8($this);
}
function _VerticalAlign___get_ratioFake0__impl__5adpb3($this) {
  return equals($this, Companion_getInstance_46().f5t_1) ? 0.0 : _VerticalAlign___get_ratio__impl__b3ilr8($this);
}
var Companion_instance_36;
function Companion_getInstance_46() {
  if (Companion_instance_36 === VOID)
    new Companion_30();
  return Companion_instance_36;
}
function VerticalAlign__getOffsetY_impl_iso0y6($this, height, baseline) {
  return equals($this, Companion_getInstance_46().f5t_1) ? baseline : -height * _VerticalAlign___get_ratio__impl__b3ilr8($this);
}
function VerticalAlign__getOffsetYRespectBaseline_impl_62po5b($this, font, totalHeight) {
  return equals($this, Companion_getInstance_46().f5t_1) ? 0.0 : interpolate_0(toRatio_0(_VerticalAlign___get_ratio__impl__b3ilr8($this)), font.q4p_1, font.q4p_1 - totalHeight);
}
function VerticalAlign__toString_impl_hcpnn2($this) {
  return equals($this, Companion_getInstance_46().c5t_1) ? 'TOP' : equals($this, Companion_getInstance_46().d5t_1) ? 'MIDDLE' : equals($this, Companion_getInstance_46().e5t_1) ? 'BOTTOM' : equals($this, Companion_getInstance_46().f5t_1) ? 'BASELINE' : 'VerticalAlign(' + _VerticalAlign___get_ratio__impl__b3ilr8($this) + ')';
}
function VerticalAlign__hashCode_impl_vx8hj7($this) {
  return getNumberHashCode($this);
}
function VerticalAlign__equals_impl_xp13z($this, other) {
  if (!(other instanceof VerticalAlign))
    return false;
  var tmp0_other_with_cast = other instanceof VerticalAlign ? other.i5t_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function _HorizontalAlign___init__impl__ad654o(ratio) {
  return ratio;
}
function _HorizontalAlign___get_ratio__impl__x9wlea($this) {
  return $this;
}
function _HorizontalAlign___get_ratioFake__impl__h46z0d($this) {
  return equals($this, Companion_getInstance_47().w5s_1) ? 0.0 : _HorizontalAlign___get_ratio__impl__x9wlea($this);
}
var Companion_instance_37;
function Companion_getInstance_47() {
  if (Companion_instance_37 === VOID)
    new Companion_31();
  return Companion_instance_37;
}
function HorizontalAlign__getOffsetX_impl_urzzxf($this, width) {
  return equals($this, Companion_getInstance_47().w5s_1) ? 0.0 : width * _HorizontalAlign___get_ratio__impl__x9wlea($this);
}
function HorizontalAlign__toString_impl_toflc0($this) {
  return equals($this, Companion_getInstance_47().x5s_1) ? 'LEFT' : equals($this, Companion_getInstance_47().y5s_1) ? 'CENTER' : equals($this, Companion_getInstance_47().z5s_1) ? 'RIGHT' : equals($this, Companion_getInstance_47().w5s_1) ? 'JUSTIFY' : 'HorizontalAlign(' + _HorizontalAlign___get_ratio__impl__x9wlea($this) + ')';
}
function HorizontalAlign__hashCode_impl_7x9oj5($this) {
  return getNumberHashCode($this);
}
function HorizontalAlign__equals_impl_hkfbhv($this, other) {
  if (!(other instanceof HorizontalAlign))
    return false;
  var tmp0_other_with_cast = other instanceof HorizontalAlign ? other.j5t_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var Companion_instance_38;
function Companion_getInstance_48() {
  if (Companion_instance_38 === VOID)
    new Companion_32();
  return Companion_instance_38;
}
var DefaultWStringTextRenderer;
function get_DefaultStringTextRenderer() {
  _init_properties_TextRenderer_kt__4uayeo();
  return DefaultStringTextRenderer;
}
var DefaultStringTextRenderer;
function CreateWStringTextRenderer(getVersion, handler) {
  var tmp;
  if (getVersion === VOID) {
    tmp = CreateWStringTextRenderer$lambda;
  } else {
    tmp = getVersion;
  }
  getVersion = tmp;
  _init_properties_TextRenderer_kt__4uayeo();
  return new CreateWStringTextRenderer$2(getVersion, handler);
}
function CreateStringTextRenderer(getVersion, handler) {
  var tmp;
  if (getVersion === VOID) {
    tmp = CreateStringTextRenderer$lambda;
  } else {
    tmp = getVersion;
  }
  getVersion = tmp;
  _init_properties_TextRenderer_kt__4uayeo();
  return new CreateStringTextRenderer$2(getVersion, handler);
}
function add($this, x, y) {
  var rx = $this.tw().e25_1 + $this.r50().p29(x, y);
  var ry = $this.tw().f25_1 + $this.r50().s29(x, y);
  $this.y4x_1 = BoundsBuilder__plus_impl_cz7f7x_1($this.y4x_1, Vector2D.n27(rx, ry));
  if ($this.z4x_1 === 0) {
    $this.x4x_1 = BoundsBuilder__plus_impl_cz7f7x_1($this.x4x_1, Vector2D.n27(rx, ry));
  }
  var _receiver__tnumb7 = $this.b4y_1;
  _receiver__tnumb7.j4y_1 = BoundsBuilder__plus_impl_cz7f7x_1(_receiver__tnumb7.j4y_1, Vector2D.n27(rx, ry));
}
function add_0($this, rect) {
  var fx = rect.v25();
  var fy = rect.x25();
  var w = rect.q25_1;
  var h = rect.r25_1;
  add($this, fx, fy);
  add($this, fx + w, fy);
  add($this, fx + w, fy + h);
  add($this, fx, fy + h);
}
function measure(_this__u8e3s4, text, size, defaultFont) {
  _init_properties_TextRenderer_kt__4uayeo();
  var actions = new BoundBuilderTextRendererActions();
  invoke(_this__u8e3s4, actions, text, size, defaultFont);
  return actions;
}
function invoke(_this__u8e3s4, actions, text, size, defaultFont) {
  _init_properties_TextRenderer_kt__4uayeo();
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.text.invoke.<anonymous>' call
  _this__u8e3s4.m5t(actions, text, size, defaultFont);
}
function DefaultWStringTextRenderer$lambda($this$CreateWStringTextRenderer, text, c, g, advance) {
  _init_properties_TextRenderer_kt__4uayeo();
  $this$CreateWStringTextRenderer.d50(text, c);
  $this$CreateWStringTextRenderer.z50(advance);
  return Unit_instance;
}
function DefaultStringTextRenderer$lambda($this$CreateStringTextRenderer, text, c, g, advance) {
  _init_properties_TextRenderer_kt__4uayeo();
  $this$CreateStringTextRenderer.d50(text, c);
  $this$CreateStringTextRenderer.z50(advance);
  return Unit_instance;
}
function CreateWStringTextRenderer$lambda() {
  _init_properties_TextRenderer_kt__4uayeo();
  return 0;
}
function CreateStringTextRenderer$lambda() {
  _init_properties_TextRenderer_kt__4uayeo();
  return 0;
}
function CreateStringTextRenderer$o$wstring$lambda($handler) {
  return function ($this$CreateWStringTextRenderer, text, c, g, advance) {
    $handler($this$CreateWStringTextRenderer, text, c, g, advance);
    return Unit_instance;
  };
}
var properties_initialized_TextRenderer_kt_lfmsb6;
function _init_properties_TextRenderer_kt__4uayeo() {
  if (!properties_initialized_TextRenderer_kt_lfmsb6) {
    properties_initialized_TextRenderer_kt_lfmsb6 = true;
    DefaultWStringTextRenderer = CreateWStringTextRenderer(VOID, DefaultWStringTextRenderer$lambda);
    DefaultStringTextRenderer = CreateStringTextRenderer(VOID, DefaultStringTextRenderer$lambda);
  }
}
function overlaps($this, a0, a1, b0, b1) {
  // Inline function 'kotlin.math.min' call
  var min = Math.min(a0, a0);
  // Inline function 'kotlin.math.max' call
  var max = Math.max(a1, a1);
  // Inline function 'kotlin.math.max' call
  var maxMinor = Math.max(a0, b0);
  // Inline function 'kotlin.math.min' call
  var minMajor = Math.min(a1, b1);
  return (min <= maxMinor ? maxMinor <= max : false) || (min <= minMajor ? minMajor <= max : false);
}
function renderFinal$flush(this$0, filler, $state, $winding, fillPath) {
  if (this$0.v5v_1.j5w_1.o27()) {
    this$0.v5v_1.h5w_1 = this$0.t5v_1 ? 4 : 1;
    this$0.z5v_1.f5v_1 = filler;
    this$0.z5v_1.o5v_1 = $state.d4r_1;
    this$0.z5v_1.c2q();
    var tmp = $winding == null ? fillPath.z3d_1 : $winding;
    this$0.v5v_1.p5w(this$0.u5v_1, VOID, VOID, tmp, Bitmap32Context2d$renderFinal$flush$lambda(this$0));
    this$0.z5v_1.lc();
    this$0.v5v_1.j5w_1.c2q();
  }
}
function Bitmap32Context2d$renderFinal$flush$lambda(this$0) {
  return function (x0, x1, y) {
    this$0.z5v_1.d5w(x0, x1, y);
    return Unit_instance;
  };
}
function CompositeOperation$Companion$UNIMPLEMENTED$lambda(dst, dstN, src, srcN, count) {
  mix_0(dst.p4o_1, dstN, src.p4o_1, srcN, count);
  return Unit_instance;
}
var Companion_instance_39;
function Companion_getInstance_49() {
  if (Companion_instance_39 === VOID)
    new Companion_33();
  return Companion_instance_39;
}
var CompositeMode_CLEAR_instance;
var CompositeMode_COPY_instance;
var CompositeMode_SOURCE_OVER_instance;
var CompositeMode_DESTINATION_OVER_instance;
var CompositeMode_SOURCE_IN_instance;
var CompositeMode_DESTINATION_IN_instance;
var CompositeMode_SOURCE_OUT_instance;
var CompositeMode_DESTINATION_OUT_instance;
var CompositeMode_SOURCE_ATOP_instance;
var CompositeMode_DESTINATION_ATOP_instance;
var CompositeMode_XOR_instance;
var CompositeMode_LIGHTER_instance;
var Companion_instance_40;
function Companion_getInstance_50() {
  return Companion_instance_40;
}
function CompositeMode$lambda(dst, dstN, src, srcN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var d = RgbaPremultipliedArray__get_impl_1u69ta(dst.p4o_1, dstN + n | 0);
      var s = RgbaPremultipliedArray__get_impl_1u69ta(src.p4o_1, srcN + n | 0);
      var tmp = dstN + n | 0;
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(d);
      RgbaPremultipliedArray__set_impl_7fwbby(dst.p4o_1, tmp, _RGBA___get_premultiplied__impl__3bulqc(RGBA__withA_impl_vogscm(tmp$ret$0, clampUByte(_RGBAPremultiplied___get_a__impl__f0hnd1(d) - _RGBAPremultiplied___get_a__impl__f0hnd1(s) | 0))));
    }
     while (inductionVariable < count);
  return Unit_instance;
}
function CompositeMode$lambda_0(dst, dstN, src, srcN, count) {
  mix_1(dst.p4o_1, dstN, dst.p4o_1, dstN, src.p4o_1, srcN, count);
  return Unit_instance;
}
function CompositeMode$lambda_1(dst, dstN, src, srcN, count) {
  mix_1(dst.p4o_1, dstN, src.p4o_1, srcN, dst.p4o_1, dstN, count);
  return Unit_instance;
}
var CompositeMode_entriesInitialized;
function CompositeMode_initEntries() {
  if (CompositeMode_entriesInitialized)
    return Unit_instance;
  CompositeMode_entriesInitialized = true;
  var tmp = Companion_getInstance_49();
  CompositeMode_CLEAR_instance = new CompositeMode('CLEAR', 0, tmp.c5x(CompositeMode$lambda));
  CompositeMode_COPY_instance = new CompositeMode('COPY', 1, Companion_getInstance_49().b5x_1);
  var tmp_0 = Companion_getInstance_49();
  CompositeMode_SOURCE_OVER_instance = new CompositeMode('SOURCE_OVER', 2, tmp_0.c5x(CompositeMode$lambda_0));
  var tmp_1 = Companion_getInstance_49();
  CompositeMode_DESTINATION_OVER_instance = new CompositeMode('DESTINATION_OVER', 3, tmp_1.c5x(CompositeMode$lambda_1));
  CompositeMode_SOURCE_IN_instance = new CompositeMode('SOURCE_IN', 4, Companion_getInstance_49().b5x_1);
  CompositeMode_DESTINATION_IN_instance = new CompositeMode('DESTINATION_IN', 5, Companion_getInstance_49().b5x_1);
  CompositeMode_SOURCE_OUT_instance = new CompositeMode('SOURCE_OUT', 6, Companion_getInstance_49().b5x_1);
  CompositeMode_DESTINATION_OUT_instance = new CompositeMode('DESTINATION_OUT', 7, Companion_getInstance_49().b5x_1);
  CompositeMode_SOURCE_ATOP_instance = new CompositeMode('SOURCE_ATOP', 8, Companion_getInstance_49().b5x_1);
  CompositeMode_DESTINATION_ATOP_instance = new CompositeMode('DESTINATION_ATOP', 9, Companion_getInstance_49().b5x_1);
  CompositeMode_XOR_instance = new CompositeMode('XOR', 10, Companion_getInstance_49().b5x_1);
  CompositeMode_LIGHTER_instance = new CompositeMode('LIGHTER', 11, Companion_getInstance_49().b5x_1);
}
function get_DEFAULT(_this__u8e3s4) {
  return Companion_instance_40.h3p();
}
function CompositeMode_SOURCE_OVER_getInstance() {
  CompositeMode_initEntries();
  return CompositeMode_SOURCE_OVER_instance;
}
function Context2d$State$transformTransform$delegate$lambda(this$0) {
  return function () {
    return this$0.n4q_1.k2a();
  };
}
function trans($this, p) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    var this_0 = $this.m45_1.n4q_1;
    if (this_0.t25()) {
      tmp$ret$0 = p;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.n27(this_0.p29(p.e25_1, p.f25_1), this_0.s29(p.e25_1, p.f25_1));
  }
  return tmp$ret$0;
}
function write_0(_this__u8e3s4, path) {
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = path.x3d_1;
  var n_0 = 0;
  while (n_0 < this_0.e1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.qx(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = path.y3d_1.d1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.n27(tmp, path.y3d_1.d1(_unary__edvuaz_1));
        _this__u8e3s4.u3d(it);
        break;
      case 1:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = path.y3d_1.d1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.n27(tmp_0, path.y3d_1.d1(_unary__edvuaz_3));
        _this__u8e3s4.h3e(it_0);
        break;
      case 2:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = path.y3d_1.d1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var c = Vector2D.n27(tmp_1, path.y3d_1.d1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = path.y3d_1.d1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var a = Vector2D.n27(tmp_2, path.y3d_1.d1(_unary__edvuaz_7));
        _this__u8e3s4.i3e(c, a);
        break;
      case 3:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = path.y3d_1.d1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var c1 = Vector2D.n27(tmp_3, path.y3d_1.d1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = path.y3d_1.d1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var c2 = Vector2D.n27(tmp_4, path.y3d_1.d1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = path.y3d_1.d1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var a_0 = Vector2D.n27(tmp_5, path.y3d_1.d1(_unary__edvuaz_13));
        _this__u8e3s4.v3d(c1, c2, a_0);
        break;
      case 4:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        _this__u8e3s4.c6();
        break;
    }
  }
}
function toBitmapPaint(_this__u8e3s4, state) {
  var filler = toFiller(_this__u8e3s4, state);
  var bb = Companion_getInstance_7().e26();
  bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, state.p4q_1.l3a());
  var tmp = bb;
  var tmp333_safe_receiver = state.o4q_1;
  bb = BoundsBuilder__plus_impl_cz7f7x_0(tmp, tmp333_safe_receiver == null ? null : tmp333_safe_receiver.l3a());
  var bounds = _BoundsBuilder___get_bounds__impl__s1l1gx(bb).x2e(state.n4q_1);
  // Inline function 'kotlin.also' call
  var this_0 = Bitmap32.e3x(toIntCeil_0(bounds.q25_1), toIntCeil_0(bounds.r25_1), VOID, true);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.toBitmapPaint.<anonymous>' call
  filler.u5o(this_0);
  var bmp = this_0;
  return new BitmapPaint(bmp, Companion_getInstance_5().a29().d2a(-bounds.v25(), -bounds.x25()));
}
function transformTransform$factory() {
  return getPropertyCallableRef('transformTransform', 1, KProperty1, function (receiver) {
    return receiver.g5x();
  }, null);
}
var CycleMethod_NO_CYCLE_instance;
var CycleMethod_NO_CYCLE_CLAMP_instance;
var CycleMethod_REPEAT_instance;
var CycleMethod_REFLECT_instance;
var Companion_instance_41;
function Companion_getInstance_51() {
  CycleMethod_initEntries();
  if (Companion_instance_41 === VOID)
    new Companion_35();
  return Companion_instance_41;
}
function values_6() {
  return [CycleMethod_NO_CYCLE_getInstance(), CycleMethod_NO_CYCLE_CLAMP_getInstance(), CycleMethod_REPEAT_getInstance(), CycleMethod_REFLECT_getInstance()];
}
var CycleMethod_entriesInitialized;
function CycleMethod_initEntries() {
  if (CycleMethod_entriesInitialized)
    return Unit_instance;
  CycleMethod_entriesInitialized = true;
  CycleMethod_NO_CYCLE_instance = new CycleMethod('NO_CYCLE', 0);
  CycleMethod_NO_CYCLE_CLAMP_instance = new CycleMethod('NO_CYCLE_CLAMP', 1);
  CycleMethod_REPEAT_instance = new CycleMethod('REPEAT', 2);
  CycleMethod_REFLECT_instance = new CycleMethod('REFLECT', 3);
  Companion_getInstance_51();
}
function _CycleMethodPair___init__impl__y6jlco(data) {
  return data;
}
function _CycleMethodPair___get_data__impl__r5ik0n($this) {
  return $this;
}
function _CycleMethodPair___init__impl__y6jlco_0(x, y) {
  return _CycleMethodPair___init__impl__y6jlco(insert8(insert8(0, x.n3_1, 0), y.n3_1, 8));
}
function _CycleMethodPair___get_x__impl__dgz5uj($this) {
  var tmp = Companion_getInstance_51().i5y_1;
  // Inline function 'korlibs.memory.extract8' call
  return tmp[(_CycleMethodPair___get_data__impl__r5ik0n($this) >>> 0 | 0) & 255];
}
function _CycleMethodPair___get_y__impl__fcnb7o($this) {
  var tmp = Companion_getInstance_51().i5y_1;
  // Inline function 'korlibs.memory.extract8' call
  return tmp[(_CycleMethodPair___get_data__impl__r5ik0n($this) >>> 8 | 0) & 255];
}
function CycleMethodPair__apply_impl_g3sekg($this, ratio) {
  return Vector2D.n27(_CycleMethodPair___get_x__impl__dgz5uj($this).j5y(ratio.e25_1), _CycleMethodPair___get_y__impl__fcnb7o($this).j5y(ratio.f25_1));
}
function CycleMethod_NO_CYCLE_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_NO_CYCLE_instance;
}
function CycleMethod_NO_CYCLE_CLAMP_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_NO_CYCLE_CLAMP_instance;
}
function CycleMethod_REPEAT_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_REPEAT_instance;
}
function CycleMethod_REFLECT_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_REFLECT_instance;
}
function draw_0(_this__u8e3s4, c) {
  c.l5h(_this__u8e3s4);
}
function draw_1(_this__u8e3s4, path) {
  _this__u8e3s4.l5h(path);
}
function msdfBmp(_this__u8e3s4, width, height) {
  var msdf_0 = msdf(_this__u8e3s4, width, height);
  // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent' call
  // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
  var width_0 = msdf_0.l3x_1 - 0 | 0;
  var inductionVariable = 0;
  var last = 0 + (msdf_0.m3x_1 - 0 | 0) | 0;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var n = msdf_0.g3y(0, 0 + y | 0);
      var inductionVariable_0 = 0;
      var last_0 = 0 + width_0 | 0;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent.<anonymous>' call
          n = n + 1 | 0;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value = msdf_0.h4a(x, y);
          var tmp = 0 === 3 ? -100.0 : value;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_0 = msdf_0.i4a(x, y);
          var tmp_0 = 1 === 3 ? -100.0 : value_0;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_1 = msdf_0.j4a(x, y);
          var tmp_1 = 2 === 3 ? -100.0 : value_1;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_2 = msdf_0.k4a(x, y);
          var tmp$ret$3 = 3 === 3 ? -100.0 : value_2;
          msdf_0.l4a(x, y, tmp, tmp_0, tmp_1, tmp$ret$3);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  msdf_0.s4a(-1.0);
  msdf_0.u4a(-1.0, +1.0);
  msdf_0.r4a();
  var msdfBitmap = msdf_0.x3x();
  return msdfBitmap;
}
function sdfBmp(_this__u8e3s4, width, height) {
  var tmp = NewSDF_instance;
  var newImage = tmp.k4d(NativeImageContext2d(width, height, VOID, sdfBmp$lambda(_this__u8e3s4)).x3x(), VOID, 0);
  return newImage.d4d_1.i45();
}
function msdf(_this__u8e3s4, width, height) {
  return msdf_0(_this__u8e3s4, FloatBitmap32.f4a(width, height));
}
function msdf_0(_this__u8e3s4, data) {
  var path = _this__u8e3s4;
  var curvesList = toCurvesList(path);
  var p = Vector2D.y27();
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(curvesList, 10));
  var tmp0_iterator = curvesList.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.image.vector.msdf.<anonymous>' call
    var tmp$ret$0 = colorize(item.o39_1, item.p39_1);
    destination.h(tmp$ret$0);
  }
  var colorizedCurves = destination;
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_0 = ArrayList.h1();
  var tmp0_iterator_0 = colorizedCurves.a1();
  while (tmp0_iterator_0.b1()) {
    var element = tmp0_iterator_0.c1();
    // Inline function 'korlibs.image.vector.msdf.<anonymous>' call
    var list = element.k5y_1;
    addAll(destination_0, list);
  }
  var allColorizedCurves = new ColorizedBeziers(destination_0);
  var inductionVariable = 0;
  var last = data.m3x_1;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = data.l3x_1;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          p = Vector2D.n27(x + 0.5, y + 0.5);
          var inside = path.t3p(p);
          var allDist = allColorizedCurves.s5y().w5y(p);
          var redDist = allColorizedCurves.x5y().w5y(p);
          var greenDist = allColorizedCurves.y5y().w5y(p);
          var blueDist = allColorizedCurves.z5y().w5y(p);
          var minR = redDist;
          var minG = greenDist;
          var minB = blueDist;
          var minA = allDist;
          if (inside) {
            minR = -minR;
            minG = -minG;
            minB = -minB;
            minA = -minA;
          }
          data.l4a(x, y, minR, minG, minB, minA);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  return data;
}
function ColorizedBeziers$red$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.k5y_1;
    var destination = ArrayList.h1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.red$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_r__impl__duz7mo(element.b5z_1) === 0)) {
        destination.h(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$green$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.k5y_1;
    var destination = ArrayList.h1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.green$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_g__impl__o8pukr(element.b5z_1) === 0)) {
        destination.h(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$blue$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.k5y_1;
    var destination = ArrayList.h1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.blue$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_b__impl__m6tl80(element.b5z_1) === 0)) {
        destination.h(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$allProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.k5y_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.allProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.a5z_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$redProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.c5z();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.redProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.a5z_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$greenProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.d5z();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.greenProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.a5z_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$blueProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.e5z();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.blueProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.a5z_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function colorize(_this__u8e3s4, closed) {
  closed = closed === VOID ? true : closed;
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(_this__u8e3s4, 10));
  var index = 0;
  var tmp0_iterator = _this__u8e3s4.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.image.vector.colorize.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var index_0 = checkIndexOverflow(tmp1);
    var color = msdfColor(index_0, _this__u8e3s4.e1(), closed);
    var tmp$ret$0 = new ColoredBezier(item, color);
    destination.h(tmp$ret$0);
  }
  return new ColorizedBeziers(destination);
}
function msdfColor(index, size, closed) {
  if (size === 1)
    return Colors_getInstance().s3y_1;
  if (index === 0)
    return Colors_getInstance().u40_1;
  return ((index - 1 | 0) % 2 | 0) === 0 ? Colors_getInstance().i44_1 : Colors_getInstance().s3z_1;
}
function sdfBmp$lambda($this_sdfBmp) {
  return function ($this$NativeImageContext2d) {
    var paint = new RGBA(Colors_getInstance().s3y_1);
    if (true) {
      $this$NativeImageContext2d.f4x();
    }
    // Inline function 'korlibs.image.vector.sdfBmp.<anonymous>.<anonymous>' call
    write($this$NativeImageContext2d, $this_sdfBmp);
    $this$NativeImageContext2d.e5y(paint, null);
    return Unit_instance;
  };
}
function red$factory() {
  return getPropertyCallableRef('red', 1, KProperty1, function (receiver) {
    return receiver.c5z();
  }, null);
}
function green$factory() {
  return getPropertyCallableRef('green', 1, KProperty1, function (receiver) {
    return receiver.d5z();
  }, null);
}
function blue$factory() {
  return getPropertyCallableRef('blue', 1, KProperty1, function (receiver) {
    return receiver.e5z();
  }, null);
}
function allProjected$factory() {
  return getPropertyCallableRef('allProjected', 1, KProperty1, function (receiver) {
    return receiver.s5y();
  }, null);
}
function redProjected$factory() {
  return getPropertyCallableRef('redProjected', 1, KProperty1, function (receiver) {
    return receiver.x5y();
  }, null);
}
function greenProjected$factory() {
  return getPropertyCallableRef('greenProjected', 1, KProperty1, function (receiver) {
    return receiver.y5y();
  }, null);
}
function blueProjected$factory() {
  return getPropertyCallableRef('blueProjected', 1, KProperty1, function (receiver) {
    return receiver.z5y();
  }, null);
}
function toContext2dCommands(_this__u8e3s4, prefix, suffix, decimalPlaces) {
  prefix = prefix === VOID ? 'ctx.' : prefix;
  suffix = suffix === VOID ? ';' : suffix;
  decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList.h1();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>' call
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_1 = _this__u8e3s4.x3d_1;
  var n_0 = 0;
  while (n_0 < this_1.e1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_1.qx(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var destruct = Vector2D.n27(tmp, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_1));
        var x = destruct.fl();
        var y = destruct.gl();
        this_0.h('moveTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(x, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(y, decimalPlaces) + ')');
        break;
      case 1:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var destruct_0 = Vector2D.n27(tmp_0, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_3));
        var x_0 = destruct_0.fl();
        var y_0 = destruct_0.gl();
        this_0.h('lineTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(x_0, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(y_0, decimalPlaces) + ')');
        break;
      case 2:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var destruct_1 = Vector2D.n27(tmp_1, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var destruct_2 = Vector2D.n27(tmp_2, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_7));
        var cx = destruct_1.fl();
        var cy = destruct_1.gl();
        var ax = destruct_2.fl();
        var ay = destruct_2.gl();
        this_0.h('quadTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ax, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ay, decimalPlaces) + ')');
        break;
      case 3:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var destruct_3 = Vector2D.n27(tmp_3, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var destruct_4 = Vector2D.n27(tmp_4, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var destruct_5 = Vector2D.n27(tmp_5, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_13));
        var cx1 = destruct_3.fl();
        var cy1 = destruct_3.gl();
        var cx2 = destruct_4.fl();
        var cy2 = destruct_4.gl();
        var ax_0 = destruct_5.fl();
        var ay_0 = destruct_5.gl();
        this_0.h('cubicTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx1, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy1, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx2, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy2, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ax_0, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ay_0, decimalPlaces) + ')');
        break;
      case 4:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        this_0.h('close()');
        break;
    }
  }
  var this_2 = this_0.u7();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_2, 10));
  var tmp0_iterator = this_2.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>' call
    var tmp$ret$3 = prefix + item + suffix;
    destination.h(tmp$ret$3);
  }
  return destination;
}
function FillShape$pathCurvesList$delegate$lambda(this$0) {
  return function () {
    return toCurvesList(this$0.h5z_1);
  };
}
function FillShape$clipCurvesList$delegate$lambda(this$0) {
  return function () {
    var tmp351_safe_receiver = this$0.i5z_1;
    return tmp351_safe_receiver == null ? null : toCurvesList(tmp351_safe_receiver);
  };
}
function toSvgPathString(_this__u8e3s4, separator, decimalPlaces) {
  separator = separator === VOID ? ' ' : separator;
  decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
  return SvgPath_instance.u5z(_this__u8e3s4, separator, decimalPlaces);
}
function PolylineShape$fillShape$delegate$lambda(this$0) {
  return function () {
    return new FillShape(strokeToFill_0(this$0.v5z_1, this$0.z5z_1), this$0.w5z_1, this$0.x5z_1, this$0.y5z_1, this$0.a60_1);
  };
}
var EmptyShape_instance;
function EmptyShape_getInstance() {
  return EmptyShape_instance;
}
function toContext2dCommands$_anonymous_$round$0_5f3kr1(_this__u8e3s4, $decimalPlaces) {
  return niceStr(_this__u8e3s4, $decimalPlaces);
}
function pathCurvesList$factory() {
  return getPropertyCallableRef('pathCurvesList', 1, KProperty1, function (receiver) {
    return receiver.p5z();
  }, null);
}
function clipCurvesList$factory() {
  return getPropertyCallableRef('clipCurvesList', 1, KProperty1, function (receiver) {
    return receiver.q5z();
  }, null);
}
function thickness$factory($b0) {
  return getPropertyCallableRef('thickness', 0, KProperty0, function () {
    return $b0.d38_1;
  }, null);
}
function scaleMode$factory($b0) {
  return getPropertyCallableRef('scaleMode', 0, KProperty0, function () {
    return $b0.f38_1;
  }, null);
}
function startCap$factory($b0) {
  return getPropertyCallableRef('startCap', 0, KProperty0, function () {
    return $b0.g38_1;
  }, null);
}
function endCap$factory($b0) {
  return getPropertyCallableRef('endCap', 0, KProperty0, function () {
    return $b0.h38_1;
  }, null);
}
function join$factory($b0) {
  return getPropertyCallableRef('join', 0, KProperty0, function () {
    return $b0.i38_1;
  }, null);
}
function miterLimit$factory($b0) {
  return getPropertyCallableRef('miterLimit', 0, KProperty0, function () {
    return $b0.j38_1;
  }, null);
}
function dash$factory($b0) {
  return getPropertyCallableRef('dash', 0, KProperty0, function () {
    return $b0.k38_1;
  }, null);
}
function dashOffset$factory($b0) {
  return getPropertyCallableRef('dashOffset', 0, KProperty0, function () {
    return $b0.l38_1;
  }, null);
}
function primitiveShapes$factory() {
  return getPropertyCallableRef('primitiveShapes', 1, KProperty1, function (receiver) {
    return receiver.m60();
  }, null);
}
function toSvgPathString$fixX(_this__u8e3s4, $decimalPlaces) {
  return toStringDecimal(_this__u8e3s4, $decimalPlaces, true);
}
function toSvgPathString$fixY(_this__u8e3s4, $decimalPlaces) {
  return toStringDecimal(_this__u8e3s4, $decimalPlaces, true);
}
var SvgPath_instance;
function SvgPath_getInstance() {
  return SvgPath_instance;
}
function Rasterizer$rasterizeFill$lambda($xmax, $xmin, this$0, $callback) {
  return function (a, b, y) {
    var tmp;
    if (a <= $xmax && b >= $xmin) {
      var a0 = coerceIn(a, $xmin, $xmax);
      var b0 = coerceIn(b, $xmin, $xmax);
      if (this$0.g5w_1) {
        println('RASTER(' + a0 + ', ' + b0 + ', ' + y + ')');
      }
      tmp = $callback(a0, b0, y);
    } else {
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function Renderer$drawImage$lambda($pos, $size) {
  return function ($this$transformed) {
    $this$transformed.z3o($pos, $size);
    return Unit_instance;
  };
}
var Companion_instance_42;
function Companion_getInstance_52() {
  if (Companion_instance_42 === VOID)
    new Companion_36();
  return Companion_instance_42;
}
var HtmlCanvas_instance;
function HtmlCanvas_getInstance() {
  return HtmlCanvas_instance;
}
function toLike(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4;
}
function toHtmlNative(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof HtmlNativeImage) {
    tmp = _this__u8e3s4;
  } else {
    tmp = HtmlNativeImage.q61(HtmlImage_instance.w60(_this__u8e3s4.x3x()));
  }
  return tmp;
}
var HtmlImage_instance;
function HtmlImage_getInstance() {
  return HtmlImage_instance;
}
function get_nativeImageFormatProvider() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return nativeImageFormatProvider;
}
var nativeImageFormatProvider;
function get_isLittleEndian() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return isLittleEndian;
}
var isLittleEndian;
var NonBrowserNativeImageFormatProvider_instance;
function NonBrowserNativeImageFormatProvider_getInstance() {
  if (NonBrowserNativeImageFormatProvider_instance === VOID)
    new NonBrowserNativeImageFormatProvider();
  return NonBrowserNativeImageFormatProvider_instance;
}
function *_generator_decodeInternal__jnwsgt_2($this, data, props, $completion) {
  var tmp = BrowserImage_instance.u61(data, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return new NativeImageResult(HtmlNativeImage.q61(tmp));
}
function *_generator_decodeInternal__jnwsgt_3($this, vfs, path, props, $completion) {
  var tmp;
  if (vfs instanceof LocalVfs) {
    var tmp_0 = BrowserImage_instance.v61(path, props, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = HtmlNativeImage.w61(tmp_0);
  } else {
    if (vfs instanceof UrlVfs) {
      var jsUrl = vfs.e24(path);
      var tmp_1 = BrowserImage_instance.v61(jsUrl, props, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp = HtmlNativeImage.w61(tmp_1);
    } else {
      var tmp_2 = BrowserImage_instance;
      var tmp_3 = vfs.bi(path).r23($completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      var tmp_4 = tmp_2.u61(tmp_3, props, $completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      tmp = HtmlNativeImage.q61(tmp_4);
    }
  }
  return new NativeImageResult(tmp);
}
var HtmlNativeImageFormatProvider_instance;
function HtmlNativeImageFormatProvider_getInstance() {
  if (HtmlNativeImageFormatProvider_instance === VOID)
    new HtmlNativeImageFormatProvider();
  return HtmlNativeImageFormatProvider_instance;
}
function HtmlNativeImage$lazyCanvasElement$delegate$lambda(this$0, $width, $height) {
  return function () {
    // Inline function 'kotlin.also' call
    var tmp;
    // Inline function 'kotlin.js.asDynamic' call
    if (this$0.m61_1.src !== undefined) {
      var tmp_0 = BrowserImage_instance;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = this$0.m61_1;
      tmp = tmp_0.x61(tmp$ret$2, $width, $height);
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this$0.m61_1;
    }
    var this_0 = tmp;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.HtmlNativeImage.lazyCanvasElement$delegate.<anonymous>.<anonymous>' call
    this$0.m61_1 = this_0;
    return this_0;
  };
}
function HtmlNativeImage$ctx$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this$0.y61().getContext('2d');
  };
}
function *_generator_decodeToCanvas__71sobd($this, bytes, props, $completion) {
  if (Companion_getInstance_10().iu()) {
    // Inline function 'kotlin.error' call
    var message = 'Canvas not available on NodeJS';
    throw IllegalStateException.w4(toString_0(message));
  }
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = [bytes];
  // Inline function 'org.w3c.files.BlobPropertyBag' call
  var type = 'image/png';
  var o = {};
  o['type'] = type;
  var blob = new Blob(tmp, o);
  var blobURL = URL.createObjectURL(blob);
  try {
    var tmp_0 = $this.p3v(blobURL, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    return tmp_0;
  }finally {
    URL.revokeObjectURL(blobURL);
  }
}
function *_generator_loadCanvas__xw76hi($this, jsUrl, $completion) {
  var tmp = $this.d62(jsUrl, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.e62(tmp);
}
function BrowserImage$loadImage$lambda($c, $img) {
  return function (it) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $c;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.Companion.success' call
    var value = $img;
    var tmp$ret$2 = _Result___init__impl__xyqfz8(value);
    this_0.oc(tmp$ret$2);
    return Unit_instance;
  };
}
function BrowserImage$loadImage$lambda_0($c, $jsUrl) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1, _unused_var__etf5q3_2, _unused_var__etf5q3_3) {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    var this_0 = $c;
    // Inline function 'kotlin.Companion.failure' call
    var exception = RuntimeException.ja('error loading image ' + $jsUrl);
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
    this_0.oc(tmp$ret$0);
    return Unit_instance;
  };
}
var BrowserImage_instance;
function BrowserImage_getInstance() {
  return BrowserImage_instance;
}
function get_isBigEndian() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return !get_isLittleEndian();
}
function bswap32(v, offset, size) {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  var inductionVariable = offset;
  var last = offset + size | 0;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      v[n] = bswap32_0(v[n]);
    }
     while (inductionVariable < last);
}
function setFont($this, font, fontSize) {
  var tmp;
  if ((font == null ? null : font.o3()) == $this.k62_1) {
    tmp = fontSize === $this.j62_1;
  } else {
    tmp = false;
  }
  if (tmp)
    return Unit_instance;
  var tmp_0 = $this;
  tmp_0.k62_1 = font == null ? null : font.o3();
  $this.j62_1 = fontSize;
  var tmp0_elvis_lhs = font == null ? null : font.o3();
  $this.i62_1.font = '' + fontSize + "px '" + (tmp0_elvis_lhs == null ? 'default' : tmp0_elvis_lhs) + "'";
}
function setState($this, state, fill, doSetFont) {
  $this.i62_1.globalAlpha = state.d4r_1;
  $this.i62_1.globalCompositeOperation = $this.l62(state.e4r_1);
  if (doSetFont) {
    setFont($this, state.z4q_1, state.a4r_1);
  }
  if (fill) {
    $this.i62_1.fillStyle = $this.m62(state.x4q_1);
  } else {
    $this.i62_1.lineWidth = state.r4q_1;
    var tmp;
    switch (state.u4q_1.n3_1) {
      case 0:
        // Inline function 'org.w3c.dom.BEVEL' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'bevel';
        break;
      case 2:
        // Inline function 'org.w3c.dom.MITER' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'miter';
        break;
      case 1:
        // Inline function 'org.w3c.dom.ROUND' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'round';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $this.i62_1.lineJoin = tmp;
    var tmp_0;
    switch (state.t4y().n3_1) {
      case 0:
        // Inline function 'org.w3c.dom.BUTT' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'butt';
        break;
      case 2:
        // Inline function 'org.w3c.dom.ROUND' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'round';
        break;
      case 1:
        // Inline function 'org.w3c.dom.SQUARE' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'square';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $this.i62_1.lineCap = tmp_0;
    $this.i62_1.strokeStyle = $this.m62(state.w4q_1);
  }
}
function transformPaint($this, paint) {
  if (isInterface(paint, TransformedPaint)) {
    $this.n62($this.i62_1, paint.r50());
  }
}
function bswap32_0(v) {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return (v >>> 24 | 0 | v << 24 | (v & 65280) << 8 | (v >>> 8 | 0)) & 65280;
}
function lazyCanvasElement$factory() {
  return getPropertyCallableRef('lazyCanvasElement', 1, KProperty1, function (receiver) {
    return receiver.y61();
  }, null);
}
function ctx$factory() {
  return getPropertyCallableRef('ctx', 1, KProperty1, function (receiver) {
    return receiver.a62();
  }, null);
}
var properties_initialized_NativeImageFormatProviderJs_kt_7b9n17;
function _init_properties_NativeImageFormatProviderJs_kt__3qg4wz() {
  if (!properties_initialized_NativeImageFormatProviderJs_kt_7b9n17) {
    properties_initialized_NativeImageFormatProviderJs_kt_7b9n17 = true;
    nativeImageFormatProvider = Companion_getInstance_10().ju() ? NonBrowserNativeImageFormatProvider_getInstance() : Companion_getInstance_10().iu() ? NonBrowserNativeImageFormatProvider_getInstance() : HtmlNativeImageFormatProvider_getInstance();
    // Inline function 'org.khronos.webgl.get' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [1];
    // Inline function 'kotlin.js.asDynamic' call
    isLittleEndian = (new Uint8Array((new Int32Array(tmp$ret$2)).buffer))[0] === 1;
  }
}
//region block: post-declaration
initMetadataForClass(GrowMethod, 'GrowMethod');
initMetadataForClass(Entry, 'Entry');
initMetadataForClass(MutableAtlas, 'MutableAtlas', MutableAtlas.h3x);
initMetadataForClass(Bitmap, 'Bitmap');
initMetadataForCompanion(Companion, VOID, VOID, [2, 3]);
initMetadataForLambda(Bitmap32$iterator$slambda, VOID, VOID, [1]);
initMetadataForClass(Bitmap32, 'Bitmap32', VOID, VOID, [Bitmap, Iterable]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(BitmapIndexed, 'BitmapIndexed');
initMetadataForClass(Bitmap8, 'Bitmap8');
initMetadataForCompanion(Companion_1);
initMetadataForClass(BitmapChannel, 'BitmapChannel');
initMetadataForObject(Bitmaps, 'Bitmaps');
initMetadataForCompanion(Companion_2);
initMetadataForClass(DistanceBitmap, 'DistanceBitmap');
initMetadataForClass(FloatBitmap32, 'FloatBitmap32');
initMetadataForClass(MultiBitmap, 'MultiBitmap');
initMetadataForClass(NativeImage, 'NativeImage', VOID, VOID, [Bitmap, NativeImageRef]);
initMetadataForInterface(ForcedTexId, 'ForcedTexId');
initMetadataForClass(NullBitmap, 'NullBitmap');
initMetadataForCompanion(Companion_3);
initMetadataForClass(Palette, 'Palette');
initMetadataForClass(Result, 'Result');
initMetadataForObject(NewSDF, 'NewSDF');
initMetadataForClass(ColorFormat32, 'ColorFormat32');
initMetadataForClass(ColorFormat24, 'ColorFormat24');
initMetadataForClass(ColorTransformMul, 'ColorTransformMul', ColorTransformMul);
initMetadataForObject(Colors, 'Colors');
initMetadataForObject(MaterialColors, 'MaterialColors');
initMetadataForClass(RGB, 'RGB');
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(RgbaArray, 'RgbaArray', VOID, VOID, [KtList]);
initMetadataForCompanion(Companion_6);
initMetadataForClass(RGBA, 'RGBA', VOID, VOID, [Comparable]);
initMetadataForCompanion(Companion_7);
initMetadataForCompanion(Companion_8);
initMetadataForClass(RgbaPremultipliedArray, 'RgbaPremultipliedArray');
initMetadataForCompanion(Companion_9);
initMetadataForCompanion(Companion_10);
initMetadataForClass(Kerning, 'Kerning');
initMetadataForClass(Glyph, 'Glyph');
initMetadataForInterface(Font, 'Font', VOID, VOID, VOID, [0]);
initMetadataForInterface(BitmapFont, 'BitmapFont', VOID, VOID, [Font], [0]);
protoOf(BitmapFontImpl).k4p = get_baseBmp;
protoOf(BitmapFontImpl).o4p = getFontMetrics;
protoOf(BitmapFontImpl).z4p = getFontMetrics$default;
protoOf(BitmapFontImpl).a4q = getGlyphMetrics;
protoOf(BitmapFontImpl).h4q = getGlyphMetrics$default;
protoOf(BitmapFontImpl).o4r = getKerning;
protoOf(BitmapFontImpl).j4q = getTextScale;
protoOf(BitmapFontImpl).d1 = get_0;
protoOf(BitmapFontImpl).k4q = get_1;
protoOf(BitmapFontImpl).l4q = getGlyph;
protoOf(BitmapFontImpl).m4q = renderGlyph;
protoOf(BitmapFontImpl).n4r = renderGlyph$default;
initMetadataForClass(BitmapFontImpl, 'BitmapFontImpl', VOID, VOID, [BitmapFont], [0]);
initMetadataForClass(TextToBitmapResult, 'TextToBitmapResult');
initMetadataForClass(PlacedGlyphMetrics, 'PlacedGlyphMetrics');
initMetadataForClass(TextMetricsResult, 'TextMetricsResult', TextMetricsResult);
initMetadataForClass(MultiplePlacedGlyphMetrics, 'MultiplePlacedGlyphMetrics', MultiplePlacedGlyphMetrics);
initMetadataForInterface(ITextRendererActions, 'ITextRendererActions');
protoOf(TextRendererActions).c2q = reset;
protoOf(TextRendererActions).z50 = advance;
protoOf(TextRendererActions).a51 = newLine;
initMetadataForClass(TextRendererActions, 'TextRendererActions', VOID, VOID, [ITextRendererActions]);
initMetadataForClass(drawText$actions$1);
initMetadataForClass(GlyphPath, 'GlyphPath', GlyphPath);
initMetadataForCompanion(Companion_11);
protoOf(LazyBitmapFont).k4p = get_baseBmp;
protoOf(LazyBitmapFont).o4p = getFontMetrics;
protoOf(LazyBitmapFont).z4p = getFontMetrics$default;
protoOf(LazyBitmapFont).a4q = getGlyphMetrics;
protoOf(LazyBitmapFont).h4q = getGlyphMetrics$default;
protoOf(LazyBitmapFont).o4r = getKerning;
protoOf(LazyBitmapFont).j4q = getTextScale;
protoOf(LazyBitmapFont).zy = getOrNull_2;
protoOf(LazyBitmapFont).d1 = get_0;
protoOf(LazyBitmapFont).k4q = get_1;
protoOf(LazyBitmapFont).l4q = getGlyph;
protoOf(LazyBitmapFont).m4q = renderGlyph;
protoOf(LazyBitmapFont).n4r = renderGlyph$default;
initMetadataForClass(LazyBitmapFont, 'LazyBitmapFont', VOID, VOID, [BitmapFont], [0]);
initMetadataForClass(FontMetrics, 'FontMetrics', FontMetrics);
initMetadataForClass(GlyphMetrics, 'GlyphMetrics', GlyphMetrics);
initMetadataForClass(TextMetrics, 'TextMetrics', TextMetrics);
initMetadataForCompanion(Companion_12);
initMetadataForClass(GlyphPath_0, 'GlyphPath');
initMetadataForClass(CFFResult, 'CFFResult');
initMetadataForClass(DataIndex, 'DataIndex', DataIndex.s53, VOID, [Iterable]);
initMetadataForClass(Op, 'Op');
initMetadataForCompanion(Companion_13);
initMetadataForClass(EvalContext, 'EvalContext', EvalContext);
initMetadataForClass(Op_0, 'Op');
initMetadataForObject(CFF, 'CFF');
initMetadataForObject(CharStringType2, 'CharStringType2');
initMetadataForObject(TtfCIDFont, 'TtfCIDFont');
initMetadataForCompanion(Companion_14, VOID, VOID, [1]);
initMetadataForInterface(VectorFont, 'VectorFont', VOID, VOID, [Font], [0]);
protoOf(BaseTtfFont).z4p = getFontMetrics$default;
protoOf(BaseTtfFont).h4q = getGlyphMetrics$default;
protoOf(BaseTtfFont).o57 = getGlyphPath$default;
protoOf(BaseTtfFont).m4q = renderGlyph_0;
protoOf(BaseTtfFont).n4r = renderGlyph$default;
protoOf(BaseTtfFont).zy = getOrNull_2;
initMetadataForClass(BaseTtfFont, 'BaseTtfFont', VOID, VOID, [VectorFont], [0]);
initMetadataForClass(TtfFont, 'TtfFont', VOID, VOID, VOID, [0]);
initMetadataForCompanion(Companion_15);
initMetadataForCompanion(Companion_16);
initMetadataForClass(NamesInfo, 'NamesInfo', NamesInfo);
initMetadataForClass(SubstitutionInfo, 'SubstitutionInfo');
initMetadataForClass(Table, 'Table');
initMetadataForClass(HorMetric, 'HorMetric');
initMetadataForCompanion(Companion_17);
initMetadataForClass(NameId, 'NameId');
initMetadataForClass(ColorBitmapInfo, 'ColorBitmapInfo', ColorBitmapInfo);
initMetadataForClass(SbitLineMetrics, 'SbitLineMetrics', SbitLineMetrics);
initMetadataForClass(BitmapGlyphInfo, 'BitmapGlyphInfo');
initMetadataForClass(ColorLine, 'ColorLine');
initMetadataForClass(ColorStop, 'ColorStop');
initMetadataForClass(Colrv1Paint, 'Colrv1Paint');
initMetadataForClass(COLRv1, 'COLRv1', COLRv1);
initMetadataForClass(Contour, 'Contour', Contour);
initMetadataForClass(GlyphReference, 'GlyphReference');
initMetadataForClass(ColrLayerInfo, 'ColrLayerInfo');
initMetadataForInterface(ColrGlyphInfo, 'ColrGlyphInfo');
protoOf(ColrGlyphInfoV1).u5e = getColorShape$default;
initMetadataForClass(ColrGlyphInfoV1, 'ColrGlyphInfoV1', VOID, VOID, [ColrGlyphInfo]);
protoOf(ColrGlyphInfoV0).u5e = getColorShape$default;
initMetadataForClass(ColrGlyphInfoV0, 'ColrGlyphInfoV0', VOID, VOID, [ColrGlyphInfo]);
protoOf(GlyphGraphicsPath).c3p = arc$default;
initMetadataForClass(GlyphGraphicsPath, 'GlyphGraphicsPath', VOID, VOID, [VectorBuilder]);
initMetadataForClass(Glyph_0, 'Glyph');
initMetadataForClass(CompositeGlyph, 'CompositeGlyph');
initMetadataForClass(CFFGlyph, 'CFFGlyph');
initMetadataForClass(SimpleGlyph, 'SimpleGlyph');
initMetadataForClass(BaseTtfFont$readCblc$Subtable, 'Subtable');
initMetadataForClass(BaseTtfFont$readSbix$StrikeInfo, 'StrikeInfo');
initMetadataForClass(BaseTtfFont$readCoverage$RangeInfo, 'RangeInfo');
initMetadataForClass(BaseTtfFont$readCmap$EncodingRecord, 'EncodingRecord');
initMetadataForCompanion(Companion_18);
initMetadataForCompanion(Companion_19);
initMetadataForClass(DataFormat, 'DataFormat');
initMetadataForObject(EXIF, 'EXIF', VOID, VOID, VOID, [3]);
initMetadataForClass(Direction, 'Direction');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(ImageAnimation, 'ImageAnimation');
initMetadataForCompanion(Companion_20);
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(ImageData, 'ImageData');
initMetadataForCompanion(Companion_21);
initMetadataForClass(ImageDataContainer, 'ImageDataContainer');
initMetadataForCompanion(Companion_22);
initMetadataForClass(ImageDecodingProps, 'ImageDecodingProps', ImageDecodingProps);
initMetadataForClass(ImageFormat, 'ImageFormat', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(ImageDecoderNotFoundException, 'ImageDecoderNotFoundException');
initMetadataForClass(ImageFormats, 'ImageFormats', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(ImageFormatsMutable, 'ImageFormatsMutable', ImageFormatsMutable.m5l, VOID, VOID, [2, 1]);
initMetadataForCompanion(Companion_23);
initMetadataForClass(ImageFrame, 'ImageFrame');
initMetadataForClass(ImageFrameLayer, 'ImageFrameLayer');
initMetadataForClass(ImageInfo, 'ImageInfo', ImageInfo);
initMetadataForCompanion(Companion_24);
initMetadataForClass(Type, 'Type');
initMetadataForClass(ImageLayer, 'ImageLayer');
initMetadataForClass(NativeImageFormatProvider, 'NativeImageFormatProvider', NativeImageFormatProvider, VOID, VOID, [1, 2, 3]);
initMetadataForClass(BaseNativeImageFormatProvider, 'BaseNativeImageFormatProvider', BaseNativeImageFormatProvider, VOID, VOID, [1, 2, 3]);
initMetadataForClass(NativeImageResult, 'NativeImageResult');
initMetadataForClass(BitmapNativeImage, 'BitmapNativeImage');
initMetadataForCompanion(Companion_25);
initMetadataForClass(InterlacedPass, 'InterlacedPass');
initMetadataForClass(Colorspace, 'Colorspace');
initMetadataForClass(Header, 'Header');
initMetadataForClass(DecodingContext, 'DecodingContext');
initMetadataForLambda(PNG$readCommon$readChunk$slambda, VOID, VOID, [0]);
initMetadataForObject(PNG, 'PNG', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(BaseFiller, 'BaseFiller');
initMetadataForClass(ColorFiller, 'ColorFiller', ColorFiller);
initMetadataForCompanion(Companion_26);
initMetadataForClass(GradientFiller, 'GradientFiller', GradientFiller);
initMetadataForClass(BitmapFiller, 'BitmapFiller', BitmapFiller);
initMetadataForObject(NoneFiller, 'NoneFiller');
initMetadataForCompanion(Companion_27);
initMetadataForInterface(TransformedPaint, 'TransformedPaint');
initMetadataForClass(GradientPaint, 'GradientPaint', VOID, VOID, [TransformedPaint]);
initMetadataForClass(GradientKind, 'GradientKind');
initMetadataForClass(GradientInterpolationMethod, 'GradientInterpolationMethod');
initMetadataForClass(GradientUnits, 'GradientUnits');
initMetadataForObject(NonePaint, 'NonePaint');
initMetadataForClass(BitmapPaint, 'BitmapPaint', VOID, VOID, [TransformedPaint]);
initMetadataForCompanion(Companion_28);
initMetadataForClass(Line, 'Line');
initMetadataForInterface(Node, 'Node');
initMetadataForClass(Style, 'Style');
initMetadataForClass(TextNode, 'TextNode', VOID, VOID, [Node]);
initMetadataForCompanion(Companion_29);
initMetadataForClass(RichTextData, 'RichTextData', VOID, VOID, [KtList]);
initMetadataForClass(Placement, 'Placement');
initMetadataForClass(RichTextDataPlacements, 'RichTextDataPlacements', RichTextDataPlacements, VOID, [KtList]);
initMetadataForCompanion(Companion_30);
initMetadataForClass(VerticalAlign, 'VerticalAlign');
initMetadataForCompanion(Companion_31);
initMetadataForClass(HorizontalAlign, 'HorizontalAlign');
initMetadataForCompanion(Companion_32);
initMetadataForClass(TextAlignment, 'TextAlignment');
initMetadataForInterface(TextRenderer, 'TextRenderer');
initMetadataForClass(LineStats, 'LineStats', LineStats);
initMetadataForClass(BoundBuilderTextRendererActions, 'BoundBuilderTextRendererActions', BoundBuilderTextRendererActions);
initMetadataForClass(LineInfo, 'LineInfo', LineInfo);
initMetadataForClass(Entry_0, 'Entry', Entry_0);
initMetadataForClass(Text2TextRendererActions, 'Text2TextRendererActions', Text2TextRendererActions);
initMetadataForClass(CreateWStringTextRenderer$2, VOID, VOID, VOID, [TextRenderer]);
initMetadataForClass(CreateStringTextRenderer$2, VOID, VOID, VOID, [TextRenderer]);
initMetadataForClass(SegmentHandler, 'SegmentHandler', SegmentHandler);
initMetadataForClass(ScanlineWriter, 'ScanlineWriter');
initMetadataForClass(Renderer, 'Renderer');
initMetadataForClass(Bitmap32Context2d, 'Bitmap32Context2d');
initMetadataForClass(CompositeOperation$Companion$invoke$1);
initMetadataForCompanion(Companion_33);
initMetadataForCompanion(Companion_34);
initMetadataForClass(CompositeMode, 'CompositeMode');
initMetadataForClass(BlendMode, 'BlendMode');
initMetadataForClass(State, 'State', State);
protoOf(Context2d).x3o = line;
protoOf(Context2d).g1 = isEmpty;
protoOf(Context2d).y3o = rect;
protoOf(Context2d).z3o = rect_0;
protoOf(Context2d).a3p = rect_1;
protoOf(Context2d).b3p = arc;
protoOf(Context2d).c3p = arc$default;
protoOf(Context2d).d3p = circle;
protoOf(Context2d).e3p = rMoveTo;
protoOf(Context2d).f3p = rLineTo;
protoOf(Context2d).x2e = transformed;
initMetadataForClass(Context2d, 'Context2d', VOID, VOID, [VectorBuilder]);
initMetadataForCompanion(Companion_35);
initMetadataForClass(CycleMethod, 'CycleMethod');
initMetadataForClass(ColorizedBeziers, 'ColorizedBeziers');
initMetadataForClass(ColoredBezier, 'ColoredBezier');
initMetadataForClass(ProjectCurvesLookup, 'ProjectCurvesLookup');
initMetadataForInterface(Shape, 'Shape');
initMetadataForInterface(StyledShape, 'StyledShape', VOID, VOID, [Shape]);
protoOf(FillShape).g5z = getBounds;
protoOf(FillShape).f5z = getPath_0;
protoOf(FillShape).c52 = getPath$default;
protoOf(FillShape).j51 = draw;
protoOf(FillShape).d5f = get_bounds;
initMetadataForClass(FillShape, 'FillShape', VOID, VOID, [StyledShape]);
protoOf(CompoundShape).c52 = getPath$default;
protoOf(CompoundShape).d5f = get_bounds;
initMetadataForClass(CompoundShape, 'CompoundShape', VOID, VOID, [Shape]);
protoOf(PolylineShape).f5z = getPath_0;
protoOf(PolylineShape).c52 = getPath$default;
protoOf(PolylineShape).j51 = draw;
protoOf(PolylineShape).d5f = get_bounds;
initMetadataForClass(PolylineShape, 'PolylineShape', VOID, VOID, [StyledShape]);
initMetadataForClass(TextShape, 'TextShape', VOID, VOID, [StyledShape]);
protoOf(EmptyShape).f5z = getPath;
protoOf(EmptyShape).c52 = getPath$default;
protoOf(EmptyShape).d5f = get_bounds;
initMetadataForObject(EmptyShape, 'EmptyShape', VOID, VOID, [Shape]);
initMetadataForClass(ShapeBuilder, 'ShapeBuilder');
initMetadataForObject(SvgPath, 'SvgPath');
initMetadataForClass(Rasterizer, 'Rasterizer', Rasterizer);
initMetadataForClass(DummyRenderer, 'DummyRenderer');
initMetadataForCompanion(Companion_36);
initMetadataForObject(HtmlCanvas, 'HtmlCanvas');
initMetadataForObject(HtmlImage, 'HtmlImage');
initMetadataForObject(NonBrowserNativeImageFormatProvider, 'NonBrowserNativeImageFormatProvider', VOID, VOID, VOID, [1, 2, 3]);
initMetadataForObject(HtmlNativeImageFormatProvider, 'HtmlNativeImageFormatProvider', VOID, VOID, VOID, [2, 3, 1]);
initMetadataForClass(HtmlNativeImage, 'HtmlNativeImage');
initMetadataForObject(BrowserImage, 'BrowserImage', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(CanvasContext2dRenderer, 'CanvasContext2dRenderer');
//endregion
//region block: init
Companion_instance_6 = new Companion_0();
Bitmaps_instance = new Bitmaps();
Companion_instance_8 = new Companion_2();
NewSDF_instance = new NewSDF();
Companion_instance_11 = new Companion_5();
Companion_instance_13 = new Companion_7();
Companion_instance_14 = new Companion_8();
Companion_instance_15 = new Companion_9();
Companion_instance_16 = new Companion_10();
DefaultTtfFontOrNull = null;
SystemFontRegistryOrNull = null;
CFF_instance = new CFF();
CharStringType2_instance = new CharStringType2();
Companion_instance_21 = new Companion_15();
Companion_instance_23 = new Companion_17();
Companion_instance_24 = new Companion_18();
Companion_instance_26 = new Companion_20();
Companion_instance_27 = new Companion_21();
Companion_instance_29 = new Companion_23();
WEBP_WASM_BASE64_ZLIB = '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';
Companion_instance_32 = new Companion_26();
Companion_instance_33 = new Companion_27();
NonePaint_instance = new NonePaint();
Companion_instance_40 = new Companion_34();
EmptyShape_instance = new EmptyShape();
SvgPath_instance = new SvgPath();
HtmlCanvas_instance = new HtmlCanvas();
HtmlImage_instance = new HtmlImage();
BrowserImage_instance = new BrowserImage();
//endregion
//region block: exports
export {
  readFont as readFont34z4s2654u5hd,
  readTtfFont as readTtfFont159as20nksus9,
  readBitmapSlice as readBitmapSlice2r7knpwifec2u,
  readBitmap_0 as readBitmap1yhww5yoq3a9l,
  readBitmap as readBitmapdk80pcjw6p8f,
  _RGBA___get_ad__impl__pt5rdj as _RGBA___get_ad__impl__pt5rdj2rhup0gteq97n,
  _RGBA___get_af__impl__vu36qv as _RGBA___get_af__impl__vu36qv3fdqajvftucv7,
  _RGBA___get_bf__impl__1xz5yg as _RGBA___get_bf__impl__1xz5yg37iolmxbb8ro0,
  _RGBA___get_gf__impl__5gcu1f as _RGBA___get_gf__impl__5gcu1f1tcfjj6a92jd8,
  RGBA__hashCode_impl_h59qf6 as RGBA__hashCode_impl_h59qf629uhw1oxrapg6,
  _RGBA___get_hexString__impl__kocngm as _RGBA___get_hexString__impl__kocngmis57bfwjkwav,
  _RGBA___get_premultiplied__impl__3bulqc as _RGBA___get_premultiplied__impl__3bulqc3rk78ta2124j5,
  _RGBA___get_premultipliedFast__impl__qiau4g as _RGBA___get_premultipliedFast__impl__qiau4g35hwdu9bo5950,
  _RGBA___get_rf__impl__kvz75k as _RGBA___get_rf__impl__kvz75k2enjmg3zrtnq3,
  _RGBA___get_rgb__impl__tijaqt as _RGBA___get_rgb__impl__tijaqtysv8goadjy9q,
  RGBA__times_impl_wehs9n as RGBA__times_impl_wehs9n2bi9iz06j1oam,
  RGBA__toString_impl_4lw6dp as RGBA__toString_impl_4lw6dp2tumn1mea41fm,
  _RGBA___get_value__impl__hhco8v as _RGBA___get_value__impl__hhco8vehpblbe3f2y8,
  RGBA__withAd_impl_cralao as RGBA__withAd_impl_cralao1ojb8pkalp2nb,
  RGBA__withAf_impl_dpdu32 as RGBA__withAf_impl_dpdu32g4ua5xko755s,
  _RGBAPremultiplied___get_af__impl__euwcjn as _RGBAPremultiplied___get_af__impl__euwcjn2miyh1t3zubgx,
  _RGBAPremultiplied___get_bf__impl__qa3on2 as _RGBAPremultiplied___get_bf__impl__qa3on231tqs9tgl21ni,
  _RGBAPremultiplied___get_gf__impl__ivron7 as _RGBAPremultiplied___get_gf__impl__ivron7124n55fu7nftq,
  _RGBAPremultiplied___get_rf__impl__pt0c4y as _RGBAPremultiplied___get_rf__impl__pt0c4yud4u7tot9j6v,
  _RgbaPremultipliedArray___init__impl__lx83hy as _RgbaPremultipliedArray___init__impl__lx83hy2e5m664sv80uc,
  HorizontalAlign__getOffsetX_impl_urzzxf as HorizontalAlign__getOffsetX_impl_urzzxfa8fekmmr9non,
  _HorizontalAlign___get_ratio__impl__x9wlea as _HorizontalAlign___get_ratio__impl__x9wlea2fkrj6kbsj2fk,
  VerticalAlign__getOffsetY_impl_iso0y6 as VerticalAlign__getOffsetY_impl_iso0y6m9d6k6n5h47j,
  _VerticalAlign___get_ratioFake__impl__1h2fwv as _VerticalAlign___get_ratioFake__impl__1h2fwv1dj21d0zq5uhq,
  Bitmaps_instance as Bitmaps_instance27726euemn90u,
  Colors_getInstance as Colors_getInstance2cnv7p5d6jz4u,
  MaterialColors_getInstance as MaterialColors_getInstance39ky4hjexuaug,
  Companion_getInstance_22 as Companion_getInstance2ou2xyvohty1g,
  Companion_instance_16 as Companion_instance1zw3l6m7tnvps,
  Companion_instance_15 as Companion_instance1sgltfeqg9bxt,
  Companion_getInstance_48 as Companion_getInstancezw1wxvwtmh0g,
  Companion_getInstance_46 as Companion_getInstance2w9pdpq8h2ue0,
  EmptyShape_instance as EmptyShape_instance1905h5dvjxi3r,
  Bitmap32 as Bitmap321klycakvwgb5w,
  Bitmap8 as Bitmap82ekc5d8xpcfp2,
  get_Bitmaps_transparent as get_Bitmaps_transparent3nm2857y3u3hn,
  get_Bitmaps_white as get_Bitmaps_white37u58wbn8ngk2,
  FloatBitmap32 as FloatBitmap321fufbxi3ys0iu,
  ForcedTexId as ForcedTexId3ivekmtdm8t3u,
  MultiBitmap as MultiBitmapk0zsv2zy1mpk,
  NativeImageOrBitmap32 as NativeImageOrBitmap3211fg7set8uiki,
  NativeImage_0 as NativeImage33w1i7ec8zfym,
  NativeImage as NativeImagebqxh3nwkmck,
  NullBitmap as NullBitmap15b22oyta4usb,
  get_baseMipmapLevel as get_baseMipmapLevel1ty2cgb5p9xw4,
  get_bmp as get_bmpevghw2zw2fa7,
  extract_0 as extractrn4rijx1x4kx,
  get_maxMipmapLevel as get_maxMipmapLevel13juf70j6ney9,
  slice as slice2pfxfvku0ybgy,
  ColorTransformMul as ColorTransformMul2rawiv5hyxh9p,
  RGBA as RGBA34obx2i62wcl3,
  Glyph as Glyphdz1l7rusab9h,
  BitmapFontImpl as BitmapFontImpljoxrxbqjo5ee,
  BitmapFont as BitmapFont35unsvaxq1brd,
  get_DefaultTtfFontAsBitmap as get_DefaultTtfFontAsBitmap1hzwi8e4truhb,
  FontMetrics as FontMetrics1b1o1zbrk6cew,
  Font as Font2bg7nte760csr,
  TextMetricsResult as TextMetricsResult1qr6b0fc6i56z,
  TextMetrics as TextMetrics1vfyzci74zdhy,
  getTextBoundsWithGlyphs as getTextBoundsWithGlyphsa2ggkffutq4d,
  getTextBounds as getTextBoundsio1pfpt2q8ze,
  get_lazyBitmap_0 as get_lazyBitmap3pyj425xl7cp4,
  HtmlNativeImage as HtmlNativeImagenz79853f60h,
  ImageDecodingProps as ImageDecodingProps12g4gdsvb3zm5,
  get_RegisteredImageFormats as get_RegisteredImageFormats243xf60qkmjxj,
  toHtmlNative as toHtmlNative1zcg9na83p2te,
  BitmapPaint as BitmapPaintgyia0tdij0bl,
  GradientPaint as GradientPaint1uc4xuo0s2w8w,
  NonePaint as NonePaint2h93brzruznft,
  get_DefaultStringTextRenderer as get_DefaultStringTextRendererdyzggul2pyry,
  RichTextData as RichTextData1m4oei1jdcuz5,
  Entry_0 as Entry3jfmfe0iy8gwc,
  LineInfo as LineInfo27uw564y6w2d2,
  Text2TextRendererActions as Text2TextRendererActions1307nbc4pqqhs,
  drawRichText as drawRichTextyqpa5ren8u0j,
  invoke as invoke2ot88cm6qcfmr,
  place as placem8wpiy4fm4tw,
  CompoundShape as CompoundShape2jsp34o6wp7wp,
  FillShape as FillShape13c5zk3dmjgcf,
  PolylineShape as PolylineShape2w5p5crr94b97,
  ShapeBuilder as ShapeBuilderk05da5wk16e9,
  TextShape as TextShape3u9vrw15swk1x,
  get_isLow as get_isLow1k7uocm2ojjr8,
};
//endregion
